(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alpha-acrylic-commerce"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const box=document.querySelector('[data-acrylic-commerce]'),root=box?.closest('[data-acrylic-preview]');
    if(!root||box.dataset.initialized)return;
    box.dataset.initialized='true';
    const source=JSON.parse(box.querySelector('[data-acrylic-source]').textContent),copy=JSON.parse(box.querySelector('[data-acrylic-commerce-copy]').textContent);
    const pay=box.querySelector('[data-acrylic-pay]'),add=box.querySelector('[data-acrylic-add]'),error=box.querySelector('[data-acrylic-commerce-error]');
    let loadTimer;let native,dialog,home,form,submit,originalLabel,owned=false,paying=false,uncertain=false,options=[],loadedCountry='',fetched=0,loading='',sequence=0,openedSelection='';
    const active=()=>document.body.dataset.artworkBrowse==='print'&&document.body.dataset.artworkFinish==='acrylic';
    const selection=()=>{try{return active()?JSON.parse(root.dataset.acrylicSelection||'null'):null;}catch{return null;}};
    const signature=()=>{const s=selection();return s?JSON.stringify(s):'';};
    const current=()=>{const s=selection();return s&&signature()===loadedCountry?options.find(o=>o.rigid?.selection.sku===s.sku&&o.rigid.selection.surface===s.surface&&Math.round(o.totalPriceEur*100)===s.priceCents):null;};
    const fail=message=>{error.textContent=message||copy.error;error.hidden=false;};
    function endpoint(){
      const url=new URL(native.dataset.aapProxy,location.origin);
      if(url.origin!==location.origin||url.pathname!=='/apps/alpha-art-print')throw Error('UNAVAILABLE');
      return url;
    }
    function close(){if(owned&&dialog.open)dialog.close();}
    function render(){
      const available=Boolean(current())&&!uncertain;
      const selected=selection();
      box.hidden=!active()||!selected;pay.disabled=add.disabled=!available||paying;
      if(!selected)error.hidden=true;
      const total=root.querySelector('[data-acrylic-price]');
      const target=box.querySelector('[data-acrylic-pay-total]');
      const amount=selected&&total?total.querySelector('.money')?.textContent||'':'';
      if(target.textContent!==amount)target.textContent=amount;
      for(const el of root.querySelectorAll('.amg-pending'))el.hidden=!selected||available;
      root.dataset.acrylicCheckout=available?'ready':'unavailable';
      root.dataset.acrylicPaying=String(paying);
    }
    async function load(force=false){
      const s=selection();if(!native||!s)return;const key=signature();
      if(!force&&loadedCountry===key&&Date.now()-fetched<20*60*1000){render();return;}
      if(loading===key)return;
      const turn=++sequence;loading=key;options=[];loadedCountry='';render();
      try{
        const url=endpoint();url.searchParams.set('variant',native.dataset.aapVariant);url.searchParams.set('country',s.country);url.searchParams.set('catalog_profile','acrylic-v1');url.searchParams.set('panel_sku',s.sku);url.searchParams.set('panel_surface',s.surface);
        const response=await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(30000)});
        const data=await response.json();
        if(!response.ok||data.offerProfile!=='acrylic-v1'||data.countryCode!==s.country||!Array.isArray(data.options))throw Error('UNAVAILABLE');
        if(turn!==sequence||signature()!==key)return;
        options=data.options.filter(o=>o.supportId==='acrylic-panel'&&o.offerProfile==='acrylic-v1'&&typeof o.quoteToken==='string'&&Number.isFinite(o.totalPriceEur));
        loadedCountry=key;fetched=Date.now();error.hidden=true;
      }catch{if(turn===sequence)fail();}
      finally{if(turn===sequence){loading='';render();}}
    }
    function syncAddress(){
      const s=selection(),countries=native.querySelector('[data-aap-country]');
      const country=[...countries.options].find(o=>o.value===s.country);
      if(!country)throw Error('UNAVAILABLE');
      form.querySelector('[data-aap-address-country]').textContent=country.textContent;
      const normalize=t=>String(t||'').trim().normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
      const metadata=native.querySelector('[data-aap-country-metadata]');
      const item=metadata&&[...metadata.options].find(o=>normalize(o.textContent)===normalize(country.textContent));
      const provinces=JSON.parse(item?.dataset.provinces||'[]');
      const field=form.querySelector('[data-aap-address-province-field]'),province=form.querySelector('[data-aap-address-province]');
      province.replaceChildren();field.hidden=!provinces.length;province.required=Boolean(provinces.length);
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});province.disabled=!provinces.length;
      if(provinces.length){province.append(new Option(copy.choose,''));for(const p of provinces)province.append(new Option(p[1],p[0]));}
      submit.disabled=false;submit.textContent=originalLabel;
      form.querySelector('[data-aap-address-error]').textContent='';
    }
    async function submitAddress(event){
      if(!owned)return;
      event.preventDefault();event.stopImmediatePropagation();
      if(paying||uncertain||!active()||openedSelection!==signature()||!current()||!form.reportValidity())return;
      const s=selection(),option=current();
      if(Date.now()-fetched>25*60*1000){close();options=[];render();await load(true);return;}
      const shippingAddress=Object.fromEntries(new FormData(form));shippingAddress.countryCode=s.country;
      paying=true;render();submit.disabled=true;submit.textContent=copy.loading;
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=true;});
      try{
        const response=await fetch(endpoint(),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({quoteToken:option.quoteToken,shippingAddress}),signal:AbortSignal.timeout(30000)});
        const result=await response.json();
        if(!response.ok){if(response.status>=500)uncertain=true;throw Error('CHECKOUT');}
        const url=new URL(result.checkoutUrl);
        if(url.protocol!=='https:'||(!/(^|\.)alphachristianart\.com$/.test(url.hostname)&&url.hostname!==box.dataset.shop))throw Error('CHECKOUT');
        location.assign(url.href);
      }catch{uncertain=true;fail(copy.uncertain);form.querySelector('[data-aap-address-error]').textContent=copy.uncertain;}
      finally{paying=false;render();submit.textContent=originalLabel;submit.disabled=true;}
    }
    function attach(){
      native=document.querySelector('[data-aap-root]');dialog=native?.querySelector('[data-aap-address-dialog]');form=dialog?.querySelector('[data-aap-address-form]');submit=form?.querySelector('[data-aap-address-submit]');
      if(!native?.dataset.aapVariant||!form||!submit||!native.querySelector('[data-aap-country]')?.options.length)return false;
      home=document.createComment('acrylic-address-home');dialog.before(home);originalLabel=submit.textContent;
      for(const key of ['--aap-accent','--aap-ink','--aap-muted','--aap-font']){const value=getComputedStyle(native).getPropertyValue(key);if(value)box.style.setProperty(key,value);}
      form.addEventListener('submit',submitAddress,true);
      dialog.addEventListener('close',()=>{if(!owned)return;owned=false;home.after(dialog);form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});submit.disabled=false;submit.textContent=originalLabel;if(active())pay.focus();});
      load();return true;
    }
    pay.addEventListener('click',async()=>{
      const before=signature();if(!before||paying||uncertain)return;
      paying=true;render();await load(true);paying=false;render();
      if(before!==signature()||!current())return;
      try{syncAddress();owned=true;openedSelection=signature();box.append(dialog);dialog.showModal();form.querySelector('input[name="firstName"]')?.focus();}catch{owned=false;home.after(dialog);fail();}
    });
    add.addEventListener('click',async()=>{
      const before=signature(),s=selection(),o=current(),wallet=document.querySelector('artwork-credit-cart');if(!s||!o||paying||!wallet?.addRigidConfiguration)return;
      paying=true;render();
      try{await wallet.addRigidConfiguration(source,{variantId:'gid://shopify/ProductVariant/'+native.dataset.aapVariant,country:s.country,optionId:o.id,priceCents:s.priceCents,label:o.supportLabel+' · '+(s.label||o.widthMm/10+' × '+o.heightMm/10+' cm')+' · '+o.finishLabel},()=>before===signature());}catch{fail();}finally{paying=false;render();}
    });
    window.addEventListener('alpha:acrylic-selection',()=>{if(owned&&signature()!==openedSelection&&!paying)close();render();clearTimeout(loadTimer);loadTimer=setTimeout(()=>load(),450);});
    window.addEventListener('alpha:artwork-browse',()=>{if(!active()&&!paying)close();render();});
    const price=root.querySelector('[data-acrylic-price]');
    if(price)new MutationObserver(render).observe(price,{childList:true,subtree:true,characterData:true});
    let tries=0;const timer=setInterval(()=>{if(attach()||++tries>60)clearInterval(timer);},500);
    render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-acrylic-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const artworkRatio = image => {
    if(!image)return NaN;
    const declared=Number(image.closest('[data-artwork-ratio]')?.dataset.artworkRatio);
    if(Number.isFinite(declared)&&declared>0)return declared;
    const width=Number(image.getAttribute('width')),height=Number(image.getAttribute('height'));
    if(width>0&&height>0)return width/height;
    return image.naturalWidth>0&&image.naturalHeight>0?image.naturalWidth/image.naturalHeight:NaN;
  };
  const printLayout = (format, ratio) => {
    if (!format || ![format.w,format.h,ratio].every(v=>Number.isFinite(v)&&v>0) || format.w<=10 || format.h<=10) return null;
    const border=0;
    const width=Math.max(format.w,format.h*ratio),height=width/ratio;
    return {width,height,left:(format.w-width)/2,top:(format.h-height)/2,border,visibleFraction:format.w*format.h/(width*height)};
  };
  const geometryFit = (format, ratio, width, height) => {
    const image=printLayout(format,ratio);
    if(!image||![width,height].every(v=>Number.isFinite(v)&&v>0))return null;
    const scale=Math.min(width*.88/format.w,height*.88/format.h);
    return {image,scale,w:format.w*scale,h:format.h*scale};
  };
  const eligible = (format, ratio) => {
    if(!printLayout(format,ratio))return false;
    const orientation=r=>Math.abs(r-1)<.02?0:Math.sign(r-1);
    const border=0;
    const imageRatio=(format.w-2*border)/(format.h-2*border);
    return orientation(format.w/format.h)===orientation(ratio)&&Math.min(ratio/imageRatio,imageRatio/ratio)>=.85;
  };
  const roomGeometry = (format,ratio,width,height) => {
    const image=printLayout(format,ratio);
    if(!image||![width,height].every(v=>Number.isFinite(v)&&v>0))return null;
    const reference=height*.64,scale=reference/1700;
    return {image,scale,reference,w:format.w*scale,h:format.h*scale,x:width*.5,y:height*.45};
  };
  function applyArtGeometry(art,f,shade='gloss'){
    if(!f)return;
    const styles={'--ap-w':f.w+'px','--ap-h':f.h+'px','--ap-depth':Math.max(.6,Math.min(5,2.5*f.scale))+'px','--ap-image-w':f.image.width*f.scale+'px','--ap-image-h':f.image.height*f.scale+'px','--ap-image-top':f.image.top*f.scale+'px','--ap-image-left':f.image.left*f.scale+'px'};
    for(const [k,v]of Object.entries(styles))if(art.style.getPropertyValue(k)!==v)art.style.setProperty(k,v);
    art.dataset.surface=shade;
  }
  if(typeof document==='undefined'){if(typeof module!=='undefined')module.exports={printLayout,geometryFit,eligible,artworkRatio,roomGeometry};return;}
  function initThumbnails(){
    document.querySelectorAll('.acp-choice .acp-art').forEach(art=>{
      if(art.dataset.thumbnailReady)return;art.dataset.thumbnailReady='true';
      const img=art.querySelector('img'),stage=art.parentElement;
      const draw=()=>{const ratio=artworkRatio(img);if(ratio>0)applyArtGeometry(art,geometryFit({w:300*ratio,h:300},ratio,stage.clientWidth,stage.clientHeight),'gloss');};
      new ResizeObserver(draw).observe(stage);img?.addEventListener('load',draw);draw();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initThumbnails,{once:true});else initThumbnails();
  document.addEventListener('shopify:section:load',initThumbnails);
  async function init(){
    const root=document.querySelector('[data-acrylic-preview]');
    if(!root||root.dataset.initialized)return;
    if(document.body.dataset.artworkFinish!=='acrylic')return;
    root.dataset.initialized='true';
    const copy=JSON.parse(root.querySelector('[data-acrylic-copy]').textContent);
    let data;
    try {
      const response=await fetch(JSON.parse(document.querySelector('[data-acrylic-catalog-url]').textContent));
      if(!response.ok)throw Error('CATALOG');
      data=await response.json();
      if(!data.version||data.checkoutEnabled!==true||!Array.isArray(data.products))throw Error('CATALOG');
    } catch (_) {
      delete root.dataset.initialized;
      if(document.body.dataset.artworkFinish==='acrylic'){
        root.hidden=root.dataset.page!=='product';document.body.classList.add('acp-active');
        const status=root.querySelector('[data-acrylic-status]');if(status)status.textContent=copy.unavailable;
      }
      return;
    }
    const product=root.dataset.page==='product';
    let country;try{country=localStorage.getItem('alpha-art-print-country');}catch(_){}
    country=country||root.dataset.defaultCountry;
    let surface='gloss',unit='cm',selected=null,active=false;
    const entries=new Map();
    const number=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:2}).format(value);
    const measure=value=>number(value/(unit==='cm'?10:25.4))+(unit==='cm'?' cm':'″');
    const dimensions=(w,h)=>number(w/(unit==='cm'?10:25.4))+' × '+measure(h);
    const money=value=>{const span=document.createElement('span');span.className='money';span.textContent=(value/100).toFixed(2)+' €';return span;};
    const text=(selector,value)=>{const e=root.querySelector(selector);if(e)e.textContent=value;};
    const regionName=code=>{try{return new Intl.DisplayNames([document.documentElement.lang||'en'],{type:'region'}).of(code);}catch(_){return data.names[code]||code;}};
    function options(ratio,shade=surface){return (data.countries[country]||[]).map(i=>data.quotes[i]).filter(q=>data.products[q[0]].surface===shade&&eligible(data.products[q[0]],ratio));}
    function best(ratio){return options(ratio).sort((a,b)=>Math.abs(Math.log(Math.max(data.products[a[0]].w,data.products[a[0]].h)/500))-Math.abs(Math.log(Math.max(data.products[b[0]].w,data.products[b[0]].h)/500))||Math.abs(data.products[a[0]].w/data.products[a[0]].h-ratio)-Math.abs(data.products[b[0]].w/data.products[b[0]].h-ratio))[0];}
    function setArt(art,format,ratio,shade=surface){
      const stage=art.parentElement;
      applyArtGeometry(art,geometryFit(format,ratio,stage.clientWidth,stage.clientHeight),shade);
    }
    const resize=new ResizeObserver(()=>renderArt());
    const hero=root.querySelector('[data-acrylic-art]');
    const heroImage=hero?.querySelector('img');
    if(hero){resize.observe(hero.parentElement);heroImage.addEventListener('load',render);}
    const roomHost=root.querySelector('[data-acrylic-room-host]');
    let room=null;
    function ensureRoom(){
      if(room||!roomHost||!hero)return;
      const source=document.querySelector('[data-aap-room]')?.closest('.aap-preview');
      if(!source)return;
      const section=source.cloneNode(true),stage=section.querySelector('[data-aap-room]');
      const oldArt=section.querySelector('[data-aap-preview]'),reference=section.querySelector('[data-aap-reference]'),label=section.querySelector('[data-aap-preview-dimension]'),zoom=section.querySelector('[data-aap-zoom]');
      if(!stage||!oldArt||!reference||!label||!zoom)return;
      section.querySelectorAll('*').forEach(el=>{el.removeAttribute('id');for(const attr of [...el.attributes])if(attr.name.startsWith('data-aap-'))el.removeAttribute(attr.name);});
      section.classList.add('acp-room');
      section.setAttribute('aria-labelledby','AcrylicRoomTitle');
      section.querySelector('h3').id='AcrylicRoomTitle';
      const titleStyle=getComputedStyle(source.querySelector('h3'));
      section.querySelector('h3').style.fontFamily=titleStyle.fontFamily;
      section.querySelector('h3').style.fontWeight=titleStyle.fontWeight;
      const art=hero.cloneNode(true);art.removeAttribute('data-acrylic-art');art.classList.add('acp-room-art');art.dataset.acrylicRoomArt='';
      const painting=art.querySelector('img');painting.removeAttribute('srcset');painting.removeAttribute('sizes');painting.loading='lazy';painting.fetchPriority='low';painting.alt=heroImage.alt;
      oldArt.replaceWith(art);
      section.querySelectorAll('img').forEach(img=>{img.loading='lazy';img.decoding='async';});
      const dialog=document.createElement('dialog');dialog.className='acp-room-dialog';dialog.setAttribute('aria-labelledby','AcrylicRoomTitle');
      const zoomMarkup=zoom.innerHTML,zoomLabel=zoom.getAttribute('aria-label');
      zoom.setAttribute('aria-haspopup','dialog');zoom.setAttribute('aria-expanded','false');
      zoom.addEventListener('click',()=>{
        if(dialog.open){dialog.close();return;}
        dialog.append(section);dialog.showModal();zoom.textContent=copy.close;zoom.setAttribute('aria-label',copy.close);zoom.setAttribute('aria-expanded','true');requestAnimationFrame(renderRoom);
      });
      dialog.addEventListener('close',()=>{roomHost.insertBefore(section,dialog);zoom.innerHTML=zoomMarkup;if(zoomLabel)zoom.setAttribute('aria-label',zoomLabel);zoom.setAttribute('aria-expanded','false');requestAnimationFrame(()=>{renderRoom();if(active)zoom.focus({preventScroll:true});});});
      dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
      room={section,stage,art,reference,label,dialog,painting};
      roomHost.append(section,dialog);resize.observe(stage);
    }
    function renderRoom(){
      if(!room||!selected||!active)return;
      const f=roomGeometry(data.products[selected[0]],artworkRatio(heroImage),room.stage.clientWidth,room.stage.clientHeight);
      if(!f)return;
      applyArtGeometry(room.art,f,surface);
      room.art.style.left=f.x+'px';room.art.style.top=f.y+'px';
      room.reference.style.height=f.reference+'px';
      room.label.style.left=f.x+'px';room.label.style.top=(f.y+f.h/2+10)+'px';
      const format=data.products[selected[0]];
      room.label.textContent=dimensions(format.w,format.h);
      room.label.hidden=false;
      if(heroImage.complete&&heroImage.currentSrc&&room.painting.src!==heroImage.currentSrc)room.painting.src=heroImage.currentSrc;
    }
    function renderArt(){
      if(!active)return;
      if(hero&&selected){
        const f=data.products[selected[0]],ratio=artworkRatio(heroImage);
        setArt(hero,f,ratio);
        root.querySelectorAll('[data-acrylic-swatch-art]').forEach(art=>setArt(art,f,ratio,art.dataset.acrylicSwatchArt));
      }
      renderRoom();
      for(const [card,entry]of entries){
        if(!card.isConnected){resize.unobserve(entry.stage);entry.source.removeEventListener('load',entry.load);entries.delete(card);continue;}
        const ratio=artworkRatio(entry.source);
        const quote=Number.isFinite(ratio)&&best(ratio);
        entry.stage.hidden=!quote;
        card.classList.toggle('acp-card-ready',Boolean(quote));
        if(quote)setArt(entry.art,data.products[quote[0]],ratio);
        const minimum=quote?Math.min(...options(ratio).map(q=>q[1])):null;
        if(entry.minimum!==minimum){entry.minimum=minimum;entry.price.replaceChildren();if(minimum!==null)entry.price.append(document.createTextNode(copy.from+' '),money(minimum),document.createElement('br'),document.createTextNode(copy.shipping_included));else entry.price.textContent=copy.no_size;}
      }
    }
    function render(){
      active=document.body.dataset.artworkBrowse==='print'&&document.body.dataset.artworkFinish==='acrylic';
      root.hidden=!active||!product;
      document.body.classList.toggle('acp-active',active);
      if(heroImage)heroImage.fetchPriority=active?'high':'auto';
      if(!active){delete root.dataset.acrylicSelection;window.dispatchEvent(new Event('alpha:acrylic-selection'));if(room?.dialog.open)room.dialog.close();root.classList.remove('acp-zoomed');const zoom=root.querySelector('[data-acrylic-zoom]');if(zoom)zoom.textContent=copy.zoom;return;}
      if(heroImage)heroImage.loading='eager';
      if(root.dataset.wall&&!root.dataset.wall.includes('Liquid error'))document.body.style.setProperty('--ap-photo-wall','url("'+root.dataset.wall+'")');
      if(!product){requestAnimationFrame(decorate);return;}
      ensureRoom();
      text('[data-acrylic-country]',regionName(country));
      const validCountry=Boolean(data.countries[country]?.length);
      const ratio=artworkRatio(heroImage);
      let choices=product&&Number.isFinite(ratio)?options(ratio):[];
      choices.sort((a,b)=>data.products[a[0]].w*data.products[a[0]].h-data.products[b[0]].w*data.products[b[0]].h);
      if(product){
        const old=selected&&data.products[selected[0]];
        selected=choices.find(q=>data.products[q[0]].w===old?.w&&data.products[q[0]].h===old?.h)||best(ratio)||null;
        const sizes=root.querySelector('[data-acrylic-sizes]');sizes.replaceChildren();
        for(const q of choices){const f=data.products[q[0]],button=document.createElement('button'),label=document.createElement('strong');button.type='button';button.dataset.acrylicSize=String(q[0]);button.setAttribute('aria-pressed',String(q===selected));label.textContent=dimensions(f.w,f.h);button.append(label,money(q[1]));sizes.append(button);}
      }
      root.querySelector('[data-acrylic-price-card]').hidden=!product||!selected;
      root.querySelector('[data-acrylic-details]').hidden=!product||!selected;
      if(hero)hero.parentElement.hidden=!selected;
      if(roomHost)roomHost.hidden=!selected;
      if(selected&&product){
        const f=data.products[selected[0]];
        hero.parentElement.dataset.orientation=f.w/f.h>1.05?'landscape':f.w/f.h<.95?'portrait':'square';
        text('[data-acrylic-selected-size]',dimensions(f.w,f.h));text('[data-acrylic-print-size]',dimensions(f.w,f.h));text('[data-acrylic-image-size]',dimensions(f.w,f.h));text('[data-acrylic-origin]',regionName(selected[3]));
        text('[data-acrylic-transit]',selected[4]===null||selected[5]===null?copy.transit_unknown:(selected[4]===selected[5]?selected[4]:selected[4]+'–'+selected[5])+' '+copy.days);
        root.querySelector('[data-acrylic-price]').replaceChildren(money(selected[1]));
        root.querySelector('[data-acrylic-shipping]').replaceChildren(document.createTextNode(copy.included+' ('),money(selected[2]),document.createTextNode(')'));
      }else text('[data-acrylic-origin]','—');
      root.querySelectorAll('[data-acrylic-surface]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.acrylicSurface===surface));b.disabled=!options(ratio,b.dataset.acrylicSurface).length;});
      root.querySelectorAll('[data-acrylic-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.acrylicUnit===unit)));
      text('[data-acrylic-status]',!validCountry?copy.unavailable:product&&!selected?copy.no_size:copy.ready);
      root.dataset.acrylicState=validCountry&&(!product||selected)?'ready':'unavailable';
      root.dataset.acrylicSelection=selected?JSON.stringify({sku:data.products[selected[0]].sku,surface,country,priceCents:selected[1],label:dimensions(data.products[selected[0]].w,data.products[selected[0]].h),fit:'cover',cropPosition:'center'}):'';
      window.dispatchEvent(new Event('alpha:acrylic-selection'));
      requestAnimationFrame(decorate);
    }
    function decorate(){
      if(!active)return;
      document.querySelectorAll('[data-alpha-product-card]').forEach(card=>{
        if(entries.has(card))return;
        const source=card.querySelector('.alpha-product-card__artwork-frame img'),media=card.querySelector('.alpha-product-card__media');
        if(!source||!media)return;
        const stage=document.createElement('div');stage.className='acp-stage acp-card-stage';
        const art=document.createElement('div');art.className='acp-art';
        art.innerHTML='<div class="acp-paper"><div class="acp-image-area"></div></div>';
        const img=source.cloneNode();img.removeAttribute('id');img.className='acp-image';img.alt='';img.decoding='async';img.fetchPriority='auto';
        const syncImage=()=>{if(source.complete&&source.naturalWidth&&source.currentSrc){img.removeAttribute('srcset');img.removeAttribute('sizes');if(img.src!==source.currentSrc)img.src=source.currentSrc;}};
        syncImage();art.querySelector('.acp-image-area').append(img);stage.append(art);media.append(stage);
        const price=document.createElement('p');price.className='acp-card-price';card.append(price);
        const load=()=>{syncImage();renderArt();};source.addEventListener('load',load);entries.set(card,{source,stage,art,load,price,minimum:undefined});resize.observe(stage);
      });renderArt();
    }
    root.addEventListener('click',e=>{
      if(root.dataset.acrylicPaying==='true')return;
      const size=e.target.closest('[data-acrylic-size]'),shade=e.target.closest('[data-acrylic-surface]'),units=e.target.closest('[data-acrylic-unit]');
      if(size){selected=options(artworkRatio(heroImage)).find(q=>q[0]===Number(size.dataset.acrylicSize));render();root.querySelector('[data-acrylic-size="'+size.dataset.acrylicSize+'"]')?.focus({preventScroll:true});}
      if(shade){surface=shade.dataset.acrylicSurface;render();}
      if(units){unit=units.dataset.acrylicUnit;render();}
      if(e.target.closest('[data-acrylic-zoom]')){root.classList.toggle('acp-zoomed');e.target.textContent=root.classList.contains('acp-zoomed')?copy.close:copy.zoom;requestAnimationFrame(renderArt);}
    });
    document.addEventListener('keydown',e=>{if(e.key==='Escape'){root.classList.remove('acp-zoomed');if(root.querySelector('[data-acrylic-zoom]'))root.querySelector('[data-acrylic-zoom]').textContent=copy.zoom;}});
    window.addEventListener('alpha:artwork-browse',render);
    window.addEventListener('alpha-art-print:country-change',e=>{if(/^[A-Z]{2}$/.test(e.detail?.country)){country=e.detail.country;render();}});
    window.addEventListener('storage',e=>{if(e.key==='alpha-art-print-country'&&e.newValue){country=e.newValue;render();}});
    const grid=document.querySelector('#ResultsList');if(grid)new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-alpha-product-card], li')||n.querySelector('[data-alpha-product-card]')))))decorate();}).observe(grid,{childList:true,subtree:true});
    decorate();render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  window.addEventListener('alpha:artwork-browse',()=>{
    if(document.body.dataset.artworkFinish==='acrylic')return;
    document.body.classList.remove('acp-active');
    const root=document.querySelector('[data-acrylic-preview]');if(root)root.hidden=true;
  });
  window.addEventListener('alpha:artwork-browse',init);
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-artwork-filters"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    document.querySelectorAll('artwork-catalog-filters.acfilt').forEach((filters) => {
      if (filters.dataset.mobileDialogReady) return;
      const panel = filters.querySelector('.acfilt__panel');
      const home = filters.querySelector('.acfilt__panel-home');
      const dialog = filters.querySelector('.acfilt__dialog');
      const content = filters.querySelector('.acfilt__dialog-content');
      const trigger = filters.querySelector('.acfilt__mobile-open');
      if (!panel || !home || !dialog || !content || !trigger) return;
      filters.dataset.mobileDialogReady = 'true';
      const mobile = window.matchMedia('(max-width: 749px)');
      const sync = () => {
        if (mobile.matches) content.append(panel);
        else {
          if (dialog.open) dialog.close();
          home.after(panel);
        }
      };
      trigger.addEventListener('click', () => { sync(); dialog.showModal(); });
      dialog.querySelectorAll('.acfilt__dialog-close, .acfilt__dialog-done').forEach((button) => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => trigger.focus());
      mobile.addEventListener('change', sync);
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-board-commerce"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const box=document.querySelector('[data-board-commerce]'),root=box?.closest('[data-board-root]');
    if(!root||box.dataset.initialized)return;
    box.dataset.initialized='true';
    const source=JSON.parse(box.querySelector('[data-board-source]').textContent),copy=JSON.parse(box.querySelector('[data-board-commerce-copy]').textContent);
    const pay=box.querySelector('[data-board-pay]'),add=box.querySelector('[data-board-add]'),error=box.querySelector('[data-board-commerce-error]');
    let loadTimer;let native,dialog,home,form,submit,originalLabel,owned=false,paying=false,uncertain=false,options=[],loadedCountry='',fetched=0,loading='',sequence=0,openedSelection='';
    const active=()=>document.body.dataset.artworkBrowse==='board';
    const selection=()=>{try{return active()?JSON.parse(root.dataset.boardSelection||'null'):null;}catch{return null;}};
    const signature=()=>{const s=selection();return s?JSON.stringify(s):'';};
    const current=()=>{const s=selection();return s&&signature()===loadedCountry?options.find(o=>o.rigid?.selection.size===s.size&&['x','y','zoom'].every(k=>o.rigid.selection[k]===s[k])&&Math.round(o.totalPriceEur*100)===s.priceCents):null;};
    const fail=message=>{error.textContent=message||copy.error;error.hidden=false;};
    function endpoint(){
      const url=new URL(native.dataset.aapProxy,location.origin);
      if(url.origin!==location.origin||url.pathname!=='/apps/alpha-art-print')throw Error('UNAVAILABLE');
      return url;
    }
    function close(){if(owned&&dialog.open)dialog.close();}
    function render(){
      const available=Boolean(current())&&!uncertain;
      const selected=selection();
      box.hidden=!active()||!selected;pay.disabled=add.disabled=!available||paying;
      if(!selected)error.hidden=true;
      const total=root.querySelector('[data-board-price]');
      const target=box.querySelector('[data-board-pay-total]');
      const amount=selected&&total?total.querySelector('.money')?.textContent||'':'';
      if(target.textContent!==amount)target.textContent=amount;
      for(const el of root.querySelectorAll('.amg-pending'))el.hidden=!selected||available;
      root.dataset.boardCheckout=available?'ready':'unavailable';
      root.dataset.boardPaying=String(paying);
    }
    async function load(force=false){
      const s=selection();if(!native||!s)return;const key=signature();
      if(!force&&loadedCountry===key&&Date.now()-fetched<20*60*1000){render();return;}
      if(loading===key)return;
      const turn=++sequence;loading=key;options=[];loadedCountry='';render();
      try{
        const url=endpoint();url.searchParams.set('variant',native.dataset.aapVariant);url.searchParams.set('country',s.country);url.searchParams.set('catalog_profile','board-v1');url.searchParams.set('board_size',s.size);['x','y','zoom'].forEach(k=>url.searchParams.set('board_'+k,s[k]));
        const response=await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(30000)});
        const data=await response.json();
        if(!response.ok||data.offerProfile!=='board-v1'||data.countryCode!==s.country||!Array.isArray(data.options))throw Error('UNAVAILABLE');
        if(turn!==sequence||signature()!==key)return;
        options=data.options.filter(o=>o.supportId==='gallery-board-stand'&&o.offerProfile==='board-v1'&&typeof o.quoteToken==='string'&&Number.isFinite(o.totalPriceEur));
        loadedCountry=key;fetched=Date.now();error.hidden=true;
      }catch{if(turn===sequence)fail();}
      finally{if(turn===sequence){loading='';render();}}
    }
    function syncAddress(){
      const s=selection(),countries=native.querySelector('[data-aap-country]');
      const country=[...countries.options].find(o=>o.value===s.country);
      if(!country)throw Error('UNAVAILABLE');
      form.querySelector('[data-aap-address-country]').textContent=country.textContent;
      const normalize=t=>String(t||'').trim().normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
      const metadata=native.querySelector('[data-aap-country-metadata]');
      const item=metadata&&[...metadata.options].find(o=>normalize(o.textContent)===normalize(country.textContent));
      const provinces=JSON.parse(item?.dataset.provinces||'[]');
      const field=form.querySelector('[data-aap-address-province-field]'),province=form.querySelector('[data-aap-address-province]');
      province.replaceChildren();field.hidden=!provinces.length;province.required=Boolean(provinces.length);
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});province.disabled=!provinces.length;
      if(provinces.length){province.append(new Option(copy.choose,''));for(const p of provinces)province.append(new Option(p[1],p[0]));}
      submit.disabled=false;submit.textContent=originalLabel;
      form.querySelector('[data-aap-address-error]').textContent='';
    }
    async function submitAddress(event){
      if(!owned)return;
      event.preventDefault();event.stopImmediatePropagation();
      if(paying||uncertain||!active()||openedSelection!==signature()||!current()||!form.reportValidity())return;
      const s=selection(),option=current();
      if(Date.now()-fetched>25*60*1000){close();options=[];render();await load(true);return;}
      const shippingAddress=Object.fromEntries(new FormData(form));shippingAddress.countryCode=s.country;
      paying=true;render();submit.disabled=true;submit.textContent=copy.loading;
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=true;});
      try{
        const response=await fetch(endpoint(),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({quoteToken:option.quoteToken,shippingAddress}),signal:AbortSignal.timeout(30000)});
        const result=await response.json();
        if(!response.ok){if(response.status>=500)uncertain=true;throw Error('CHECKOUT');}
        const url=new URL(result.checkoutUrl);
        if(url.protocol!=='https:'||(!/(^|\.)alphachristianart\.com$/.test(url.hostname)&&url.hostname!==box.dataset.shop))throw Error('CHECKOUT');
        location.assign(url.href);
      }catch{uncertain=true;fail(copy.uncertain);form.querySelector('[data-aap-address-error]').textContent=copy.uncertain;}
      finally{paying=false;render();submit.textContent=originalLabel;submit.disabled=true;}
    }
    function attach(){
      native=document.querySelector('[data-aap-root]');dialog=native?.querySelector('[data-aap-address-dialog]');form=dialog?.querySelector('[data-aap-address-form]');submit=form?.querySelector('[data-aap-address-submit]');
      if(!native?.dataset.aapVariant||!form||!submit||!native.querySelector('[data-aap-country]')?.options.length)return false;
      home=document.createComment('board-address-home');dialog.before(home);originalLabel=submit.textContent;
      for(const key of ['--aap-accent','--aap-ink','--aap-muted','--aap-font']){const value=getComputedStyle(native).getPropertyValue(key);if(value)box.style.setProperty(key,value);}
      form.addEventListener('submit',submitAddress,true);
      dialog.addEventListener('close',()=>{if(!owned)return;owned=false;home.after(dialog);form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});submit.disabled=false;submit.textContent=originalLabel;if(active())pay.focus();});
      load();return true;
    }
    pay.addEventListener('click',async()=>{
      const before=signature();if(!before||paying||uncertain)return;
      paying=true;render();await load(true);paying=false;render();
      if(before!==signature()||!current())return;
      try{syncAddress();owned=true;openedSelection=signature();box.append(dialog);dialog.showModal();form.querySelector('input[name="firstName"]')?.focus();}catch{owned=false;home.after(dialog);fail();}
    });
    add.addEventListener('click',async()=>{
      const before=signature(),s=selection(),o=current(),wallet=document.querySelector('artwork-credit-cart');if(!s||!o||paying||!wallet?.addRigidConfiguration)return;
      paying=true;render();
      try{await wallet.addRigidConfiguration(source,{variantId:'gid://shopify/ProductVariant/'+native.dataset.aapVariant,country:s.country,optionId:o.id,priceCents:s.priceCents,label:o.supportLabel+' · '+(s.label||o.widthMm/10+' × '+o.heightMm/10+' cm')+' · '+o.finishLabel},()=>before===signature());}catch{fail();}finally{paying=false;render();}
    });
    window.addEventListener('alpha:board-selection',()=>{if(owned&&signature()!==openedSelection&&!paying)close();render();clearTimeout(loadTimer);loadTimer=setTimeout(()=>load(),450);});
    window.addEventListener('alpha:artwork-browse',()=>{if(!active()&&!paying)close();render();});
    const price=root.querySelector('[data-board-price]');
    if(price)new MutationObserver(render).observe(price,{childList:true,subtree:true,characterData:true});
    let tries=0;const timer=setInterval(()=>{if(attach()||++tries>60)clearInterval(timer);},500);
    render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-board-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const formats={
    '4x6':{w:101.6,h:152.4,fw:1259,fh:1859,stand:90},
    '5x7':{w:127,h:177.8,fw:1559,fh:2159,stand:90},
    '6x6':{w:152.4,h:152.4,fw:1859,fh:1859,stand:90},
    '8x8':{w:203.2,h:203.2,fw:2459,fh:2459,stand:165},
    '8x10':{w:203.2,h:254,fw:2459,fh:3059,stand:165},
    '10x10':{w:254,h:254,fw:3059,fh:3059,stand:165},
    '10x12':{w:254,h:304.8,fw:3059,fh:3659,stand:165},
    '11x14':{w:279.4,h:355.6,fw:3359,fh:4259,stand:165}
  };
  const normal=value=>({size:Object.hasOwn(formats,value?.size)?value.size:'4x6',x:Number.isInteger(value?.x)&&value.x>=0&&value.x<=100?value.x:50,y:Number.isInteger(value?.y)&&value.y>=0&&value.y<=100?value.y:50,zoom:Number.isInteger(value?.zoom)&&value.zoom>=100&&value.zoom<=200?value.zoom:100});
  const geometry=(sw,sh,value)=>{
    if(![sw,sh].every(n=>Number.isFinite(n)&&n>0))return null;
    const s=normal(value),f=formats[s.size],landscape=f.w!==f.h&&sw>sh;
    const w=landscape?f.h:f.w,h=landscape?f.w:f.h,fw=landscape?f.fh:f.fw,fh=landscape?f.fw:f.fh;
    const scale=Math.max(fw/sw,fh/sh)*s.zoom/100,iw=sw*scale,ih=sh*scale,left=(fw-iw)*s.x/100,top=(fh-ih)*s.y/100;
    return {...s,widthMm:w,heightMm:h,fileWidthPx:fw,fileHeightPx:fh,standMm:f.stand,orientation:f.w===f.h?'square':landscape?'landscape':'portrait',imageWidthPx:iw,imageHeightPx:ih,leftPx:left,topPx:top,bleedPx:29.5,sourceRect:{x:(29.5-left)/scale,y:(29.5-top)/scale,w:(fw-59)/scale,h:(fh-59)/scale},retainedFraction:((fw-59)*(fh-59))/(iw*ih)};
  };
  const bestSize=(sw,sh)=>Object.keys(formats).reduce((best,size)=>geometry(sw,sh,{size}).retainedFraction>geometry(sw,sh,{size:best}).retainedFraction+.0001?size:best,'4x6');
  const sceneLayout=(g,W,H)=>{
    const scale=Math.min(W*.82/Math.max(g.widthMm,g.standMm/.824),H*.82/(g.heightMm+g.standMm/.824/3*.64));
    const w=g.widthMm*scale,h=g.heightMm*scale,standW=g.standMm*scale/.824,standH=standW/3;
    const x=(W-w)/2,y=(H-h-standH*.64)/2,bottom=y+h;
    return {w,h,x,y,bottom,standW,standH,standX:(W-standW)/2,standY:bottom-standH*.369};
  };
  const priceFor=(data,country,size)=>data?.version===1&&data.checkoutEnabled===true&&data.currency==='EUR'&&Number.isSafeInteger(data.prices?.[size]?.[country])&&data.prices[size][country]>0?data.prices[size][country]:null;
  const minimum=(data,country)=>{const p=Object.keys(formats).map(s=>priceFor(data,country,s)).filter(Number.isFinite);return p.length?Math.min(...p):null;};
  if(typeof document==='undefined'){if(typeof module!=='undefined')module.exports={normal,geometry,priceFor,minimum,formats,bestSize,sceneLayout};return;}
  let dispose=()=>{};
  function init(){
    dispose();const root=document.querySelector('[data-board-root]'),selector=document.querySelector('[data-alpha-browse-type]');if(!root||!selector)return;
    const data=JSON.parse(root.querySelector('[data-board-data]').textContent),copy=JSON.parse(root.querySelector('[data-board-copy]').textContent),listeners=new AbortController(),cards=new Map(),pixels=new WeakMap();
    const panel=root.querySelector('[data-board-panel]'),hero=panel?.querySelector('[data-board-scene]'),source=hero?.querySelector('.abo-source'),stand=root.querySelector('.abo-stand-source');
    let country=root.dataset.defaultCountry,selected=normal(null),scheduled=false,stopped=false;
    const cropKey='alpha-gallery-board-crop-v1:'+location.pathname;
    try{country=localStorage.getItem('alpha-art-print-country')||country;selected=normal(JSON.parse(sessionStorage.getItem(cropKey)));}catch{}
    if(!data.sizes.some(s=>s.id===selected.size))selected=normal({size:data.sizes[0]?.id});
    country=String(country).toUpperCase();
    const active=()=>document.body.dataset.artworkBrowse==='board';
    const schedule=()=>{if(scheduled||stopped)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;if(!stopped)render();});};
    function writePrice(node,value,from=false,shipping=true){
      const key=[country,value,from,shipping].join(':');if(node.dataset.boardPriceKey===key)return;node.dataset.boardPriceKey=key;node.hidden=false;node.replaceChildren();
      const line=document.createElement('span');line.className='asp-price__line';
      if(value===null)line.textContent=copy.unavailable;else{if(from)line.append(document.createTextNode(copy.from+' '));const money=document.createElement('strong');money.className='money';money.textContent=(value/100).toFixed(2)+' €';line.append(money);}node.append(line);
      if(value!==null&&shipping){const note=document.createElement('small');note.className='asp-price__note';note.textContent=copy.shipping;node.append(note);}
    }
    function fullPixels(original){
      if(!original?.complete||!original.naturalWidth)return null;
      const url=original.currentSrc||original.src;let item=pixels.get(original);
      if(!item||item.url!==url){const image=new Image();image.decoding='async';image.addEventListener('load',schedule,{once:true,signal:listeners.signal});item={url,image};pixels.set(original,item);image.src=url;}
      return item.image.complete&&item.image.naturalWidth?item.image:null;
    }
    function draw(scene,original,selection){
      const img=fullPixels(original);
      if(!img?.complete||!img.naturalWidth||!stand?.complete||!stand.naturalWidth)return false;
      const g=geometry(img.naturalWidth,img.naturalHeight,selection||{size:bestSize(img.naturalWidth,img.naturalHeight)});if(!g)return false;
      const canvas=scene.querySelector('canvas'),ctx=canvas.getContext('2d');if(!ctx)return false;
      const rect=scene.getBoundingClientRect();if(rect.width<1||rect.height<1)return false;
      const density=Math.min(window.devicePixelRatio||1,2),cw=Math.max(1,Math.round(rect.width*density)),ch=Math.max(1,Math.round(rect.height*density));
      if(canvas.width!==cw||canvas.height!==ch){canvas.width=cw;canvas.height=ch;}
      const key=[img.currentSrc||img.src,JSON.stringify(g),canvas.width,canvas.height].join(':');if(scene.dataset.boardDrawn===key)return true;
      const W=canvas.width,H=canvas.height,{w,h,x,y,bottom,standW,standH,standX,standY}=sceneLayout(g,W,H);
      ctx.clearRect(0,0,W,H);const bg=ctx.createLinearGradient(0,0,W,H);bg.addColorStop(0,'#faf5e9');bg.addColorStop(1,'#e8dcc8');ctx.fillStyle=bg;ctx.fillRect(0,0,W,H);
      const glow=ctx.createRadialGradient(W*.08,H*.2,0,W*.08,H*.2,W*.85);glow.addColorStop(0,'rgba(255,255,255,.65)');glow.addColorStop(1,'rgba(255,255,255,0)');ctx.fillStyle=glow;ctx.fillRect(0,0,W,H);
      const floor=bottom+standH*.12;ctx.fillStyle='rgba(148,116,72,.055)';ctx.fillRect(0,floor,W,H-floor);
      ctx.drawImage(stand,standX,standY,standW,standH);
      ctx.save();ctx.shadowColor='rgba(62,44,26,.28)';ctx.shadowBlur=W*.018;ctx.shadowOffsetX=W*.01;ctx.shadowOffsetY=W*.006;ctx.fillStyle='#ad9b7e';ctx.fillRect(x+2,y+1,w,h);ctx.restore();
      const r=g.sourceRect;ctx.drawImage(img,r.x,r.y,r.w,r.h,x,y,w,h);
      ctx.strokeStyle='rgba(56,38,23,.18)';ctx.lineWidth=1;ctx.strokeRect(x,y,w,h);
      ctx.save();ctx.beginPath();ctx.rect(0,standY+standH*.377,W,H);ctx.clip();ctx.drawImage(stand,standX,standY,standW,standH);ctx.restore();
      scene.dataset.boardDrawn=key;scene.dataset.boardSourceWidth=String(img.naturalWidth);scene.dataset.boardSourceHeight=String(img.naturalHeight);scene.dataset.boardFormat=g.size;return true;
    }
    const resizeObserver=new ResizeObserver(schedule);
    selector.querySelectorAll('[data-board-scene]').forEach(n=>resizeObserver.observe(n));if(hero)resizeObserver.observe(hero);
    const observer=new IntersectionObserver(entries=>{entries.forEach(e=>{const item=cards.get(e.target);if(item&&e.isIntersecting){item.visible=true;observer.unobserve(e.target);}});schedule();},{rootMargin:'300px'});
    function attachCards(){
      document.querySelectorAll('[data-alpha-product-card]').forEach(card=>{
        if(cards.has(card))return;const img=card.querySelector('.alpha-product-card__artwork-frame img'),media=card.querySelector('.alpha-product-card__media');if(!img||!media)return;
        const scene=root.querySelector('[data-board-scene-template]').content.firstElementChild.cloneNode(true);scene.classList.add('abo-card-scene');scene.querySelector('canvas').width=720;scene.querySelector('canvas').height=540;media.append(scene);
        const price=document.createElement('div');price.className='asp-price abo-card-price';card.append(price);cards.set(card,{img,scene,price,visible:false});observer.observe(card);resizeObserver.observe(media);img.addEventListener('load',schedule,{signal:listeners.signal});
      });
      for(const [card,item]of cards){if(!card.isConnected){observer.unobserve(card);resizeObserver.unobserve(card.querySelector('.alpha-product-card__media'));cards.delete(card);continue;}writePrice(item.price,minimum(data,country),true);if(item.visible){card.classList.add('abo-card-preparing');if(draw(item.scene,item.img))card.classList.add('abo-card-ready');}}
    }
    function render(){
      selector.querySelectorAll('[data-board-minimum]').forEach(n=>writePrice(n,minimum(data,country),true));
      selector.querySelectorAll('[data-board-scene]').forEach(n=>draw(n,n.querySelector('.abo-source')));
      if(panel)panel.hidden=!active();if(!active())return;
      selector.querySelectorAll('[data-browse-for="board"] input').forEach(n=>{n.disabled=false;n.checked=true;});attachCards();
      document.querySelectorAll('.abt-card-action__link').forEach(n=>n.textContent=selector.dataset.boardCardCta);document.querySelectorAll('.abt-card-action__note').forEach(n=>n.textContent=selector.dataset.boardCardNote);
      if(!panel)return;
      const drawn=draw(hero,source,selected),full=fullPixels(source),g=geometry(full?.naturalWidth,full?.naturalHeight,selected);
      root.querySelectorAll('[data-board-size]').forEach(n=>{n.hidden=!data.sizes.some(s=>s.id===n.dataset.boardSize);n.setAttribute('aria-pressed',String(n.dataset.boardSize===selected.size));});
      root.querySelectorAll('[data-board-size-price]').forEach(n=>writePrice(n,priceFor(data,country,n.dataset.boardSizePrice),false,false));
      root.querySelectorAll('[data-board-crop]').forEach(n=>{if(document.activeElement!==n)n.value=String(selected[n.dataset.boardCrop]);});
      const number=new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:2});
      root.querySelector('[data-board-zoom]').textContent=selected.zoom+' %';root.querySelector('[data-board-orientation]').textContent=g?copy[g.orientation]+' · '+number.format(g.widthMm/10)+' × '+number.format(g.heightMm/10)+' cm':'';
      root.querySelector('[data-board-crop-note]').textContent=source?.complete&&!drawn?copy.image_error:copy.crop_note;
      writePrice(root.querySelector('[data-board-price]'),priceFor(data,country,selected.size));
      try{root.querySelector('[data-board-country]').textContent=new Intl.DisplayNames([document.documentElement.lang||'en'],{type:'region'}).of(country);}catch{}
      const value=JSON.stringify({country,...selected,priceCents:priceFor(data,country,selected.size)});
      if(root.dataset.boardSelection!==value){root.dataset.boardSelection=value;window.dispatchEvent(new CustomEvent('alpha:board-selection'));}
    }
    const save=()=>{try{sessionStorage.setItem(cropKey,JSON.stringify(selected));}catch{}schedule();};
    root.addEventListener('click',e=>{const size=e.target.closest('[data-board-size]');if(size){selected=normal({...selected,size:size.dataset.boardSize});save();}if(e.target.closest('[data-board-reset]')){selected=normal({size:selected.size});save();}},{signal:listeners.signal});
    root.addEventListener('input',e=>{if(e.target.matches('[data-board-crop]')){selected=normal({...selected,[e.target.dataset.boardCrop]:Number(e.target.value)});save();}},{signal:listeners.signal});
    source?.addEventListener('load',schedule,{signal:listeners.signal});source?.addEventListener('error',schedule,{signal:listeners.signal});stand?.addEventListener('load',schedule,{signal:listeners.signal});
    selector.querySelectorAll('.abo-source').forEach(n=>n.addEventListener('load',schedule,{signal:listeners.signal}));
    window.addEventListener('alpha:artwork-browse',schedule,{signal:listeners.signal});
    const setCountry=value=>{if(/^[A-Z]{2}$/.test(value||'')){country=value;schedule();}};
    window.addEventListener('alpha-art-print:country-change',e=>setCountry(e.detail?.country),{signal:listeners.signal});window.addEventListener('storage',e=>{if(e.key==='alpha-art-print-country')setCountry(e.newValue);},{signal:listeners.signal});
    window.addEventListener('pageshow',()=>{try{setCountry(localStorage.getItem('alpha-art-print-country'));}catch{}schedule();},{signal:listeners.signal});
    const grid=document.getElementById('ResultsList'),gridObserver=new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-alpha-product-card],li')||n.querySelector('[data-alpha-product-card]')))))schedule();});if(grid)gridObserver.observe(grid,{childList:true,subtree:true});
    dispose=()=>{stopped=true;listeners.abort();observer.disconnect();resizeObserver.disconnect();gridObserver.disconnect();cards.forEach((item,card)=>{item.scene.remove();item.price.remove();card.classList.remove('abo-card-ready','abo-card-preparing');});};schedule();
  }
  document.addEventListener('shopify:section:load',init);document.addEventListener('shopify:section:unload',()=>{if(!document.querySelector('[data-board-root]'))dispose();});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-book-checkout"] && !Shopify.designMode) return;
  try {
    (() => {
  function checkoutURL(value) {
    if(typeof value!=='string'||value.length>4096||/[\x00-\x20\\]/.test(value)) throw Error('checkout_uncertain');
    const url=new URL(value);
    if(url.protocol!=='https:'||!['alphachristianart.com','tspjgu-rf.myshopify.com'].includes(url.hostname)||url.username||url.password||(url.port&&url.port!=='443')||!/^\/(?:checkouts\/[A-Za-z0-9/_-]+|(?:[1-9]\d*\/)?invoices\/[A-Za-z0-9_-]+)$/.test(url.pathname)) throw Error('checkout_uncertain');
    return url.href;
  }
  function offerFor(result,country,size) {
    const offer=result?.offers?.[String(size)];
    if(result?.ordering_enabled!==true||result.country!==country||!offer||offer.currency!=='EUR'||!/^\d{1,3}\.\d{2}$/.test(offer.unit_price)||Number(offer.unit_price)<=0||Number(offer.unit_price)>750||offer.page_count!==({20:24,30:34,50:54,75:80,100:104})[size]) return null;
    return {unit_price:offer.unit_price,currency:offer.currency,page_count:offer.page_count};
  }
  async function purchase({api,client,composition,country,address,accepted,expected}) {
    if(accepted!==true||address.countryCode!==country) throw Error('invalid_delivery');
    const offer=offerFor(await api('purchase_options',{country}),country,composition.package);
    if(!offer||!expected||offer.unit_price!==expected.unit_price||offer.page_count!==expected.page_count) throw Error('offer_changed');
    const project=await client.prepare(composition);
    const result=await api('purchase',{project_id:project.id,revision:project.revision,country,shipping_address:address,accepted:true});
    return checkoutURL(result?.checkout_url);
  }
  if(typeof document==='undefined'){if(typeof module!=='undefined')module.exports={checkoutURL,offerFor,purchase};return;}
  if(window.__alphaBookCheckout)return;window.__alphaBookCheckout=true;
  document.querySelectorAll('[data-book-screen-preview]').forEach(dialog=>{
    const root=dialog.querySelector('[data-book-checkout]');if(!root)return;
    const form=root.querySelector('form'),country=form.elements.countryCode,button=root.querySelector('[data-purchase-submit]'),status=root.querySelector('[data-purchase-status]'),login=root.querySelector('[data-purchase-login]');
    let current=null;
    const tell=key=>{status.textContent=root.dataset[key];};
    const errorMessage=error=>{
      const needsLogin=['LOGIN_REQUIRED','unauthorized'].includes(error.message);
      login.hidden=!needsLogin;
      tell(needsLogin?'login':['checkout_uncertain','checkout_pending'].includes(error.message)?'uncertain':error.message==='ordering_unavailable'?'unavailable':'failed');
    };
    const lock=busy=>{root.querySelector('fieldset').disabled=busy;form.elements.accepted.disabled=busy;button.disabled=busy||!current?.offer||!form.elements.accepted.checked;};
    const reset=()=>{current?.abort.abort();current=null;form.reset();root.hidden=true;};
    dialog.addEventListener('close',reset);
    dialog.addEventListener('alpha:book-preview-invalid',reset);
    dialog.addEventListener('alpha:book-preview-ready',async event=>{
      current?.abort.abort();
      const state={abort:new AbortController(),composition:structuredClone(event.detail.composition),offer:null,csrf:null,busy:false,quoteId:0};current=state;
      const alive=()=>current===state&&!state.abort.signal.aborted;
      root.hidden=false;form.hidden=true;login.hidden=true;form.elements.accepted.checked=false;tell('loading');
      async function api(action,payload,retry=true) {
        const endpoint=new URL(root.dataset.endpoint,location.origin);if(endpoint.origin!==location.origin)throw Error('UNAVAILABLE');
        endpoint.searchParams.set('mode','books');endpoint.searchParams.set('action',action);
        const response=await fetch(endpoint,{method:payload===undefined?'GET':'POST',credentials:'same-origin',cache:'no-store',redirect:'error',signal:AbortSignal.any([state.abort.signal,AbortSignal.timeout(25000)]),headers:payload===undefined?{}:{'Content-Type':'application/json','X-Books-CSRF':state.csrf},...(payload===undefined?{}:{body:JSON.stringify(payload)})});
        const data=await response.json();
        if(!response.ok&&data.error==='INVALID_CSRF'&&retry&&action!=='session'){state.csrf=(await api('session')).csrf;return api(action,payload,false);}
        if(!response.ok)throw Error(data.error||'UNAVAILABLE');return data;
      }
      async function quote() {
        const id=++state.quoteId,destination=country.value;state.offer=null;lock(false);tell('loading');root.querySelector('[data-purchase-price]').textContent='';form.elements.accepted.checked=false;
        try{const result=await api('purchase_options',{country:destination});if(!alive()||id!==state.quoteId)return;state.offer=offerFor(result,destination,state.composition.package);if(!state.offer){tell('unavailable');return;}root.querySelector('[data-purchase-price]').textContent=`€${state.offer.unit_price} EUR`;status.textContent='';}
        catch(error){if(alive()&&id===state.quoteId)errorMessage(error);}
        finally{if(alive()&&id===state.quoteId)lock(false);}
      }
      country.onchange=quote;form.elements.accepted.onchange=()=>lock(state.busy);
      form.onsubmit=async event=>{
        event.preventDefault();if(!alive()||state.busy||!state.offer||!form.reportValidity())return;
        const address=Object.fromEntries(new FormData(form));delete address.accepted;
        state.busy=true;lock(true);tell('loading');
        try{
          const shared=window.alphaBookProjectClient;if(!shared||!navigator.locks)throw Error('UNAVAILABLE');
          const client=shared.createClient({api,read:()=>localStorage.getItem(shared.recordKey),write:value=>localStorage.setItem(shared.recordKey,value),uuid:()=>crypto.randomUUID()});
          const url=await navigator.locks.request(shared.recordKey,{signal:state.abort.signal},()=>purchase({api,client,composition:state.composition,country:address.countryCode,address,accepted:true,expected:state.offer}));
          if(alive())location.assign(url);
        }catch(error){if(alive()){errorMessage(error);state.offer=null;}}
        finally{if(alive()){state.busy=false;lock(false);}}
      };
      try{
        const catalog=JSON.parse(document.querySelector('[data-book-country-catalog]').textContent),names=new Intl.DisplayNames([document.documentElement.lang||'en'],{type:'region'});
        country.replaceChildren();
        for(const code of Object.keys(catalog.countries).filter(code=>/^[A-Z]{2}$/.test(code)).sort((a,b)=>names.of(a).localeCompare(names.of(b)))){const option=document.createElement('option');option.value=code;option.textContent=names.of(code);country.append(option);}
        let destination=root.dataset.country;try{destination=localStorage.getItem('alpha-art-print-country')||destination;}catch(_){}
        country.value=destination;
        if(!country.value){const option=document.createElement('option');option.value='';option.textContent=root.dataset.unavailable;country.prepend(option);country.value='';}
        state.csrf=(await api('session')).csrf;if(!alive())return;if(typeof state.csrf!=='string')throw Error('UNAVAILABLE');
        form.hidden=false;await quote();
      }catch(error){if(alive())errorMessage(error);}
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-book-country-pricing"] && !Shopify.designMode) return;
  try {
    (() => {
  const sizes = [20,30,50,75,100];
  function priceFor(catalog,country,size) {
    if(catalog?.currency !== 'EUR' || catalog?.coefficient !== '2.5' || !/^[A-Z]{2}$/.test(country) || !sizes.includes(Number(size))) return null;
    const value = catalog?.countries?.[country]?.[String(size)];
    return Number.isInteger(value) && value > 0 && value <= 75000 ? value : null;
  }
  if(typeof module !== 'undefined' && module.exports) {module.exports={priceFor};return;}
  function init() {
    const root = document.querySelector('[data-book-country-pricing]');
    if(!root || root.dataset.ready) return;
    root.dataset.ready='true';
    let catalog=null,country=root.dataset.defaultCountry;
    try {catalog=JSON.parse(root.querySelector('[data-book-country-catalog]').textContent);} catch(_) {}
    try {country=localStorage.getItem('alpha-art-print-country') || country;} catch(_) {}
    country=String(country || '').toUpperCase();
    function render() {
      document.querySelectorAll('[data-book-country-price]').forEach(node=>{
        const value=priceFor(catalog,country,node.dataset.bookCountryPrice);
        const key=country+':'+value;
        if(node.dataset.bookPriceKey===key) return;
        node.dataset.bookPriceKey=key;
        node.replaceChildren();
        if(value===null) {node.textContent=root.dataset.unavailable;return;}
        const money=document.createElement('strong');
        money.className='money';
        money.textContent=(value/100).toFixed(2)+' €';
        node.append(money);
      });
    }
    function change(value) {country=String(value || root.dataset.defaultCountry || '').toUpperCase();render();}
    window.addEventListener('alpha-art-print:country-change',event=>change(event.detail?.country));
    window.addEventListener('storage',event=>{if(event.key==='alpha-art-print-country') change(event.newValue);});
    window.addEventListener('pageshow',()=>{try {change(localStorage.getItem('alpha-art-print-country'));} catch(_) {render();}});
    document.addEventListener('shopify:section:load',render);
    render();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-book-screen-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  function validateBook(book) {
    if(!book||![20,30,50,75,100].includes(book.package)||!Array.isArray(book.artworks)||book.artworks.length!==book.package||new Set(book.artworks).size!==book.package) throw Error('INVALID');
    if(book.artworks.some(key=>typeof key!=='string'||key.length>255||!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(key))||!book.artworks.includes(book.cover)) throw Error('INVALID');
    for(const [text,limit] of [[book.title,100],[book.dedication,500]]) if(typeof text!=='string'||[...text].length>limit||/[\x00-\x09\x0b-\x1f]/.test(text)) throw Error('INVALID');
    return {package:book.package,artworks:[...book.artworks],cover:book.cover,title:book.title,dedication:book.dedication};
  }
  function plan(value) {
    const book=validateBook(value);
    const pages=[{kind:'front_cover',artwork:book.cover,text:book.title},{kind:'title',text:book.title},{kind:'dedication',text:book.dedication},...book.artworks.map(artwork=>({kind:'artwork',artwork}))];
    if((pages.length+1)%2) pages.push({kind:'blank'});
    pages.push({kind:'back_cover',text:'Christian Books · Alpha Christian Art'});
    return pages.map((page,index)=>({pdf_page:index+1,...page}));
  }
  function spread(page,total,single) {
    page=Math.max(1,Math.min(total,Math.trunc(page)||1));
    if(single||page===1||page===total) return [page];
    const first=page%2===0?page:page-1;
    return [first,first+1];
  }
  function showPageNumber(kind) {return kind!=='front_cover'&&kind!=='back_cover';}
  function previewImage(product,handle,origin) {
    if(product?.handle!==handle||typeof product.featured_image!=='string') throw Error('INVALID_IMAGE');
    const url=new URL(product.featured_image,origin);
    if(url.protocol!=='https:'||url.username||url.password||!(url.origin===origin||url.hostname==='cdn.shopify.com')) throw Error('INVALID_IMAGE');
    if(!/\.(png|jpe?g|webp|avif)(?:$)/i.test(url.pathname)) throw Error('INVALID_IMAGE');
    url.searchParams.delete('height');url.searchParams.delete('crop');url.searchParams.set('width','1200');
    return {src:url.href,title:typeof product.title==='string'?product.title.slice(0,500):handle};
  }
  async function resilientImage(asset,load,signal) {
    const smaller=new URL(asset.src);smaller.searchParams.set('width','900');
    const original=new URL(asset.src);original.searchParams.delete('width');
    let failure;
    for(const src of [asset.src,smaller.href,original.href]) {
      if(signal.aborted)throw Error('ABORTED');
      try {const dimensions=await load(src);if(signal.aborted)throw Error('ABORTED');return {...asset,src,...dimensions};}
      catch(error){failure=error;if(signal.aborted)throw Error('ABORTED');}
    }
    throw failure;
  }
  async function loadAll(keys,obtain,signal,progress) {
    let next=0,done=0,stopped=false;const results=new Map();
    async function worker() {
      while(!stopped&&next<keys.length) {
        if(signal.aborted) throw Error('ABORTED');
        const key=keys[next++];
        try {const value=await obtain(key);if(signal.aborted) throw Error('ABORTED');results.set(key,value);progress(++done,keys.length,key,value);}
        catch(error){stopped=true;error.artwork=key;throw error;}
      }
    }
    await Promise.all(Array.from({length:Math.min(3,keys.length)},worker));return results;
  }
  if(typeof document==='undefined') {if(typeof module!=='undefined')module.exports={validateBook,plan,spread,showPageNumber,previewImage,resilientImage,loadAll};return;}
  if(window.__alphaBookScreenPreview) return;
  window.__alphaBookScreenPreview=true;
  const cache=new Map();let current=null;
  document.addEventListener('alpha:book-screen-build',event=>{
    const dialog=document.querySelector('[data-book-screen-preview]');
    if(!dialog||current) return;
    let book,pages;try{book=validateBook(event.detail.composition);pages=plan(book);}catch(_){return;}
    const state={abort:null,assets:null,page:1,closed:false,complete:false,failed:false};current=state;
    const query=selector=>dialog.querySelector(selector),media=matchMedia('(max-width:650px)');
    const alive=()=>current===state&&!state.closed;
    const controls=query('[data-screen-controls]'),stage=query('[data-screen-stage]'),status=query('[data-screen-status]'),jump=query('[data-screen-jump]');
    const close=()=>dialog.close();
    query('[data-book-close]').onclick=close;
    stage.replaceChildren();stage.hidden=true;controls.hidden=true;jump.replaceChildren();query('[data-screen-retry]').hidden=true;
    for(const page of pages) {const option=document.createElement('option');option.value=page.pdf_page;option.textContent=`${page.pdf_page} / ${pages.length}`;jump.append(option);}
    function render() {
      if(!alive()||!state.assets) return;
      const shown=spread(state.page,pages.length,media.matches);stage.replaceChildren();
      stage.dataset.single=String(shown.length===1);
      for(const number of shown) {
        const page=pages[number-1],sheet=document.createElement('figure');sheet.className='absp__paper';sheet.dataset.kind=page.kind;
        sheet.setAttribute('aria-label',`${dialog.dataset.page} ${number}`);
        if(page.artwork) {
          const box=document.createElement('div');box.className='absp__image';
          const asset=state.assets.get(page.artwork),img=document.createElement('img');
          if(!asset) {
            box.textContent=dialog.dataset.loading;box.classList.add('absp__pending');box.setAttribute('aria-busy','true');
            sheet.append(box);
          } else {
          img.src=asset.src;img.alt=asset.title;img.width=asset.width;img.height=asset.height;img.draggable=false;
          img.onerror=()=>{if(alive()){status.textContent=dialog.dataset.failed;query('[data-screen-retry]').hidden=false;cache.delete(page.artwork);dialog.dispatchEvent(new Event('alpha:book-preview-invalid'));}};
          box.append(img);sheet.append(box);
          }
        }
        if(page.text) {const text=document.createElement('div');text.className='absp__text';text.textContent=page.text;sheet.append(text);}
        if(showPageNumber(page.kind)) {const numberLabel=document.createElement('figcaption');numberLabel.textContent=number;sheet.append(numberLabel);}
        stage.append(sheet);
      }
      query('[data-screen-prev]').disabled=shown[0]===1;
      query('[data-screen-next]').disabled=shown.at(-1)===pages.length;
      jump.value=String(state.page);stage.hidden=false;controls.hidden=false;
      status.textContent=state.failed?dialog.dataset.failed:state.complete?`${dialog.dataset.ready} · ${shown.join('–')} / ${pages.length}`:`${dialog.dataset.loading} ${state.assets.size} / ${book.package} · ${dialog.dataset.page} ${shown.join('–')} / ${pages.length}`;
    }
    function turn(delta) {const shown=spread(state.page,pages.length,media.matches);state.page=delta<0?Math.max(1,shown[0]-1):Math.min(pages.length,shown.at(-1)+1);render();}
    query('[data-screen-prev]').onclick=()=>turn(-1);query('[data-screen-next]').onclick=()=>turn(1);
    jump.onchange=()=>{state.page=Number(jump.value);render();};
    const keyboard=event=>{if(['INPUT','TEXTAREA','SELECT'].includes(event.target.tagName))return;if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();turn(event.key==='ArrowLeft'?-1:1);}};
    dialog.addEventListener('keydown',keyboard);media.addEventListener('change',render);
    async function prepare() {
      delete dialog.dataset.failedArtwork;delete dialog.dataset.failureReason;
      dialog.dispatchEvent(new Event('alpha:book-preview-invalid'));
      state.abort?.abort();const abort=new AbortController();state.abort=abort;state.assets=new Map();state.complete=false;state.failed=false;
      stage.hidden=true;controls.hidden=true;query('[data-screen-retry]').hidden=true;
      status.textContent=`${dialog.dataset.loading} 0 / ${book.package}`;
      const active=()=>alive()&&state.abort===abort&&!abort.signal.aborted;
      render();
      async function obtain(handle) {
        if(cache.has(handle)) return cache.get(handle);
        const root=new URL(dialog.dataset.root,location.origin);
        if(root.origin!==location.origin) throw Error('INVALID');
        if(!root.pathname.endsWith('/'))root.pathname+='/';
        const endpoint=new URL(`products/${handle}.js`,root);
        const response=await fetch(endpoint,{credentials:'same-origin',signal:AbortSignal.any([abort.signal,AbortSignal.timeout(20000)]),headers:{Accept:'application/json'}});
        if(!response.ok)throw Error('IMAGE_UNAVAILABLE');
        const sourceAsset=previewImage(await response.json(),handle,location.origin);
        const asset=await resilientImage(sourceAsset,src=>new Promise((resolve,reject)=>{
          const img=new Image();let settled=false;
          const finish=error=>{if(settled)return;settled=true;clearTimeout(timer);abort.signal.removeEventListener('abort',cancel);img.onload=null;img.onerror=null;if(error){img.src='';reject(error);}else{resolve({width:img.naturalWidth,height:img.naturalHeight});}};
          const cancel=()=>finish(Error('ABORTED'));
          const timer=setTimeout(()=>finish(Error('IMAGE_TIMEOUT')),20000);
          img.onload=()=>finish(img.naturalWidth&&img.naturalHeight?null:Error('INVALID_IMAGE'));img.onerror=()=>finish(Error('IMAGE_UNAVAILABLE'));
          abort.signal.addEventListener('abort',cancel,{once:true});if(abort.signal.aborted){cancel();return;}img.src=src;
        }),abort.signal);
        if(!active())throw Error('ABORTED');
        if(cache.size>=100)cache.delete(cache.keys().next().value);cache.set(handle,asset);return asset;
      }
      try {
        const ordered=[book.cover,...book.artworks.filter(key=>key!==book.cover)];
        const assets=await loadAll(ordered,obtain,abort.signal,(done,total,key,asset)=>{
          if(!active())return;
          state.assets.set(key,asset);
          if(spread(state.page,pages.length,media.matches).some(number=>pages[number-1].artwork===key))render();
          else status.textContent=`${dialog.dataset.loading} ${done} / ${total} · ${dialog.dataset.page} ${state.page} / ${pages.length}`;
        });
        if(active()){state.assets=assets;state.complete=true;render();dialog.dispatchEvent(new CustomEvent('alpha:book-preview-ready',{detail:{composition:book}}));}
      } catch(error) {if(active()){state.failed=true;dialog.dataset.failedArtwork=error.artwork||'';dialog.dataset.failureReason=error.message;abort.abort();render();query('[data-screen-retry]').hidden=false;}}
    }
    query('[data-screen-retry]').onclick=prepare;
    dialog.addEventListener('close',()=>{state.closed=true;state.abort?.abort();dialog.removeEventListener('keydown',keyboard);media.removeEventListener('change',render);stage.replaceChildren();if(current===state)current=null;},{once:true});
    dialog.showModal();prepare();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-book-selection"] && !Shopify.designMode) return;
  try {
    (() => {
  const key = 'alpha-book-selection-v1';
  const packages = [20,30,50,75,100];
  const valid = handle => typeof handle === 'string' && handle.length <= 255 && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle);
  function normalize(value) {
    const size = packages.includes(value?.size) ? value.size : 50;
    const handles = value?.handles ?? [];
    if (!Array.isArray(handles) || handles.length > 100 || handles.some(handle => !valid(handle))) throw new Error('invalid_selection');
    const unique = [...new Set(handles)];
    if (unique.length > size) throw new Error('invalid_selection');
    const cover = value?.cover ?? null;
    if (cover !== null && !unique.includes(cover)) throw new Error('invalid_cover');
    const title = value?.title ?? '', dedication = value?.dedication ?? '';
    for (const [text, limit] of [[title,100],[dedication,500]]) {
      if (typeof text !== 'string' || [...text].length > limit || /[\x00-\x09\x0b-\x1f]/.test(text)) throw new Error('invalid_text');
    }
    return {size, handles:unique, cover, title, dedication};
  }
  function select(value, handle) {
    const draft = normalize(value);
    if (!valid(handle)) throw new Error('invalid_artwork');
    if (draft.handles.includes(handle)) return draft;
    if (draft.handles.length >= draft.size) throw new Error('book_full');
    return {...draft, handles:[...draft.handles, handle]};
  }
  function resize(value, size) {
    const draft = normalize(value);
    if (!packages.includes(size)) throw new Error('invalid_package');
    if (draft.handles.length > size) throw new Error('remove_artworks_first');
    return {...draft, size};
  }
  function remove(value, handle) {
    const draft = normalize(value);
    return {...draft, handles:draft.handles.filter(item => item !== handle), cover:draft.cover === handle ? null : draft.cover};
  }
  function move(value, handle, delta) {
    const draft = normalize(value), index = draft.handles.indexOf(handle), target = index + delta;
    if (![1,-1].includes(delta) || index < 0 || target < 0 || target >= draft.handles.length) return draft;
    [draft.handles[index], draft.handles[target]] = [draft.handles[target], draft.handles[index]];
    return draft;
  }
  function personalize(value, changes) {
    if (Object.keys(changes).some(key => !['cover','title','dedication'].includes(key))) throw new Error('invalid_text');
    return normalize({...normalize(value), ...changes});
  }
  function composition(value) {
    const draft = normalize(value);
    return {package:draft.size, artworks:draft.handles, cover:draft.cover || draft.handles[0] || null, title:draft.title, dedication:draft.dedication};
  }
  function build(value, defaultTitle = 'My Christian Art Book') {
    const book = composition(value);
    if (book.artworks.length !== book.package) throw new Error('book_incomplete');
    if (!book.title) book.title = defaultTitle;
    const pages = [
      {kind:'front_cover', artwork:book.cover, text:book.title},
      {kind:'title', text:book.title},
      {kind:'dedication', text:book.dedication},
      ...book.artworks.map(artwork => ({kind:'artwork', artwork}))
    ];
    if ((pages.length + 1) % 2) pages.push({kind:'blank'});
    pages.push({kind:'back_cover', text:'Christian Books · Alpha Christian Art'});
    return {composition:book, pages:pages.map((page,index) => ({pdf_page:index + 1, ...page}))};
  }
  if (typeof document === 'undefined') {
    if (typeof module !== 'undefined') module.exports = {key, normalize, select, resize, remove, move, personalize, composition, build};
    return;
  }
  if (window.__alphaBookSelection) return;
  window.__alphaBookSelection = true;
  const panel = () => document.querySelector('[data-book-selection]');
  const names = new Map();
  const images = new Map();
  let draft = normalize(null), available = false, notice = 'saved';
  function read() {const raw = localStorage.getItem(key); return normalize(raw === null ? null : JSON.parse(raw));}
  function render() {
    const root = panel(); if (!root) return;
    root.hidden = document.body.dataset.artworkBrowse !== 'book';
    const floating = document.querySelector('[data-book-floating]');
    if (floating) {
      floating.hidden = root.hidden;
      floating.querySelectorAll('[data-book-price-size]').forEach(item => { item.hidden = Number(item.dataset.bookPriceSize) !== draft.size; });
      floating.querySelector('[data-book-floating-count]').textContent = `${draft.handles.length} / ${draft.size} ${root.dataset.countLabel}`;
      floating.querySelector('[data-book-floating-pages]').textContent = `${draft.size + (draft.size % 2 ? 5 : 4)} ${root.dataset.pageLabel}`;
    }
    root.querySelector('[data-book-count]').textContent = `${draft.handles.length} / ${draft.size}`;
    const previewDisabled = root.dataset.screenPreviewEnabled !== 'true' || !available || draft.handles.length !== draft.size;
    root.querySelector('[data-book-build]').disabled = previewDisabled;
    if(floating) floating.querySelector('[data-book-floating-preview]').disabled = previewDisabled;
    root.querySelector('[data-book-message]').textContent = root.dataset[available ? notice : 'storage'];
    root.querySelectorAll('[data-book-text]').forEach(input => {
      if (document.activeElement !== input) input.value = draft[input.dataset.bookText];
      input.disabled = !available;
    });
    document.querySelectorAll('[data-book-artwork]').forEach(button => {
      button.hidden = root.hidden;
      const selected = draft.handles.includes(button.dataset.bookArtwork);
      const label = root.dataset[selected ? 'remove' : 'add'];
      if (button.textContent !== label) button.textContent = label;
      button.setAttribute('aria-pressed', String(selected));
      button.disabled = root.hidden || !available || (!selected && draft.handles.length >= draft.size);
    });
    const list = root.querySelector('[data-book-list]'); list.replaceChildren();
    draft.handles.forEach((handle, index) => {
      const row = document.createElement('li'), title = document.createElement('span'), button = document.createElement('button');
      title.textContent = names.get(handle) || handle.replaceAll('-', ' ');
      button.type = 'button'; button.dataset.bookRemove = handle; button.textContent = root.dataset.remove;
      button.setAttribute('aria-label', root.dataset.remove + ' — ' + title.textContent);
      button.disabled = !available; row.append(title);
      for (const kind of ['up','down','cover']) {
        const control = document.createElement('button'); control.type = 'button';
        control.dataset.bookAction = kind; control.dataset.bookHandle = handle; control.textContent = root.dataset[kind];
        control.setAttribute('aria-label', root.dataset[kind] + ' — ' + title.textContent);
        if (kind === 'cover') control.setAttribute('aria-pressed', String(composition(draft).cover === handle));
        control.disabled = !available || kind === 'up' && index === 0 || kind === 'down' && index === draft.handles.length - 1;
        row.append(control);
      }
      row.append(button); list.append(row);
    });
  }
  function commit(change) {
    try {const next = change(read()); localStorage.setItem(key, JSON.stringify(next)); draft = next; available = true; notice = 'saved'; panel()?.querySelector('[data-book-preview]')?.close(); render(); return true;}
    catch (error) {notice = error.message === 'book_full' ? 'full' : error.message === 'remove_artworks_first' ? 'smaller' : ['invalid_text','invalid_cover'].includes(error.message) ? 'invalid' : 'storage'; render(); return false;}
  }
  function decorate() {
    if (!panel()) return;
    document.querySelectorAll('[data-credit-add]').forEach(button => {
      let url; try {url = new URL(button.dataset.url, location.href);} catch (_) {return;}
      if (url.origin !== location.origin) return;
      const handle = url.pathname.match(/\/products\/([^/]+)\/?$/)?.[1]; if (!valid(handle)) return;
      if (button.dataset.title) names.set(handle, button.dataset.title.slice(0,500));
      const src = safeImage(button.dataset.image); if (src) images.set(handle, src);
    });
    document.querySelectorAll('[data-alpha-product-card]').forEach(card => {
      if (card.querySelector('[data-book-artwork]') || !card.querySelector('[data-credit-add]')) return;
      const content = card.querySelector('.alpha-product-card__content'); if (!content || !card.dataset.alphaProductUrl) return;
      let url; try {url = new URL(card.dataset.alphaProductUrl, location.href);} catch (_) {return;}
      if (url.origin !== location.origin) return;
      const handle = url.pathname.match(/\/products\/([^/]+)\/?$/)?.[1]; if (!valid(handle)) return;
      const title = card.querySelector('.alpha-product-card__title');
      if (title?.textContent.trim()) names.set(handle, title.textContent.trim().slice(0,500));
      const button = document.createElement('button'); button.type = 'button'; button.hidden = true; button.dataset.bookArtwork = handle; button.className = 'artwork-credit-add abs__add'; content.append(button);
    });
    render();
  }
  function load() {
    panel()?.querySelector('[data-book-preview]')?.close();
    try {draft = read(); available = true; notice = 'saved';} catch (_) {available = false;}
    decorate();
  }
  window.addEventListener('alpha:book-package', event => {if (!commit(value => resize(value, event.detail.size))) event.preventDefault();});
  function syncMode() {
    if (document.body.dataset.artworkBrowse === 'book') {
      const size = Number((document.body.dataset.artworkFinish || '').slice(8));
      if (packages.includes(size) && size !== draft.size && !commit(value => resize(value, size))) {
        window.dispatchEvent(new CustomEvent('alpha:book-restore', {detail:{size:draft.size}}));
      }
    }
    render();
  }
  window.addEventListener('alpha:artwork-browse', syncMode);
  window.addEventListener('storage', event => {
    if (event.key === key || event.key === null) {load(); window.dispatchEvent(new CustomEvent('alpha:book-restore', {detail:{size:draft.size}}));}
  });
  window.addEventListener('pageshow', load);
  function safeImage(value) {
    if (!value) return null;
    try {const url = new URL(value, location.href); return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com') ? url.href : null;} catch (_) {return null;}
  }
  function openPreview() {
    const root=panel();
    if (root.dataset.screenPreviewEnabled !== 'true') return;
    try {
      draft=read();
      const result=build(draft,root.dataset.defaultTitle);
      document.dispatchEvent(new CustomEvent('alpha:book-screen-build',{detail:{composition:result.composition}}));
    } catch (_) {notice='incomplete';render();}
  }
  document.addEventListener('input', event => {
    if (event.isComposing) return;
    const input = event.target.closest('[data-book-text]');
    if (input) commit(value => personalize(value, {[input.dataset.bookText]:input.value}));
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-book-build]')) {event.preventDefault(); openPreview(); return;}
    if (event.target.closest('[data-book-close]')) {panel().querySelector('[data-book-preview]').close(); return;}
    const control = event.target.closest('[data-book-action]');
    if (control && !control.disabled) {
      const handle = control.dataset.bookHandle, kind = control.dataset.bookAction;
      if (commit(value => kind === 'cover' ? personalize(value,{cover:handle}) : move(value,handle,kind === 'up' ? -1 : 1))) {
        const next = [...panel().querySelectorAll('[data-book-action]')].find(button => button.dataset.bookHandle === handle && button.dataset.bookAction === kind && !button.disabled);
        (next || panel().querySelector('summary')).focus();
      }
      return;
    }
    const button = event.target.closest('[data-book-artwork], [data-book-remove]'); if (!button || button.disabled) return;
    if (document.body.dataset.artworkBrowse !== 'book') return;
    event.preventDefault(); event.stopPropagation();
    const handle = button.dataset.bookArtwork || button.dataset.bookRemove;
    const removing = button.hasAttribute('data-book-remove');
    if (commit(value => removing || value.handles.includes(handle) ? remove(value, handle) : select(value, handle)) && removing) panel().querySelector('summary').focus();
  });
  function init() {
    load();
    syncMode();
    document.querySelectorAll('[data-book-build], [data-book-floating-preview]').forEach(button => {
      button.onclick = event => {event.preventDefault();event.stopPropagation();if(!button.disabled)openPreview();};
    });
    const review = document.querySelector('[data-book-review]');
    if (review) review.onclick = event => {
      event.preventDefault(); event.stopPropagation();
      const details = panel().querySelector('details');
      details.open = true;
      details.scrollIntoView({block:'center',behavior:'auto'});
      details.querySelector('summary').focus({preventScroll:true});
    };
    const grid = document.getElementById('ResultsList');
    if (grid && !grid.dataset.bookObserved) {
      grid.dataset.bookObserved = 'true';
      new MutationObserver(records => {
        if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-alpha-product-card]') || node.querySelector('[data-alpha-product-card]'))))) decorate();
      }).observe(grid, {childList:true, subtree:true});
    }
  }
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-book-service"] && !Shopify.designMode) return;
  try {
    (() => {
  const recordKey='alpha-book-project-v1';
  const canonical=value=>JSON.stringify(value,Object.keys(value).sort());
  function createClient({api,read,write,uuid}) {
    return {async prepare(composition) {
      const raw=read(); let record;
      if(raw!==null) {
        record=JSON.parse(raw);
        if(!record||typeof record.key!=='string'||!record.composition||
          (record.id!==null&&(!/^[A-Za-z0-9_-]{24}$/.test(record.id)||!Number.isInteger(record.revision)))) throw Error('CONFLICT');
      } else {
        record={key:uuid(),id:null,revision:null,composition};
        write(JSON.stringify(record));
      }
      let project;
      if(record.id===null) {
        project=await api('compose',{request_key:record.key,selection:record.composition});
        if(!project||!/^[A-Za-z0-9_-]{24}$/.test(project.id)||!Number.isInteger(project.revision)||canonical(project.composition)!==canonical(record.composition)) throw Error('CONFLICT');
        if(canonical(project.composition)!==canonical(composition)) {
          record={key:record.key,id:project.id,revision:project.revision,composition:project.composition};
          write(JSON.stringify(record));
        }
      } else {
        project=await api('project',{project_id:record.id});
      }
      if(!project||!/^[A-Za-z0-9_-]{24}$/.test(project.id)||!Number.isInteger(project.revision)||(record.id!==null&&project.id!==record.id)) throw Error('CONFLICT');
      if(canonical(project.composition)!==canonical(composition)) {
        if(project.revision!==record.revision) throw Error('CONFLICT');
        project=await api('save',{project_id:record.id,revision:record.revision,composition});
      }
      if(!project||!/^[A-Za-z0-9_-]{24}$/.test(project.id)||!Number.isInteger(project.revision)||(record.id!==null&&project.id!==record.id)||canonical(project.composition)!==canonical(composition)) throw Error('CONFLICT');
      write(JSON.stringify({key:record.key,id:project.id,revision:project.revision,composition:project.composition}));
      return project;
    }};
  }
  if(typeof document==='undefined') {if(typeof module!=='undefined') module.exports={createClient,recordKey};return;}
  if(window.__alphaBookService) return;
  window.__alphaBookService=true;
  window.alphaBookProjectClient={createClient,recordKey};
  let current=null;
  document.addEventListener('alpha:book-build',async event=>{
    if(document.querySelector('[data-book-selection]')?.dataset.generationEnabled!=='true') return;
    const dialog=document.querySelector('[data-book-service]');if(!dialog||current) return;
    const state={abort:new AbortController(),project:null,proof:null,page:0,viewed:new Set(),imageURL:null,busy:false};
    current=state;
    const query=selector=>dialog.querySelector(selector);
    const message=key=>{query('[data-proof-message]').textContent=dialog.dataset[key];};
    query('[data-proof-login]').hidden=true;
    ['[data-proof-sheet]','[data-proof-controls]','[data-proof-confirm]','[data-proof-approve]'].forEach(selector=>query(selector).hidden=true);
    query('[data-proof-accepted]').checked=false;
    query('[data-proof-approve]').disabled=true;
    dialog.showModal();message('waiting');
    const alive=()=>current===state&&!state.abort.signal.aborted;
    const fail=error=>{
      if(!alive()) return;
      const codes=['UNAVAILABLE','LOGIN_REQUIRED','INVALID_CSRF','INVALID_REQUEST','RATE_LIMITED','CONFLICT','unknown_artwork','invalid_composition','invalid_request_key','unauthorized'];
      query('[data-proof-message]').dataset.failure = `${state.action || 'client'}:${state.status || 0}:${codes.includes(error.message)?error.message:'INVALID_RESPONSE'}`;
      const login=['LOGIN_REQUIRED','unauthorized'].includes(error.message);
      query('[data-proof-login]').hidden=!login;
      message(login?'login':['CONFLICT','conflict','composition_conflict','stale_preview','not_found'].includes(error.message)?'conflict':'failed');
    };
    let csrf;
    async function api(action,payload,retry=true) {
      const endpoint=new URL(dialog.dataset.endpoint,location.origin);
      if(endpoint.origin!==location.origin) throw Error('UNAVAILABLE');
      endpoint.searchParams.set('mode','books');endpoint.searchParams.set('action',action);
      state.action=action;state.status=0;
      const response=await fetch(endpoint,{method:payload===undefined?'GET':'POST',credentials:'same-origin',cache:'no-store',signal:AbortSignal.any([state.abort.signal,AbortSignal.timeout(25000)]),
        headers:payload===undefined?{}:{'Content-Type':'application/json','X-Books-CSRF':csrf},...(payload===undefined?{}:{body:JSON.stringify(payload)})});
      state.status=response.status;
      if(action==='proof_page'&&response.ok&&response.headers.get('content-type')==='image/png') return response.blob();
      const data=await response.json();
      if(!response.ok&&data.error==='INVALID_CSRF'&&retry&&action!=='session') {csrf=(await api('session')).csrf;return api(action,payload,false);}
      if(!response.ok) throw Error(data.error||'UNAVAILABLE');
      return data;
    }
    function controls() {
      query('[data-proof-prev]').disabled=state.busy||state.page<=1;
      query('[data-proof-next]').disabled=state.busy||state.page>=state.proof.pages.length;
      query('[data-proof-approve]').disabled=state.busy||state.viewed.size!==state.proof.pages.length||!query('[data-proof-accepted]').checked;
    }
    async function page(number) {
      if(!alive()||state.busy) return;
      state.busy=true;controls();
      try {
        const blob=await api('proof_page',{project_id:state.project.id,proof_id:state.proof.id,page:number});
        if(!alive()) return;
        if(!(blob instanceof Blob)||blob.type!=='image/png') throw Error('UNAVAILABLE');
        const src=URL.createObjectURL(blob),img=query('[data-proof-image]');
        try {img.src=src;await img.decode();if(!alive()) {URL.revokeObjectURL(src);return;}}
        catch(error){URL.revokeObjectURL(src);throw error;}
        if(state.imageURL) URL.revokeObjectURL(state.imageURL);
        state.imageURL=src;state.page=number;state.viewed.add(number);
        query('[data-proof-page]').textContent=`${number} / ${state.proof.pages.length}`;
        query('[data-proof-sheet]').hidden=false;
      } catch(error){fail(error);}
      finally{state.busy=false;if(alive()) controls();}
    }
    query('[data-proof-prev]').onclick=()=>page(state.page-1);
    query('[data-proof-next]').onclick=()=>page(state.page+1);
    query('[data-proof-accepted]').onchange=controls;
    query('[data-proof-approve]').onclick=async()=>{
      if(state.busy||state.viewed.size!==state.proof.pages.length||!query('[data-proof-accepted]').checked) return;
      state.busy=true;controls();
      try {await api('approve',{project_id:state.project.id,proof_id:state.proof.id,revision:state.proof.revision,preview_token:state.proof.preview_token,accepted:true});if(alive()){message('approved');query('[data-proof-approve]').hidden=true;query('[data-proof-confirm]').hidden=true;}}
      catch(error){fail(error);}finally{state.busy=false;if(alive()) controls();}
    };
    dialog.addEventListener('close',()=>{state.abort.abort();if(state.imageURL) URL.revokeObjectURL(state.imageURL);if(current===state)current=null;},{once:true});
    try {
      csrf=(await api('session')).csrf;
      if(typeof csrf!=='string'||!navigator.locks) throw Error('UNAVAILABLE');
      const client=createClient({api,read:()=>localStorage.getItem(recordKey),write:value=>localStorage.setItem(recordKey,value),uuid:()=>crypto.randomUUID()});
      state.project=await navigator.locks.request(recordKey,{signal:state.abort.signal},()=>client.prepare(event.detail.composition));
      if(!alive())return;
      state.proof=await api('proof',{project_id:state.project.id});
      while(alive()&&['queued','rendering'].includes(state.proof.state)) {
        await new Promise(resolve=>{const timer=setTimeout(done,2000);function done(){clearTimeout(timer);state.abort.signal.removeEventListener('abort',done);resolve();}state.abort.signal.addEventListener('abort',done,{once:true});});
        if(!alive())return;
        state.proof=await api('proof_status',{project_id:state.project.id,proof_id:state.proof.id});
      }
      if(!alive())return;
      if(state.proof.state!=='ready'||state.proof.revision!==state.project.revision||!Array.isArray(state.proof.pages)||state.proof.pages.length<1||state.proof.pages.length>104) throw Error('UNAVAILABLE');
      query('[data-proof-message]').textContent='';
      ['[data-proof-controls]','[data-proof-confirm]','[data-proof-approve]'].forEach(selector=>query(selector).hidden=false);
      await page(1);
    }catch(error){fail(error);}
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-browse-type-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  const choices = {
    canvas: { family: 'canvas', finishes: { stretched: 'stretched-canvas', floating: 'framed-canvas', rolled: 'rolled-canvas' } },
    print: { family: 'fine-art', finishes: { unframed: 'fine-art-german-etching', poster: 'budget-poster', budgetframe: 'budget-framed-poster', classic: 'classic-framed-print', hanger: 'art-print-with-hanger', dibond: 'dibond-print', acrylic: 'acrylic-print' } },
    oil: { family: 'oil-painting', finishes: { rolled: 'hand-painted-oil' } },
    digital: { family: 'digital', finishes: { files: null } },
    phone: { family: 'phone-case', finishes: { snap: 'snap-case', tough: 'tough-case', clear: 'clear-case' } },
    mug: { family: 'mug', finishes: { ceramic: 'ceramic-mug' } },
    board: { family: 'gallery-board', finishes: { oak: 'gallery-board-stand' } },
    book: { family: 'book', finishes: { artworks50: null, artworks20: null, artworks30: null, artworks75: null, artworks100: null } }
  };
  const storageKey = 'alpha-artwork-browse-v1';
  const normalize = value => {
    const validType = value && typeof value.type === 'string' && Object.hasOwn(choices, value.type);
    const type = validType ? value.type : 'canvas';
    const finishes = choices[type].finishes;
    const requested = !validType ? null : type === 'print' && value?.finish === 'foil' ? 'dibond' : type === 'print' && value?.finish === 'box' ? 'classic' : value?.finish;
    const finish = typeof requested === 'string' && Object.hasOwn(finishes, requested) ? requested : Object.keys(finishes)[0];
    // Retired offer: migrate old white-mount links and saved choices to the classic frame.
    return { type, finish, mount: 'none' };
  };
  const supportFor = value => {
    const valid = normalize(value);
    return choices[valid.type].finishes[valid.finish];
  };
  const preferenceForSelection = (family, support) => {
    const type = Object.keys(choices).find(key => choices[key].family === family);
    if (!type) return null;
    if (type === 'print' && support === 'classic-mounted-print') return normalize({ type, finish: 'classic' });
    if (type === 'print' && support === 'box-framed-print') return normalize({ type, finish: 'box' });
    if (type === 'canvas' && support === 'rolled-canvas') return normalize({ type, finish: 'rolled' });
    const finish = Object.keys(choices[type].finishes).find(key => choices[type].finishes[key] === (type === 'digital' ? null : support));
    return finish ? normalize({ type, finish }) : null;
  };
  // Pure helpers also allow local tests without connecting to Shopify.
  const preferenceFrom = (url, stored) => normalize(url.searchParams.has('art_type') ? {
    type: url.searchParams.get('art_type'), finish: url.searchParams.get('art_finish'), mount: url.searchParams.get('art_mount')
  } : stored);
  const preferenceURL = (url, value) => {
    const result = new URL(url);
    const valid = normalize(value);
    result.searchParams.set('art_type', valid.type);
    result.searchParams.set('art_finish', valid.finish);
    if(valid.finish === 'dibond' && /^#Foil/.test(result.hash)) result.hash = result.hash.replace('#Foil', '#Dibond');
    if (valid.type === 'print' && valid.finish === 'classic') result.searchParams.set('art_mount', valid.mount);
    else result.searchParams.delete('art_mount');
    return result;
  };
  if (typeof document === 'undefined') {
    if (typeof module !== 'undefined') module.exports = { choices, normalize, preferenceFrom, preferenceURL, supportFor, preferenceForSelection };
    return;
  }
  let activeSession = null;
  function init() {
    const selector = document.querySelector('[data-alpha-browse-type]');
    if (activeSession?.selector === selector) return;
    activeSession?.dispose();
    if (!selector) return;
    selector.dataset.initialized = 'true';
    const controls = selector.querySelector('[data-browse-controls]');
    const status = selector.querySelector('[data-browse-status]');
    const isProduct = Boolean(document.querySelector('[data-aam-pod-product]'));
    const mountedRoot = selector.dataset.mountedQa === 'true' ? document.querySelector('[data-alpha-mounted-offer]') : null;
    let stored;
    try { stored = JSON.parse(localStorage.getItem(storageKey)); } catch (_) { /* Storage is optional. */ }
    let preference = preferenceFrom(new URL(location.href), stored);
    let config = null;
    let pending = isProduct;
    let applying = false;
    let observer = null;
    let gridObserver = null;
    let timer = null;
    let scheduled = false;
    let disposed = false;
    const listeners = new AbortController();
    const session = {
      selector,
      belongsTo: section => section.contains(selector) || Boolean(config && section.contains(config)),
      dispose() {
        disposed = true;
        listeners.abort();
        observer?.disconnect();
        gridObserver?.disconnect();
        if (timer !== null) clearInterval(timer);
        delete selector.dataset.initialized;
        controls.disabled = true;
        if (activeSession === session) activeSession = null;
      }
    };
    activeSession = session;
    window.addEventListener('alpha:book-restore', event => {
      if (preference.type !== 'book') return;
      preference = normalize({type:'book', finish:'artworks' + event.detail.size});
      persist(); render();
    }, {signal:listeners.signal});
    const setStatus = key => {
      const text = selector.dataset[key] || '';
      if (status.textContent !== text) status.textContent = text;
    };
    function persist() {
      try { localStorage.setItem(storageKey, JSON.stringify(preference)); } catch (_) { /* URL remains the fallback. */ }
      const url = preferenceURL(location.href, preference);
      if (url.href !== location.href) history.replaceState(history.state, '', url);
    }
    function render() {
      document.body.dataset.artworkBrowse = preference.type;
      document.body.dataset.artworkFinish = preference.finish;
      document.body.dataset.artworkMount = preference.mount;
      selector.querySelectorAll('input[data-browse-type]').forEach(input => { input.checked = input.value === preference.type; });
      selector.querySelectorAll('[data-browse-for]').forEach(group => {
        group.hidden = group.dataset.browseFor !== preference.type;
        if (!group.hidden) group.querySelectorAll('input[data-browse-presentation]').forEach(input => {
          input.checked = input.value === preference.finish && (input.dataset.browseMount || 'none') === preference.mount;
        });
      });
      if (!isProduct) {
        // A collection cannot verify a mounted supplier variant. Keep it closed until product support exists.
        const whiteMount = selector.querySelector('[data-browse-mount="white"]');
        const mountStatus = selector.querySelector('[data-browse-mount-status]');
        const canBrowseMounted = selector.dataset.mountedQa === 'true';
        if (whiteMount) whiteMount.disabled = !canBrowseMounted;
        const mountBadge = selector.querySelector('[data-browse-mount-badge]');
        if (mountBadge) mountBadge.hidden = canBrowseMounted;
        if (mountStatus) mountStatus.hidden = canBrowseMounted || preference.type !== 'print';
        setStatus(preference.mount === 'white' && !canBrowseMounted ? 'statusMountPending' : preference.type === 'digital' ? 'statusDigital' : 'statusCollection');
      }
      window.dispatchEvent(new CustomEvent('alpha:artwork-browse', { detail: preference }));
    }
    function active(name) {
      return config.querySelector('[data-' + name + '][aria-pressed="true"]');
    }
    function availability() {
      if (mountedRoot) {
        const white = selector.querySelector('[data-browse-mount="white"]');
        if (white) white.disabled = mountedRoot.dataset.mountedAvailable !== 'true';
        const badge = selector.querySelector('[data-browse-mount-badge]');
        if (badge) badge.hidden = !white?.disabled;
        const note = selector.querySelector('[data-browse-mount-status]');
        if (note) note.hidden = preference.type !== 'print' || !white?.disabled;
      }
      if (!config || config.getAttribute('aria-busy') === 'true' || !config.querySelector('[data-family]')) return;
      selector.querySelectorAll('input[data-browse-type]').forEach(input => {
        if (['phone','mug','board','book'].includes(input.value)) { input.disabled = false; return; }
        const button = config.querySelector('[data-family="' + choices[input.value].family + '"]');
        input.disabled = !button || button.disabled;
      });
      const family = active('family');
      if (!family || family.dataset.family !== choices[preference.type].family) return;
      const group = selector.querySelector('[data-browse-for="' + preference.type + '"]');
      group.querySelectorAll('input[data-browse-presentation]').forEach(input => {
        if (['hanger','dibond','acrylic','poster','budgetframe'].includes(input.value)) { input.disabled = false; return; }
        if (mountedRoot && input.dataset.browseMount === 'white') return;
        const support = supportFor({ type: preference.type, finish: input.value, mount: input.dataset.browseMount });
        const button = support && config.querySelector('[data-support="' + support + '"]');
        input.disabled = Boolean(support && (!button || button.disabled));
      });
      const mountStatus = selector.querySelector('[data-browse-mount-status]');
      const whiteMount = selector.querySelector('[data-browse-mount="white"]');
      const mountBadge = selector.querySelector('[data-browse-mount-badge]');
      if (!mountedRoot && mountStatus) mountStatus.hidden = preference.type !== 'print' || !whiteMount?.disabled;
      if (!mountedRoot && mountBadge) mountBadge.hidden = !whiteMount?.disabled;
    }
    function bridge() {
      if (!config || !pending || applying) return;
      if (['phone','mug','board','book'].includes(preference.type)) {
        config.dataset.abtBridge = 'unavailable';
        pending = false;
        availability();
        setStatus(preference.type === 'book' ? 'statusBook' : preference.type === 'board' ? 'statusBoard' : preference.type === 'mug' ? 'statusMug' : 'statusPhone');
        return;
      }
      if (config.getAttribute('aria-busy') === 'true') return;
      if (preference.type === 'print' && ['hanger','dibond','acrylic','poster','budgetframe'].includes(preference.finish)) {
        config.dataset.abtBridge = 'unavailable';
        pending = false;
        availability();
        setStatus(preference.finish === 'budgetframe' ? 'statusBudgetframePreview' : preference.finish === 'poster' ? 'statusPosterPreview' : preference.finish === 'acrylic' ? 'statusAcrylicPreview' : preference.finish === 'dibond' ? 'statusDibondPreview' : 'statusHangerPreview');
        return;
      }
      if (mountedRoot && preference.mount === 'white') {
        const mountedState = mountedRoot.dataset.mountedState;
        config.dataset.abtBridge = 'unavailable';
        pending = false;
        availability();
        setStatus(mountedState === 'ready' ? 'statusReady' : mountedState === 'loading' ? 'statusLoading' : 'statusMountUnavailable');
        return;
      }
      const family = config.querySelector('[data-family="' + choices[preference.type].family + '"]');
      if (!config.querySelector('[data-family]')) {
        if (config.getAttribute('aria-busy') === 'false') {
          config.dataset.abtBridge = 'unavailable'; pending = false; setStatus('statusUnavailable');
        }
        return;
      }
      applying = true;
      if (family && !family.disabled && family.getAttribute('aria-pressed') !== 'true') family.click();
      const supportId = supportFor(preference);
      const support = supportId && config.querySelector('[data-support="' + supportId + '"]');
      if (family && support && !support.disabled && support.getAttribute('aria-pressed') !== 'true') support.click();
      const selectedFamily = active('family');
      const selectedSupport = active('support');
      const checkout = config.querySelector('[data-aap-checkout]');
      const summary = config.querySelector('[data-aap-summary]');
      const priceCard = config.querySelector('[data-aap-price-card]');
      const physicalReady = checkout && !checkout.disabled && summary && !summary.hidden && priceCard && !priceCard.hidden;
      const matches = family && !family.disabled && selectedFamily && selectedFamily.dataset.family === choices[preference.type].family &&
        (!supportId || support && !support.disabled && selectedSupport && selectedSupport.dataset.support === supportId && physicalReady);
      config.dataset.abtBridge = matches ? 'ready' : 'unavailable';
      pending = false;
      applying = false;
      availability();
      setStatus(matches ? preference.type === 'digital' ? 'statusDigital' : 'statusReady' : preference.mount === 'white' ? 'statusMountUnavailable' : 'statusUnavailable');
    }
    function scheduleBridge() {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(() => { scheduled = false; if (!disposed) { bridge(); availability(); } });
    }
    function attach() {
      config = document.querySelector('[data-aap-root]');
      if (!config) return false;
      config.dataset.abtBridge = 'loading';
      config.addEventListener('click', event => {
        if (config.dataset.abtBridge !== 'ready' && event.target.closest('[data-aap-checkout], [data-credit-physical]')) {
          event.preventDefault(); event.stopImmediatePropagation(); setStatus(preference.mount === 'white' ? 'statusMountUnavailable' : 'statusUnavailable');
        }
      }, { capture: true, signal: listeners.signal });
      observer = new MutationObserver(records => {
        // A country reload rebuilds the option buttons. Never observe the whole page.
        if (records.some(record => record.target === config && record.attributeName === 'aria-busy')) {
          pending = true;
          if (config.getAttribute('aria-busy') === 'true') {
            config.dataset.abtBridge = 'loading';
            setStatus('statusLoading');
          }
        }
        scheduleBridge();
      });
      observer.observe(config, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-busy'] });
      config.addEventListener('click', event => {
        if (applying || !event.target.closest('[data-family], [data-support]')) return;
        queueMicrotask(() => {
          if (disposed) return;
          const family = active('family');
          const support = active('support');
          const selected = preferenceForSelection(family?.dataset.family, support?.dataset.support);
          if (!selected) { config.dataset.abtBridge = 'unavailable'; pending = false; setStatus('statusUnavailable'); return; }
          preference = selected;
          persist(); render(); pending = true; bridge();
        });
      }, { signal: listeners.signal });
      bridge();
      return true;
    }
    function decorateCards(root) {
      root.querySelectorAll('[data-alpha-product-card]').forEach(card => {
        if (card.querySelector('.abt-card-action') || !card.querySelector('[data-credit-add]')) return;
        const content = card.querySelector('.alpha-product-card__content');
        if (!content || !card.dataset.alphaProductUrl) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'abt-card-action';
        const link = document.createElement('a');
        link.className = 'abt-card-action__link';
        link.href = card.dataset.alphaProductUrl;
        link.textContent = selector.dataset.cardCta;
        const note = document.createElement('p');
        note.className = 'abt-card-action__note';
        note.textContent = selector.dataset.cardNote;
        wrapper.append(link, note); content.append(wrapper);
      });
    }
    selector.addEventListener('change', event => {
      const input = event.target;
      if (!input.matches('input[data-browse-type], input[data-browse-presentation]')) return;
      if (input.disabled) return;
      let next;
      if (input.matches('input[data-browse-type]')) {
        const presentation = selector.querySelector('[data-browse-for="' + input.value + '"] input[data-browse-presentation]:checked');
        next = normalize({ type: input.value, finish: presentation?.value, mount: presentation?.dataset.browseMount });
        if (next.type === 'book') {
          try {
            const savedBook = JSON.parse(localStorage.getItem('alpha-book-selection-v1'));
            if ([20,30,50,75,100].includes(savedBook?.size)) next = normalize({type:'book', finish:'artworks' + savedBook.size});
          } catch (_) {}
        }
      } else next = normalize({ type: preference.type, finish: input.value, mount: input.dataset.browseMount });
      if (next.type === 'book' && !window.dispatchEvent(new CustomEvent('alpha:book-package', {cancelable:true, detail:{size:Number(next.finish.slice(8))}}))) {
        render(); return;
      }
      preference = next;
      persist(); render();
      if (isProduct) { pending = true; setStatus('statusLoading'); bridge(); }
    }, { signal: listeners.signal });
    if (mountedRoot) window.addEventListener('alpha:mounted-state', event => {
      if (event.detail?.root !== mountedRoot) return;
      if (preference.mount === 'white') { pending = true; bridge(); }
      availability();
    }, { signal: listeners.signal });
    // Carry only this UI preference. Country, currency, variant, filters and hash survive.
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link || link.hasAttribute('download')) return;
      const url = new URL(link.href, location.href);
      if (!/^https?:$/.test(url.protocol) || !/(^|\.)alphachristianart\.com$/.test(url.hostname) ||
          !/\/(?:collections|products)\//.test(url.pathname)) return;
      // A navigation entry with an explicit format is an intentional switch.
      // Only inherit the current preference when the destination has no format.
      if (url.searchParams.has('art_type')) return;
      link.href = preferenceURL(url, preference).href;
    }, { capture: true, signal: listeners.signal });
    persist(); render(); controls.disabled = false;
    if (isProduct) {
      setStatus('statusLoading');
      if (!attach()) {
        let attempts = 0;
        timer = setInterval(() => {
          if (attach() || ++attempts >= 40) { clearInterval(timer); if (!config) setStatus('statusUnavailable'); }
        }, 500);
      }
    } else {
      const grid = document.getElementById('ResultsList');
      if (grid) {
        decorateCards(grid);
        gridObserver = new MutationObserver(records => {
          if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-alpha-product-card], li') || node.querySelector('[data-alpha-product-card]'))))) decorateCards(grid);
        });
        gridObserver.observe(grid, { childList: true, subtree: true });
      }
    }
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      let saved;
      try { saved = JSON.parse(localStorage.getItem(storageKey)); } catch (_) { /* Keep current selection. */ }
      preference = normalize(saved || preference); persist(); render(); pending = isProduct; bridge();
    }, { signal: listeners.signal });
  }
  document.addEventListener('shopify:section:unload', event => {
    if (event.target instanceof Element && activeSession?.belongsTo(event.target)) activeSession.dispose();
  });
  document.addEventListener('shopify:section:load', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.matches('[data-alpha-browse-type], [data-aap-root]') ||
        event.target.querySelector('[data-alpha-browse-type], [data-aap-root]')) {
      activeSession?.dispose();
      init();
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-budgetframe-commerce"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const box=document.querySelector('[data-budgetframe-commerce]'),root=box?.closest('[data-budgetframe-preview]');
    if(!root||box.dataset.initialized)return;
    box.dataset.initialized='true';
    const source=JSON.parse(box.querySelector('[data-budgetframe-source]').textContent),copy=JSON.parse(box.querySelector('[data-budgetframe-commerce-copy]').textContent);
    const pay=box.querySelector('[data-budgetframe-pay]'),add=box.querySelector('[data-budgetframe-add]'),error=box.querySelector('[data-budgetframe-commerce-error]');
    let native,dialog,home,form,submit,originalLabel,owned=false,paying=false,uncertain=false,options=[],loadedCountry='',fetched=0,loading='',sequence=0,openedSelection='';
    const active=()=>document.body.dataset.artworkBrowse==='print'&&document.body.dataset.artworkFinish==='budgetframe';
    const selection=()=>{try{return active()?JSON.parse(root.dataset.budgetframeSelection||'null'):null;}catch{return null;}};
    const signature=()=>{const s=selection();return s?JSON.stringify([s.country,s.sku,s.widthMm,s.heightMm,s.surface,s.priceCents]):'';};
    const current=()=>{const s=selection();return s&&s.country===loadedCountry?options.find(o=>o.supplierSku===s.sku&&o.frameColor===s.surface&&o.widthMm===s.widthMm&&o.heightMm===s.heightMm&&Math.round(o.totalPriceEur*100)===s.priceCents):null;};
    const fail=message=>{error.textContent=message||copy.error;error.hidden=false;};
    function endpoint(){
      const url=new URL(native.dataset.aapProxy,location.origin);
      if(url.origin!==location.origin||url.pathname!=='/apps/alpha-art-print')throw Error('UNAVAILABLE');
      return url;
    }
    function close(){if(owned&&dialog.open)dialog.close();}
    function render(){
      const available=Boolean(current())&&!uncertain;
      const selected=selection();
      box.hidden=!active()||!selected;pay.disabled=add.disabled=!available||paying;
      if(!selected)error.hidden=true;
      const total=root.querySelector('[data-budgetframe-price]');
      const target=box.querySelector('[data-budgetframe-pay-total]');
      const amount=selected&&total?total.textContent:'';
      if(target.textContent!==amount)target.textContent=amount;
      for(const el of root.querySelectorAll('.bfp-preview-badge,.bfp-purchase-note'))el.hidden=true;
      root.dataset.budgetframeCheckout=available?'ready':'unavailable';
      root.dataset.budgetframePaying=String(paying);
    }
    async function load(force=false){
      const s=selection();if(!native||!s)return;
      if(!force&&loadedCountry===s.country&&Date.now()-fetched<20*60*1000){render();return;}
      if(loading===s.country)return;
      const turn=++sequence;loading=s.country;options=[];loadedCountry='';render();
      try{
        const url=endpoint();url.searchParams.set('variant',native.dataset.aapVariant);url.searchParams.set('country',s.country);url.searchParams.set('catalog_profile','budgetframe-v1');
        const response=await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(30000)});
        const data=await response.json();
        if(!response.ok||data.offerProfile!=='budgetframe-v1'||data.countryCode!==s.country||!Array.isArray(data.options))throw Error('UNAVAILABLE');
        if(turn!==sequence||selection()?.country!==s.country)return;
        options=data.options.filter(o=>o.supportId==='budget-framed-poster'&&o.offerProfile==='budgetframe-v1'&&typeof o.quoteToken==='string'&&Number.isFinite(o.totalPriceEur));
        loadedCountry=s.country;fetched=Date.now();error.hidden=true;
      }catch{if(turn===sequence)fail();}
      finally{if(turn===sequence){loading='';render();}}
    }
    function syncAddress(){
      const s=selection(),countries=native.querySelector('[data-aap-country]');
      const country=[...countries.options].find(o=>o.value===s.country);
      if(!country)throw Error('UNAVAILABLE');
      form.querySelector('[data-aap-address-country]').textContent=country.textContent;
      const normalize=t=>String(t||'').trim().normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
      const metadata=native.querySelector('[data-aap-country-metadata]');
      const item=metadata&&[...metadata.options].find(o=>normalize(o.textContent)===normalize(country.textContent));
      const provinces=JSON.parse(item?.dataset.provinces||'[]');
      const field=form.querySelector('[data-aap-address-province-field]'),province=form.querySelector('[data-aap-address-province]');
      province.replaceChildren();field.hidden=!provinces.length;province.required=Boolean(provinces.length);
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});province.disabled=!provinces.length;
      if(provinces.length){province.append(new Option(copy.choose,''));for(const p of provinces)province.append(new Option(p[1],p[0]));}
      submit.disabled=false;submit.textContent=originalLabel;
      form.querySelector('[data-aap-address-error]').textContent='';
    }
    async function submitAddress(event){
      if(!owned)return;
      event.preventDefault();event.stopImmediatePropagation();
      if(paying||uncertain||!active()||openedSelection!==signature()||!current()||!form.reportValidity())return;
      const s=selection(),option=current();
      if(Date.now()-fetched>25*60*1000){close();options=[];render();await load(true);return;}
      const shippingAddress=Object.fromEntries(new FormData(form));shippingAddress.countryCode=s.country;
      paying=true;render();submit.disabled=true;submit.textContent=copy.loading;
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=true;});
      try{
        const response=await fetch(endpoint(),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({quoteToken:option.quoteToken,shippingAddress}),signal:AbortSignal.timeout(30000)});
        const result=await response.json();
        if(!response.ok){if(response.status>=500)uncertain=true;throw Error('CHECKOUT');}
        const url=new URL(result.checkoutUrl);
        if(url.protocol!=='https:'||(!/(^|\.)alphachristianart\.com$/.test(url.hostname)&&url.hostname!==box.dataset.shop))throw Error('CHECKOUT');
        location.assign(url.href);
      }catch{uncertain=true;fail(copy.uncertain);form.querySelector('[data-aap-address-error]').textContent=copy.uncertain;}
      finally{paying=false;render();submit.textContent=originalLabel;submit.disabled=true;}
    }
    function attach(){
      native=document.querySelector('[data-aap-root]');dialog=native?.querySelector('[data-aap-address-dialog]');form=dialog?.querySelector('[data-aap-address-form]');submit=form?.querySelector('[data-aap-address-submit]');
      if(!native?.dataset.aapVariant||!form||!submit||!native.querySelector('[data-aap-country]')?.options.length)return false;
      home=document.createComment('budgetframe-address-home');dialog.before(home);originalLabel=submit.textContent;
      for(const key of ['--aap-accent','--aap-ink','--aap-muted','--aap-font']){const value=getComputedStyle(native).getPropertyValue(key);if(value)box.style.setProperty(key,value);}
      form.addEventListener('submit',submitAddress,true);
      dialog.addEventListener('close',()=>{if(!owned)return;owned=false;home.after(dialog);form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});submit.disabled=false;submit.textContent=originalLabel;if(active())pay.focus();});
      load();return true;
    }
    pay.addEventListener('click',async()=>{
      const before=signature();if(!before||paying||uncertain)return;
      paying=true;render();await load(true);paying=false;render();
      if(before!==signature()||!current())return;
      try{syncAddress();owned=true;openedSelection=signature();box.append(dialog);dialog.showModal();form.querySelector('input[name="firstName"]')?.focus();}catch{owned=false;home.after(dialog);fail();}
    });
    add.addEventListener('click',async()=>{
      const before=signature(),s=selection(),o=current(),wallet=document.querySelector('artwork-credit-cart');if(!s||!o||paying||!wallet?.addBudgetframeConfiguration)return;
      paying=true;render();
      try{await wallet.addBudgetframeConfiguration(source,{variantId:'gid://shopify/ProductVariant/'+native.dataset.aapVariant,country:s.country,optionId:o.id,priceCents:s.priceCents,label:root.querySelector('#BudgetFramePreviewTitle').textContent+' · '+s.label},()=>before===signature());}catch{fail();}finally{paying=false;render();}
    });
    window.addEventListener('alpha:budgetframe-selection',()=>{if(owned&&signature()!==openedSelection&&!paying)close();render();load();});
    window.addEventListener('alpha:artwork-browse',()=>{if(!active()&&!paying)close();render();});
    const price=root.querySelector('[data-budgetframe-price]');
    if(price)new MutationObserver(render).observe(price,{childList:true,subtree:true,characterData:true});
    let tries=0;const timer=setInterval(()=>{if(attach()||++tries>60)clearInterval(timer);},500);
    render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-budgetframe-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const artworkRatio = image => {
    if(!image)return NaN;
    const declared=Number(image.closest('[data-artwork-ratio]')?.dataset.artworkRatio);
    if(Number.isFinite(declared)&&declared>0)return declared;
    const width=Number(image.getAttribute('width')),height=Number(image.getAttribute('height'));
    if(width>0&&height>0)return width/height;
    return image.naturalWidth>0&&image.naturalHeight>0?image.naturalWidth/image.naturalHeight:NaN;
  };
  const printLayout = (format, ratio) => {
    if (!format || ![format.w,format.h,ratio].every(v=>Number.isFinite(v)&&v>0) || format.w<=10 || format.h<=10) return null;
    const border=0;
    const width=Math.max(format.w,format.h*ratio),height=width/ratio;
    return {width,height,left:(format.w-width)/2,top:(format.h-height)/2,border,visibleFraction:format.w*format.h/(width*height)};
  };
  const geometryFit = (format, ratio, width, height) => {
    const image=printLayout(format,ratio);
    if(!image||![width,height].every(v=>Number.isFinite(v)&&v>0))return null;
    const scale=Math.min(width*.88/(format.w+30),height*.88/(format.h+30));
    return {image,scale,w:(format.w+30)*scale,h:(format.h+30)*scale};
  };
  const eligible = (format, ratio) => {
    if(!printLayout(format,ratio))return false;
    const orientation=r=>Math.abs(r-1)<.02?0:Math.sign(r-1);
    const border=0;
    const imageRatio=(format.w-2*border)/(format.h-2*border);
    return orientation(format.w/format.h)===orientation(ratio)&&Math.min(ratio/imageRatio,imageRatio/ratio)>=.85;
  };
  const roomGeometry = (format,ratio,width,height) => {
    const image=printLayout(format,ratio);
    if(!image||![width,height].every(v=>Number.isFinite(v)&&v>0))return null;
    const reference=height*.64,scale=reference/1700;
    return {image,scale,reference,w:(format.w+30)*scale,h:(format.h+30)*scale,x:width*.5,y:height*.45};
  };
  function applyArtGeometry(art,f,shade='natural'){
    if(!f)return;
    const styles={'--bf-w':f.w+'px','--bf-h':f.h+'px','--bf-frame':20*f.scale+'px','--bf-depth':Math.max(.5,Math.min(8,15*f.scale))+'px','--bf-image-w':f.image.width*f.scale+'px','--bf-image-h':f.image.height*f.scale+'px','--bf-image-top':(f.image.top-5)*f.scale+'px','--bf-image-left':(f.image.left-5)*f.scale+'px'};
    for(const [k,v]of Object.entries(styles))if(art.style.getPropertyValue(k)!==v)art.style.setProperty(k,v);
    art.dataset.surface=shade;
  }
  if(typeof document==='undefined'){if(typeof module!=='undefined')module.exports={printLayout,geometryFit,eligible,artworkRatio,roomGeometry};return;}
  function initThumbnails(){
    const preview=document.querySelector('[data-budgetframe-preview]');
    if(preview?.dataset.wall)document.body.style.setProperty('--bf-photo-wall','url("'+preview.dataset.wall+'")');
    const materialNode=document.querySelector('[data-budgetframe-materials]');
    if(materialNode){
      const materials=JSON.parse(materialNode.textContent);
      for(const shade of ['natural','white','black'])document.body.style.setProperty('--bf-material-'+shade,'url("'+materials[shade]+'")');
    }
    document.querySelectorAll('.bfp-choice .bfp-art').forEach(art=>{
      if(art.dataset.thumbnailReady)return;art.dataset.thumbnailReady='true';
      const img=art.querySelector('img'),stage=art.parentElement;
      const draw=()=>{const ratio=artworkRatio(img);if(ratio>0)applyArtGeometry(art,geometryFit({w:300*ratio,h:300},ratio,stage.clientWidth,stage.clientHeight),'natural');};
      new ResizeObserver(draw).observe(stage);img?.addEventListener('load',draw);draw();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initThumbnails,{once:true});else initThumbnails();
  document.addEventListener('shopify:section:load',initThumbnails);
  async function init(){
    const root=document.querySelector('[data-budgetframe-preview]');
    if(!root||root.dataset.initialized)return;
    if(document.body.dataset.artworkFinish!=='budgetframe')return;
    root.dataset.initialized='true';
    const materials=JSON.parse(document.querySelector('[data-budgetframe-materials]').textContent);
    for(const shade of ['natural','white','black'])document.body.style.setProperty('--bf-material-'+shade,'url("'+materials[shade]+'")');
    const copy=JSON.parse(root.querySelector('[data-budgetframe-copy]').textContent);
    let data;
    try {
      const response=await fetch(JSON.parse(document.querySelector('[data-budgetframe-catalog-url]').textContent));
      if(!response.ok)throw Error('CATALOG');
      data=await response.json();
      if(!data.version||data.checkoutEnabled!==false||!Array.isArray(data.products))throw Error('CATALOG');
    } catch (_) {
      delete root.dataset.initialized;
      if(document.body.dataset.artworkFinish==='budgetframe'){
        root.hidden=root.dataset.page!=='product';document.body.classList.add('bfp-active');
        const status=root.querySelector('[data-budgetframe-status]');if(status)status.textContent=copy.unavailable;
      }
      return;
    }
    const product=root.dataset.page==='product';
    let country;try{country=localStorage.getItem('alpha-art-print-country');}catch(_){}
    country=country||root.dataset.defaultCountry;
    let surface='natural',unit='cm',selected=null,active=false;
    const entries=new Map();
    const number=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:2}).format(value);
    const measure=value=>number(value/(unit==='cm'?10:25.4))+(unit==='cm'?' cm':'″');
    const dimensions=(w,h)=>number(w/(unit==='cm'?10:25.4))+' × '+measure(h);
    const money=value=>{const span=document.createElement('span');span.className='money';span.textContent=(value/100).toFixed(2)+' €';return span;};
    const text=(selector,value)=>{const e=root.querySelector(selector);if(e)e.textContent=value;};
    const regionName=code=>{try{return new Intl.DisplayNames([document.documentElement.lang||'en'],{type:'region'}).of(code);}catch(_){return data.names[code]||code;}};
    function options(ratio,shade=surface){return (data.countries[country]||[]).map(i=>data.quotes[i]).filter(q=>(shade===null||data.products[q[0]].surface===shade)&&eligible(data.products[q[0]],ratio));}
    function best(ratio){return options(ratio).sort((a,b)=>Math.abs(Math.log(Math.max(data.products[a[0]].w,data.products[a[0]].h)/500))-Math.abs(Math.log(Math.max(data.products[b[0]].w,data.products[b[0]].h)/500))||Math.abs(data.products[a[0]].w/data.products[a[0]].h-ratio)-Math.abs(data.products[b[0]].w/data.products[b[0]].h-ratio))[0];}
    function setArt(art,format,ratio,shade=surface){
      const stage=art.parentElement;
      applyArtGeometry(art,geometryFit(format,ratio,stage.clientWidth,stage.clientHeight),shade);
    }
    const resize=new ResizeObserver(()=>renderArt());
    const hero=root.querySelector('[data-budgetframe-art]');
    const heroImage=hero?.querySelector('img');
    if(hero){resize.observe(hero.parentElement);heroImage.addEventListener('load',render);}
    const roomHost=root.querySelector('[data-budgetframe-room-host]');
    let room=null;
    function ensureRoom(){
      if(room||!roomHost||!hero)return;
      const source=document.querySelector('[data-aap-room]')?.closest('.aap-preview');
      if(!source)return;
      const section=source.cloneNode(true),stage=section.querySelector('[data-aap-room]');
      const oldArt=section.querySelector('[data-aap-preview]'),reference=section.querySelector('[data-aap-reference]'),label=section.querySelector('[data-aap-preview-dimension]'),zoom=section.querySelector('[data-aap-zoom]');
      if(!stage||!oldArt||!reference||!label||!zoom)return;
      section.querySelectorAll('*').forEach(el=>{el.removeAttribute('id');for(const attr of [...el.attributes])if(attr.name.startsWith('data-aap-'))el.removeAttribute(attr.name);});
      section.classList.add('bfp-room');
      section.setAttribute('aria-labelledby','BudgetFrameRoomTitle');
      section.querySelector('h3').id='BudgetFrameRoomTitle';
      const titleStyle=getComputedStyle(source.querySelector('h3'));
      section.querySelector('h3').style.fontFamily=titleStyle.fontFamily;
      section.querySelector('h3').style.fontWeight=titleStyle.fontWeight;
      const art=hero.cloneNode(true);art.removeAttribute('data-budgetframe-art');art.classList.add('bfp-room-art');art.dataset.budgetframeRoomArt='';
      const painting=art.querySelector('img');painting.removeAttribute('srcset');painting.removeAttribute('sizes');painting.loading='lazy';painting.fetchPriority='low';painting.alt=heroImage.alt;
      oldArt.replaceWith(art);
      section.querySelectorAll('img').forEach(img=>{img.loading='lazy';img.decoding='async';});
      const dialog=document.createElement('dialog');dialog.className='bfp-room-dialog';dialog.setAttribute('aria-labelledby','BudgetFrameRoomTitle');
      const zoomMarkup=zoom.innerHTML,zoomLabel=zoom.getAttribute('aria-label');
      zoom.setAttribute('aria-haspopup','dialog');zoom.setAttribute('aria-expanded','false');
      zoom.addEventListener('click',()=>{
        if(dialog.open){dialog.close();return;}
        dialog.append(section);dialog.showModal();zoom.textContent=copy.close;zoom.setAttribute('aria-label',copy.close);zoom.setAttribute('aria-expanded','true');requestAnimationFrame(renderRoom);
      });
      dialog.addEventListener('close',()=>{roomHost.insertBefore(section,dialog);zoom.innerHTML=zoomMarkup;if(zoomLabel)zoom.setAttribute('aria-label',zoomLabel);zoom.setAttribute('aria-expanded','false');requestAnimationFrame(()=>{renderRoom();if(active)zoom.focus({preventScroll:true});});});
      dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
      room={section,stage,art,reference,label,dialog,painting};
      roomHost.append(section,dialog);resize.observe(stage);
    }
    function renderRoom(){
      if(!room||!selected||!active)return;
      const f=roomGeometry(data.products[selected[0]],artworkRatio(heroImage),room.stage.clientWidth,room.stage.clientHeight);
      if(!f)return;
      applyArtGeometry(room.art,f,surface);
      room.art.style.left=f.x+'px';room.art.style.top=f.y+'px';
      room.reference.style.height=f.reference+'px';
      room.label.style.left=f.x+'px';room.label.style.top=(f.y+f.h/2+10)+'px';
      const format=data.products[selected[0]];
      room.label.textContent=dimensions(format.w,format.h);
      room.label.hidden=false;
      if(heroImage.complete&&heroImage.currentSrc&&room.painting.src!==heroImage.currentSrc)room.painting.src=heroImage.currentSrc;
    }
    function renderArt(){
      if(!active)return;
      if(hero&&selected){
        const f=data.products[selected[0]],ratio=artworkRatio(heroImage);
        setArt(hero,f,ratio);
        root.querySelectorAll('[data-budgetframe-swatch-art]').forEach(art=>setArt(art,f,ratio,art.dataset.budgetframeSwatchArt));
      }
      renderRoom();
      for(const [card,entry]of entries){
        if(!card.isConnected){resize.unobserve(entry.stage);entry.source.removeEventListener('load',entry.load);entries.delete(card);continue;}
        const ratio=artworkRatio(entry.source);
        const quote=Number.isFinite(ratio)&&best(ratio);
        entry.stage.hidden=!quote;
        card.classList.toggle('bfp-card-ready',Boolean(quote));
        if(quote)setArt(entry.art,data.products[quote[0]],ratio);
        const minimum=quote?Math.min(...options(ratio,null).map(q=>q[1])):null;
        if(entry.minimum!==minimum){entry.minimum=minimum;entry.price.replaceChildren();if(minimum!==null)entry.price.append(document.createTextNode(copy.from+' '),money(minimum),document.createElement('br'),document.createTextNode(copy.shipping_included));else entry.price.textContent=copy.no_size;}
      }
    }
    function render(){
      active=document.body.dataset.artworkBrowse==='print'&&document.body.dataset.artworkFinish==='budgetframe';
      root.hidden=!active||!product;
      document.body.classList.toggle('bfp-active',active);
      if(heroImage)heroImage.fetchPriority=active?'high':'auto';
      if(!active){delete root.dataset.budgetframeSelection;window.dispatchEvent(new Event('alpha:budgetframe-selection'));if(room?.dialog.open)room.dialog.close();root.classList.remove('bfp-zoomed');const zoom=root.querySelector('[data-budgetframe-zoom]');if(zoom)zoom.textContent=copy.zoom;return;}
      if(heroImage)heroImage.loading='eager';
      if(root.dataset.wall&&!root.dataset.wall.includes('Liquid error'))document.body.style.setProperty('--bf-photo-wall','url("'+root.dataset.wall+'")');
      if(!product){requestAnimationFrame(decorate);return;}
      ensureRoom();
      text('[data-budgetframe-country]',regionName(country));
      const validCountry=Boolean(data.countries[country]?.length);
      const ratio=artworkRatio(heroImage);
      if(Number.isFinite(ratio)&&!options(ratio).length)surface=data.surfaces.find(shade=>options(ratio,shade).length)||surface;
      let choices=product&&Number.isFinite(ratio)?options(ratio,null):[];
      choices.sort((a,b)=>data.products[a[0]].w*data.products[a[0]].h-data.products[b[0]].w*data.products[b[0]].h);
      if(product){
        const old=selected&&data.products[selected[0]];
        const sameSize=choices.filter(q=>data.products[q[0]].w===old?.w&&data.products[q[0]].h===old?.h);
        selected=sameSize.find(q=>data.products[q[0]].surface===surface)||sameSize[0]||best(ratio)||choices[0]||null;
        if(selected)surface=data.products[selected[0]].surface;
        const sizesByDimension=new Map();
        for(const q of choices){const p=data.products[q[0]],key=p.w+':'+p.h,prior=sizesByDimension.get(key);if(!prior||p.surface===surface||data.products[prior[0]].surface!==surface&&q[1]<prior[1])sizesByDimension.set(key,q);}
        const sizes=root.querySelector('[data-budgetframe-sizes]');sizes.replaceChildren();
        for(const q of sizesByDimension.values()){const f=data.products[q[0]],button=document.createElement('button'),label=document.createElement('strong');button.type='button';button.dataset.budgetframeSize=String(q[0]);button.setAttribute('aria-pressed',String(q===selected));label.textContent=dimensions(f.w,f.h);button.append(label,money(q[1]));if(f.surface!==surface)button.title=copy.available_colour; sizes.append(button);}
      }
      root.querySelector('[data-budgetframe-price-card]').hidden=!product||!selected;
      root.querySelector('[data-budgetframe-details]').hidden=!product||!selected;
      if(hero)hero.parentElement.hidden=!selected;
      if(roomHost)roomHost.hidden=!selected;
      if(selected&&product){
        const f=data.products[selected[0]];
        hero.parentElement.dataset.orientation=f.w/f.h>1.05?'landscape':f.w/f.h<.95?'portrait':'square';
        text('[data-budgetframe-selected-size]',dimensions(f.w,f.h));text('[data-budgetframe-print-size]',dimensions(f.w,f.h));text('[data-budgetframe-image-size]',dimensions(f.w,f.h));text('[data-budgetframe-origin]',regionName(selected[3]));
        text('[data-budgetframe-outer-size]',dimensions(f.w+30,f.h+30));
        text('[data-budgetframe-transit]',selected[4]===null||selected[5]===null?copy.transit_unknown:(selected[4]===selected[5]?selected[4]:selected[4]+'–'+selected[5])+' '+copy.days);
        root.querySelector('[data-budgetframe-price]').replaceChildren(money(selected[1]));
        text('[data-budgetframe-shipping]',copy.included);
      }else text('[data-budgetframe-origin]','—');
      root.querySelectorAll('[data-budgetframe-surface]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.budgetframeSurface===surface));const format=selected&&data.products[selected[0]];b.disabled=!format||!options(ratio,b.dataset.budgetframeSurface).some(q=>{const p=data.products[q[0]];return p.w===format.w&&p.h===format.h;});});
      root.querySelectorAll('[data-budgetframe-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.budgetframeUnit===unit)));
      text('[data-budgetframe-status]',!validCountry?copy.unavailable:product&&!selected?copy.no_size:copy.ready);
      root.dataset.budgetframeState=validCountry&&(!product||selected)?'ready':'unavailable';
      root.dataset.budgetframeSelection=selected?JSON.stringify({sku:data.products[selected[0]].sku,surface,country,widthMm:data.products[selected[0]].w,heightMm:data.products[selected[0]].h,priceCents:selected[1],label:dimensions(data.products[selected[0]].w,data.products[selected[0]].h),fit:'cover',cropPosition:'center'}):'';
      window.dispatchEvent(new Event('alpha:budgetframe-selection'));
      requestAnimationFrame(decorate);
    }
    function decorate(){
      if(!active)return;
      document.querySelectorAll('[data-alpha-product-card]').forEach(card=>{
        if(entries.has(card))return;
        const source=card.querySelector('.alpha-product-card__artwork-frame img'),media=card.querySelector('.alpha-product-card__media');
        if(!source||!media)return;
        const stage=document.createElement('div');stage.className='bfp-stage bfp-card-stage';
        const art=document.createElement('div');art.className='bfp-art';
        art.innerHTML='<div class="bfp-paper"><div class="bfp-image-area"></div></div>';
        const img=source.cloneNode();img.removeAttribute('id');img.className='bfp-image';img.alt='';img.decoding='async';img.fetchPriority='auto';
        const syncImage=()=>{if(source.complete&&source.naturalWidth&&source.currentSrc){img.removeAttribute('srcset');img.removeAttribute('sizes');if(img.src!==source.currentSrc)img.src=source.currentSrc;}};
        syncImage();art.querySelector('.bfp-image-area').append(img);stage.append(art);media.append(stage);
        const price=document.createElement('p');price.className='bfp-card-price';card.append(price);
        const load=()=>{syncImage();renderArt();};source.addEventListener('load',load);entries.set(card,{source,stage,art,load,price,minimum:undefined});resize.observe(stage);
      });renderArt();
    }
    root.addEventListener('click',e=>{
      if(root.dataset.budgetframePaying==='true')return;
      const size=e.target.closest('[data-budgetframe-size]'),shade=e.target.closest('[data-budgetframe-surface]'),units=e.target.closest('[data-budgetframe-unit]');
      if(size){selected=options(artworkRatio(heroImage),null).find(q=>q[0]===Number(size.dataset.budgetframeSize));if(selected)surface=data.products[selected[0]].surface;render();root.querySelector('[data-budgetframe-size="'+size.dataset.budgetframeSize+'"]')?.focus({preventScroll:true});}
      if(shade){surface=shade.dataset.budgetframeSurface;render();}
      if(units){unit=units.dataset.budgetframeUnit;render();}
      if(e.target.closest('[data-budgetframe-zoom]')){root.classList.toggle('bfp-zoomed');e.target.textContent=root.classList.contains('bfp-zoomed')?copy.close:copy.zoom;requestAnimationFrame(renderArt);}
    });
    document.addEventListener('keydown',e=>{if(e.key==='Escape'){root.classList.remove('bfp-zoomed');if(root.querySelector('[data-budgetframe-zoom]'))root.querySelector('[data-budgetframe-zoom]').textContent=copy.zoom;}});
    window.addEventListener('alpha:artwork-browse',render);
    window.addEventListener('alpha-art-print:country-change',e=>{if(/^[A-Z]{2}$/.test(e.detail?.country)){country=e.detail.country;render();}});
    window.addEventListener('storage',e=>{if(e.key==='alpha-art-print-country'&&e.newValue){country=e.newValue;render();}});
    const grid=document.querySelector('#ResultsList');if(grid)new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-alpha-product-card], li')||n.querySelector('[data-alpha-product-card]')))))decorate();}).observe(grid,{childList:true,subtree:true});
    decorate();render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  window.addEventListener('alpha:artwork-browse',init);
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-christian-primary-offers"] && !Shopify.designMode) return;
  try {
    (() => {
  let queued = false;
  const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
  const sync = () => {
    queued = false;
    const template = document.getElementById('AlphaChristianPrimaryOffers');
    const header = document.querySelector('.aap-panel__header');
    const selector = document.querySelector('[data-alpha-browse-type]');
    if (!template || !header || !selector) return;
    let offers = header.parentElement.querySelector('.ar-offers');
    if (!offers) {
      offers = template.content.firstElementChild.cloneNode(true);
      header.after(offers);
      offers.querySelectorAll('[data-ar-offer]').forEach(button => {
        button.addEventListener('click', () => {
          selector.querySelector('input[data-browse-type][value="' + button.dataset.arOffer + '"]')?.click();
          if (button.dataset.arOffer === 'print') selector.querySelector('[data-browse-for="print"] input[value="unframed"]')?.click();
        });
      });
    }
    const type = selector.querySelector('input[data-browse-type]:checked')?.value;
    const finish = selector.querySelector('[data-browse-for="' + type + '"] input:checked');
    const isOtherPrint = type === 'print' && !['unframed', 'classic'].includes(finish?.value);
    offers.querySelectorAll('[data-ar-offer]').forEach(button => {
      const radio = selector.querySelector('input[data-browse-type][value="' + button.dataset.arOffer + '"]');
      button.disabled = !radio || radio.disabled || !!radio.closest('fieldset[disabled]');
      const selected = String(button.dataset.arOffer === type && !isOtherPrint);
      if (button.getAttribute('aria-pressed') !== selected) button.setAttribute('aria-pressed', selected);
      const price = radio?.closest('label')?.querySelector('.asp-price__line');
      setText(button.querySelector('[data-ar-price]'), price?.querySelector('.money') ? price.textContent.trim() : '');
    });
    const copy = isOtherPrint ? finish?.closest('label')?.querySelector('.abt__finish-detail') : offers.querySelector('[data-ar-offer="' + type + '"] > span');
    const lead = header.querySelector('.aap-panel__lead');
    if (lead && !lead.dataset.arOriginal) lead.dataset.arOriginal = lead.textContent;
    if (lead) setText(lead, copy ? copy.textContent : lead.dataset.arOriginal);
    const group = offers.querySelector('.ar-offers__finishes');
    const shouldHide = !['canvas', 'print'].includes(type);
    if (group.hidden !== shouldHide) group.hidden = shouldHide;
    const target = group.querySelector('[data-ar-finishes]');
    const radios = [...selector.querySelectorAll('[data-browse-for="' + type + '"] input[data-browse-presentation]')].filter(radio => type !== 'print' || ['unframed', 'classic'].includes(radio.value));
    radios.forEach((radio, index) => {
      let button = target.children[index];
      if (!button) { button = document.createElement('button'); button.type = 'button'; target.append(button); }
      button.onclick = () => radio.click();
      setText(button, radio.closest('label')?.querySelector('.abt__finish-copy > strong')?.textContent.trim() || radio.value);
      const selected = String(radio.checked);
      if (button.getAttribute('aria-pressed') !== selected) button.setAttribute('aria-pressed', selected);
      button.disabled = radio.disabled || !!radio.closest('fieldset[disabled]');
    });
    while (target.children.length > radios.length) target.lastElementChild.remove();
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(sync); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true}); else schedule();
  window.addEventListener('alpha:artwork-browse', schedule);
  document.addEventListener('change', schedule);
  new MutationObserver(schedule).observe(document.getElementById('MainContent'), {childList:true, subtree:true, characterData:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-collapsible-products"] && !Shopify.designMode) return;
  try {
    (() => {
  function syncFamily() {
    const root = document.querySelector('[data-alpha-browse-type]');
    const label = root?.querySelector('input[data-browse-type]:checked')?.closest('label');
    const current = root?.querySelector('[data-family-current]');
    if (label && current) current.textContent = label.querySelector('.abt__type-copy > strong').textContent + ' ✓';
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-family-toggle]');
    if (!button) return;
    const root = button.closest('[data-alpha-browse-type]');
    const open = root.dataset.productsOpen !== 'true';
    root.dataset.productsOpen = String(open);
    button.setAttribute('aria-expanded', String(open));
    window.dispatchEvent(new Event('resize'));
  });
  document.addEventListener('change', event => {
    if (event.target.closest('[data-alpha-browse-type]')) syncFamily();
  });
  window.addEventListener('alpha:artwork-browse', syncFamily);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncFamily, {once:true});
  else syncFamily();
  document.addEventListener('shopify:section:load', syncFamily);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-collection-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('alpha-collection-gallery')) {
    customElements.define('alpha-collection-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.container = this.closest('results-list');
        this.dialog = this.querySelector('dialog');
        if (!this.container || !this.dialog || !this.dialog.showModal) return;
        this.controller = new AbortController();
        this.entries = [];
        this.requests = new Map();
        this.loadedPages = new Set();
        this.index = 0;
        this.version = 0;
        this.playing = false;
        this.image = this.dialog.querySelector('[data-gallery-image]');
        this.status = this.dialog.querySelector('[role="status"]');
        this.titleNode = this.dialog.querySelector('[data-gallery-title]');
        this.link = this.dialog.querySelector('[data-gallery-product]');
        this.count = this.dialog.querySelector('.alpha-gallery-count');
        this.prev = this.dialog.querySelector('[data-gallery-prev]');
        this.next = this.dialog.querySelector('[data-gallery-next]');
        this.play = this.dialog.querySelector('[data-gallery-play]');
        this.pageSize = Number(this.dataset.pageSize) || 24;
        this.total = Number(this.dataset.total) || 0;
        this.pages = Number(this.dataset.pages) || 1;
        this.baseURL = location.href;
        this.dialog.setAttribute('dir', getComputedStyle(this).direction);
        document.body.appendChild(this.dialog);
        const listen = (node, type, fn, options = {}) => node.addEventListener(type, fn, { ...options, signal: this.controller.signal });
        listen(this, 'click', event => {
          if (event.target.closest('[data-gallery-launch]')) this.open();
        });
        listen(this.container, 'click', event => {
          const button = event.target.closest('[data-alpha-gallery-open]');
          if (!button) return;
          event.preventDefault();
          this.open(button.closest('[data-alpha-product-card]')?.dataset.alphaProductId, button);
        });
        listen(document, 'alpha:openCollectionSlideshowAt', event => {
          const card = this.container.querySelector('[data-alpha-product-handle="' + CSS.escape(event.detail?.handle || '') + '"]');
          if (card) this.open(card.dataset.alphaProductId);
        });
        listen(this.dialog.querySelector('[data-gallery-close]'), 'click', () => this.close());
        listen(this.dialog, 'cancel', event => { event.preventDefault(); this.close(); });
        listen(this.dialog, 'close', () => this.cleanup());
        listen(this.prev, 'click', () => { this.stop(); this.step(-1); });
        listen(this.next, 'click', () => { this.stop(); this.step(1); });
        listen(this.play, 'click', () => {
          if (this.playing) this.stop();
          else { this.playing = true; this.play.textContent = this.dataset.pause; this.play.setAttribute('aria-pressed', 'true'); this.schedule(); }
        });
        listen(this.dialog, 'keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); this.stop(); this.step(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
        listen(this.dialog, 'touchstart', event => {
          if (event.touches.length === 1) this.touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
          else this.touch = null;
        }, { passive: true });
        listen(this.dialog, 'touchend', event => {
          if (!this.touch || event.changedTouches.length !== 1) return;
          const dx = event.changedTouches[0].clientX - this.touch.x;
          const dy = event.changedTouches[0].clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) { this.stop(); this.step(dx < 0 ? 1 : -1); }
        }, { passive: true });
        listen(document, 'visibilitychange', () => { if (document.hidden) this.stop(); });
        this.buildPreview();
        this.container.setAttribute('data-alpha-gallery-ready', '');
        this.hidden = false;
      }
      buildPreview() {
        const preview = this.querySelector('[data-gallery-preview]');
        if (!preview) return;
        const images = Array.from(this.container.querySelectorAll('[data-alpha-product-card] img')).slice(0, 3);
        preview.replaceChildren(...images.map(original => {
          const image = document.createElement('img');
          image.alt = '';
          image.width = 76;
          image.height = 108;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.src = original.currentSrc || original.getAttribute('src');
          return image;
        }));
      }
      readCards(root) {
        return Array.from(root.querySelectorAll('[data-alpha-product-card]')).map(card => ({
          id: card.dataset.alphaProductId,
          handle: card.dataset.alphaProductHandle,
          title: card.querySelector('.alpha-product-card__title')?.textContent.trim() || card.dataset.alphaProductTitle,
          url: card.dataset.alphaProductUrl,
          image: card.dataset.alphaGalleryImage || card.dataset.alphaProductImage,
          thumb: card.querySelector('img')?.currentSrc || card.querySelector('img')?.getAttribute('src'),
          ratio: Number(card.dataset.alphaGalleryRatio) || 1,
          page: Number(card.closest('[data-page]')?.dataset.page) || Number(this.dataset.page),
        })).filter(item => item.id && item.url && item.image);
      }
      merge(items) {
        const active = this.entries[this.index]?.id;
        const known = new Set(this.entries.map(item => item.id));
        for (const item of items) {
          this.loadedPages.add(item.page);
          if (!known.has(item.id)) { this.entries.push(item); known.add(item.id); }
        }
        this.entries.sort((a, b) => a.page - b.page);
        if (active) this.index = this.entries.findIndex(item => item.id === active);
      }
      open(id, trigger) {
        if (this.dialog.open) return;
        this.baseURL = location.href;
        this.session = (this.session || 0) + 1;
        this.entries = [];
        this.loadedPages.clear();
        this.merge(this.readCards(this.container));
        if (!this.entries.length) return;
        this.index = Math.max(0, this.entries.findIndex(item => item.id === id));
        this.trigger = trigger || this.querySelector('[data-gallery-launch]');
        this.oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
        this.show();
      }
      source(item) {
        const url = new URL(item.image, location.origin);
        if (url.pathname.includes('/cdn/shop/') || url.hostname === 'cdn.shopify.com') {
          const slow = navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || '');
          const stage = this.dialog.querySelector('.alpha-gallery-stage').getBoundingClientRect();
          const displayWidth = Math.min(stage.width, stage.height * (item.ratio || 1));
          const width = Math.max(400, Math.min(slow ? 900 : 1500, Math.ceil(displayWidth * Math.min(devicePixelRatio || 1, slow ? 1 : 1.5) / 100) * 100));
          url.searchParams.set('width', String(width));
          url.searchParams.delete('height');
          url.searchParams.delete('crop');
        }
        return url.href;
      }
      show() {
        const item = this.entries[this.index];
        if (!item || !this.dialog.open) return;
        const version = ++this.version;
        clearTimeout(this.timer);
        this.titleNode.textContent = item.title;
        this.link.href = item.url;
        this.count.textContent = ((Math.min(...this.loadedPages) - 1) * this.pageSize + this.index + 1) + ' / ' + this.total;
        this.prev.disabled = this.index === 0 && this.loadedPages.has(1);
        this.next.disabled = this.index === this.entries.length - 1 && this.loadedPages.has(this.pages);
        this.status.textContent = this.dataset.loading;
        this.image.alt = item.title;
        this.image.hidden = !item.thumb;
        if (item.thumb) this.image.src = item.thumb;
        else this.image.removeAttribute('src');
        const source = this.source(item);
        const loader = new Image();
        loader.decoding = 'async';
        loader.onload = () => {
          if (version !== this.version || !this.dialog.open) return;
          this.image.src = source;
          this.image.hidden = false;
          this.status.textContent = '';
          this.schedule();
          if (!navigator.connection?.saveData && !/(^|-)2g$/.test(navigator.connection?.effectiveType || '')) {
            const following = this.entries[this.index + 1];
            if (following) { const preload = new Image(); preload.decoding = 'async'; preload.src = this.source(following); }
          }
        };
        loader.onerror = () => {
          if (version !== this.version || !this.dialog.open) return;
          this.status.textContent = this.dataset.error;
          this.stop();
          if (item.thumb && item.thumb !== source) { this.image.src = item.thumb; this.image.hidden = false; }
        };
        loader.src = source;
      }
      async page(number) {
        if (number < 1 || number > this.pages || this.loadedPages.has(number)) return;
        if (this.requests.has(number)) return this.requests.get(number);
        const session = this.session;
        const request = (async () => {
          const url = new URL(this.baseURL);
          url.searchParams.set('page', String(number));
          url.searchParams.set('sections', this.dataset.section);
          url.hash = '';
          const abort = new AbortController();
          this.pageAbort = abort;
          const timeout = setTimeout(() => abort.abort(), 12000);
          try {
            const response = await fetch(url, { signal: abort.signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error('Gallery page unavailable');
            const json = await response.json();
            const html = json[this.dataset.section];
            if (!html) throw new Error('Gallery section unavailable');
            const template = document.createElement('template');
            template.innerHTML = html;
            const items = this.readCards(template.content);
            if (!items.length) throw new Error('Gallery page empty');
            if (this.dialog.open && session === this.session) this.merge(items);
          } finally { clearTimeout(timeout); }
        })().finally(() => this.requests.delete(number));
        this.requests.set(number, request);
        return request;
      }
      async step(direction) {
        if (this.moving || !this.dialog.open) return;
        this.moving = true;
        try {
          if (this.index + direction >= this.entries.length) {
            const last = Math.max(...this.loadedPages);
            if (last >= this.pages) { this.stop(); return; }
            this.status.textContent = this.dataset.loading;
            await this.page(last + 1);
          } else if (this.index + direction < 0) {
            const first = Math.min(...this.loadedPages);
            if (first <= 1) return;
            this.status.textContent = this.dataset.loading;
            await this.page(first - 1);
          }
          if (!this.dialog.open) return;
          this.index = Math.max(0, Math.min(this.entries.length - 1, this.index + direction));
          this.show();
        } catch (_error) { this.status.textContent = this.dataset.error; this.stop(); }
        finally { this.moving = false; }
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.playing && this.dialog.open && !document.hidden) this.timer = setTimeout(() => this.step(1), 6000);
      }
      stop() {
        this.playing = false;
        clearTimeout(this.timer);
        this.play.textContent = this.dataset.play;
        this.play.setAttribute('aria-pressed', 'false');
      }
      close() { this.dialog.close(); }
      cleanup() {
        this.stop();
        this.version++;
        this.pageAbort?.abort();
        document.documentElement.style.overflow = this.oldOverflow || '';
        this.image.removeAttribute('src');
        this.image.hidden = true;
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        if (!this.controller) return;
        if (this.dialog.open) this.close();
        this.controller.abort();
        this.pageAbort?.abort();
        this.dialog.remove();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-country-price-filter"] && !Shopify.designMode) return;
  try {
    (() => {
  function amount(text) {
    let number=String(text||'').replace(/[^0-9.,]/g,'');
    if(!number)return null;
    const comma=number.lastIndexOf(','),dot=number.lastIndexOf('.');
    if(comma>=0&&dot>=0){const decimal=comma>dot?',':'.';number=number.replace(decimal===','?/\./g:/,/g,'').replace(',','.');}
    else if(comma>=0)number=/,\d{1,2}$/.test(number)?number.replace(',','.'):number.replace(/,/g,'');
    else if((number.match(/\./g)||[]).length>1)number=number.replace(/\./g,'');
    const value=Number(number);return Number.isFinite(value)&&value>=0?Math.round(value*100):null;
  }
  function range(min,max){const a=min===''?0:Number(min),b=max===''?Infinity:Number(max);return Number.isFinite(a)&&a>=0&&(Number.isFinite(b)||b===Infinity)&&b>=a?[Math.round(a*100),b===Infinity?Infinity:Math.round(b*100)]:null;}
  if(typeof document==='undefined'){if(typeof module!=='undefined')module.exports={amount,range};return;}
  let dispose=()=>{};
  function init(){
    dispose();const root=document.querySelector('[data-country-price-filter]'),grid=document.querySelector('#ResultsList .product-grid'),results=document.querySelector('results-list.product-grid-container');if(!root||!grid||!results)return;
    const copy=JSON.parse(root.querySelector('[data-price-copy]').textContent),min=root.querySelector('[data-price-min]'),max=root.querySelector('[data-price-max]'),status=root.querySelector('[data-price-status]'),more=root.querySelector('[data-price-more]'),currencyNode=root.querySelector('[data-price-currency]');
    const abort=new AbortController();let limits=null,timer,working=false,country=root.dataset.country,requested=new Set(),stopped=false,currency='';
    try{country=localStorage.getItem('alpha-art-print-country')||country;}catch(_){}
    const selectedCurrency=()=>document.querySelector('[data-translation-shop-currency]')?.value||'EUR';
    const cards=()=>Array.from(grid.querySelectorAll('[data-alpha-product-card]'));
    const write=(node,text)=>{if(node.textContent!==text)node.textContent=text;};
    const schedule=()=>{clearTimeout(timer);timer=setTimeout(render,150);};
    function price(card){
      const type=document.body.dataset.artworkBrowse,finish=document.body.dataset.artworkFinish;
      const cls={phone:'.aph-card-price',mug:'.amg-card-price',board:'.abo-card-price'}[type]||'.asp-card-price';
      const node=card.querySelector(cls);if(!node)return {state:'pending'};
      const key=node.dataset.phonePriceKey||node.dataset.mugPriceKey||node.dataset.boardPriceKey||node.dataset.priceKey||'';
      const parts=key.split(':');if(parts[0]!==country)return {state:'pending'};
      let state='ready';
      if(cls==='.asp-card-price'){
        if(parts[1]!==((type==='canvas'&&finish==='rolled')?'canvas_rolled':finish))return {state:'pending'};
        state=parts[3];
      }else if(cls==='.aph-card-price')state=parts[3];
      if(state==='loading'||!state)return {state:'pending'};
      if(state==='error')return {state:'error'};
      const money=node.querySelector('.money');if(!money)return {state:'unavailable'};
      const converted=money.dataset.translationShopRenderedText;
      if(currency!=='EUR'&&(!converted||converted!==money.textContent))return {state:'pending'};
      const value=amount(money.textContent);return value===null?{state:'error'}:{state:'ready',value};
    }
    function requestBatch(){
      let count=0;for(const card of cards()){
        if(requested.has(card)||price(card).state!=='pending')continue;requested.add(card);card.setAttribute('data-price-filter-requested','');if(++count>=24)break;
      }
      window.dispatchEvent(new CustomEvent('alpha:price-filter-evaluate'));schedule();return count;
    }
    function render(){
      if(stopped)return;
      const nextCurrency=selectedCurrency();if(currency&&currency!==nextCurrency){limits=null;min.value='';max.value='';write(status,copy.currencyChanged);}
      currency=nextCurrency;write(currencyNode,'('+currency+')');
      document.documentElement.toggleAttribute('data-price-filter-active',!!limits);
      if(!limits){for(const card of cards())card.closest('.product-grid__item')?.removeAttribute('data-price-accepted');more.hidden=true;return;}
      let matched=0,checked=0,pending=0,errors=0;const all=cards();
      for(const card of all){
        const p=price(card),item=card.closest('.product-grid__item');
        const accepted=p.state==='ready'&&p.value>=limits[0]&&p.value<=limits[1];
        if(item&&item.hasAttribute('data-price-accepted')!==accepted)item.toggleAttribute('data-price-accepted',accepted);
        if(accepted)matched++;
        if(p.state==='ready'||p.state==='unavailable')checked++;else if(p.state==='error')errors++;else if(requested.has(card))pending++;
      }
      const unrequested=all.some(card=>!requested.has(card)&&price(card).state==='pending');
      const hasMore=unrequested||(results.alphaPricePagination?results.alphaPricePagination.more():all.length<Number(root.dataset.total));
      more.hidden=!hasMore;more.disabled=working||pending>0||!!results.alphaPricePagination?.busy();
      let message=copy.progress.replace('[matches]',matched).replace('[checked]',checked).replace('[loaded]',all.length).replace('[total]',root.dataset.total);
      if(pending||working)message+=' '+copy.pending;
      if(errors)message+=' '+copy.error.replace('[count]',errors);
      if(!hasMore&&!pending&&!errors)message+=' '+copy.complete;
      write(status,message);
    }
    root.querySelector('[data-price-form]').addEventListener('submit',event=>{
      event.preventDefault();const next=range(min.value,max.value);if(!next){write(status,copy.invalid);return;}
      limits=min.value===''&&max.value===''?null:next;requested.clear();cards().forEach(c=>c.removeAttribute('data-price-filter-requested'));write(status,'');
      render();if(limits)requestBatch();
    },{signal:abort.signal});
    root.querySelector('[data-price-reset]').addEventListener('click',()=>{limits=null;min.value='';max.value='';requested.clear();cards().forEach(c=>c.removeAttribute('data-price-filter-requested'));write(status,'');render();},{signal:abort.signal});
    more.addEventListener('click',async()=>{
      if(working)return;working=true;render();try{
        if(!cards().some(c=>!requested.has(c)&&price(c).state==='pending'))await results.alphaPricePagination?.load();
        requestBatch();
      }finally{working=false;schedule();}
    },{signal:abort.signal});
    const observer=new MutationObserver(schedule);observer.observe(grid,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['data-price-key','data-phone-price-key','data-mug-price-key','data-board-price-key','data-translation-shop-rendered-text']});
    const refresh=()=>{requested.clear();cards().forEach(c=>c.removeAttribute('data-price-filter-requested'));if(limits)requestBatch();schedule();};
    window.addEventListener('alpha:artwork-browse',refresh,{signal:abort.signal});
    window.addEventListener('alpha-art-print:country-change',event=>{country=String(event.detail?.country||country).toUpperCase();refresh();},{signal:abort.signal});
    document.addEventListener('change',event=>{if(event.target.matches('[data-translation-shop-currency]'))schedule();},{signal:abort.signal});
    window.addEventListener('storage',event=>{if(event.key==='alpha-art-print-country'){country=String(event.newValue||root.dataset.country).toUpperCase();refresh();}},{signal:abort.signal});
    root.hidden=false;render();
    dispose=()=>{stopped=true;clearTimeout(timer);abort.abort();observer.disconnect();document.documentElement.removeAttribute('data-price-filter-active');cards().forEach(c=>{c.removeAttribute('data-price-filter-requested');c.closest('.product-grid__item')?.removeAttribute('data-price-accepted');});};
  }
  document.addEventListener('shopify:section:load',init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-dibond-commerce"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const box=document.querySelector('[data-dibond-commerce]'),root=box?.closest('[data-dibond-preview]');
    if(!root||box.dataset.initialized)return;
    box.dataset.initialized='true';
    const source=JSON.parse(box.querySelector('[data-dibond-source]').textContent),copy=JSON.parse(box.querySelector('[data-dibond-commerce-copy]').textContent);
    const pay=box.querySelector('[data-dibond-pay]'),add=box.querySelector('[data-dibond-add]'),error=box.querySelector('[data-dibond-commerce-error]');
    let loadTimer;let native,dialog,home,form,submit,originalLabel,owned=false,paying=false,uncertain=false,options=[],loadedCountry='',fetched=0,loading='',sequence=0,openedSelection='';
    const active=()=>document.body.dataset.artworkBrowse==='print'&&document.body.dataset.artworkFinish==='dibond';
    const selection=()=>{try{return active()?JSON.parse(root.dataset.dibondSelection||'null'):null;}catch{return null;}};
    const signature=()=>{const s=selection();return s?JSON.stringify(s):'';};
    const current=()=>{const s=selection();return s&&signature()===loadedCountry?options.find(o=>o.rigid?.selection.sku===s.sku&&o.rigid.selection.surface===s.surface&&Math.round(o.totalPriceEur*100)===s.priceCents):null;};
    const fail=message=>{error.textContent=message||copy.error;error.hidden=false;};
    function endpoint(){
      const url=new URL(native.dataset.aapProxy,location.origin);
      if(url.origin!==location.origin||url.pathname!=='/apps/alpha-art-print')throw Error('UNAVAILABLE');
      return url;
    }
    function close(){if(owned&&dialog.open)dialog.close();}
    function render(){
      const available=Boolean(current())&&!uncertain;
      const selected=selection();
      box.hidden=!active()||!selected;pay.disabled=add.disabled=!available||paying;
      if(!selected)error.hidden=true;
      const total=root.querySelector('[data-dibond-price]');
      const target=box.querySelector('[data-dibond-pay-total]');
      const amount=selected&&total?total.querySelector('.money')?.textContent||'':'';
      if(target.textContent!==amount)target.textContent=amount;
      for(const el of root.querySelectorAll('.amg-pending'))el.hidden=!selected||available;
      root.dataset.dibondCheckout=available?'ready':'unavailable';
      root.dataset.dibondPaying=String(paying);
    }
    async function load(force=false){
      const s=selection();if(!native||!s)return;const key=signature();
      if(!force&&loadedCountry===key&&Date.now()-fetched<20*60*1000){render();return;}
      if(loading===key)return;
      const turn=++sequence;loading=key;options=[];loadedCountry='';render();
      try{
        const url=endpoint();url.searchParams.set('variant',native.dataset.aapVariant);url.searchParams.set('country',s.country);url.searchParams.set('catalog_profile','dibond-v1');url.searchParams.set('panel_sku',s.sku);url.searchParams.set('panel_surface',s.surface);
        const response=await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(30000)});
        const data=await response.json();
        if(!response.ok||data.offerProfile!=='dibond-v1'||data.countryCode!==s.country||!Array.isArray(data.options))throw Error('UNAVAILABLE');
        if(turn!==sequence||signature()!==key)return;
        options=data.options.filter(o=>o.supportId==='aluminium-panel'&&o.offerProfile==='dibond-v1'&&typeof o.quoteToken==='string'&&Number.isFinite(o.totalPriceEur));
        loadedCountry=key;fetched=Date.now();error.hidden=true;
      }catch{if(turn===sequence)fail();}
      finally{if(turn===sequence){loading='';render();}}
    }
    function syncAddress(){
      const s=selection(),countries=native.querySelector('[data-aap-country]');
      const country=[...countries.options].find(o=>o.value===s.country);
      if(!country)throw Error('UNAVAILABLE');
      form.querySelector('[data-aap-address-country]').textContent=country.textContent;
      const normalize=t=>String(t||'').trim().normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
      const metadata=native.querySelector('[data-aap-country-metadata]');
      const item=metadata&&[...metadata.options].find(o=>normalize(o.textContent)===normalize(country.textContent));
      const provinces=JSON.parse(item?.dataset.provinces||'[]');
      const field=form.querySelector('[data-aap-address-province-field]'),province=form.querySelector('[data-aap-address-province]');
      province.replaceChildren();field.hidden=!provinces.length;province.required=Boolean(provinces.length);
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});province.disabled=!provinces.length;
      if(provinces.length){province.append(new Option(copy.choose,''));for(const p of provinces)province.append(new Option(p[1],p[0]));}
      submit.disabled=false;submit.textContent=originalLabel;
      form.querySelector('[data-aap-address-error]').textContent='';
    }
    async function submitAddress(event){
      if(!owned)return;
      event.preventDefault();event.stopImmediatePropagation();
      if(paying||uncertain||!active()||openedSelection!==signature()||!current()||!form.reportValidity())return;
      const s=selection(),option=current();
      if(Date.now()-fetched>25*60*1000){close();options=[];render();await load(true);return;}
      const shippingAddress=Object.fromEntries(new FormData(form));shippingAddress.countryCode=s.country;
      paying=true;render();submit.disabled=true;submit.textContent=copy.loading;
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=true;});
      try{
        const response=await fetch(endpoint(),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({quoteToken:option.quoteToken,shippingAddress}),signal:AbortSignal.timeout(30000)});
        const result=await response.json();
        if(!response.ok){if(response.status>=500)uncertain=true;throw Error('CHECKOUT');}
        const url=new URL(result.checkoutUrl);
        if(url.protocol!=='https:'||(!/(^|\.)alphachristianart\.com$/.test(url.hostname)&&url.hostname!==box.dataset.shop))throw Error('CHECKOUT');
        location.assign(url.href);
      }catch{uncertain=true;fail(copy.uncertain);form.querySelector('[data-aap-address-error]').textContent=copy.uncertain;}
      finally{paying=false;render();submit.textContent=originalLabel;submit.disabled=true;}
    }
    function attach(){
      native=document.querySelector('[data-aap-root]');dialog=native?.querySelector('[data-aap-address-dialog]');form=dialog?.querySelector('[data-aap-address-form]');submit=form?.querySelector('[data-aap-address-submit]');
      if(!native?.dataset.aapVariant||!form||!submit||!native.querySelector('[data-aap-country]')?.options.length)return false;
      home=document.createComment('dibond-address-home');dialog.before(home);originalLabel=submit.textContent;
      for(const key of ['--aap-accent','--aap-ink','--aap-muted','--aap-font']){const value=getComputedStyle(native).getPropertyValue(key);if(value)box.style.setProperty(key,value);}
      form.addEventListener('submit',submitAddress,true);
      dialog.addEventListener('close',()=>{if(!owned)return;owned=false;home.after(dialog);form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});submit.disabled=false;submit.textContent=originalLabel;if(active())pay.focus();});
      load();return true;
    }
    pay.addEventListener('click',async()=>{
      const before=signature();if(!before||paying||uncertain)return;
      paying=true;render();await load(true);paying=false;render();
      if(before!==signature()||!current())return;
      try{syncAddress();owned=true;openedSelection=signature();box.append(dialog);dialog.showModal();form.querySelector('input[name="firstName"]')?.focus();}catch{owned=false;home.after(dialog);fail();}
    });
    add.addEventListener('click',async()=>{
      const before=signature(),s=selection(),o=current(),wallet=document.querySelector('artwork-credit-cart');if(!s||!o||paying||!wallet?.addRigidConfiguration)return;
      paying=true;render();
      try{await wallet.addRigidConfiguration(source,{variantId:'gid://shopify/ProductVariant/'+native.dataset.aapVariant,country:s.country,optionId:o.id,priceCents:s.priceCents,label:o.supportLabel+' · '+(s.label||o.widthMm/10+' × '+o.heightMm/10+' cm')+' · '+o.finishLabel},()=>before===signature());}catch{fail();}finally{paying=false;render();}
    });
    window.addEventListener('alpha:dibond-selection',()=>{if(owned&&signature()!==openedSelection&&!paying)close();render();clearTimeout(loadTimer);loadTimer=setTimeout(()=>load(),450);});
    window.addEventListener('alpha:artwork-browse',()=>{if(!active()&&!paying)close();render();});
    const price=root.querySelector('[data-dibond-price]');
    if(price)new MutationObserver(render).observe(price,{childList:true,subtree:true,characterData:true});
    let tries=0;const timer=setInterval(()=>{if(attach()||++tries>60)clearInterval(timer);},500);
    render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-dibond-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const artworkRatio = image => {
    if(!image)return NaN;
    const declared=Number(image.closest('[data-artwork-ratio]')?.dataset.artworkRatio);
    if(Number.isFinite(declared)&&declared>0)return declared;
    const width=Number(image.getAttribute('width')),height=Number(image.getAttribute('height'));
    if(width>0&&height>0)return width/height;
    return image.naturalWidth>0&&image.naturalHeight>0?image.naturalWidth/image.naturalHeight:NaN;
  };
  const printLayout = (format, ratio) => {
    if (!format || ![format.w,format.h,ratio].every(v=>Number.isFinite(v)&&v>0) || format.w<=10 || format.h<=10) return null;
    const border=0;
    const width=Math.max(format.w,format.h*ratio),height=width/ratio;
    return {width,height,left:(format.w-width)/2,top:(format.h-height)/2,border,visibleFraction:format.w*format.h/(width*height)};
  };
  const geometryFit = (format, ratio, width, height) => {
    const image=printLayout(format,ratio);
    if(!image||![width,height].every(v=>Number.isFinite(v)&&v>0))return null;
    const scale=Math.min(width*.88/format.w,height*.88/format.h);
    return {image,scale,w:format.w*scale,h:format.h*scale};
  };
  const eligible = (format, ratio) => {
    if(!printLayout(format,ratio))return false;
    const orientation=r=>Math.abs(r-1)<.02?0:Math.sign(r-1);
    const border=0;
    const imageRatio=(format.w-2*border)/(format.h-2*border);
    return orientation(format.w/format.h)===orientation(ratio)&&Math.min(ratio/imageRatio,imageRatio/ratio)>=.85;
  };
  const roomGeometry = (format,ratio,width,height) => {
    const image=printLayout(format,ratio);
    if(!image||![width,height].every(v=>Number.isFinite(v)&&v>0))return null;
    const reference=height*.64,scale=reference/1700;
    return {image,scale,reference,w:format.w*scale,h:format.h*scale,x:width*.5,y:height*.45};
  };
  function applyArtGeometry(art,f,shade='matte'){
    if(!f)return;
    const styles={'--dp-w':f.w+'px','--dp-h':f.h+'px','--dp-depth':Math.max(.5,Math.min(5,3*f.scale))+'px','--dp-image-w':f.image.width*f.scale+'px','--dp-image-h':f.image.height*f.scale+'px','--dp-image-top':f.image.top*f.scale+'px','--dp-image-left':f.image.left*f.scale+'px'};
    for(const [k,v]of Object.entries(styles))if(art.style.getPropertyValue(k)!==v)art.style.setProperty(k,v);
    art.dataset.surface=shade;
  }
  if(typeof document==='undefined'){if(typeof module!=='undefined')module.exports={printLayout,geometryFit,eligible,artworkRatio,roomGeometry};return;}
  function initThumbnails(){
    document.querySelectorAll('.adp-choice .adp-art').forEach(art=>{
      if(art.dataset.thumbnailReady)return;art.dataset.thumbnailReady='true';
      const img=art.querySelector('img'),stage=art.parentElement;
      const draw=()=>{const ratio=artworkRatio(img);if(ratio>0)applyArtGeometry(art,geometryFit({w:300*ratio,h:300},ratio,stage.clientWidth,stage.clientHeight),'matte');};
      new ResizeObserver(draw).observe(stage);img?.addEventListener('load',draw);draw();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initThumbnails,{once:true});else initThumbnails();
  document.addEventListener('shopify:section:load',initThumbnails);
  async function init(){
    const root=document.querySelector('[data-dibond-preview]');
    if(!root||root.dataset.initialized)return;
    if(document.body.dataset.artworkFinish!=='dibond')return;
    root.dataset.initialized='true';
    const copy=JSON.parse(root.querySelector('[data-dibond-copy]').textContent);
    let data;
    try {
      const response=await fetch(JSON.parse(document.querySelector('[data-dibond-catalog-url]').textContent));
      if(!response.ok)throw Error('CATALOG');
      data=await response.json();
      if(!data.version||data.checkoutEnabled!==true||!Array.isArray(data.products))throw Error('CATALOG');
    } catch (_) {
      delete root.dataset.initialized;
      if(document.body.dataset.artworkFinish==='dibond'){
        root.hidden=root.dataset.page!=='product';document.body.classList.add('adp-active');
        const status=root.querySelector('[data-dibond-status]');if(status)status.textContent=copy.unavailable;
      }
      return;
    }
    const product=root.dataset.page==='product';
    let country;try{country=localStorage.getItem('alpha-art-print-country');}catch(_){}
    country=country||root.dataset.defaultCountry;
    let surface='matte',unit='cm',selected=null,active=false;
    const entries=new Map();
    const number=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:2}).format(value);
    const measure=value=>number(value/(unit==='cm'?10:25.4))+(unit==='cm'?' cm':'″');
    const dimensions=(w,h)=>number(w/(unit==='cm'?10:25.4))+' × '+measure(h);
    const money=value=>{const span=document.createElement('span');span.className='money';span.textContent=(value/100).toFixed(2)+' €';return span;};
    const text=(selector,value)=>{const e=root.querySelector(selector);if(e)e.textContent=value;};
    const regionName=code=>{try{return new Intl.DisplayNames([document.documentElement.lang||'en'],{type:'region'}).of(code);}catch(_){return data.names[code]||code;}};
    function options(ratio,shade=surface){return (data.countries[country]||[]).map(i=>data.quotes[i]).filter(q=>data.products[q[0]].surface===shade&&eligible(data.products[q[0]],ratio));}
    function best(ratio){return options(ratio).sort((a,b)=>Math.abs(Math.log(Math.max(data.products[a[0]].w,data.products[a[0]].h)/500))-Math.abs(Math.log(Math.max(data.products[b[0]].w,data.products[b[0]].h)/500))||Math.abs(data.products[a[0]].w/data.products[a[0]].h-ratio)-Math.abs(data.products[b[0]].w/data.products[b[0]].h-ratio))[0];}
    function setArt(art,format,ratio,shade=surface){
      const stage=art.parentElement;
      applyArtGeometry(art,geometryFit(format,ratio,stage.clientWidth,stage.clientHeight),shade);
    }
    const resize=new ResizeObserver(()=>renderArt());
    const hero=root.querySelector('[data-dibond-art]');
    const heroImage=hero?.querySelector('img');
    if(hero){resize.observe(hero.parentElement);heroImage.addEventListener('load',render);}
    const roomHost=root.querySelector('[data-dibond-room-host]');
    let room=null;
    function ensureRoom(){
      if(room||!roomHost||!hero)return;
      const source=document.querySelector('[data-aap-room]')?.closest('.aap-preview');
      if(!source)return;
      const section=source.cloneNode(true),stage=section.querySelector('[data-aap-room]');
      const oldArt=section.querySelector('[data-aap-preview]'),reference=section.querySelector('[data-aap-reference]'),label=section.querySelector('[data-aap-preview-dimension]'),zoom=section.querySelector('[data-aap-zoom]');
      if(!stage||!oldArt||!reference||!label||!zoom)return;
      section.querySelectorAll('*').forEach(el=>{el.removeAttribute('id');for(const attr of [...el.attributes])if(attr.name.startsWith('data-aap-'))el.removeAttribute(attr.name);});
      section.classList.add('adp-room');
      section.setAttribute('aria-labelledby','DibondRoomTitle');
      section.querySelector('h3').id='DibondRoomTitle';
      const titleStyle=getComputedStyle(source.querySelector('h3'));
      section.querySelector('h3').style.fontFamily=titleStyle.fontFamily;
      section.querySelector('h3').style.fontWeight=titleStyle.fontWeight;
      const art=hero.cloneNode(true);art.removeAttribute('data-dibond-art');art.classList.add('adp-room-art');art.dataset.dibondRoomArt='';
      const painting=art.querySelector('img');painting.removeAttribute('srcset');painting.removeAttribute('sizes');painting.loading='lazy';painting.fetchPriority='low';painting.alt=heroImage.alt;
      oldArt.replaceWith(art);
      section.querySelectorAll('img').forEach(img=>{img.loading='lazy';img.decoding='async';});
      const dialog=document.createElement('dialog');dialog.className='adp-room-dialog';dialog.setAttribute('aria-labelledby','DibondRoomTitle');
      const zoomMarkup=zoom.innerHTML,zoomLabel=zoom.getAttribute('aria-label');
      zoom.setAttribute('aria-haspopup','dialog');zoom.setAttribute('aria-expanded','false');
      zoom.addEventListener('click',()=>{
        if(dialog.open){dialog.close();return;}
        dialog.append(section);dialog.showModal();zoom.textContent=copy.close;zoom.setAttribute('aria-label',copy.close);zoom.setAttribute('aria-expanded','true');requestAnimationFrame(renderRoom);
      });
      dialog.addEventListener('close',()=>{roomHost.insertBefore(section,dialog);zoom.innerHTML=zoomMarkup;if(zoomLabel)zoom.setAttribute('aria-label',zoomLabel);zoom.setAttribute('aria-expanded','false');requestAnimationFrame(()=>{renderRoom();if(active)zoom.focus({preventScroll:true});});});
      dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
      room={section,stage,art,reference,label,dialog,painting};
      roomHost.append(section,dialog);resize.observe(stage);
    }
    function renderRoom(){
      if(!room||!selected||!active)return;
      const f=roomGeometry(data.products[selected[0]],artworkRatio(heroImage),room.stage.clientWidth,room.stage.clientHeight);
      if(!f)return;
      applyArtGeometry(room.art,f,surface);
      room.art.style.left=f.x+'px';room.art.style.top=f.y+'px';
      room.reference.style.height=f.reference+'px';
      room.label.style.left=f.x+'px';room.label.style.top=(f.y+f.h/2+10)+'px';
      const format=data.products[selected[0]];
      room.label.textContent=dimensions(format.w,format.h);
      room.label.hidden=false;
      if(heroImage.complete&&heroImage.currentSrc&&room.painting.src!==heroImage.currentSrc)room.painting.src=heroImage.currentSrc;
    }
    function renderArt(){
      if(!active)return;
      if(hero&&selected){
        const f=data.products[selected[0]],ratio=artworkRatio(heroImage);
        setArt(hero,f,ratio);
        root.querySelectorAll('[data-dibond-swatch-art]').forEach(art=>setArt(art,f,ratio,art.dataset.dibondSwatchArt));
      }
      renderRoom();
      for(const [card,entry]of entries){
        if(!card.isConnected){resize.unobserve(entry.stage);entry.source.removeEventListener('load',entry.load);entries.delete(card);continue;}
        const ratio=artworkRatio(entry.source);
        const quote=Number.isFinite(ratio)&&best(ratio);
        entry.stage.hidden=!quote;
        card.classList.toggle('adp-card-ready',Boolean(quote));
        if(quote)setArt(entry.art,data.products[quote[0]],ratio);
        const minimum=quote?Math.min(...options(ratio).map(q=>q[1])):null;
        if(entry.minimum!==minimum){entry.minimum=minimum;entry.price.replaceChildren();if(minimum!==null)entry.price.append(document.createTextNode(copy.from+' '),money(minimum),document.createElement('br'),document.createTextNode(copy.shipping_included));else entry.price.textContent=copy.no_size;}
      }
    }
    function render(){
      active=document.body.dataset.artworkBrowse==='print'&&document.body.dataset.artworkFinish==='dibond';
      root.hidden=!active||!product;
      document.body.classList.toggle('adp-active',active);
      if(heroImage)heroImage.fetchPriority=active?'high':'auto';
      if(!active){delete root.dataset.dibondSelection;window.dispatchEvent(new Event('alpha:dibond-selection'));if(room?.dialog.open)room.dialog.close();root.classList.remove('adp-zoomed');const zoom=root.querySelector('[data-dibond-zoom]');if(zoom)zoom.textContent=copy.zoom;return;}
      if(heroImage)heroImage.loading='eager';
      if(root.dataset.wall&&!root.dataset.wall.includes('Liquid error'))document.body.style.setProperty('--dp-photo-wall','url("'+root.dataset.wall+'")');
      if(!product){requestAnimationFrame(decorate);return;}
      ensureRoom();
      text('[data-dibond-country]',regionName(country));
      const validCountry=Boolean(data.countries[country]?.length);
      const ratio=artworkRatio(heroImage);
      let choices=product&&Number.isFinite(ratio)?options(ratio):[];
      choices.sort((a,b)=>data.products[a[0]].w*data.products[a[0]].h-data.products[b[0]].w*data.products[b[0]].h);
      if(product){
        const old=selected&&data.products[selected[0]];
        selected=choices.find(q=>data.products[q[0]].w===old?.w&&data.products[q[0]].h===old?.h)||best(ratio)||null;
        const sizes=root.querySelector('[data-dibond-sizes]');sizes.replaceChildren();
        for(const q of choices){const f=data.products[q[0]],button=document.createElement('button'),label=document.createElement('strong');button.type='button';button.dataset.dibondSize=String(q[0]);button.setAttribute('aria-pressed',String(q===selected));label.textContent=dimensions(f.w,f.h);button.append(label,money(q[1]));sizes.append(button);}
      }
      root.querySelector('[data-dibond-price-card]').hidden=!product||!selected;
      root.querySelector('[data-dibond-details]').hidden=!product||!selected;
      if(hero)hero.parentElement.hidden=!selected;
      if(roomHost)roomHost.hidden=!selected;
      if(selected&&product){
        const f=data.products[selected[0]];
        hero.parentElement.dataset.orientation=f.w/f.h>1.05?'landscape':f.w/f.h<.95?'portrait':'square';
        text('[data-dibond-selected-size]',dimensions(f.w,f.h));text('[data-dibond-print-size]',dimensions(f.w,f.h));text('[data-dibond-image-size]',dimensions(f.w,f.h));text('[data-dibond-origin]',regionName(selected[3]));
        text('[data-dibond-transit]',selected[4]===null||selected[5]===null?copy.transit_unknown:(selected[4]===selected[5]?selected[4]:selected[4]+'–'+selected[5])+' '+copy.days);
        root.querySelector('[data-dibond-price]').replaceChildren(money(selected[1]));
        root.querySelector('[data-dibond-shipping]').replaceChildren(document.createTextNode(copy.included+' ('),money(selected[2]),document.createTextNode(')'));
      }else text('[data-dibond-origin]','—');
      root.querySelectorAll('[data-dibond-surface]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.dibondSurface===surface));b.disabled=!options(ratio,b.dataset.dibondSurface).length;});
      root.querySelectorAll('[data-dibond-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.dibondUnit===unit)));
      text('[data-dibond-status]',!validCountry?copy.unavailable:product&&!selected?copy.no_size:copy.ready);
      root.dataset.dibondState=validCountry&&(!product||selected)?'ready':'unavailable';
      root.dataset.dibondSelection=selected?JSON.stringify({sku:data.products[selected[0]].sku,surface,country,priceCents:selected[1],label:dimensions(data.products[selected[0]].w,data.products[selected[0]].h),fit:'cover',cropPosition:'center'}):'';
      window.dispatchEvent(new Event('alpha:dibond-selection'));
      requestAnimationFrame(decorate);
    }
    function decorate(){
      if(!active)return;
      document.querySelectorAll('[data-alpha-product-card]').forEach(card=>{
        if(entries.has(card))return;
        const source=card.querySelector('.alpha-product-card__artwork-frame img'),media=card.querySelector('.alpha-product-card__media');
        if(!source||!media)return;
        const stage=document.createElement('div');stage.className='adp-stage adp-card-stage';
        const art=document.createElement('div');art.className='adp-art';
        art.innerHTML='<div class="adp-paper"><div class="adp-image-area"></div></div>';
        const img=source.cloneNode();img.removeAttribute('id');img.className='adp-image';img.alt='';img.decoding='async';img.fetchPriority='auto';
        const syncImage=()=>{if(source.complete&&source.naturalWidth&&source.currentSrc){img.removeAttribute('srcset');img.removeAttribute('sizes');if(img.src!==source.currentSrc)img.src=source.currentSrc;}};
        syncImage();art.querySelector('.adp-image-area').append(img);stage.append(art);media.append(stage);
        const price=document.createElement('p');price.className='adp-card-price';card.append(price);
        const load=()=>{syncImage();renderArt();};source.addEventListener('load',load);entries.set(card,{source,stage,art,load,price,minimum:undefined});resize.observe(stage);
      });renderArt();
    }
    root.addEventListener('click',e=>{
      if(root.dataset.dibondPaying==='true')return;
      const size=e.target.closest('[data-dibond-size]'),shade=e.target.closest('[data-dibond-surface]'),units=e.target.closest('[data-dibond-unit]');
      if(size){selected=options(artworkRatio(heroImage)).find(q=>q[0]===Number(size.dataset.dibondSize));render();root.querySelector('[data-dibond-size="'+size.dataset.dibondSize+'"]')?.focus({preventScroll:true});}
      if(shade){surface=shade.dataset.dibondSurface;render();}
      if(units){unit=units.dataset.dibondUnit;render();}
      if(e.target.closest('[data-dibond-zoom]')){root.classList.toggle('adp-zoomed');e.target.textContent=root.classList.contains('adp-zoomed')?copy.close:copy.zoom;requestAnimationFrame(renderArt);}
    });
    document.addEventListener('keydown',e=>{if(e.key==='Escape'){root.classList.remove('adp-zoomed');if(root.querySelector('[data-dibond-zoom]'))root.querySelector('[data-dibond-zoom]').textContent=copy.zoom;}});
    window.addEventListener('alpha:artwork-browse',render);
    window.addEventListener('alpha-art-print:country-change',e=>{if(/^[A-Z]{2}$/.test(e.detail?.country)){country=e.detail.country;render();}});
    window.addEventListener('storage',e=>{if(e.key==='alpha-art-print-country'&&e.newValue){country=e.newValue;render();}});
    const grid=document.querySelector('#ResultsList');if(grid)new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-alpha-product-card], li')||n.querySelector('[data-alpha-product-card]')))))decorate();}).observe(grid,{childList:true,subtree:true});
    decorate();render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  window.addEventListener('alpha:artwork-browse',init);
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-display-terminology"] && !Shopify.designMode) return;
  try {
    (() => {
  const normalise = (value, copy) => value
    .replace(/\ble tirage Fine Art\b/g, 'l’' + copy.printNoun + ' Fine Art')
    .replace(/\ben tirage Fine Art\b/g, 'en ' + copy.printNoun + ' Fine Art')
    .replace(/\bTirage Fine Art\b/g, copy.fineArt)
    .replace(/\bDIBOND\b/g, copy.aluminium.toUpperCase())
    .replace(/\bDibond\b/g, copy.aluminiumTitle)
    .replace(/\bdibond\b/g, copy.aluminium);
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { normalise };
    return;
  }
  const initialise = () => {
    const marker = document.querySelector('[data-alpha-display-terminology]');
    const main = document.querySelector('#MainContent');
    if (!marker || !main) return;
    const copy = JSON.parse(marker.textContent);
    const eligible = '.rte, .aap-panel__lead, [data-achc-section], [data-alpha-collection-description]';
    const ignored = 'script, style, textarea, input, select, option, code, pre, [contenteditable], [translate="no"]';
    const update = node => {
      const parent = node.parentElement;
      if (!parent || !parent.closest(eligible) || parent.closest(ignored)) return;
      const next = normalise(node.nodeValue, copy);
      if (next !== node.nodeValue) node.nodeValue = next;
    };
    const visit = node => {
      if (node.nodeType === Node.TEXT_NODE) { update(node); return; }
      if (node.nodeType !== Node.ELEMENT_NODE || node.matches(ignored)) return;
      const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) update(walker.currentNode);
    };
    visit(main);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') update(record.target);
        else record.addedNodes.forEach(visit);
      }
    }).observe(main, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-email-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.querySelector('[data-alpha-email-popup]');
    if (!(popup instanceof HTMLDialogElement)) return;

    const dismissedKey = 'alphaEmailPopupDismissedAt';
    const subscribedKey = 'alphaEmailPopupSubscribed';
    const success = Boolean(popup.querySelector('.alpha-email-popup__message--success'));

    const rememberDismissal = () => {
      try {
        localStorage.setItem(dismissedKey, String(Date.now()));
      } catch (_) {}
    };

    popup.querySelector('[data-alpha-email-popup-close]')?.addEventListener('click', () => {
      rememberDismissal();
      popup.close();
    });

    popup.addEventListener('cancel', rememberDismissal);
    popup.addEventListener('click', (event) => {
      if (event.target !== popup) return;
      const bounds = popup.getBoundingClientRect();
      const inside = event.clientX >= bounds.left && event.clientX <= bounds.right
        && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
      if (!inside) {
        rememberDismissal();
        popup.close();
      }
    });

    if (success) {
      try { localStorage.setItem(subscribedKey, 'true'); } catch (_) {}
      popup.showModal();
      return;
    }

    let shouldShow = true;
    try {
      if (localStorage.getItem(subscribedKey) === 'true') shouldShow = false;
      const dismissedAt = Number(localStorage.getItem(dismissedKey) || 0);
      if (dismissedAt && Date.now() - dismissedAt < 14 * 24 * 60 * 60 * 1000) shouldShow = false;
    } catch (_) {}

    if (shouldShow && !Shopify.designMode) {
      window.setTimeout(() => {
        if (!popup.open) popup.showModal();
      }, 8000);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-foil-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const artworkRatio = image => {
    if(!image)return NaN;
    const declared=Number(image.closest('[data-artwork-ratio]')?.dataset.artworkRatio);
    if(Number.isFinite(declared)&&declared>0)return declared;
    const width=Number(image.getAttribute('width')),height=Number(image.getAttribute('height'));
    if(width>0&&height>0)return width/height;
    return image.naturalWidth>0&&image.naturalHeight>0?image.naturalWidth/image.naturalHeight:NaN;
  };
  const printLayout = (format, ratio) => {
    if (!format || ![format.w,format.h,ratio].every(v=>Number.isFinite(v)&&v>0) || format.w<=10 || format.h<=10) return null;
    const border=Math.max(5,Math.min(format.w,format.h)*.05);
    const width=Math.min(format.w-2*border,(format.h-2*border)*ratio),height=width/ratio;
    return {width,height,left:(format.w-width)/2,top:(format.h-height)/2,border};
  };
  const geometryFit = (format, ratio, width, height) => {
    const image=printLayout(format,ratio);
    if(!image||![width,height].every(v=>Number.isFinite(v)&&v>0))return null;
    const scale=Math.min(width*.88/format.w,height*.88/format.h);
    return {image,scale,w:format.w*scale,h:format.h*scale};
  };
  const eligible = (format, ratio) => {
    if(!printLayout(format,ratio))return false;
    const orientation=r=>Math.abs(r-1)<.02?0:Math.sign(r-1);
    const border=Math.max(5,Math.min(format.w,format.h)*.05);
    const imageRatio=(format.w-2*border)/(format.h-2*border);
    return orientation(format.w/format.h)===orientation(ratio)&&Math.min(ratio/imageRatio,imageRatio/ratio)>=.80;
  };
  const roomGeometry = (format,ratio,width,height) => {
    const image=printLayout(format,ratio);
    if(!image||![width,height].every(v=>Number.isFinite(v)&&v>0))return null;
    const reference=height*.64,scale=reference/1700;
    return {image,scale,reference,w:format.w*scale,h:format.h*scale,x:width*.5,y:height*.45};
  };
  function applyArtGeometry(art,f,shade='gold'){
    if(!f)return;
    const styles={'--fp-w':f.w+'px','--fp-h':f.h+'px','--fp-image-w':f.image.width*f.scale+'px','--fp-image-h':f.image.height*f.scale+'px','--fp-image-top':f.image.top*f.scale+'px','--fp-image-left':f.image.left*f.scale+'px'};
    for(const [k,v]of Object.entries(styles))if(art.style.getPropertyValue(k)!==v)art.style.setProperty(k,v);
    art.dataset.color=shade;
  }
  if(typeof document==='undefined'){if(typeof module!=='undefined')module.exports={printLayout,geometryFit,eligible,artworkRatio,roomGeometry};return;}
  function initThumbnails(){
    document.querySelectorAll('.afp-choice .afp-art').forEach(art=>{
      if(art.dataset.thumbnailReady)return;art.dataset.thumbnailReady='true';
      const img=art.querySelector('img'),stage=art.parentElement;
      const draw=()=>{const ratio=artworkRatio(img);if(ratio>0)applyArtGeometry(art,geometryFit({w:300*ratio+32,h:332},ratio,stage.clientWidth,stage.clientHeight),'gold');};
      new ResizeObserver(draw).observe(stage);img?.addEventListener('load',draw);draw();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initThumbnails,{once:true});else initThumbnails();
  document.addEventListener('shopify:section:load',initThumbnails);
  async function init(){
    const root=document.querySelector('[data-foil-preview]');
    if(!root||root.dataset.initialized)return;
    if(document.body.dataset.artworkFinish!=='foil')return;
    root.dataset.initialized='true';
    const copy=JSON.parse(root.querySelector('[data-foil-copy]').textContent);
    let data;
    try {
      const response=await fetch(JSON.parse(document.querySelector('[data-foil-catalog-url]').textContent));
      if(!response.ok)throw Error('CATALOG');
      data=await response.json();
      if(!data.version||data.checkoutEnabled!==false||!Array.isArray(data.products))throw Error('CATALOG');
    } catch (_) {
      delete root.dataset.initialized;
      if(document.body.dataset.artworkFinish==='foil'){
        root.hidden=root.dataset.page!=='product';document.body.classList.add('afp-active');
        const status=root.querySelector('[data-foil-status]');if(status)status.textContent=copy.unavailable;
      }
      return;
    }
    const product=root.dataset.page==='product';
    let country;try{country=localStorage.getItem('alpha-art-print-country');}catch(_){}
    country=country||root.dataset.defaultCountry;
    let color='gold',unit='cm',selected=null,active=false;
    const entries=new Map();
    const number=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:2}).format(value);
    const measure=value=>number(value/(unit==='cm'?10:25.4))+(unit==='cm'?' cm':'″');
    const dimensions=(w,h)=>number(w/(unit==='cm'?10:25.4))+' × '+measure(h);
    const money=value=>{const span=document.createElement('span');span.className='money';span.textContent=(value/100).toFixed(2)+' €';return span;};
    const text=(selector,value)=>{const e=root.querySelector(selector);if(e)e.textContent=value;};
    const regionName=code=>{try{return new Intl.DisplayNames([document.documentElement.lang||'en'],{type:'region'}).of(code);}catch(_){return data.names[code]||code;}};
    function options(ratio,shade=color){return (data.countries[country]||[]).map(i=>data.quotes[i]).filter(q=>data.products[q[0]].color===shade&&eligible(data.products[q[0]],ratio));}
    function best(ratio){return options(ratio).sort((a,b)=>Math.abs(Math.log(Math.max(data.products[a[0]].w,data.products[a[0]].h)/500))-Math.abs(Math.log(Math.max(data.products[b[0]].w,data.products[b[0]].h)/500))||Math.abs(data.products[a[0]].w/data.products[a[0]].h-ratio)-Math.abs(data.products[b[0]].w/data.products[b[0]].h-ratio))[0];}
    function setArt(art,format,ratio,shade=color){
      const stage=art.parentElement;
      applyArtGeometry(art,geometryFit(format,ratio,stage.clientWidth,stage.clientHeight),shade);
    }
    const resize=new ResizeObserver(()=>renderArt());
    const hero=root.querySelector('[data-foil-art]');
    const heroImage=hero?.querySelector('img');
    if(hero){resize.observe(hero.parentElement);heroImage.addEventListener('load',render);}
    const roomHost=root.querySelector('[data-foil-room-host]');
    let room=null;
    function ensureRoom(){
      if(room||!roomHost||!hero)return;
      const source=document.querySelector('[data-aap-room]')?.closest('.aap-preview');
      if(!source)return;
      const section=source.cloneNode(true),stage=section.querySelector('[data-aap-room]');
      const oldArt=section.querySelector('[data-aap-preview]'),reference=section.querySelector('[data-aap-reference]'),label=section.querySelector('[data-aap-preview-dimension]'),zoom=section.querySelector('[data-aap-zoom]');
      if(!stage||!oldArt||!reference||!label||!zoom)return;
      section.querySelectorAll('*').forEach(el=>{el.removeAttribute('id');for(const attr of [...el.attributes])if(attr.name.startsWith('data-aap-'))el.removeAttribute(attr.name);});
      section.classList.add('afp-room');
      section.setAttribute('aria-labelledby','FoilRoomTitle');
      section.querySelector('h3').id='FoilRoomTitle';
      const titleStyle=getComputedStyle(source.querySelector('h3'));
      section.querySelector('h3').style.fontFamily=titleStyle.fontFamily;
      section.querySelector('h3').style.fontWeight=titleStyle.fontWeight;
      const art=hero.cloneNode(true);art.removeAttribute('data-foil-art');art.classList.add('afp-room-art');art.dataset.foilRoomArt='';
      const painting=art.querySelector('img');painting.removeAttribute('srcset');painting.removeAttribute('sizes');painting.loading='lazy';painting.fetchPriority='low';painting.alt=heroImage.alt;
      oldArt.replaceWith(art);
      section.querySelectorAll('img').forEach(img=>{img.loading='lazy';img.decoding='async';});
      const dialog=document.createElement('dialog');dialog.className='afp-room-dialog';dialog.setAttribute('aria-labelledby','FoilRoomTitle');
      const zoomMarkup=zoom.innerHTML,zoomLabel=zoom.getAttribute('aria-label');
      zoom.setAttribute('aria-haspopup','dialog');zoom.setAttribute('aria-expanded','false');
      zoom.addEventListener('click',()=>{
        if(dialog.open){dialog.close();return;}
        dialog.append(section);dialog.showModal();zoom.textContent=copy.close;zoom.setAttribute('aria-label',copy.close);zoom.setAttribute('aria-expanded','true');requestAnimationFrame(renderRoom);
      });
      dialog.addEventListener('close',()=>{roomHost.insertBefore(section,dialog);zoom.innerHTML=zoomMarkup;if(zoomLabel)zoom.setAttribute('aria-label',zoomLabel);zoom.setAttribute('aria-expanded','false');requestAnimationFrame(()=>{renderRoom();if(active)zoom.focus({preventScroll:true});});});
      dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
      room={section,stage,art,reference,label,dialog,painting};
      roomHost.append(section,dialog);resize.observe(stage);
    }
    function renderRoom(){
      if(!room||!selected||!active)return;
      const f=roomGeometry(data.products[selected[0]],artworkRatio(heroImage),room.stage.clientWidth,room.stage.clientHeight);
      if(!f)return;
      applyArtGeometry(room.art,f,color);
      room.art.style.left=f.x+'px';room.art.style.top=f.y+'px';
      room.reference.style.height=f.reference+'px';
      room.label.style.left=f.x+'px';room.label.style.top=(f.y+f.h/2+10)+'px';
      const format=data.products[selected[0]];
      room.label.textContent=dimensions(format.w,format.h);
      room.label.hidden=false;
      if(heroImage.complete&&heroImage.currentSrc&&room.painting.src!==heroImage.currentSrc)room.painting.src=heroImage.currentSrc;
    }
    function renderArt(){
      if(!active)return;
      if(hero&&selected){
        const f=data.products[selected[0]],ratio=artworkRatio(heroImage);
        setArt(hero,f,ratio);
        root.querySelectorAll('[data-foil-swatch-art]').forEach(art=>setArt(art,f,ratio,art.dataset.foilSwatchArt));
      }
      renderRoom();
      for(const [card,entry]of entries){
        if(!card.isConnected){resize.unobserve(entry.stage);entry.source.removeEventListener('load',entry.load);entries.delete(card);continue;}
        const ratio=artworkRatio(entry.source);
        const quote=Number.isFinite(ratio)&&best(ratio);
        entry.stage.hidden=!quote;
        card.classList.toggle('afp-card-ready',Boolean(quote));
        if(quote)setArt(entry.art,data.products[quote[0]],ratio);
        const minimum=quote?Math.min(...options(ratio).map(q=>q[1])):null;
        if(entry.minimum!==minimum){entry.minimum=minimum;entry.price.replaceChildren();if(minimum!==null)entry.price.append(document.createTextNode(copy.from+' '),money(minimum),document.createElement('br'),document.createTextNode(copy.shipping_included));else entry.price.textContent=copy.no_size;}
      }
    }
    function render(){
      active=document.body.dataset.artworkBrowse==='print'&&document.body.dataset.artworkFinish==='foil';
      root.hidden=!active||!product;
      document.body.classList.toggle('afp-active',active);
      if(heroImage)heroImage.fetchPriority=active?'high':'auto';
      if(!active){delete root.dataset.foilSelection;window.dispatchEvent(new Event('alpha:foil-selection'));if(room?.dialog.open)room.dialog.close();root.classList.remove('afp-zoomed');const zoom=root.querySelector('[data-foil-zoom]');if(zoom)zoom.textContent=copy.zoom;return;}
      if(heroImage)heroImage.loading='eager';
      if(root.dataset.wall&&!root.dataset.wall.includes('Liquid error'))document.body.style.setProperty('--fp-photo-wall','url("'+root.dataset.wall+'")');
      if(!product){requestAnimationFrame(decorate);return;}
      ensureRoom();
      text('[data-foil-country]',regionName(country));
      const validCountry=Boolean(data.countries[country]?.length);
      const ratio=artworkRatio(heroImage);
      let choices=product&&Number.isFinite(ratio)?options(ratio):[];
      choices.sort((a,b)=>data.products[a[0]].w*data.products[a[0]].h-data.products[b[0]].w*data.products[b[0]].h);
      if(product){
        const old=selected&&data.products[selected[0]];
        selected=choices.find(q=>data.products[q[0]].w===old?.w&&data.products[q[0]].h===old?.h)||best(ratio)||null;
        const sizes=root.querySelector('[data-foil-sizes]');sizes.replaceChildren();
        for(const q of choices){const f=data.products[q[0]],button=document.createElement('button'),label=document.createElement('strong');button.type='button';button.dataset.foilSize=String(q[0]);button.setAttribute('aria-pressed',String(q===selected));label.textContent=dimensions(f.w,f.h);button.append(label,money(q[1]));sizes.append(button);}
      }
      root.querySelector('[data-foil-price-card]').hidden=!product||!selected;
      root.querySelector('[data-foil-details]').hidden=!product||!selected;
      if(hero)hero.parentElement.hidden=!selected;
      if(roomHost)roomHost.hidden=!selected;
      if(selected&&product){
        const f=data.products[selected[0]],image=printLayout(f,ratio);
        hero.parentElement.dataset.orientation=ratio>1.05?'landscape':ratio<.95?'portrait':'square';
        text('[data-foil-selected-size]',dimensions(f.w,f.h));text('[data-foil-print-size]',dimensions(f.w,f.h));text('[data-foil-border-sides]',measure(image.left));text('[data-foil-border-top]',measure(image.top));text('[data-foil-image-size]',dimensions(image.width,image.height));text('[data-foil-origin]',regionName(selected[3]));
        text('[data-foil-transit]',selected[4]===null||selected[5]===null?copy.transit_unknown:selected[4]+'–'+selected[5]+' '+copy.days);
        root.querySelector('[data-foil-price]').replaceChildren(money(selected[1]));
        root.querySelector('[data-foil-shipping]').replaceChildren(document.createTextNode(copy.included+' ('),money(selected[2]),document.createTextNode(')'));
      }else text('[data-foil-origin]','—');
      root.querySelectorAll('[data-foil-color]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.foilColor===color));b.disabled=!options(ratio,b.dataset.foilColor).length;});
      root.querySelectorAll('[data-foil-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.foilUnit===unit)));
      text('[data-foil-status]',!validCountry?copy.unavailable:product&&!selected?copy.no_size:copy.ready);
      root.dataset.foilState=validCountry&&(!product||selected)?'ready':'unavailable';
      root.dataset.foilSelection=selected?JSON.stringify({sku:data.products[selected[0]].sku,color,country,priceCents:selected[1],label:dimensions(data.products[selected[0]].w,data.products[selected[0]].h)}):'';
      window.dispatchEvent(new Event('alpha:foil-selection'));
      requestAnimationFrame(decorate);
    }
    function decorate(){
      if(!active)return;
      document.querySelectorAll('[data-alpha-product-card]').forEach(card=>{
        if(entries.has(card))return;
        const source=card.querySelector('.alpha-product-card__artwork-frame img'),media=card.querySelector('.alpha-product-card__media');
        if(!source||!media)return;
        const stage=document.createElement('div');stage.className='afp-stage afp-card-stage';
        const art=document.createElement('div');art.className='afp-art';
        art.innerHTML='<div class="afp-paper"><div class="afp-image-area"></div></div>';
        const img=source.cloneNode();img.removeAttribute('id');img.className='afp-image';img.alt='';img.decoding='async';img.fetchPriority='auto';
        const syncImage=()=>{if(source.complete&&source.naturalWidth&&source.currentSrc){img.removeAttribute('srcset');img.removeAttribute('sizes');if(img.src!==source.currentSrc)img.src=source.currentSrc;}};
        syncImage();art.querySelector('.afp-image-area').append(img);stage.append(art);media.append(stage);
        const price=document.createElement('p');price.className='afp-card-price';card.append(price);
        const load=()=>{syncImage();renderArt();};source.addEventListener('load',load);entries.set(card,{source,stage,art,load,price,minimum:undefined});resize.observe(stage);
      });renderArt();
    }
    root.addEventListener('click',e=>{
      if(root.dataset.foilPaying==='true')return;
      const size=e.target.closest('[data-foil-size]'),shade=e.target.closest('[data-foil-color]'),units=e.target.closest('[data-foil-unit]');
      if(size){selected=options(artworkRatio(heroImage)).find(q=>q[0]===Number(size.dataset.foilSize));render();root.querySelector('[data-foil-size="'+size.dataset.foilSize+'"]')?.focus({preventScroll:true});}
      if(shade){color=shade.dataset.foilColor;render();}
      if(units){unit=units.dataset.foilUnit;render();}
      if(e.target.closest('[data-foil-zoom]')){root.classList.toggle('afp-zoomed');e.target.textContent=root.classList.contains('afp-zoomed')?copy.close:copy.zoom;requestAnimationFrame(renderArt);}
    });
    document.addEventListener('keydown',e=>{if(e.key==='Escape'){root.classList.remove('afp-zoomed');if(root.querySelector('[data-foil-zoom]'))root.querySelector('[data-foil-zoom]').textContent=copy.zoom;}});
    window.addEventListener('alpha:artwork-browse',render);
    window.addEventListener('alpha-art-print:country-change',e=>{if(/^[A-Z]{2}$/.test(e.detail?.country)){country=e.detail.country;render();}});
    window.addEventListener('storage',e=>{if(e.key==='alpha-art-print-country'&&e.newValue){country=e.newValue;render();}});
    const grid=document.querySelector('#ResultsList');if(grid)new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-alpha-product-card], li')||n.querySelector('[data-alpha-product-card]')))))decorate();}).observe(grid,{childList:true,subtree:true});
    decorate();render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  window.addEventListener('alpha:artwork-browse',init);
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-hanger-commerce"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const box=document.querySelector('[data-hanger-commerce]'),root=box?.closest('[data-hanger-preview]');
    if(!root||box.dataset.initialized)return;
    box.dataset.initialized='true';
    const source=JSON.parse(box.querySelector('[data-hanger-source]').textContent),copy=JSON.parse(box.querySelector('[data-hanger-commerce-copy]').textContent);
    const pay=box.querySelector('[data-hanger-pay]'),add=box.querySelector('[data-hanger-add]'),error=box.querySelector('[data-hanger-commerce-error]');
    let native,dialog,home,form,submit,originalLabel,owned=false,paying=false,uncertain=false,options=[],loadedCountry='',fetched=0,loading='',sequence=0,openedSelection='';
    const active=()=>document.body.dataset.artworkBrowse==='print'&&document.body.dataset.artworkFinish==='hanger';
    const selection=()=>{try{return active()?JSON.parse(root.dataset.hangerSelection||'null'):null;}catch{return null;}};
    const signature=()=>{const s=selection();return s?JSON.stringify([s.country,s.sku,s.color,s.priceCents]):'';};
    const current=()=>{const s=selection();return s&&s.country===loadedCountry?options.find(o=>o.supplierSku===s.sku&&o.frameColor===s.color&&Math.round(o.totalPriceEur*100)===s.priceCents):null;};
    const fail=message=>{error.textContent=message||copy.error;error.hidden=false;};
    function endpoint(){
      const url=new URL(native.dataset.aapProxy,location.origin);
      if(url.origin!==location.origin||url.pathname!=='/apps/alpha-art-print')throw Error('UNAVAILABLE');
      return url;
    }
    function close(){if(owned&&dialog.open)dialog.close();}
    function render(){
      const available=Boolean(current())&&!uncertain;
      box.hidden=!active();pay.disabled=add.disabled=!available||paying;
      const total=root.querySelector('[data-hanger-price]');
      const target=box.querySelector('[data-hanger-pay-total]');
      if(total&&target.textContent!==total.textContent)target.textContent=total.textContent;
      for(const el of root.querySelectorAll('.ahp-preview-badge,.ahp-purchase-note'))el.hidden=true;
      root.dataset.hangerCheckout=available?'ready':'unavailable';
      root.dataset.hangerPaying=String(paying);
    }
    async function load(force=false){
      const s=selection();if(!native||!s)return;
      if(!force&&loadedCountry===s.country&&Date.now()-fetched<20*60*1000){render();return;}
      if(loading===s.country)return;
      const turn=++sequence;loading=s.country;options=[];loadedCountry='';render();
      try{
        const url=endpoint();url.searchParams.set('variant',native.dataset.aapVariant);url.searchParams.set('country',s.country);url.searchParams.set('catalog_profile','hanger-v2');
        const response=await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(30000)});
        const data=await response.json();
        if(!response.ok||data.offerProfile!=='hanger-v2'||data.countryCode!==s.country||!Array.isArray(data.options))throw Error('UNAVAILABLE');
        if(turn!==sequence||selection()?.country!==s.country)return;
        options=data.options.filter(o=>o.supportId==='art-print-with-hanger'&&o.offerProfile==='hanger-v2'&&typeof o.quoteToken==='string'&&Number.isFinite(o.totalPriceEur));
        loadedCountry=s.country;fetched=Date.now();error.hidden=true;
      }catch{if(turn===sequence)fail();}
      finally{if(turn===sequence){loading='';render();}}
    }
    function syncAddress(){
      const s=selection(),countries=native.querySelector('[data-aap-country]');
      const country=[...countries.options].find(o=>o.value===s.country);
      if(!country)throw Error('UNAVAILABLE');
      form.querySelector('[data-aap-address-country]').textContent=country.textContent;
      const normalize=t=>String(t||'').trim().normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
      const metadata=native.querySelector('[data-aap-country-metadata]');
      const item=metadata&&[...metadata.options].find(o=>normalize(o.textContent)===normalize(country.textContent));
      const provinces=JSON.parse(item?.dataset.provinces||'[]');
      const field=form.querySelector('[data-aap-address-province-field]'),province=form.querySelector('[data-aap-address-province]');
      province.replaceChildren();field.hidden=!provinces.length;province.required=Boolean(provinces.length);
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});province.disabled=!provinces.length;
      if(provinces.length){province.append(new Option(copy.choose,''));for(const p of provinces)province.append(new Option(p[1],p[0]));}
      submit.disabled=false;submit.textContent=originalLabel;
      form.querySelector('[data-aap-address-error]').textContent='';
    }
    async function submitAddress(event){
      if(!owned)return;
      event.preventDefault();event.stopImmediatePropagation();
      if(paying||uncertain||!active()||openedSelection!==signature()||!current()||!form.reportValidity())return;
      const s=selection(),option=current();
      if(Date.now()-fetched>25*60*1000){close();options=[];render();await load(true);return;}
      const shippingAddress=Object.fromEntries(new FormData(form));shippingAddress.countryCode=s.country;
      paying=true;render();submit.disabled=true;submit.textContent=copy.loading;
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=true;});
      try{
        const response=await fetch(endpoint(),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({quoteToken:option.quoteToken,shippingAddress}),signal:AbortSignal.timeout(30000)});
        const result=await response.json();
        if(!response.ok){if(response.status>=500)uncertain=true;throw Error('CHECKOUT');}
        const url=new URL(result.checkoutUrl);
        if(url.protocol!=='https:'||(!/(^|\.)alphachristianart\.com$/.test(url.hostname)&&url.hostname!==box.dataset.shop))throw Error('CHECKOUT');
        location.assign(url.href);
      }catch{uncertain=true;fail(copy.uncertain);form.querySelector('[data-aap-address-error]').textContent=copy.uncertain;}
      finally{paying=false;render();submit.textContent=originalLabel;submit.disabled=true;}
    }
    function attach(){
      native=document.querySelector('[data-aap-root]');dialog=native?.querySelector('[data-aap-address-dialog]');form=dialog?.querySelector('[data-aap-address-form]');submit=form?.querySelector('[data-aap-address-submit]');
      if(!native?.dataset.aapVariant||!form||!submit||!native.querySelector('[data-aap-country]')?.options.length)return false;
      home=document.createComment('hanger-address-home');dialog.before(home);originalLabel=submit.textContent;
      for(const key of ['--aap-accent','--aap-ink','--aap-muted','--aap-font']){const value=getComputedStyle(native).getPropertyValue(key);if(value)box.style.setProperty(key,value);}
      form.addEventListener('submit',submitAddress,true);
      dialog.addEventListener('close',()=>{if(!owned)return;owned=false;home.after(dialog);form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});submit.disabled=false;submit.textContent=originalLabel;if(active())pay.focus();});
      load();return true;
    }
    pay.addEventListener('click',async()=>{
      const before=signature();if(!before||paying||uncertain)return;
      paying=true;render();await load(true);paying=false;render();
      if(before!==signature()||!current())return;
      try{syncAddress();owned=true;openedSelection=signature();box.append(dialog);dialog.showModal();form.querySelector('input[name="firstName"]')?.focus();}catch{owned=false;home.after(dialog);fail();}
    });
    add.addEventListener('click',async()=>{
      const before=signature(),s=selection(),o=current(),wallet=document.querySelector('artwork-credit-cart');if(!s||!o||paying||!wallet?.addHangerConfiguration)return;
      paying=true;render();
      try{await wallet.addHangerConfiguration(source,{variantId:'gid://shopify/ProductVariant/'+native.dataset.aapVariant,country:s.country,optionId:o.id,priceCents:s.priceCents,label:root.querySelector('#HangerPreviewTitle').textContent+' · '+s.label+' · '+root.querySelector('[data-hanger-color="'+s.color+'"] strong').textContent},()=>before===signature());}catch{fail();}finally{paying=false;render();}
    });
    window.addEventListener('alpha:hanger-selection',()=>{if(owned&&signature()!==openedSelection&&!paying)close();render();load();});
    window.addEventListener('alpha:artwork-browse',()=>{if(!active()&&!paying)close();render();});
    let tries=0;const timer=setInterval(()=>{if(attach()||++tries>60)clearInterval(timer);},500);
    render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-hanger-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const artworkRatio = image => {
    if(!image)return NaN;
    const declared=Number(image.closest('[data-artwork-ratio]')?.dataset.artworkRatio);
    if(Number.isFinite(declared)&&declared>0)return declared;
    const width=Number(image.getAttribute('width')),height=Number(image.getAttribute('height'));
    if(width>0&&height>0)return width/height;
    return image.naturalWidth>0&&image.naturalHeight>0?image.naturalWidth/image.naturalHeight:NaN;
  };
  const printLayout = (format, ratio) => {
    if (!format || ![format.w,format.h,format.bar,ratio].every(v=>Number.isFinite(v)&&v>0) || format.w<=10 || format.h<=30) return null;
    const width=Math.max(format.w,format.h*ratio),height=width/ratio;
    return {width,height,left:(format.w-width)/2,top:(format.h-height)/2};
  };
  const geometryFit = (format, ratio, width, height) => {
    const image=printLayout(format,ratio);
    if(!image||![width,height].every(v=>Number.isFinite(v)&&v>0))return null;
    const cord=format.w*.16;
    const scale=Math.min(width*.87/Math.max(format.w,format.bar),height*.88/(format.h+cord));
    return {image,scale,w:format.w*scale,h:format.h*scale,bar:format.bar*scale,barH:15*scale,cord:cord*scale};
  };
  const eligible = (format, ratio) => {
    if(!printLayout(format,ratio))return false;
    const orientation=r=>Math.abs(r-1)<.02?0:Math.sign(r-1);
    const imageRatio=format.w/format.h;
    return orientation(format.w/format.h)===orientation(ratio)&&Math.min(ratio/imageRatio,imageRatio/ratio)>=.65;
  };
  const roomGeometry = (format,ratio,width,height) => {
    const image=printLayout(format,ratio);
    if(!image||![width,height].every(v=>Number.isFinite(v)&&v>0))return null;
    const reference=height*.64,scale=reference/1700;
    return {image,scale,reference,w:format.w*scale,h:format.h*scale,bar:format.bar*scale,barH:15*scale,cord:format.w*.16*scale,x:width*.5,y:height*.45};
  };
  function applyArtGeometry(art,f,shade='natural'){
    if(!f)return;
    const styles={'--hp-w':f.w+'px','--hp-h':f.h+'px','--hp-bar':f.bar+'px','--hp-bar-h':f.barH+'px','--hp-cord':f.cord+'px','--hp-image-w':f.image.width*f.scale+'px','--hp-image-h':f.image.height*f.scale+'px','--hp-image-top':f.image.top*f.scale+'px','--hp-image-left':f.image.left*f.scale+'px'};
    for(const [k,v]of Object.entries(styles))if(art.style.getPropertyValue(k)!==v)art.style.setProperty(k,v);
    art.dataset.color=shade;
  }
  if(typeof document==='undefined'){if(typeof module!=='undefined')module.exports={printLayout,geometryFit,eligible,artworkRatio,roomGeometry};return;}
  function initThumbnails(){
    const preview=document.querySelector('[data-hanger-preview]');
    if(preview?.dataset.wall)document.body.style.setProperty('--hp-photo-wall','url("'+preview.dataset.wall+'")');
    if(preview?.dataset.wood)document.body.style.setProperty('--hp-photo-wood','url("'+preview.dataset.wood+'")');
    document.querySelectorAll('.ahp-choice .ahp-art').forEach(art=>{
      if(art.dataset.thumbnailReady)return;art.dataset.thumbnailReady='true';
      const img=art.querySelector('img'),stage=art.parentElement;
      const draw=()=>{const ratio=artworkRatio(img);if(ratio>0)applyArtGeometry(art,geometryFit({w:300*ratio,h:300,bar:300*ratio+10},ratio,stage.clientWidth,stage.clientHeight),'natural');};
      new ResizeObserver(draw).observe(stage);img?.addEventListener('load',draw);draw();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initThumbnails,{once:true});else initThumbnails();
  document.addEventListener('shopify:section:load',initThumbnails);
  function init(){
    const root=document.querySelector('[data-hanger-preview]');
    if(!root||root.dataset.initialized)return;
    root.dataset.initialized='true';
    const data=JSON.parse(document.querySelector('[data-hanger-catalog]').textContent);
    const copy=JSON.parse(root.querySelector('[data-hanger-copy]').textContent);
    const product=root.dataset.page==='product';
    let country;try{country=localStorage.getItem('alpha-art-print-country');}catch(_){}
    country=country||root.dataset.defaultCountry;
    let color='natural',unit='cm',selected=null,active=false;
    const entries=new Map();
    const number=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:2}).format(value);
    const measure=value=>number(value/(unit==='cm'?10:25.4))+(unit==='cm'?' cm':'″');
    const dimensions=(w,h)=>number(w/(unit==='cm'?10:25.4))+' × '+measure(h);
    const money=value=>{const span=document.createElement('span');span.className='money';span.textContent=(value/100).toFixed(2)+' €';return span;};
    const text=(selector,value)=>{const e=root.querySelector(selector);if(e)e.textContent=value;};
    const regionName=code=>{try{return new Intl.DisplayNames([document.documentElement.lang||'en'],{type:'region'}).of(code);}catch(_){return data.names[code]||code;}};
    function options(ratio){return (data.countries[country]||[]).map(i=>data.quotes[i]).filter(q=>eligible(data.products[q[0]],ratio));}
    function best(ratio){return options(ratio).sort((a,b)=>Math.abs(Math.log(data.products[a[0]].w/data.products[a[0]].h/ratio))-Math.abs(Math.log(data.products[b[0]].w/data.products[b[0]].h/ratio))||a[1]-b[1])[0];}
    function applyArtGeometry(art,f,shade=color){
      if(!f)return;
      const styles={'--hp-w':f.w+'px','--hp-h':f.h+'px','--hp-bar':f.bar+'px','--hp-bar-h':f.barH+'px','--hp-cord':f.cord+'px','--hp-image-w':f.image.width*f.scale+'px','--hp-image-h':f.image.height*f.scale+'px','--hp-image-top':f.image.top*f.scale+'px','--hp-image-left':f.image.left*f.scale+'px'};
      for(const [k,v]of Object.entries(styles))if(art.style.getPropertyValue(k)!==v)art.style.setProperty(k,v);
      art.dataset.color=shade;
    }
    function setArt(art,format,ratio,shade=color){
      const stage=art.parentElement;
      applyArtGeometry(art,geometryFit(format,ratio,stage.clientWidth,stage.clientHeight),shade);
    }
    const resize=new ResizeObserver(()=>renderArt());
    const hero=root.querySelector('[data-hanger-art]');
    const heroImage=hero?.querySelector('img');
    if(hero){resize.observe(hero.parentElement);heroImage.addEventListener('load',render);}
    const roomHost=root.querySelector('[data-hanger-room-host]');
    let room=null;
    function ensureRoom(){
      if(room||!roomHost||!hero)return;
      const source=document.querySelector('[data-aap-room]')?.closest('.aap-preview');
      if(!source)return;
      const section=source.cloneNode(true),stage=section.querySelector('[data-aap-room]');
      const oldArt=section.querySelector('[data-aap-preview]'),reference=section.querySelector('[data-aap-reference]'),label=section.querySelector('[data-aap-preview-dimension]'),zoom=section.querySelector('[data-aap-zoom]');
      if(!stage||!oldArt||!reference||!label||!zoom)return;
      section.querySelectorAll('*').forEach(el=>{el.removeAttribute('id');for(const attr of [...el.attributes])if(attr.name.startsWith('data-aap-'))el.removeAttribute(attr.name);});
      section.classList.add('ahp-room');
      section.setAttribute('aria-labelledby','HangerRoomTitle');
      section.querySelector('h3').id='HangerRoomTitle';
      const titleStyle=getComputedStyle(source.querySelector('h3'));
      section.querySelector('h3').style.fontFamily=titleStyle.fontFamily;
      section.querySelector('h3').style.fontWeight=titleStyle.fontWeight;
      const art=hero.cloneNode(true);art.removeAttribute('data-hanger-art');art.classList.add('ahp-room-art');art.dataset.hangerRoomArt='';
      const painting=art.querySelector('img');painting.removeAttribute('srcset');painting.removeAttribute('sizes');painting.loading='lazy';painting.fetchPriority='low';painting.alt=heroImage.alt;
      oldArt.replaceWith(art);
      section.querySelectorAll('img').forEach(img=>{img.loading='lazy';img.decoding='async';});
      const dialog=document.createElement('dialog');dialog.className='ahp-room-dialog';dialog.setAttribute('aria-labelledby','HangerRoomTitle');
      const zoomMarkup=zoom.innerHTML,zoomLabel=zoom.getAttribute('aria-label');
      zoom.setAttribute('aria-haspopup','dialog');zoom.setAttribute('aria-expanded','false');
      zoom.addEventListener('click',()=>{
        if(dialog.open){dialog.close();return;}
        dialog.append(section);dialog.showModal();zoom.textContent=copy.close;zoom.setAttribute('aria-label',copy.close);zoom.setAttribute('aria-expanded','true');requestAnimationFrame(renderRoom);
      });
      dialog.addEventListener('close',()=>{roomHost.insertBefore(section,dialog);zoom.innerHTML=zoomMarkup;if(zoomLabel)zoom.setAttribute('aria-label',zoomLabel);zoom.setAttribute('aria-expanded','false');requestAnimationFrame(()=>{renderRoom();if(active)zoom.focus({preventScroll:true});});});
      dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
      room={section,stage,art,reference,label,dialog,painting};
      roomHost.append(section,dialog);resize.observe(stage);
    }
    function renderRoom(){
      if(!room||!selected||!active)return;
      const f=roomGeometry(data.products[selected[0]],artworkRatio(heroImage),room.stage.clientWidth,room.stage.clientHeight);
      if(!f)return;
      applyArtGeometry(room.art,f);
      room.art.style.left=f.x+'px';room.art.style.top=f.y+'px';
      room.reference.style.height=f.reference+'px';
      room.label.style.left=f.x+'px';room.label.style.top=(f.y+f.h/2+10)+'px';
      const format=data.products[selected[0]];
      room.label.textContent=dimensions(format.w,format.h);
      if(heroImage.complete&&heroImage.currentSrc&&room.painting.src!==heroImage.currentSrc)room.painting.src=heroImage.currentSrc;
    }
    function renderArt(){
      if(!active)return;
      if(hero&&selected){
        const f=data.products[selected[0]],ratio=artworkRatio(heroImage);
        setArt(hero,f,ratio);
        root.querySelectorAll('[data-hanger-swatch-art]').forEach(art=>setArt(art,f,ratio,art.dataset.hangerSwatchArt));
      }
      renderRoom();
      for(const [card,entry]of entries){
        if(!card.isConnected){resize.unobserve(entry.stage);entry.source.removeEventListener('load',entry.load);entries.delete(card);continue;}
        const ratio=artworkRatio(entry.source);
        const quote=Number.isFinite(ratio)&&best(ratio);
        entry.stage.hidden=!quote;
        card.classList.toggle('ahp-card-ready',Boolean(quote));
        if(quote)setArt(entry.art,data.products[quote[0]],ratio);
        const minimum=quote?Math.min(...options(ratio).map(q=>q[1])):null;
        if(entry.minimum!==minimum){entry.minimum=minimum;entry.price.replaceChildren();if(minimum!==null)entry.price.append(document.createTextNode(copy.from+' '),money(minimum),document.createElement('br'),document.createTextNode(copy.shipping_included));else entry.price.textContent=copy.no_size;}
      }
    }
    function render(){
      active=document.body.dataset.artworkBrowse==='print'&&document.body.dataset.artworkFinish==='hanger';
      root.hidden=!active||!product;
      document.body.classList.toggle('ahp-active',active);
      if(heroImage)heroImage.fetchPriority=active?'high':'auto';
      if(!active){delete root.dataset.hangerSelection;window.dispatchEvent(new Event('alpha:hanger-selection'));if(room?.dialog.open)room.dialog.close();root.classList.remove('ahp-zoomed');const zoom=root.querySelector('[data-hanger-zoom]');if(zoom)zoom.textContent=copy.zoom;return;}
      if(heroImage)heroImage.loading='eager';
      for(const [key,url]of [['--hp-photo-wall',root.dataset.wall],['--hp-photo-wood',root.dataset.wood]])if(url&&!url.includes('Liquid error'))document.body.style.setProperty(key,'url("'+url+'")');
      if(!product){requestAnimationFrame(decorate);return;}
      ensureRoom();
      text('[data-hanger-country]',regionName(country));
      const validCountry=Boolean(data.countries[country]?.length);
      const ratio=artworkRatio(heroImage);
      let choices=product&&Number.isFinite(ratio)?options(ratio):[];
      choices.sort((a,b)=>data.products[a[0]].w*data.products[a[0]].h-data.products[b[0]].w*data.products[b[0]].h);
      if(product){
        const oldSku=selected&&data.products[selected[0]].sku;
        selected=choices.find(q=>data.products[q[0]].sku===oldSku)||best(ratio)||null;
        const sizes=root.querySelector('[data-hanger-sizes]');sizes.replaceChildren();
        for(const q of choices){const f=data.products[q[0]],button=document.createElement('button'),label=document.createElement('strong');button.type='button';button.dataset.hangerSize=String(q[0]);button.setAttribute('aria-pressed',String(q===selected));label.textContent=dimensions(f.w,f.h);button.append(label,money(q[1]));sizes.append(button);}
      }
      root.querySelector('[data-hanger-price-card]').hidden=!product||!selected;
      root.querySelector('[data-hanger-details]').hidden=!product||!selected;
      if(hero)hero.parentElement.hidden=!selected;
      if(roomHost)roomHost.hidden=!selected;
      if(selected&&product){
        const f=data.products[selected[0]],image=printLayout(f,ratio);
        hero.parentElement.dataset.orientation=ratio>1.05?'landscape':ratio<.95?'portrait':'square';
        text('[data-hanger-selected-size]',dimensions(f.w,f.h));text('[data-hanger-print-size]',dimensions(f.w,f.h));text('[data-hanger-bar-size]',measure(f.bar));text('[data-hanger-image-size]',dimensions(image.width,image.height));text('[data-hanger-origin]',regionName(selected[3]));
        text('[data-hanger-transit]',selected[4]+'–'+selected[5]+' '+copy.days);
        root.querySelector('[data-hanger-price]').replaceChildren(money(selected[1]));
        root.querySelector('[data-hanger-shipping]').replaceChildren(document.createTextNode(copy.included+' ('),money(selected[2]),document.createTextNode(')'));
      }else text('[data-hanger-origin]','—');
      root.querySelectorAll('[data-hanger-color]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.hangerColor===color)));
      root.querySelectorAll('[data-hanger-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.hangerUnit===unit)));
      text('[data-hanger-status]',!validCountry?copy.unavailable:product&&!selected?copy.no_size:copy.ready);
      root.dataset.hangerState=validCountry&&(!product||selected)?'ready':'unavailable';
      root.dataset.hangerSelection=selected?JSON.stringify({sku:data.products[selected[0]].sku,color,country,priceCents:selected[1],label:dimensions(data.products[selected[0]].w,data.products[selected[0]].h)}):'';
      window.dispatchEvent(new Event('alpha:hanger-selection'));
      requestAnimationFrame(decorate);
    }
    function decorate(){
      if(!active)return;
      document.querySelectorAll('[data-alpha-product-card]').forEach(card=>{
        if(entries.has(card))return;
        const source=card.querySelector('.alpha-product-card__artwork-frame img'),media=card.querySelector('.alpha-product-card__media');
        if(!source||!media)return;
        const stage=document.createElement('div');stage.className='ahp-stage ahp-card-stage';
        const art=document.createElement('div');art.className='ahp-art';
        art.innerHTML='<svg class="ahp-cord" viewBox="0 0 100 32" preserveAspectRatio="none" aria-hidden="true"><path class="ahp-rope" d="M12 32 50 2 88 32"/><path class="ahp-rope-fibres" d="M12 32 50 2 88 32"/></svg><span class="ahp-peg" aria-hidden="true"></span><div class="ahp-paper"><div class="ahp-image-area"></div></div><span class="ahp-bar ahp-bar--top" aria-hidden="true"></span><span class="ahp-bar ahp-bar--bottom" aria-hidden="true"></span>';
        const img=source.cloneNode();img.removeAttribute('id');img.className='ahp-image';img.alt='';img.decoding='async';img.fetchPriority='auto';
        const syncImage=()=>{if(source.complete&&source.naturalWidth&&source.currentSrc){img.removeAttribute('srcset');img.removeAttribute('sizes');if(img.src!==source.currentSrc)img.src=source.currentSrc;}};
        syncImage();art.querySelector('.ahp-image-area').append(img);stage.append(art);media.append(stage);
        const price=document.createElement('p');price.className='ahp-card-price';card.append(price);
        const load=()=>{syncImage();renderArt();};source.addEventListener('load',load);entries.set(card,{source,stage,art,load,price,minimum:undefined});resize.observe(stage);
      });renderArt();
    }
    root.addEventListener('click',e=>{
      if(root.dataset.hangerPaying==='true')return;
      const size=e.target.closest('[data-hanger-size]'),shade=e.target.closest('[data-hanger-color]'),units=e.target.closest('[data-hanger-unit]');
      if(size){selected=options(artworkRatio(heroImage)).find(q=>q[0]===Number(size.dataset.hangerSize));render();root.querySelector('[data-hanger-size="'+size.dataset.hangerSize+'"]')?.focus({preventScroll:true});}
      if(shade){color=shade.dataset.hangerColor;render();}
      if(units){unit=units.dataset.hangerUnit;render();}
      if(e.target.closest('[data-hanger-zoom]')){root.classList.toggle('ahp-zoomed');e.target.textContent=root.classList.contains('ahp-zoomed')?copy.close:copy.zoom;requestAnimationFrame(renderArt);}
    });
    document.addEventListener('keydown',e=>{if(e.key==='Escape'){root.classList.remove('ahp-zoomed');if(root.querySelector('[data-hanger-zoom]'))root.querySelector('[data-hanger-zoom]').textContent=copy.zoom;}});
    window.addEventListener('alpha:artwork-browse',render);
    window.addEventListener('alpha-art-print:country-change',e=>{if(/^[A-Z]{2}$/.test(e.detail?.country)){country=e.detail.country;render();}});
    window.addEventListener('storage',e=>{if(e.key==='alpha-art-print-country'&&e.newValue){country=e.newValue;render();}});
    const grid=document.querySelector('#ResultsList');if(grid)new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-alpha-product-card], li')||n.querySelector('[data-alpha-product-card]')))))decorate();}).observe(grid,{childList:true,subtree:true});
    decorate();render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-mirror-edge-only"] && !Shopify.designMode) return;
  try {
    (() => {
  const bound = new WeakSet();
  const bind = () => {
    document.querySelectorAll('[data-aap-finishes]').forEach(group => {
      if (bound.has(group)) return;
      bound.add(group);
      const sync = () => {
        const mirror = group.querySelector('[data-value="edge-mirrorwrap"]');
        if (!mirror || mirror.disabled) return;
        group.querySelectorAll('[data-value^="edge-"]').forEach(button => {
          if (button !== mirror) button.disabled = true;
        });
        if (mirror.getAttribute('aria-pressed') !== 'true') mirror.click();
      };
      new MutationObserver(sync).observe(group, {childList:true,subtree:true,attributes:true,attributeFilter:['aria-pressed']});
      sync();
    });
  };
  const init = () => {
    bind();
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(bind).observe(main, {childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-mounted-configurator"] && !Shopify.designMode) return;
  try {
    (() => {
  const profile = 'classic-mount-qa';
  const countryKey = 'alpha-art-print-country';
  const finitePositive = value => Number.isFinite(value) && value > 0;
  const validOption = (option, country) => Boolean(option && option.offerProfile === profile &&
    option.supportId === 'classic-mounted-print' && option.countryCode === country &&
    option.mountColor === 'Snow white' && option.dimensionsBasis === 'glazing' &&
    option.scalePreviewAvailable === false && option.imageFit === 'contain-white-padding' &&
    finitePositive(option.widthMm) && finitePositive(option.heightMm) &&
    finitePositive(option.imageWidthPx) && finitePositive(option.imageHeightPx) &&
    finitePositive(option.totalPriceEur) && Number.isFinite(option.includedShippingEur) &&
    option.includedShippingEur >= 0 && option.includedShippingEur <= option.totalPriceEur &&
    typeof option.frameColor === 'string' && typeof option.quoteToken === 'string' && option.quoteToken.length > 0);
  const sizeKey = option => option.widthMm + 'x' + option.heightMm;
  const compatibleSize = (option, sourceWidth, sourceHeight) => {
    const dimensions = [sourceWidth, sourceHeight, option?.imageWidthPx, option?.imageHeightPx, option?.widthMm, option?.heightMm];
    if (!dimensions.every(value => Number.isFinite(value) && value > 0)) return false;
    const orientation = (width, height) => Math.min(width, height) / Math.max(width, height) >= .995 ? 0 : Math.sign(width - height);
    const direction = orientation(sourceWidth, sourceHeight);
    if (orientation(option.widthMm, option.heightMm) !== direction || orientation(option.imageWidthPx, option.imageHeightPx) !== direction) return false;
    const sourceRatio = sourceWidth / sourceHeight;
    const targetRatio = option.imageWidthPx / option.imageHeightPx;
    return 1 - Math.min(sourceRatio / targetRatio, targetRatio / sourceRatio) <= .08 + Number.EPSILON;
  };
  if (typeof document === 'undefined') {
    if (typeof module !== 'undefined') module.exports = { validOption, sizeKey, compatibleSize };
    return;
  }
  let session;
  function init() {
    const root = document.querySelector('[data-alpha-mounted-offer][data-mounted-profile="classic-mount-qa"]');
    if (session?.root === root) return;
    session?.dispose();
    if (!root) return;
    const copy = JSON.parse(root.querySelector('[data-am-copy]').textContent);
    let selectCountry;
    let form;
    let dialog;
    let addressSubmit;
    let addressError;
    let addressCountry;
    let province;
    let provinceField;
    let destination;
    let countryTrigger;
    let destinationHome;
    let dialogHome;
    let submitLabel = '';
    let mountedDialogOpen = false;
    const pay = root.querySelector('[data-am-pay]');
    const status = root.querySelector('[data-am-status]');
    const optionsPanel = root.querySelector('[data-am-options]');
    const error = root.querySelector('[data-am-checkout-error]');
    const refresh = root.querySelector('[data-am-refresh]');
    const sizes = root.querySelector('[data-am-sizes]');
    const colors = root.querySelector('[data-am-color]');
    const colorCards = root.querySelector('[data-am-color-cards]');
    const overview = root.querySelector('[data-am-price-card]');
    const abort = new AbortController();
    const deadlines = new Set();
    let nativeRoot;
    let nativePanel;
    let request;
    let checkoutRequest;
    let sequence = 0;
    let attempts = 0;
    let timer;
    let disposed = false;
    let active = false;
    let country = '';
    let unit = 'cm';
    let all = [];
    let selectedSize = '';
    let selectedColor = 'black';
    let option = null;
    let fetchedAt = 0;
    let paying = false;
    let endpoint;
    let lastEmitted = '';
    async function requestJSON(url, settings, milliseconds, controller) {
      let deadline;
      const timeout = new Promise((resolve, reject) => {
        deadline = setTimeout(() => {
          const failure = new Error('Request deadline exceeded');
          failure.name = 'TimeoutError';
          reject(failure);
          controller.abort();
        }, milliseconds);
        deadlines.add(deadline);
      });
      try {
        return await Promise.race([timeout, (async () => {
          const response = await fetch(url, { ...settings, signal: controller.signal });
          return { response, payload: await response.json() };
        })()]);
      } finally { clearTimeout(deadline); deadlines.delete(deadline); }
    }
    const displayNumber = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 2 }).format(value);
    const sizeLabel = item => displayNumber(item.widthMm / (unit === 'cm' ? 10 : 25.4)) + ' × ' + displayNumber(item.heightMm / (unit === 'cm' ? 10 : 25.4)) + (unit === 'cm' ? ' cm' : '″');
    const money = value => {
      const span = document.createElement('span');
      span.className = 'money';
      span.textContent = value.toFixed(2) + ' €';
      return span;
    };
    const isSelected = () => {
      const url = new URL(location.href);
      return url.searchParams.get('art_type') === 'print' && url.searchParams.get('art_finish') === 'classic' && url.searchParams.get('art_mount') === 'white';
    };
    function emit() {
      if (disposed) return;
      root.dataset.mountedAvailable = String(all.length > 0);
      root.hidden = !active || !nativePanel;
      if (active) document.body.dataset.alphaMounted = root.dataset.mountedState;
      else delete document.body.dataset.alphaMounted;
      const signature = [active, root.dataset.mountedState, root.dataset.mountedAvailable].join(':');
      if (signature === lastEmitted) return;
      lastEmitted = signature;
      window.dispatchEvent(new CustomEvent('alpha:mounted-state', { detail: { root } }));
    }
    function setPhase(phase) {
      root.dataset.mountedState = phase;
      root.setAttribute('aria-busy', String(phase === 'loading'));
      status.textContent = copy[phase] || copy.unavailable;
      pay.disabled = phase !== 'ready' || paying;
      optionsPanel.hidden = phase !== 'ready';
      overview.hidden = phase !== 'ready';
      refresh.disabled = phase === 'loading' || paying;
      if (active) lockAddress(phase !== 'ready' || paying);
      emit();
    }
    function lockAddress(locked) {
      if (!form) return;
      form.querySelectorAll('input, select').forEach(field => { field.disabled = locked || (field === province && provinceField.hidden); });
      addressSubmit.disabled = locked;
      selectCountry.disabled = paying;
      countryTrigger.disabled = paying;
    }
    function closeMountedDialog(restoreFocus = false) {
      if (!mountedDialogOpen || !dialog) return;
      mountedDialogOpen = false;
      if (dialog.open) dialog.close();
      if (restoreFocus && active) pay.focus();
    }
    function placeNativeControls() {
      if (!dialog || !destination) return;
      if (active) {
        const slot = root.querySelector('[data-am-destination-slot]');
        if (destination.parentElement !== slot) slot.append(destination);
        if (dialog.parentElement !== root) root.append(dialog);
        lockAddress(root.dataset.mountedState !== 'ready' || paying);
      } else {
        closeMountedDialog();
        if (destination.previousSibling !== destinationHome) destinationHome.after(destination);
        if (dialog.previousSibling !== dialogHome) dialogHome.after(dialog);
        lockAddress(false);
        if (submitLabel) addressSubmit.textContent = submitLabel;
      }
    }
    function setActive(value) {
      const previous = active;
      active = value;
      if (previous && !active) { form?.reset(); error.hidden = true; if (addressError) addressError.textContent = ''; }
      placeNativeControls();
      emit();
    }
    function syncAddressCountry() {
      const selected = selectCountry.selectedOptions[0];
      addressCountry.textContent = selected?.textContent || country;
      province.replaceChildren();
      const metadata = nativeRoot?.querySelector('[data-aap-country-metadata]');
      const normaliseLabel = text => String(text || '').trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const source = metadata && [...metadata.options].find(item => normaliseLabel(item.textContent) === normaliseLabel(selected?.textContent));
      let provinces = [];
      try { provinces = JSON.parse(source?.dataset.provinces || '[]'); } catch (_) {}
      provinces = Array.isArray(provinces) ? provinces.filter(item => Array.isArray(item) && item.length >= 2 && item[0] && item[1]) : [];
      provinceField.hidden = provinces.length === 0;
      province.required = provinces.length > 0;
      province.disabled = provinces.length === 0;
      if (provinces.length) {
        province.append(new Option(copy.choose, ''));
        provinces.forEach(item => province.append(new Option(String(item[1]), String(item[0]))));
      }
    }
    function renderOptions() {
      const bySize = new Map();
      all.forEach(item => {
        const key = sizeKey(item);
        if (!bySize.has(key) || item.totalPriceEur < bySize.get(key).totalPriceEur) bySize.set(key, item);
      });
      const sorted = [...bySize.values()].sort((a, b) => a.widthMm * a.heightMm - b.widthMm * b.heightMm);
      if (!bySize.has(selectedSize)) selectedSize = sorted[0] ? sizeKey(sorted[0]) : '';
      const available = all.filter(item => sizeKey(item) === selectedSize);
      if (!available.some(item => item.frameColor === selectedColor)) selectedColor = available.find(item => item.frameColor === 'black')?.frameColor || available[0]?.frameColor || '';
      option = available.find(item => item.frameColor === selectedColor) || null;
      sizes.replaceChildren();
      sorted.forEach(item => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'aap-size';
        button.classList.toggle('is-active', sizeKey(item) === selectedSize);
        button.dataset.amSize = sizeKey(item);
        button.setAttribute('aria-pressed', String(sizeKey(item) === selectedSize));
        button.disabled = paying;
        const title = document.createElement('strong');
        title.textContent = sizeLabel(item);
        const price = document.createElement('span');
        price.append(document.createTextNode(copy.from + ' '), money(item.totalPriceEur));
        button.append(title, price);
        sizes.append(button);
      });
      colors.replaceChildren();
      colorCards.replaceChildren();
      const frameColors = new Set();
      const frameAssets = nativeRoot?.querySelector('[data-aap-frame-assets]')?.content;
      available.forEach(item => {
        if (frameColors.has(item.frameColor)) return;
        frameColors.add(item.frameColor);
        colors.append(new Option(copy[item.frameColor] || item.frameLabel, item.frameColor));
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'aap-frame-choice';
        button.dataset.amFrameColor = item.frameColor;
        button.classList.toggle('is-active', item.frameColor === selectedColor);
        button.setAttribute('aria-pressed', String(item.frameColor === selectedColor));
        button.disabled = paying;
        const asset = [...(frameAssets?.querySelectorAll('[data-color]') || [])].find(node => node.dataset.color === item.frameColor);
        if (asset?.dataset.classicUrl) {
          const image = document.createElement('img');
          image.src = asset.dataset.classicUrl;
          image.alt = '';
          image.width = 160;
          image.height = 160;
          image.loading = 'lazy';
          button.append(image);
        }
        const label = document.createElement('span');
        label.textContent = copy[item.frameColor] || item.frameLabel;
        button.append(label);
        colorCards.append(button);
      });
      colors.value = selectedColor;
      root.dataset.mountedFrameColor = selectedColor;
      colors.disabled = paying;
      if (!option) { setPhase('unavailable'); return; }
      root.dataset.mountedGlazingWidth = String(option.widthMm);
      root.dataset.mountedGlazingHeight = String(option.heightMm);
      root.dataset.mountedUnit = unit;
      root.querySelector('[data-am-dimensions]').textContent = sizeLabel(option);
      root.querySelector('[data-am-overview-dimensions]').textContent = sizeLabel(option);
      root.querySelector('[data-am-overview-total]').replaceChildren(money(option.totalPriceEur));
      root.querySelector('[data-am-total]').replaceChildren(money(option.totalPriceEur));
      root.querySelector('[data-am-shipping]').replaceChildren(money(option.includedShippingEur));
      root.querySelector('[data-am-pay-total]').replaceChildren(money(option.totalPriceEur));
      const min = option.shippingTransitDaysMin;
      const max = option.shippingTransitDaysMax;
      root.querySelector('[data-am-transit]').textContent = Number.isInteger(min) && Number.isInteger(max) && min >= 0 && max >= min ? (min === max ? min : min + '–' + max) + ' ' + copy.days : copy.transit_unknown;
      setPhase('ready');
    }
    async function load() {
      if (!endpoint || paying) return;
      request?.abort();
      request = new AbortController();
      const current = ++sequence;
      const requestedCountry = country;
      option = null;
      all = [];
      error.hidden = true;
      if (active) { closeMountedDialog(); addressError.textContent = ''; }
      setPhase('loading');
      try {
        const url = new URL(endpoint);
        url.searchParams.set('variant', nativeRoot.dataset.aapVariant);
        url.searchParams.set('country', country);
        url.searchParams.set('catalog_profile', profile);
        const { response, payload } = await requestJSON(url.href, { credentials: 'same-origin', headers: { Accept: 'application/json' } }, 20000, request);
        if (disposed || current !== sequence) return;
        if (!response.ok || payload.offerProfile !== profile || payload.countryCode !== requestedCountry || payload.mountedAvailability !== 'available' || !Array.isArray(payload.options)) throw new Error(copy.unavailable);
        const sourceWidth = Number(nativeRoot.dataset.aapSourceWidth);
        const sourceHeight = Number(nativeRoot.dataset.aapSourceHeight);
        all = payload.options.filter(item => validOption(item, requestedCountry) && compatibleSize(item, sourceWidth, sourceHeight));
        if (!all.length) throw new Error(copy.unavailable);
        fetchedAt = Date.now();
        renderOptions();
      } catch (failure) {
        if (disposed || current !== sequence || failure.name === 'AbortError') return;
        all = []; option = null;
        setPhase('unavailable');
      }
    }
    function changeCountry(value, broadcast) {
      const next = String(value || '').toUpperCase();
      if (paying || !/^[A-Z]{2}$/.test(next) || ![...selectCountry.options].some(item => item.value === next) || next === country) return;
      country = next;
      selectCountry.value = country;
      closeMountedDialog();
      form.reset();
      syncAddressCountry();
      try { localStorage.setItem(countryKey, country); } catch (_) {}
      if (broadcast) window.dispatchEvent(new CustomEvent('alpha-art-print:country-change', { detail: { country, source: 'mounted-configurator' } }));
      load();
    }
    function attach() {
      nativeRoot = document.querySelector('[data-aap-root]');
      nativePanel = nativeRoot?.querySelector('.aap-panel');
      const originalCountries = nativeRoot?.querySelector('[data-aap-country]');
      const originalDialog = nativeRoot?.querySelector('[data-aap-address-dialog]');
      const originalForm = originalDialog?.querySelector('[data-aap-address-form]');
      const originalTrigger = nativeRoot?.querySelector('[data-aap-country-product-trigger]');
      if (!nativeRoot?.dataset.aapVariant || !nativePanel || !originalCountries?.options.length || !originalForm || !originalTrigger || !originalDialog.querySelector('[data-aap-address-submit]') || !originalForm.querySelector('[data-aap-address-province]')) return false;
      selectCountry = originalCountries;
      dialog = originalDialog;
      form = originalForm;
      countryTrigger = originalTrigger;
      destination = originalCountries.closest('.aap-destination');
      addressSubmit = form.querySelector('[data-aap-address-submit]');
      addressError = form.querySelector('[data-aap-address-error]');
      addressCountry = form.querySelector('[data-aap-address-country]');
      province = form.querySelector('[data-aap-address-province]');
      provinceField = form.querySelector('[data-aap-address-province-field]');
      if (!destination || !addressError || !addressCountry || !provinceField) return false;
      destinationHome = document.createComment('');
      dialogHome = document.createComment('');
      destination.before(destinationHome);
      dialog.before(dialogHome);
      submitLabel = addressSubmit.textContent;
      form.addEventListener('submit', submitMountedAddress, { capture: true, signal: abort.signal });
      dialog.addEventListener('close', () => { if (mountedDialogOpen) { mountedDialogOpen = false; if (active) pay.focus(); } }, { signal: abort.signal });
      if (root.parentElement !== nativePanel) nativePanel.append(root);
      placeNativeControls();
      emit();
      try {
        endpoint = new URL(nativeRoot.dataset.aapProxy, location.origin);
        if (endpoint.origin !== location.origin || endpoint.pathname !== '/apps/alpha-art-print') throw new Error('Invalid endpoint');
      } catch (_) { endpoint = null; setPhase('unavailable'); return true; }
      let stored;
      try { stored = localStorage.getItem(countryKey); } catch (_) {}
      const exists = value => [...selectCountry.options].some(item => item.value === value);
      country = exists(stored) ? stored : exists(originalCountries.value) ? originalCountries.value : nativeRoot.dataset.aapDetectedCountry;
      if (!exists(country)) { setPhase('unavailable'); return true; }
      selectCountry.value = country;
      syncAddressCountry();
      load();
      return true;
    }
    pay.addEventListener('click', () => {
      if (!active || !dialog || !option || paying || root.dataset.mountedState !== 'ready') return;
      if (Date.now() - fetchedAt > 25 * 60 * 1000) { error.textContent = copy.expired; error.hidden = false; option = null; lockAddress(true); pay.disabled = true; refresh.focus(); return; }
      syncAddressCountry();
      lockAddress(false);
      addressError.textContent = '';
      submitLabel = addressSubmit.textContent;
      mountedDialogOpen = true;
      dialog.showModal();
      form.querySelector('input[name="firstName"]')?.focus();
    }, { signal: abort.signal });
    refresh.addEventListener('click', load, { signal: abort.signal });
    sizes.addEventListener('click', event => {
      const button = event.target.closest('[data-am-size]');
      if (!button || paying) return;
      selectedSize = button.dataset.amSize;
      error.hidden = true;
      renderOptions();
    }, { signal: abort.signal });
    colors.addEventListener('change', () => { if (!paying) { selectedColor = colors.value; error.hidden = true; renderOptions(); } }, { signal: abort.signal });
    colorCards.addEventListener('click', event => {
      const button = event.target.closest('[data-am-frame-color]');
      if (!button || paying) return;
      selectedColor = button.dataset.amFrameColor;
      error.hidden = true;
      renderOptions();
      colorCards.querySelector('[data-am-frame-color="' + selectedColor + '"]')?.focus({ preventScroll: true });
    }, { signal: abort.signal });
    root.querySelectorAll('[data-am-unit]').forEach(button => button.addEventListener('click', () => {
      if (paying) return;
      unit = button.dataset.amUnit;
      root.querySelectorAll('[data-am-unit]').forEach(item => {
        item.setAttribute('aria-pressed', String(item === button));
        item.classList.toggle('is-active', item === button);
      });
      if (all.length) renderOptions();
    }, { signal: abort.signal }));
    window.addEventListener('alpha:artwork-browse', event => setActive(event.detail?.type === 'print' && event.detail?.finish === 'classic' && event.detail?.mount === 'white'), { signal: abort.signal });
    window.addEventListener('alpha-art-print:country-change', event => changeCountry(event.detail?.country, false), { signal: abort.signal });
    window.addEventListener('storage', event => { if (event.key === countryKey) changeCountry(event.newValue, false); }, { signal: abort.signal });
    async function submitMountedAddress(event) {
      if (!active) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!mountedDialogOpen || !dialog.open || !option || paying || root.dataset.mountedState !== 'ready') return;
      if (Date.now() - fetchedAt > 25 * 60 * 1000) { error.textContent = copy.expired; error.hidden = false; option = null; lockAddress(true); pay.disabled = true; closeMountedDialog(); refresh.focus(); return; }
      if (!form.checkValidity()) { form.reportValidity(); return; }
      const shippingAddress = Object.fromEntries(new FormData(form));
      shippingAddress.countryCode = country;
      const quoteToken = option.quoteToken;
      paying = true;
      lockAddress(true); pay.disabled = true; colors.disabled = true; refresh.disabled = true;
      sizes.querySelectorAll('button').forEach(button => { button.disabled = true; });
      colorCards.querySelectorAll('button').forEach(button => { button.disabled = true; });
      pay.firstElementChild.textContent = copy.preparing;
      addressSubmit.textContent = copy.preparing;
      addressError.textContent = '';
      error.hidden = true;
      try {
        checkoutRequest = new AbortController();
        const { response, payload } = await requestJSON(endpoint.href, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ quoteToken, shippingAddress }) }, 30000, checkoutRequest);
        if (disposed) return;
        if (!response.ok) {
          const failure = new Error(payload.error || copy.checkout_error);
          failure.retryable = true;
          throw failure;
        }
        if (!payload.checkoutUrl) throw new Error(copy.checkout_error);
        const checkoutURL = new URL(payload.checkoutUrl, location.origin);
        const allowed = /(^|\.)alphachristianart\.com$/.test(checkoutURL.hostname) || checkoutURL.hostname === root.dataset.shopDomain;
        if (checkoutURL.protocol !== 'https:' || !allowed) throw new Error(copy.checkout_error);
        window.location.assign(checkoutURL.href);
      } catch (failure) {
        if (disposed) return;
        pay.firstElementChild.textContent = copy.pay;
        addressSubmit.textContent = submitLabel;
        if (failure.retryable) {
          paying = false;
          renderOptions();
          error.textContent = failure.message || copy.checkout_error;
        } else {
          error.textContent = copy.checkout_uncertain;
          status.textContent = copy.checkout_uncertain;
        }
        error.hidden = false;
        addressError.textContent = error.textContent;
      }
    }
    session = { root, dispose() { disposed = true; active = false; placeNativeControls(); abort.abort(); request?.abort(); checkoutRequest?.abort(); clearInterval(timer); deadlines.forEach(clearTimeout); deadlines.clear(); form?.reset(); destinationHome?.remove(); dialogHome?.remove(); delete document.body.dataset.alphaMounted; session = null; } };
    setActive(isSelected());
    if (!attach()) timer = setInterval(() => {
      if (attach() || ++attempts >= 40) { clearInterval(timer); if (!endpoint) setPhase('unavailable'); }
    }, 500);
  }
  document.addEventListener('shopify:section:unload', event => { if (session && event.target instanceof Element && event.target.contains(session.root)) session.dispose(); });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-mounted-presentation"] && !Shopify.designMode) return;
  try {
    (() => {
  const palette = { black: '#242321', white: '#f4f1e9', natural: '#b48e61', brown: '#593c2c', gold: '#b59a52', silver: '#b6b5ad', 'dark-grey': '#656d6b', 'light-grey': '#b4b4a9' };
  const measurements = (width, height) => {
    if (![width, height].every(value => Number.isFinite(value) && value > 0)) return null;
    return { width, height, outerWidth: width + 2 * (20 - 5), outerHeight: height + 2 * (20 - 5) };
  };
  const artworkFit = (width, height, sourceWidth, sourceHeight) => {
    if (![width, height, sourceWidth, sourceHeight].every(value => Number.isFinite(value) && value > 0)) return null;
    const border = Math.min(width, height) * .14;
    const scale = Math.min((width - border * 2) / sourceWidth, (height - border * 2) / sourceHeight);
    return { width: sourceWidth * scale / width * 100, height: sourceHeight * scale / height * 100 };
  };
  if (typeof document === 'undefined') {
    if (typeof module !== 'undefined') module.exports = { measurements, artworkFit, palette };
    return;
  }
  let session;
  function init() {
    const template = document.querySelector('[data-amp-template]');
    const mounted = document.querySelector('[data-alpha-mounted-offer]');
    if (session?.template === template && session?.mounted === mounted) return;
    session?.dispose();
    session = null;
    if (!template || !mounted) return;
    const fragment = template.content.cloneNode(true);
    const details = fragment.querySelector('[data-amp-details]');
    const wall = fragment.querySelector('[data-amp-wall]');
    const finishesNote = fragment.querySelector('[data-amp-finishes-note]');
    const zoomDialog = fragment.querySelector('[data-amp-dialog]');
    const room = wall.querySelector('[data-amp-room]');
    const roomArt = wall.querySelector('[data-amp-art]');
    const cards = mounted.querySelector('[data-am-color-cards]');
    const originals = new Map();
    const abort = new AbortController();
    let nativeRoot;
    let source;
    let currentGeometry;
    let frame;
    let raf;
    let disposed = false;
    const number = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 2 }).format(value);
    const label = (width, height) => {
      const inches = mounted.dataset.mountedUnit === 'in';
      const divisor = inches ? 25.4 : 10;
      return number(width / divisor) + ' × ' + number(height / divisor) + (inches ? '″' : ' cm');
    };
    function mockup() {
      const visual = document.createElement('span');
      visual.className = 'amp-frame';
      const image = document.createElement('img');
      image.src = source.currentSrc || source.src;
      image.alt = '';
      image.loading = 'lazy';
      image.width = Number(nativeRoot.dataset.aapSourceWidth);
      image.height = Number(nativeRoot.dataset.aapSourceHeight);
      visual.append(image);
      return visual;
    }
    function styleMockup(visual, color, geometry) {
      const fit = artworkFit(geometry.width, geometry.height, Number(nativeRoot.dataset.aapSourceWidth), Number(nativeRoot.dataset.aapSourceHeight));
      if (!fit) return;
      visual.dataset.ampFrameColor = color;
      visual.style.setProperty('--amp-color', palette[color] || palette.black);
      visual.style.aspectRatio = geometry.outerWidth + ' / ' + geometry.outerHeight;
      visual.style.setProperty('--amp-ratio', geometry.outerWidth / geometry.outerHeight);
      visual.style.setProperty('--amp-image-width', fit.width + '%');
      visual.style.setProperty('--amp-image-height', fit.height + '%');
    }
    function positionRoom() {
      if (!currentGeometry || wall.hidden) return;
      const height = room.clientHeight;
      const width = room.clientWidth;
      if (!(height > 0 && width > 0)) return;
      const scale = height * .64 / 1700;
      const artWidth = currentGeometry.outerWidth * scale;
      const artHeight = currentGeometry.outerHeight * scale;
      roomArt.style.width = artWidth + 'px';
      roomArt.style.height = artHeight + 'px';
      roomArt.style.setProperty('--amp-rim', 20 * scale + 'px');
      const measure = wall.querySelector('[data-amp-room-measure]');
      measure.style.top = height * .45 + artHeight / 2 + 10 + 'px';
    }
    function attach() {
      nativeRoot = mounted.closest('[data-aap-root]') || document.querySelector('[data-aap-root]');
      source = nativeRoot?.querySelector('[data-aap-product-preview-image]');
      const productBlock = nativeRoot?.querySelector('[data-aap-product-preview-block]');
      if (!source || !productBlock || !cards) return false;
      if (!details.isConnected) {
        cards.after(finishesNote);
        cards.closest('fieldset').after(details);
        productBlock.after(wall);
        wall.after(zoomDialog);
        const scene = nativeRoot.querySelector('.aap-preview__scene');
        const person = nativeRoot.querySelector('.aap-reference');
        if (scene) wall.querySelector('[data-amp-background]').append(scene.cloneNode(true));
        if (person) {
          const copy = person.cloneNode(true);
          copy.removeAttribute('data-aap-reference');
          copy.removeAttribute('id');
          copy.removeAttribute('style');
          wall.querySelector('[data-amp-person]').append(copy);
        }
        frame = mockup();
        roomArt.append(frame);
      }
      return true;
    }
    function sync() {
      raf = null;
      if (disposed || !attach()) return;
      const active = !mounted.hidden && mounted.dataset.mountedState === 'ready';
      currentGeometry = measurements(Number(mounted.dataset.mountedGlazingWidth), Number(mounted.dataset.mountedGlazingHeight));
      details.hidden = !active || !currentGeometry;
      wall.hidden = !active || !currentGeometry || !wall.querySelector('.aap-preview__scene');
      if (wall.hidden && zoomDialog.open) zoomDialog.close();
      if (!currentGeometry) return;
      const color = mounted.dataset.mountedFrameColor;
      const asset = [...(nativeRoot.querySelector('[data-aap-frame-assets]')?.content?.querySelectorAll('[data-color]') || [])].find(node => node.dataset.color === color);
      const detailImage = details.querySelector('[data-amp-detail-image]');
      const detailUrl = asset?.dataset.classicDetailUrl || asset?.dataset.classicUrl;
      detailImage.hidden = !detailUrl;
      if (detailUrl && detailImage.getAttribute('src') !== detailUrl) detailImage.src = detailUrl;
      details.querySelector('[data-amp-color]').textContent = cards.querySelector('[aria-pressed="true"]')?.textContent || '';
      details.querySelector('[data-amp-glazing]').textContent = label(currentGeometry.width, currentGeometry.height);
      details.querySelector('[data-amp-outer]').textContent = '≈ ' + label(currentGeometry.outerWidth, currentGeometry.outerHeight);
      wall.querySelector('[data-amp-room-measure]').textContent = '≈ ' + label(currentGeometry.outerWidth, currentGeometry.outerHeight);
      cards.querySelectorAll('[data-am-frame-color]').forEach(button => {
        let stage = button.querySelector('.amp-finish');
        if (!stage) {
          stage = document.createElement('span');
          stage.className = 'amp-finish';
          stage.setAttribute('aria-hidden', 'true');
          stage.append(mockup());
          const original = button.querySelector('img');
          if (original) { originals.set(button, original); original.replaceWith(stage); }
          else button.prepend(stage);
        }
        styleMockup(stage.querySelector('.amp-frame'), button.dataset.amFrameColor, currentGeometry);
      });
      for (const button of originals.keys()) if (!button.isConnected) originals.delete(button);
      styleMockup(frame, color, currentGeometry);
      positionRoom();
    }
    function schedule() { if (!disposed && raf == null) raf = requestAnimationFrame(sync); }
    const observer = new MutationObserver(schedule);
    wall.querySelector('[data-amp-zoom]').addEventListener('click', () => {
      if (wall.hidden || !currentGeometry) return;
      const copy = room.cloneNode(true);
      copy.querySelector('[data-amp-zoom]')?.remove();
      const art = copy.querySelector('[data-amp-art]');
      art.style.width = currentGeometry.outerWidth * .64 / 1700 * 941 / 1672 * 100 + '%';
      art.style.height = currentGeometry.outerHeight * .64 / 1700 * 100 + '%';
      art.style.setProperty('--amp-rim', '2px');
      const measure = copy.querySelector('[data-amp-room-measure]');
      measure.style.top = (45 + currentGeometry.outerHeight * .64 / 1700 * 50 + 3) + '%';
      zoomDialog.querySelector('[data-amp-zoom-content]').replaceChildren(copy);
      zoomDialog.showModal();
    }, { signal: abort.signal });
    zoomDialog.querySelector('[data-amp-close]').addEventListener('click', () => zoomDialog.close(), { signal: abort.signal });
    zoomDialog.addEventListener('click', event => { if (event.target === zoomDialog) zoomDialog.close(); }, { signal: abort.signal });
    zoomDialog.addEventListener('close', () => { zoomDialog.querySelector('[data-amp-zoom-content]').replaceChildren(); wall.querySelector('[data-amp-zoom]').focus(); }, { signal: abort.signal });
    observer.observe(mounted, { attributes: true, attributeFilter: ['hidden', 'data-mounted-state', 'data-mounted-frame-color', 'data-mounted-glazing-width', 'data-mounted-glazing-height', 'data-mounted-unit'] });
    if (cards) observer.observe(cards, { childList: true });
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(positionRoom) : null;
    resize?.observe(room);
    window.addEventListener('resize', positionRoom, { signal: abort.signal });
    window.addEventListener('alpha:mounted-state', schedule, { signal: abort.signal });
    session = { template, mounted, dispose() {
      disposed = true;
      if (raf != null) cancelAnimationFrame(raf);
      observer.disconnect(); resize?.disconnect(); abort.abort();
      originals.forEach((image, button) => button.querySelector('.amp-finish')?.replaceWith(image));
      if (zoomDialog.open) zoomDialog.close();
      details.remove(); wall.remove(); finishesNote.remove(); zoomDialog.remove();
    } };
    schedule();
  }
  document.addEventListener('shopify:section:unload', event => { if (session && event.target instanceof Element && event.target.contains(session.template)) { session.dispose(); session = null; } });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-mug-commerce"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const box=document.querySelector('[data-mug-commerce]'),root=box?.closest('[data-mug-root]');
    if(!root||box.dataset.initialized)return;
    box.dataset.initialized='true';
    const source=JSON.parse(box.querySelector('[data-mug-source]').textContent),copy=JSON.parse(box.querySelector('[data-mug-commerce-copy]').textContent);
    const pay=box.querySelector('[data-mug-pay]'),add=box.querySelector('[data-mug-add]'),error=box.querySelector('[data-mug-commerce-error]');
    let loadTimer;let native,dialog,home,form,submit,originalLabel,owned=false,paying=false,uncertain=false,options=[],loadedCountry='',fetched=0,loading='',sequence=0,openedSelection='';
    const active=()=>document.body.dataset.artworkBrowse==='mug';
    const selection=()=>{try{return active()?JSON.parse(root.dataset.mugSelection||'null'):null;}catch{return null;}};
    const signature=()=>{const s=selection();return s?JSON.stringify(s):'';};
    const current=()=>{const s=selection();return s&&signature()===loadedCountry?options.find(o=>o.mug?.layout===s.layout&&Math.round(o.totalPriceEur*100)===s.priceCents):null;};
    const fail=message=>{error.textContent=message||copy.error;error.hidden=false;};
    function endpoint(){
      const url=new URL(native.dataset.aapProxy,location.origin);
      if(url.origin!==location.origin||url.pathname!=='/apps/alpha-art-print')throw Error('UNAVAILABLE');
      return url;
    }
    function close(){if(owned&&dialog.open)dialog.close();}
    function render(){
      const available=Boolean(current())&&!uncertain;
      const selected=selection();
      box.hidden=!active()||!selected;pay.disabled=add.disabled=!available||paying;
      if(!selected)error.hidden=true;
      const total=root.querySelector('[data-mug-price]');
      const target=box.querySelector('[data-mug-pay-total]');
      const amount=selected&&total?total.querySelector('.money')?.textContent||'':'';
      if(target.textContent!==amount)target.textContent=amount;
      for(const el of root.querySelectorAll('.amg-pending'))el.hidden=!selected||available;
      root.dataset.mugCheckout=available?'ready':'unavailable';
      root.dataset.mugPaying=String(paying);
    }
    async function load(force=false){
      const s=selection();if(!native||!s)return;const key=signature();
      if(!force&&loadedCountry===key&&Date.now()-fetched<20*60*1000){render();return;}
      if(loading===key)return;
      const turn=++sequence;loading=key;options=[];loadedCountry='';render();
      try{
        const url=endpoint();url.searchParams.set('variant',native.dataset.aapVariant);url.searchParams.set('country',s.country);url.searchParams.set('catalog_profile','mug-v1');url.searchParams.set('mug_layout',s.layout);
        const response=await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(30000)});
        const data=await response.json();
        if(!response.ok||data.offerProfile!=='mug-v1'||data.countryCode!==s.country||!Array.isArray(data.options))throw Error('UNAVAILABLE');
        if(turn!==sequence||signature()!==key)return;
        options=data.options.filter(o=>o.supportId==='ceramic-mug'&&o.offerProfile==='mug-v1'&&typeof o.quoteToken==='string'&&Number.isFinite(o.totalPriceEur));
        loadedCountry=key;fetched=Date.now();error.hidden=true;
      }catch{if(turn===sequence)fail();}
      finally{if(turn===sequence){loading='';render();}}
    }
    function syncAddress(){
      const s=selection(),countries=native.querySelector('[data-aap-country]');
      const country=[...countries.options].find(o=>o.value===s.country);
      if(!country)throw Error('UNAVAILABLE');
      form.querySelector('[data-aap-address-country]').textContent=country.textContent;
      const normalize=t=>String(t||'').trim().normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
      const metadata=native.querySelector('[data-aap-country-metadata]');
      const item=metadata&&[...metadata.options].find(o=>normalize(o.textContent)===normalize(country.textContent));
      const provinces=JSON.parse(item?.dataset.provinces||'[]');
      const field=form.querySelector('[data-aap-address-province-field]'),province=form.querySelector('[data-aap-address-province]');
      province.replaceChildren();field.hidden=!provinces.length;province.required=Boolean(provinces.length);
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});province.disabled=!provinces.length;
      if(provinces.length){province.append(new Option(copy.choose,''));for(const p of provinces)province.append(new Option(p[1],p[0]));}
      submit.disabled=false;submit.textContent=originalLabel;
      form.querySelector('[data-aap-address-error]').textContent='';
    }
    async function submitAddress(event){
      if(!owned)return;
      event.preventDefault();event.stopImmediatePropagation();
      if(paying||uncertain||!active()||openedSelection!==signature()||!current()||!form.reportValidity())return;
      const s=selection(),option=current();
      if(Date.now()-fetched>25*60*1000){close();options=[];render();await load(true);return;}
      const shippingAddress=Object.fromEntries(new FormData(form));shippingAddress.countryCode=s.country;
      paying=true;render();submit.disabled=true;submit.textContent=copy.loading;
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=true;});
      try{
        const response=await fetch(endpoint(),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({quoteToken:option.quoteToken,shippingAddress}),signal:AbortSignal.timeout(30000)});
        const result=await response.json();
        if(!response.ok){if(response.status>=500)uncertain=true;throw Error('CHECKOUT');}
        const url=new URL(result.checkoutUrl);
        if(url.protocol!=='https:'||(!/(^|\.)alphachristianart\.com$/.test(url.hostname)&&url.hostname!==box.dataset.shop))throw Error('CHECKOUT');
        location.assign(url.href);
      }catch{uncertain=true;fail(copy.uncertain);form.querySelector('[data-aap-address-error]').textContent=copy.uncertain;}
      finally{paying=false;render();submit.textContent=originalLabel;submit.disabled=true;}
    }
    function attach(){
      native=document.querySelector('[data-aap-root]');dialog=native?.querySelector('[data-aap-address-dialog]');form=dialog?.querySelector('[data-aap-address-form]');submit=form?.querySelector('[data-aap-address-submit]');
      if(!native?.dataset.aapVariant||!form||!submit||!native.querySelector('[data-aap-country]')?.options.length)return false;
      home=document.createComment('mug-address-home');dialog.before(home);originalLabel=submit.textContent;
      for(const key of ['--aap-accent','--aap-ink','--aap-muted','--aap-font']){const value=getComputedStyle(native).getPropertyValue(key);if(value)box.style.setProperty(key,value);}
      form.addEventListener('submit',submitAddress,true);
      dialog.addEventListener('close',()=>{if(!owned)return;owned=false;home.after(dialog);form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});submit.disabled=false;submit.textContent=originalLabel;if(active())pay.focus();});
      load();return true;
    }
    pay.addEventListener('click',async()=>{
      const before=signature();if(!before||paying||uncertain)return;
      paying=true;render();await load(true);paying=false;render();
      if(before!==signature()||!current())return;
      try{syncAddress();owned=true;openedSelection=signature();box.append(dialog);dialog.showModal();form.querySelector('input[name="firstName"]')?.focus();}catch{owned=false;home.after(dialog);fail();}
    });
    add.addEventListener('click',async()=>{
      const before=signature(),s=selection(),o=current(),wallet=document.querySelector('artwork-credit-cart');if(!s||!o||paying||!wallet?.addMugConfiguration)return;
      paying=true;render();
      try{await wallet.addMugConfiguration(source,{variantId:'gid://shopify/ProductVariant/'+native.dataset.aapVariant,country:s.country,optionId:o.id,priceCents:s.priceCents,label:s.label},()=>before===signature());}catch{fail();}finally{paying=false;render();}
    });
    window.addEventListener('alpha:mug-selection',()=>{if(owned&&signature()!==openedSelection&&!paying)close();render();clearTimeout(loadTimer);loadTimer=setTimeout(()=>load(),450);});
    window.addEventListener('alpha:artwork-browse',()=>{if(!active()&&!paying)close();render();});
    const price=root.querySelector('[data-mug-price]');
    if(price)new MutationObserver(render).observe(price,{childList:true,subtree:true,characterData:true});
    let tries=0;const timer=setInterval(()=>{if(attach()||++tries>60)clearInterval(timer);},500);
    render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-mug-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const dimensions={width:2670,height:1110};
  const layoutFor=(ratio,choice='auto')=>choice==='two'||choice==='panorama'?choice:ratio>=1.45?'panorama':'two';
  const fit=(ratio,box)=>{if(!Number.isFinite(ratio)||ratio<=0)return null;const width=Math.min(box.w,box.h*ratio),height=width/ratio;return {x:box.x+(box.w-width)/2,y:box.y+(box.h-height)/2,w:width,h:height};};
  const placements=(ratio,choice='auto')=>{
    if(!Number.isFinite(ratio)||ratio<=0)return [];
    const W=dimensions.width,H=dimensions.height;
    return (layoutFor(ratio,choice)==='two'?[{x:W*.06,y:H*.055,w:W*.38,h:H*.89},{x:W*.56,y:H*.055,w:W*.38,h:H*.89}]:[{x:W*.025,y:H*.055,w:W*.95,h:H*.89}]).map(box=>fit(ratio,box));
  };
  const faceGeometry=side=>side==='back'?{center:.25,cx:.528}:side==='middle'?{center:.5,cx:.472}:{center:.75,cx:.472};
  const surfaceU=(side,theta)=>faceGeometry(side).center+theta/(2*Math.PI);
  const priceFor=(data,country)=>data?.version===1&&data.checkoutEnabled===false&&data.currency==='EUR'&&Number.isInteger(data.prices?.[country])&&data.prices[country]>0?data.prices[country]:null;
  if(typeof document==='undefined'){if(typeof module!=='undefined')module.exports={layoutFor,fit,placements,priceFor,dimensions,faceGeometry,surfaceU};return;}
  let dispose=()=>{};
  function init(){
    dispose();const root=document.querySelector('[data-mug-root]'),selector=document.querySelector('[data-alpha-browse-type]');if(!root||!selector)return;
    const data=JSON.parse(root.querySelector('[data-mug-data]').textContent),copy=JSON.parse(root.querySelector('[data-mug-copy]').textContent),listeners=new AbortController(),cards=new Map();
    const panel=root.querySelector('[data-mug-panel]'),hero=panel?.querySelector('[data-mug-scene]'),source=hero?.querySelector('.amg-source');
    let country=root.dataset.defaultCountry,choice='auto',view='front',scheduled=false,stopped=false;
    try{country=localStorage.getItem('alpha-art-print-country')||country;}catch(_){}
    country=String(country).toUpperCase();
    const active=()=>document.body.dataset.artworkBrowse==='mug';
    const schedule=()=>{if(scheduled||stopped)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;if(!stopped)render();});};
    function writePrice(node,from=false){
      const value=priceFor(data,country),key=country+':'+value+':'+from;if(node.dataset.mugPriceKey===key)return;
      node.dataset.mugPriceKey=key;node.hidden=false;node.replaceChildren();const line=document.createElement('span');line.className='asp-price__line';
      if(value===null)line.textContent=copy.unavailable;
      else {if(from)line.append(document.createTextNode(copy.from+' '));const money=document.createElement('strong');money.className='money';money.textContent=(value/100).toFixed(2)+' €';line.append(money);}
      node.append(line);if(value!==null){const note=document.createElement('small');note.className='asp-price__note';note.textContent=copy.shipping;node.append(note);}
    }
    function draw(scene,img,layoutChoice='auto',side='front',flatPreview=null){
      if(!img?.complete||!img.naturalWidth||!img.naturalHeight)return false;
      const ratio=img.naturalWidth/img.naturalHeight,layout=layoutFor(ratio,layoutChoice),key=[img.currentSrc||img.src,ratio,layout,side].join(':');
      if(scene.dataset.mugDrawn===key)return true;
      const flat=document.createElement('canvas');flat.width=dimensions.width;flat.height=dimensions.height;const f=flat.getContext('2d');if(!f)return false;
      placements(ratio,layout).forEach(p=>f.drawImage(img,p.x,p.y,p.w,p.h));
      if(flatPreview){const fc=flatPreview.getContext('2d');fc.clearRect(0,0,flatPreview.width,flatPreview.height);fc.drawImage(flat,0,0,flatPreview.width,flatPreview.height);}
      const canvas=scene.querySelector('canvas'),ctx=canvas.getContext('2d');if(!ctx)return false;
      const W=canvas.width,H=canvas.height,geometry=faceGeometry(side);scene.dataset.mugSide=side;ctx.clearRect(0,0,W,H);
      const cx=geometry.cx*W,R=.195*W,steps=240;
      for(let i=0;i<steps;i++){
        const t1=-Math.PI/2+i*Math.PI/steps,t2=-Math.PI/2+(i+1)*Math.PI/steps,t=(t1+t2)/2;
        const u1=surfaceU(side,t1),u2=surfaceU(side,t2),sx=u1*flat.width,sw=(u2-u1)*flat.width;
        if(sx<0||sx+sw>flat.width)continue;
        const x1=cx+R*Math.sin(t1),x2=cx+R*Math.sin(t2),curve=Math.cos(t),top=(.155-.012*(1-curve))*H,bottom=(.873-.038*(1-curve))*H;
        ctx.drawImage(flat,sx,0,sw,flat.height,x1,top,Math.max(.8,x2-x1+.4),bottom-top);
      }
      ctx.globalCompositeOperation='source-atop';const shade=ctx.createLinearGradient(cx-R,0,cx+R,0);shade.addColorStop(0,'rgba(0,0,0,.25)');shade.addColorStop(.2,'rgba(255,255,255,.05)');shade.addColorStop(.45,'rgba(255,255,255,.02)');shade.addColorStop(.8,'rgba(0,0,0,.04)');shade.addColorStop(1,'rgba(0,0,0,.22)');ctx.fillStyle=shade;ctx.fillRect(0,0,W,H);ctx.globalCompositeOperation='source-over';
      scene.dataset.mugDrawn=key;return true;
    }
    const observer=new IntersectionObserver(entries=>{entries.forEach(e=>{const item=cards.get(e.target);if(item&&e.isIntersecting){item.visible=true;observer.unobserve(e.target);}});schedule();},{rootMargin:'400px'});
    function attachCards(){
      document.querySelectorAll('[data-alpha-product-card]').forEach(card=>{
        if(cards.has(card))return;const img=card.querySelector('.alpha-product-card__artwork-frame img'),media=card.querySelector('.alpha-product-card__media');if(!img||!media)return;
        const scene=root.querySelector('[data-mug-scene-template]').content.firstElementChild.cloneNode(true);scene.classList.add('amg-card-scene');scene.querySelector('img').sizes='(min-width:990px) 30vw, 50vw';scene.querySelector('canvas').width=720;scene.querySelector('canvas').height=480;media.append(scene);
        const price=document.createElement('div');price.className='asp-price amg-card-price';card.append(price);const item={img,scene,price,visible:false};cards.set(card,item);observer.observe(card);img.addEventListener('load',schedule,{signal:listeners.signal});
      });
      for(const [card,item]of cards){if(!card.isConnected){observer.unobserve(card);cards.delete(card);continue;}writePrice(item.price,true);if(item.visible&&draw(item.scene,item.img))card.classList.add('amg-card-ready');}
    }
    function render(){
      selector.querySelectorAll('[data-mug-minimum]').forEach(n=>writePrice(n,true));selector.querySelectorAll('[data-mug-scene]').forEach(scene=>draw(scene,scene.querySelector('.amg-source')));if(panel)panel.hidden=!active();if(!active())return;
      selector.querySelectorAll('[data-browse-for="mug"] input').forEach(n=>{n.disabled=false;n.value=n.dataset.browsePresentation;n.checked=true;});
      attachCards();document.querySelectorAll('.abt-card-action__link').forEach(n=>n.textContent=selector.dataset.mugCardCta);document.querySelectorAll('.abt-card-action__note').forEach(n=>n.textContent=selector.dataset.mugCardNote);
      if(!panel)return;writePrice(root.querySelector('[data-mug-price]'));
      const ratio=source?.naturalWidth/source?.naturalHeight,layout=layoutFor(ratio,choice);draw(hero,source,choice,view,root.querySelector('[data-mug-flat]'));
      root.querySelector('[data-mug-layout-note]').textContent=copy[layout];
      root.querySelectorAll('[data-mug-layout]').forEach(n=>n.setAttribute('aria-pressed',String(n.dataset.mugLayout===choice)));root.querySelectorAll('[data-mug-view]').forEach(n=>n.setAttribute('aria-pressed',String(n.dataset.mugView===view)));
      try{root.querySelector('[data-mug-country]').textContent=new Intl.DisplayNames([document.documentElement.lang||'en'],{type:'region'}).of(country);}catch(_){}
      const selection=JSON.stringify({country,layout,priceCents:priceFor(data,country),label:root.querySelector('.amg-spec').textContent+' · '+copy[layout]});
      if(root.dataset.mugSelection!==selection){root.dataset.mugSelection=selection;window.dispatchEvent(new CustomEvent('alpha:mug-selection'));}
    }
    root.addEventListener('click',e=>{const layout=e.target.closest('[data-mug-layout]'),side=e.target.closest('[data-mug-view]');if(layout){choice=layout.dataset.mugLayout;view='front';schedule();}if(side){view=side.dataset.mugView;schedule();}},{signal:listeners.signal});
    selector.querySelectorAll('.amg-source').forEach(image=>image.addEventListener('load',schedule,{signal:listeners.signal}));
    source?.addEventListener('load',schedule,{signal:listeners.signal});source?.addEventListener('error',()=>{root.querySelector('[data-mug-layout-note]').textContent=copy.image_error;},{signal:listeners.signal});
    window.addEventListener('alpha:artwork-browse',schedule,{signal:listeners.signal});
    const setCountry=value=>{if(/^[A-Z]{2}$/.test(value||'')){country=value;schedule();}};
    window.addEventListener('alpha-art-print:country-change',e=>setCountry(e.detail?.country),{signal:listeners.signal});window.addEventListener('storage',e=>{if(e.key==='alpha-art-print-country')setCountry(e.newValue);},{signal:listeners.signal});
    window.addEventListener('pageshow',()=>{try{setCountry(localStorage.getItem('alpha-art-print-country'));}catch(_){}schedule();},{signal:listeners.signal});
    const grid=document.getElementById('ResultsList'),gridObserver=new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-alpha-product-card],li')||n.querySelector('[data-alpha-product-card]')))))schedule();});if(grid)gridObserver.observe(grid,{childList:true,subtree:true});
    dispose=()=>{stopped=true;listeners.abort();observer.disconnect();gridObserver.disconnect();cards.forEach((item,card)=>{item.scene.remove();item.price.remove();card.classList.remove('amg-card-ready');});};schedule();
  }
  document.addEventListener('shopify:section:load',init);document.addEventListener('shopify:section:unload',()=>{if(!document.querySelector('[data-mug-root]'))dispose();});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-phone-commerce"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const box=document.querySelector('[data-phone-commerce]'),root=box?.closest('[data-phone-root]');
    if(!root||box.dataset.initialized)return;
    box.dataset.initialized='true';
    const source=JSON.parse(box.querySelector('[data-phone-source]').textContent),copy=JSON.parse(box.querySelector('[data-phone-commerce-copy]').textContent);
    const pay=box.querySelector('[data-phone-pay]'),add=box.querySelector('[data-phone-add]'),error=box.querySelector('[data-phone-commerce-error]');
    let loadTimer;let native,dialog,home,form,submit,originalLabel,owned=false,paying=false,uncertain=false,options=[],loadedCountry='',fetched=0,loading='',sequence=0,openedSelection='';
    const active=()=>document.body.dataset.artworkBrowse==='phone';
    const selection=()=>{try{return active()?JSON.parse(root.dataset.phoneSelection||'null'):null;}catch{return null;}};
    const signature=()=>{const s=selection();return s?JSON.stringify(s):'';};
    const current=()=>{const s=selection();return s&&signature()===loadedCountry?options.find(o=>o.phone?.model===s.model&&o.phone.caseType===s.type&&o.phone.finish===s.finish&&o.phone.x===s.x&&o.phone.y===s.y&&o.phone.zoom===s.zoom&&Math.round(o.totalPriceEur*100)===s.priceCents):null;};
    const fail=message=>{error.textContent=message||copy.error;error.hidden=false;};
    function endpoint(){
      const url=new URL(native.dataset.aapProxy,location.origin);
      if(url.origin!==location.origin||url.pathname!=='/apps/alpha-art-print')throw Error('UNAVAILABLE');
      return url;
    }
    function close(){if(owned&&dialog.open)dialog.close();}
    function render(){
      const available=Boolean(current())&&!uncertain;
      const selected=selection();
      box.hidden=!active()||!selected;pay.disabled=add.disabled=!available||paying;
      if(!selected)error.hidden=true;
      const total=root.querySelector('[data-phone-price]');
      const target=box.querySelector('[data-phone-pay-total]');
      const amount=selected&&total?total.querySelector('.money')?.textContent||'':'';
      if(target.textContent!==amount)target.textContent=amount;
      for(const el of root.querySelectorAll('.aph-pending'))el.hidden=!selected||available;
      root.dataset.phoneCheckout=available?'ready':'unavailable';
      root.dataset.phonePaying=String(paying);
    }
    async function load(force=false){
      const s=selection();if(!native||!s)return;const key=signature();
      if(!force&&loadedCountry===key&&Date.now()-fetched<20*60*1000){render();return;}
      if(loading===key)return;
      const turn=++sequence;loading=key;options=[];loadedCountry='';render();
      try{
        const url=endpoint();url.searchParams.set('variant',native.dataset.aapVariant);url.searchParams.set('country',s.country);url.searchParams.set('catalog_profile','phone-v1');url.searchParams.set('phone_model',s.model);for(const k of ['x','y','zoom'])url.searchParams.set('phone_'+k,s[k]);
        const response=await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(30000)});
        const data=await response.json();
        if(!response.ok||data.offerProfile!=='phone-v1'||data.countryCode!==s.country||!Array.isArray(data.options))throw Error('UNAVAILABLE');
        if(turn!==sequence||signature()!==key)return;
        options=data.options.filter(o=>o.supportId==='phone-case'&&o.offerProfile==='phone-v1'&&typeof o.quoteToken==='string'&&Number.isFinite(o.totalPriceEur));
        loadedCountry=key;fetched=Date.now();error.hidden=true;
      }catch{if(turn===sequence)fail();}
      finally{if(turn===sequence){loading='';render();}}
    }
    function syncAddress(){
      const s=selection(),countries=native.querySelector('[data-aap-country]');
      const country=[...countries.options].find(o=>o.value===s.country);
      if(!country)throw Error('UNAVAILABLE');
      form.querySelector('[data-aap-address-country]').textContent=country.textContent;
      const normalize=t=>String(t||'').trim().normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
      const metadata=native.querySelector('[data-aap-country-metadata]');
      const item=metadata&&[...metadata.options].find(o=>normalize(o.textContent)===normalize(country.textContent));
      const provinces=JSON.parse(item?.dataset.provinces||'[]');
      const field=form.querySelector('[data-aap-address-province-field]'),province=form.querySelector('[data-aap-address-province]');
      province.replaceChildren();field.hidden=!provinces.length;province.required=Boolean(provinces.length);
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});province.disabled=!provinces.length;
      if(provinces.length){province.append(new Option(copy.choose,''));for(const p of provinces)province.append(new Option(p[1],p[0]));}
      submit.disabled=false;submit.textContent=originalLabel;
      form.querySelector('[data-aap-address-error]').textContent='';
    }
    async function submitAddress(event){
      if(!owned)return;
      event.preventDefault();event.stopImmediatePropagation();
      if(paying||uncertain||!active()||openedSelection!==signature()||!current()||!form.reportValidity())return;
      const s=selection(),option=current();
      if(Date.now()-fetched>25*60*1000){close();options=[];render();await load(true);return;}
      const shippingAddress=Object.fromEntries(new FormData(form));shippingAddress.countryCode=s.country;
      paying=true;render();submit.disabled=true;submit.textContent=copy.loading;
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=true;});
      try{
        const response=await fetch(endpoint(),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({quoteToken:option.quoteToken,shippingAddress}),signal:AbortSignal.timeout(30000)});
        const result=await response.json();
        if(!response.ok){if(response.status>=500)uncertain=true;throw Error('CHECKOUT');}
        const url=new URL(result.checkoutUrl);
        if(url.protocol!=='https:'||(!/(^|\.)alphachristianart\.com$/.test(url.hostname)&&url.hostname!==box.dataset.shop))throw Error('CHECKOUT');
        location.assign(url.href);
      }catch{uncertain=true;fail(copy.uncertain);form.querySelector('[data-aap-address-error]').textContent=copy.uncertain;}
      finally{paying=false;render();submit.textContent=originalLabel;submit.disabled=true;}
    }
    function attach(){
      native=document.querySelector('[data-aap-root]');dialog=native?.querySelector('[data-aap-address-dialog]');form=dialog?.querySelector('[data-aap-address-form]');submit=form?.querySelector('[data-aap-address-submit]');
      if(!native?.dataset.aapVariant||!form||!submit||!native.querySelector('[data-aap-country]')?.options.length)return false;
      home=document.createComment('phone-address-home');dialog.before(home);originalLabel=submit.textContent;
      for(const key of ['--aap-accent','--aap-ink','--aap-muted','--aap-font']){const value=getComputedStyle(native).getPropertyValue(key);if(value)box.style.setProperty(key,value);}
      form.addEventListener('submit',submitAddress,true);
      dialog.addEventListener('close',()=>{if(!owned)return;owned=false;home.after(dialog);form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});submit.disabled=false;submit.textContent=originalLabel;if(active())pay.focus();});
      load();return true;
    }
    pay.addEventListener('click',async()=>{
      const before=signature();if(!before||paying||uncertain)return;
      paying=true;render();await load(true);paying=false;render();
      if(before!==signature()||!current())return;
      try{syncAddress();owned=true;openedSelection=signature();box.append(dialog);dialog.showModal();form.querySelector('input[name="firstName"]')?.focus();}catch{owned=false;home.after(dialog);fail();}
    });
    add.addEventListener('click',async()=>{
      const before=signature(),s=selection(),o=current(),wallet=document.querySelector('artwork-credit-cart');if(!s||!o||paying||!wallet?.addPhoneConfiguration)return;
      paying=true;render();
      try{await wallet.addPhoneConfiguration(source,{variantId:'gid://shopify/ProductVariant/'+native.dataset.aapVariant,country:s.country,optionId:o.id,priceCents:s.priceCents,label:s.label},()=>before===signature());}catch{fail();}finally{paying=false;render();}
    });
    window.addEventListener('alpha:phone-selection',()=>{if(owned&&signature()!==openedSelection&&!paying)close();render();clearTimeout(loadTimer);loadTimer=setTimeout(()=>load(),450);});
    window.addEventListener('alpha:artwork-browse',()=>{if(!active()&&!paying)close();render();});
    const price=root.querySelector('[data-phone-price]');
    if(price)new MutationObserver(render).observe(price,{childList:true,subtree:true,characterData:true});
    let tries=0;const timer=setInterval(()=>{if(attach()||++tries>60)clearInterval(timer);},500);
    render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-phone-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const types=['snap','tough','clear'];
  const selectOptions=(data,type,model,country)=>data?.options?.filter(o=>o.type===type&&(!model||o.model===model)&&Number.isInteger(o.prices?.[country])&&o.prices[country]>0)||[];
  const minimum=(data,type,country)=>{const prices=(data?.options||[]).filter(o=>type==='all'||o.type===type).map(o=>o.prices?.[country]).filter(p=>Number.isInteger(p)&&p>0);return prices.length?Math.min(...prices):null;};
  const modelMinimum=(data,type,model,country)=>{const prices=selectOptions(data,type,model,country).map(o=>o.prices[country]);return prices.length?Math.min(...prices):null;};
  const modelVariants=(data,type,model)=>data?.options?.filter(o=>o.type===type&&o.model===model)||[];
  const fit=(ratio,target,x=50,y=50,zoom=100)=>{
    if(!Number.isFinite(ratio)||ratio<=0||!Number.isFinite(target)||target<=0)return null;
    const z=Math.min(160,Math.max(100,Number(zoom)||100))/100;
    const w=Math.max(1,ratio/target)*z,h=Math.max(1,target/ratio)*z;
    return {width:w*100,height:h*100,left:(1-w)*Math.min(100,Math.max(0,Number(x)||0)),top:(1-h)*Math.min(100,Math.max(0,Number(y)||0)),retained:1/(w*h)};
  };
  const project=(ratio,print,x=50,y=50,zoom=100)=>{
    if(!print?.view)return null;
    const f=fit(ratio,print.width/print.height,x,y,zoom),v=print.view;if(!f)return null;
    return {width:f.width/v.w,height:f.height/v.h,left:(f.left-v.x*100)/v.w,top:(f.top-v.y*100)/v.h,retained:f.retained*v.w*v.h,ratio:print.width*v.w/(print.height*v.h)};
  };
  if(typeof document==='undefined'){if(typeof module!=='undefined')module.exports={types,selectOptions,minimum,modelMinimum,modelVariants,fit,project};return;}
  let dispose=()=>{};
  function init(){
    dispose();
    const root=document.querySelector('[data-phone-root]'),selector=document.querySelector('[data-alpha-browse-type]');if(!root||!selector)return;
    // The shared browsing controls read input.value; phone cards declare their type in data.
    selector.querySelectorAll('[data-browse-presentation]').forEach(input=>{if(types.includes(input.dataset.browsePresentation))input.value=input.dataset.browsePresentation;});
    const settings=JSON.parse(root.querySelector('[data-phone-settings]').textContent),copy=JSON.parse(root.querySelector('[data-phone-copy]').textContent);
    const panel=root.querySelector('[data-phone-panel]'),hero=root.querySelector('[data-phone-case]'),modelSelect=root.querySelector('[data-phone-model]'),brandSelect=root.querySelector('[data-phone-brand]');
    const listeners=new AbortController(),cards=new Map();
    let data=null,state='loading',country=root.dataset.defaultCountry,model='IP15',finish='G',lastType='',positions={x:50,y:50,zoom:100},stopped=false,scheduled=false;
    try{country=localStorage.getItem('alpha-art-print-country')||country;}catch(_){}
    const savedModel=()=>{try{return new URL(location.href).searchParams.get('phone_model')||localStorage.getItem('alpha-phone-model');}catch(_){return null;}};
    const rememberModel=()=>{try{localStorage.setItem('alpha-phone-model',model);const url=new URL(location.href);if(active()){url.searchParams.set('phone_model',model);history.replaceState(history.state,'',url);}}catch(_){}};
    const active=()=>document.body.dataset.artworkBrowse==='phone';
    const type=()=>types.includes(document.body.dataset.artworkFinish)?document.body.dataset.artworkFinish:'snap';
    const schedule=()=>{if(scheduled||stopped)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;if(!stopped)render();});};
    function writePrice(node,value,from=false,missing=copy.no_price){
      if(!node)return;
      const key=[country,value,from,state,missing].join(':');if(node.dataset.phonePriceKey===key)return;
      node.dataset.phonePriceKey=key;node.hidden=false;node.replaceChildren();
      const line=document.createElement('span');line.className='asp-price__line';
      if(value===null)line.textContent=state==='loading'?copy.loading:missing;
      else{if(from)line.append(document.createTextNode(copy.from+' '));const money=document.createElement('strong');money.className='money';money.textContent=(value/100).toFixed(2)+' €';line.append(money);}
      node.append(line);
      if(value!==null){const note=document.createElement('small');note.className='asp-price__note';note.textContent=copy.shipping;node.append(note);}
    }
    function setArt(art,ratio,isHero=false){
      const current=data?.models.find(m=>m.id===model),target=current?.ratio||.475;
      art.dataset.kind=type();art.dataset.pro=String(Boolean(current?.pro));art.dataset.finish=finish;
      art.dataset.camera=current?.camera||'diagonal';art.dataset.brand=current?.brand||'Apple';
      art.dataset.model=current?.id||'';
      art.classList.toggle('aph-unavailable-art',Boolean(data)&&!modelVariants(data,type(),model).length);
      art.parentElement.dataset.unavailableMessage=copy.unavailable;
      art.style.aspectRatio=String(target);
      const image=art.querySelector('img'),area=art.querySelector('.aph-print');
      const print=modelVariants(data,type(),model).find(o=>o.finish===finish)?.print;
      const f=project(ratio,print,...(isHero?[positions.x,positions.y,positions.zoom]:[50,50,100]));
      if(!image||!f){if(isHero)root.querySelector('[data-phone-warning]').hidden=true;return;}
      const border=parseFloat(getComputedStyle(art).borderLeftWidth)||0;
      art.style.height=((art.clientWidth)/f.ratio+border*2)+'px';
      Object.assign(image.style,{width:f.width+'%',height:f.height+'%',left:f.left+'%',top:f.top+'%'});
      if(isHero){const warning=root.querySelector('[data-phone-warning]');warning.hidden=f.retained>=.7||!modelVariants(data,type(),model).length;}
    }
    function decorate(){
      if(!active())return;
      document.querySelectorAll('[data-alpha-product-card]').forEach(card=>{
        if(cards.has(card))return;
        const source=card.querySelector('.alpha-product-card__artwork-frame img'),media=card.querySelector('.alpha-product-card__media');if(!source||!media)return;
        const stage=document.createElement('div');stage.className='aph-stage aph-card-stage';
        const art=document.createElement('div');art.className='aph-case';
        art.innerHTML='<div class="aph-print"></div><span class="aph-camera" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><b></b></span><span class="aph-glint" aria-hidden="true"></span>';
        const img=source.cloneNode();img.removeAttribute('id');img.className='aph-image';img.alt='';img.loading='lazy';img.decoding='async';img.sizes='(min-width: 990px) 180px, 32vw';
        art.querySelector('.aph-print').append(img);stage.append(art);media.append(stage);card.classList.add('aph-card-ready');
        const price=document.createElement('div');price.className='asp-price aph-card-price';card.append(price);
        const load=()=>schedule();source.addEventListener('load',load,{signal:listeners.signal});
        cards.set(card,{source,stage,art,price});
      });
      for(const [card,entry]of cards){if(!card.isConnected){cards.delete(card);continue;}const ratio=Number(card.dataset.alphaGalleryRatio)||entry.source.naturalWidth/entry.source.naturalHeight;setArt(entry.art,ratio);writePrice(entry.price,modelMinimum(data,type(),model,country),true,modelVariants(data,type(),model).length?copy.no_price:copy.unavailable);}
    }
    function render(){
      if(active())selector.querySelectorAll('[data-browse-presentation]').forEach(input=>{if(types.includes(input.dataset.browsePresentation))input.checked=input.value===type();});
      selector.querySelectorAll('[data-phone-minimum]').forEach(node=>{const t=node.dataset.phoneMinimum;writePrice(node,t==='all'?minimum(data,t,country):modelMinimum(data,t,model,country),true,t==='all'||modelVariants(data,t,model).length?copy.no_price:copy.unavailable);});
      if(panel)panel.hidden=!active();
      if(document.body.dataset.artworkBrowse!=='mug'){
        document.querySelectorAll('.abt-card-action__link').forEach(link=>{link.textContent=active()?selector.dataset.phoneCardCta:selector.dataset.cardCta;});
        document.querySelectorAll('.abt-card-action__note').forEach(note=>{note.textContent=active()?selector.dataset.phoneCardNote:selector.dataset.cardNote;});
      }
      if(!active())return;
      if(lastType!==type()){finish=type()==='clear'?'S':'G';lastType=type();}
      if(panel&&data){
        const variants=modelVariants(data,type(),model),current=data.models.find(m=>m.id===model);
        if(brandSelect)brandSelect.value=current.brand;
        if(modelSelect&&modelSelect.dataset.brand!==current.brand){modelSelect.dataset.brand=current.brand;modelSelect.replaceChildren(...data.models.filter(m=>m.brand===current.brand).map(m=>{const o=document.createElement('option');o.value=m.id;o.textContent=m.name;return o;}));}
        if(modelSelect)modelSelect.value=model;
        if(!variants.some(v=>v.finish===finish))finish=variants[0]?.finish||'G';
        const group=root.querySelector('[data-phone-finishes]'),key=type()+model;
        if(group.dataset.key!==key){group.dataset.key=key;group.replaceChildren();variants.forEach(v=>{const button=document.createElement('button');button.type='button';button.dataset.phoneFinish=v.finish;button.textContent=copy[v.finish];group.append(button);});}
        group.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.phoneFinish===finish)));
        const selected=selectOptions(data,type(),model,country).find(o=>o.finish===finish);
        writePrice(root.querySelector('[data-phone-price]'),selected?.prices[country]??null,false,variants.length?copy.no_price:copy.unavailable);
        root.querySelector('[data-phone-selected]').textContent=copy[type()]+' · '+current.name+(variants.length?' · '+copy[finish]:'');
        const offered=types.filter(t=>modelVariants(data,t,model).length).map(t=>copy[t]);
        root.querySelector('[data-phone-model-hint]').textContent=copy.model_hint+' '+(offered.length?offered.join(' · '):copy.unavailable);
        root.querySelector('[data-phone-unavailable]').hidden=variants.length>0;
        const alternatives=root.querySelector('[data-phone-compatible]');
        alternatives.hidden=variants.length>0;
        if(alternatives.dataset.model!==model){alternatives.dataset.model=model;alternatives.replaceChildren();types.filter(t=>modelVariants(data,t,model).length).forEach(t=>{const b=document.createElement('button');b.type='button';b.dataset.phoneCompatible=t;b.textContent=copy[t];alternatives.append(b);});}
        root.querySelector('[data-phone-finishes]').closest('fieldset').hidden=!variants.length;
        root.querySelector('.aph-crop').hidden=!variants.length;
        const image=hero.querySelector('img');setArt(hero,image?.naturalWidth/image?.naturalHeight,true);
        const selection=selected?{country,model,type:type(),finish,...positions,priceCents:selected.prices[country],label:root.querySelector('[data-phone-selected]').textContent}:null;
        const encoded=JSON.stringify(selection);if(root.dataset.phoneSelection!==encoded){root.dataset.phoneSelection=encoded;window.dispatchEvent(new CustomEvent('alpha:phone-selection'));}
      }else if(panel)writePrice(root.querySelector('[data-phone-price]'),null);
      try{const name=new Intl.DisplayNames([document.documentElement.lang||'en'],{type:'region'}).of(country);const label=root.querySelector('[data-phone-country]');if(label)label.textContent=name;}catch(_){}
      decorate();
    }
    const chooseModel=id=>{if(!data?.models.some(m=>m.id===id))return;model=id;positions={x:50,y:50,zoom:100};root.querySelectorAll('[data-phone-position]').forEach(input=>input.value=positions[input.dataset.phonePosition]);rememberModel();schedule();};
    modelSelect?.addEventListener('change',()=>chooseModel(modelSelect.value),{signal:listeners.signal});
    brandSelect?.addEventListener('change',()=>{const selected=data?.models.find(m=>m.brand===brandSelect.value&&modelVariants(data,type(),m.id).length)||data?.models.find(m=>m.brand===brandSelect.value);if(selected)chooseModel(selected.id);},{signal:listeners.signal});
    document.addEventListener('click',event=>{if(!active()||!data)return;const link=event.target.closest('a[href]');if(!link||link.hasAttribute('download'))return;const url=new URL(link.href,location.href);if(/^https?:$/.test(url.protocol)&&/(^|\.)alphachristianart\.com$/.test(url.hostname)&&/\/(collections|products)\//.test(url.pathname)){url.searchParams.set('phone_model',model);link.href=url.href;}},{capture:true,signal:listeners.signal});
    root.addEventListener('input',event=>{const axis=event.target.dataset.phonePosition;if(!['x','y','zoom'].includes(axis))return;positions[axis]=Number(event.target.value);schedule();},{signal:listeners.signal});
    root.addEventListener('click',event=>{const compatible=event.target.closest('[data-phone-compatible] button');if(compatible){const control=selector.querySelector('[data-browse-presentation="'+compatible.dataset.phoneCompatible+'"]');control?.closest('label')?.click();}const selected=event.target.closest('[data-phone-finish]');if(selected){finish=selected.dataset.phoneFinish;schedule();}if(event.target.closest('[data-phone-reset]')){positions={x:50,y:50,zoom:100};root.querySelectorAll('[data-phone-position]').forEach(input=>input.value=positions[input.dataset.phonePosition]);schedule();}},{signal:listeners.signal});
    hero?.querySelector('img')?.addEventListener('load',schedule,{signal:listeners.signal});
    window.addEventListener('alpha:artwork-browse',schedule,{signal:listeners.signal});
    window.addEventListener('resize',schedule,{signal:listeners.signal});
    const changeCountry=value=>{if(/^[A-Z]{2}$/.test(value||'')){country=value;schedule();}};
    window.addEventListener('alpha-art-print:country-change',e=>changeCountry(e.detail?.country),{signal:listeners.signal});
    window.addEventListener('storage',e=>{if(e.key==='alpha-art-print-country')changeCountry(e.newValue);},{signal:listeners.signal});
    window.addEventListener('pageshow',()=>{const id=savedModel();if(data?.models.some(m=>m.id===id))model=id;try{changeCountry(localStorage.getItem('alpha-art-print-country'));}catch(_){}schedule();},{signal:listeners.signal});
    const grid=document.getElementById('ResultsList'),observer=new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-alpha-product-card],li')||n.querySelector('[data-alpha-product-card]')))))schedule();});
    if(grid)observer.observe(grid,{childList:true,subtree:true});
    const abort=new AbortController();
    fetch(settings.catalog,{signal:abort.signal}).then(r=>{if(!r.ok)throw Error('Unavailable');return r.json();}).then(value=>{if(stopped)return;if(value.version!==2||value.checkoutEnabled!==false||value.currency!=='EUR')throw Error('Invalid catalogue');data=value;state='ready';const id=savedModel();if(data.models.some(m=>m.id===id))model=id;if(brandSelect){brandSelect.replaceChildren(...[...new Set(data.models.map(m=>m.brand))].map(brand=>{const o=document.createElement('option');o.value=brand;o.textContent=brand;return o;}));brandSelect.disabled=false;}if(modelSelect)modelSelect.disabled=false;schedule();}).catch(()=>{if(stopped)return;state='error';schedule();});
    dispose=()=>{stopped=true;abort.abort();listeners.abort();observer.disconnect();cards.forEach((e,card)=>{e.stage.remove();e.price.remove();card.classList.remove('aph-card-ready');});};
    schedule();
  }
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',()=>{if(!document.querySelector('[data-phone-root]'))dispose();});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-poster-commerce"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const box=document.querySelector('[data-poster-commerce]'),root=box?.closest('[data-poster-preview]');
    if(!root||box.dataset.initialized)return;
    box.dataset.initialized='true';
    const source=JSON.parse(box.querySelector('[data-poster-source]').textContent),copy=JSON.parse(box.querySelector('[data-poster-commerce-copy]').textContent);
    const pay=box.querySelector('[data-poster-pay]'),add=box.querySelector('[data-poster-add]'),error=box.querySelector('[data-poster-commerce-error]');
    let native,dialog,home,form,submit,originalLabel,owned=false,paying=false,uncertain=false,options=[],loadedCountry='',fetched=0,loading='',sequence=0,openedSelection='';
    const active=()=>document.body.dataset.artworkBrowse==='print'&&document.body.dataset.artworkFinish==='poster';
    const selection=()=>{try{return active()?JSON.parse(root.dataset.posterSelection||'null'):null;}catch{return null;}};
    const signature=()=>{const s=selection();return s?JSON.stringify([s.country,s.sku,s.widthMm,s.heightMm,s.priceCents]):'';};
    const current=()=>{const s=selection();return s&&s.country===loadedCountry?options.find(o=>o.supplierSku===s.sku&&o.widthMm===s.widthMm&&o.heightMm===s.heightMm&&Math.round(o.totalPriceEur*100)===s.priceCents):null;};
    const fail=message=>{error.textContent=message||copy.error;error.hidden=false;};
    function endpoint(){
      const url=new URL(native.dataset.aapProxy,location.origin);
      if(url.origin!==location.origin||url.pathname!=='/apps/alpha-art-print')throw Error('UNAVAILABLE');
      return url;
    }
    function close(){if(owned&&dialog.open)dialog.close();}
    function render(){
      const available=Boolean(current())&&!uncertain;
      box.hidden=!active();pay.disabled=add.disabled=!available||paying;
      const total=root.querySelector('[data-poster-price]');
      const target=box.querySelector('[data-poster-pay-total]');
      if(total&&target.textContent!==total.textContent)target.textContent=total.textContent;
      for(const el of root.querySelectorAll('.bpp-preview-badge,.bpp-purchase-note'))el.hidden=true;
      root.dataset.posterCheckout=available?'ready':'unavailable';
      root.dataset.posterPaying=String(paying);
    }
    async function load(force=false){
      const s=selection();if(!native||!s)return;
      if(!force&&loadedCountry===s.country&&Date.now()-fetched<20*60*1000){render();return;}
      if(loading===s.country)return;
      const turn=++sequence;loading=s.country;options=[];loadedCountry='';render();
      try{
        const url=endpoint();url.searchParams.set('variant',native.dataset.aapVariant);url.searchParams.set('country',s.country);url.searchParams.set('catalog_profile','poster-v1');
        const response=await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(30000)});
        const data=await response.json();
        if(!response.ok||data.offerProfile!=='poster-v1'||data.countryCode!==s.country||!Array.isArray(data.options))throw Error('UNAVAILABLE');
        if(turn!==sequence||selection()?.country!==s.country)return;
        options=data.options.filter(o=>o.supportId==='budget-poster'&&o.offerProfile==='poster-v1'&&typeof o.quoteToken==='string'&&Number.isFinite(o.totalPriceEur));
        loadedCountry=s.country;fetched=Date.now();error.hidden=true;
      }catch{if(turn===sequence)fail();}
      finally{if(turn===sequence){loading='';render();}}
    }
    function syncAddress(){
      const s=selection(),countries=native.querySelector('[data-aap-country]');
      const country=[...countries.options].find(o=>o.value===s.country);
      if(!country)throw Error('UNAVAILABLE');
      form.querySelector('[data-aap-address-country]').textContent=country.textContent;
      const normalize=t=>String(t||'').trim().normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
      const metadata=native.querySelector('[data-aap-country-metadata]');
      const item=metadata&&[...metadata.options].find(o=>normalize(o.textContent)===normalize(country.textContent));
      const provinces=JSON.parse(item?.dataset.provinces||'[]');
      const field=form.querySelector('[data-aap-address-province-field]'),province=form.querySelector('[data-aap-address-province]');
      province.replaceChildren();field.hidden=!provinces.length;province.required=Boolean(provinces.length);
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});province.disabled=!provinces.length;
      if(provinces.length){province.append(new Option(copy.choose,''));for(const p of provinces)province.append(new Option(p[1],p[0]));}
      submit.disabled=false;submit.textContent=originalLabel;
      form.querySelector('[data-aap-address-error]').textContent='';
    }
    async function submitAddress(event){
      if(!owned)return;
      event.preventDefault();event.stopImmediatePropagation();
      if(paying||uncertain||!active()||openedSelection!==signature()||!current()||!form.reportValidity())return;
      const s=selection(),option=current();
      if(Date.now()-fetched>25*60*1000){close();options=[];render();await load(true);return;}
      const shippingAddress=Object.fromEntries(new FormData(form));shippingAddress.countryCode=s.country;
      paying=true;render();submit.disabled=true;submit.textContent=copy.loading;
      form.querySelectorAll('input,select').forEach(el=>{el.disabled=true;});
      try{
        const response=await fetch(endpoint(),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({quoteToken:option.quoteToken,shippingAddress}),signal:AbortSignal.timeout(30000)});
        const result=await response.json();
        if(!response.ok){if(response.status>=500)uncertain=true;throw Error('CHECKOUT');}
        const url=new URL(result.checkoutUrl);
        if(url.protocol!=='https:'||(!/(^|\.)alphachristianart\.com$/.test(url.hostname)&&url.hostname!==box.dataset.shop))throw Error('CHECKOUT');
        location.assign(url.href);
      }catch{uncertain=true;fail(copy.uncertain);form.querySelector('[data-aap-address-error]').textContent=copy.uncertain;}
      finally{paying=false;render();submit.textContent=originalLabel;submit.disabled=true;}
    }
    function attach(){
      native=document.querySelector('[data-aap-root]');dialog=native?.querySelector('[data-aap-address-dialog]');form=dialog?.querySelector('[data-aap-address-form]');submit=form?.querySelector('[data-aap-address-submit]');
      if(!native?.dataset.aapVariant||!form||!submit||!native.querySelector('[data-aap-country]')?.options.length)return false;
      home=document.createComment('poster-address-home');dialog.before(home);originalLabel=submit.textContent;
      for(const key of ['--aap-accent','--aap-ink','--aap-muted','--aap-font']){const value=getComputedStyle(native).getPropertyValue(key);if(value)box.style.setProperty(key,value);}
      form.addEventListener('submit',submitAddress,true);
      dialog.addEventListener('close',()=>{if(!owned)return;owned=false;home.after(dialog);form.querySelectorAll('input,select').forEach(el=>{el.disabled=false;});submit.disabled=false;submit.textContent=originalLabel;if(active())pay.focus();});
      load();return true;
    }
    pay.addEventListener('click',async()=>{
      const before=signature();if(!before||paying||uncertain)return;
      paying=true;render();await load(true);paying=false;render();
      if(before!==signature()||!current())return;
      try{syncAddress();owned=true;openedSelection=signature();box.append(dialog);dialog.showModal();form.querySelector('input[name="firstName"]')?.focus();}catch{owned=false;home.after(dialog);fail();}
    });
    add.addEventListener('click',async()=>{
      const before=signature(),s=selection(),o=current(),wallet=document.querySelector('artwork-credit-cart');if(!s||!o||paying||!wallet?.addPosterConfiguration)return;
      paying=true;render();
      try{await wallet.addPosterConfiguration(source,{variantId:'gid://shopify/ProductVariant/'+native.dataset.aapVariant,country:s.country,optionId:o.id,priceCents:s.priceCents,label:root.querySelector('#PosterPreviewTitle').textContent+' · '+s.label},()=>before===signature());}catch{fail();}finally{paying=false;render();}
    });
    window.addEventListener('alpha:poster-selection',()=>{if(owned&&signature()!==openedSelection&&!paying)close();render();load();});
    window.addEventListener('alpha:artwork-browse',()=>{if(!active()&&!paying)close();render();});
    const price=root.querySelector('[data-poster-price]');
    if(price)new MutationObserver(render).observe(price,{childList:true,subtree:true,characterData:true});
    let tries=0;const timer=setInterval(()=>{if(attach()||++tries>60)clearInterval(timer);},500);
    render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-poster-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const artworkRatio = image => {
    if(!image)return NaN;
    const declared=Number(image.closest('[data-artwork-ratio]')?.dataset.artworkRatio);
    if(Number.isFinite(declared)&&declared>0)return declared;
    const width=Number(image.getAttribute('width')),height=Number(image.getAttribute('height'));
    if(width>0&&height>0)return width/height;
    return image.naturalWidth>0&&image.naturalHeight>0?image.naturalWidth/image.naturalHeight:NaN;
  };
  const printLayout = (format, ratio) => {
    if (!format || ![format.w,format.h,ratio].every(v=>Number.isFinite(v)&&v>0) || format.w<=10 || format.h<=10) return null;
    const border=0;
    const width=Math.max(format.w,format.h*ratio),height=width/ratio;
    return {width,height,left:(format.w-width)/2,top:(format.h-height)/2,border,visibleFraction:format.w*format.h/(width*height)};
  };
  const geometryFit = (format, ratio, width, height) => {
    const image=printLayout(format,ratio);
    if(!image||![width,height].every(v=>Number.isFinite(v)&&v>0))return null;
    const scale=Math.min(width*.88/format.w,height*.88/format.h);
    return {image,scale,w:format.w*scale,h:format.h*scale};
  };
  const eligible = (format, ratio) => {
    if(!printLayout(format,ratio))return false;
    const orientation=r=>Math.abs(r-1)<.02?0:Math.sign(r-1);
    const border=0;
    const imageRatio=(format.w-2*border)/(format.h-2*border);
    return orientation(format.w/format.h)===orientation(ratio)&&Math.min(ratio/imageRatio,imageRatio/ratio)>=.85;
  };
  const roomGeometry = (format,ratio,width,height) => {
    const image=printLayout(format,ratio);
    if(!image||![width,height].every(v=>Number.isFinite(v)&&v>0))return null;
    const reference=height*.64,scale=reference/1700;
    return {image,scale,reference,w:format.w*scale,h:format.h*scale,x:width*.5,y:height*.45};
  };
  function applyArtGeometry(art,f,shade='silk'){
    if(!f)return;
    const styles={'--ap-w':f.w+'px','--ap-h':f.h+'px','--ap-image-w':f.image.width*f.scale+'px','--ap-image-h':f.image.height*f.scale+'px','--ap-image-top':f.image.top*f.scale+'px','--ap-image-left':f.image.left*f.scale+'px'};
    for(const [k,v]of Object.entries(styles))if(art.style.getPropertyValue(k)!==v)art.style.setProperty(k,v);
    art.dataset.surface=shade;
  }
  if(typeof document==='undefined'){if(typeof module!=='undefined')module.exports={printLayout,geometryFit,eligible,artworkRatio,roomGeometry};return;}
  function initThumbnails(){
    document.querySelectorAll('.bpp-choice .bpp-art').forEach(art=>{
      if(art.dataset.thumbnailReady)return;art.dataset.thumbnailReady='true';
      const img=art.querySelector('img'),stage=art.parentElement;
      const draw=()=>{const ratio=artworkRatio(img);if(ratio>0)applyArtGeometry(art,geometryFit({w:300*ratio,h:300},ratio,stage.clientWidth,stage.clientHeight),'silk');};
      new ResizeObserver(draw).observe(stage);img?.addEventListener('load',draw);draw();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initThumbnails,{once:true});else initThumbnails();
  document.addEventListener('shopify:section:load',initThumbnails);
  async function init(){
    const root=document.querySelector('[data-poster-preview]');
    if(!root||root.dataset.initialized)return;
    if(document.body.dataset.artworkFinish!=='poster')return;
    root.dataset.initialized='true';
    const copy=JSON.parse(root.querySelector('[data-poster-copy]').textContent);
    let data;
    try {
      const response=await fetch(JSON.parse(document.querySelector('[data-poster-catalog-url]').textContent));
      if(!response.ok)throw Error('CATALOG');
      data=await response.json();
      if(!data.version||data.checkoutEnabled!==false||!Array.isArray(data.products))throw Error('CATALOG');
    } catch (_) {
      delete root.dataset.initialized;
      if(document.body.dataset.artworkFinish==='poster'){
        root.hidden=root.dataset.page!=='product';document.body.classList.add('bpp-active');
        const status=root.querySelector('[data-poster-status]');if(status)status.textContent=copy.unavailable;
      }
      return;
    }
    const product=root.dataset.page==='product';
    let country;try{country=localStorage.getItem('alpha-art-print-country');}catch(_){}
    country=country||root.dataset.defaultCountry;
    let surface='silk',unit='cm',selected=null,active=false;
    const entries=new Map();
    const number=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:2}).format(value);
    const measure=value=>number(value/(unit==='cm'?10:25.4))+(unit==='cm'?' cm':'″');
    const dimensions=(w,h)=>number(w/(unit==='cm'?10:25.4))+' × '+measure(h);
    const money=value=>{const span=document.createElement('span');span.className='money';span.textContent=(value/100).toFixed(2)+' €';return span;};
    const text=(selector,value)=>{const e=root.querySelector(selector);if(e)e.textContent=value;};
    const regionName=code=>{try{return new Intl.DisplayNames([document.documentElement.lang||'en'],{type:'region'}).of(code);}catch(_){return data.names[code]||code;}};
    function options(ratio,shade=surface){
      const formats=new Map();
      for(const i of data.countries[country]||[]){const q=data.quotes[i],p=data.products[q[0]],key=p.w+':'+p.h;if(p.surface!==shade||!eligible(p,ratio))continue;const old=formats.get(key);if(!old||q[1]<old[1])formats.set(key,q);}
      return [...formats.values()];
    }
    function best(ratio){return options(ratio).sort((a,b)=>Math.abs(Math.log(Math.max(data.products[a[0]].w,data.products[a[0]].h)/500))-Math.abs(Math.log(Math.max(data.products[b[0]].w,data.products[b[0]].h)/500))||Math.abs(data.products[a[0]].w/data.products[a[0]].h-ratio)-Math.abs(data.products[b[0]].w/data.products[b[0]].h-ratio))[0];}
    function setArt(art,format,ratio,shade=surface){
      const stage=art.parentElement;
      applyArtGeometry(art,geometryFit(format,ratio,stage.clientWidth,stage.clientHeight),shade);
    }
    const resize=new ResizeObserver(()=>renderArt());
    const hero=root.querySelector('[data-poster-art]');
    const heroImage=hero?.querySelector('img');
    if(hero){resize.observe(hero.parentElement);heroImage.addEventListener('load',render);}
    const roomHost=root.querySelector('[data-poster-room-host]');
    let room=null;
    function ensureRoom(){
      if(room||!roomHost||!hero)return;
      const source=document.querySelector('[data-aap-room]')?.closest('.aap-preview');
      if(!source)return;
      const section=source.cloneNode(true),stage=section.querySelector('[data-aap-room]');
      const oldArt=section.querySelector('[data-aap-preview]'),reference=section.querySelector('[data-aap-reference]'),label=section.querySelector('[data-aap-preview-dimension]'),zoom=section.querySelector('[data-aap-zoom]');
      if(!stage||!oldArt||!reference||!label||!zoom)return;
      section.querySelectorAll('*').forEach(el=>{el.removeAttribute('id');for(const attr of [...el.attributes])if(attr.name.startsWith('data-aap-'))el.removeAttribute(attr.name);});
      section.classList.add('bpp-room');
      section.setAttribute('aria-labelledby','PosterRoomTitle');
      section.querySelector('h3').id='PosterRoomTitle';
      const titleStyle=getComputedStyle(source.querySelector('h3'));
      section.querySelector('h3').style.fontFamily=titleStyle.fontFamily;
      section.querySelector('h3').style.fontWeight=titleStyle.fontWeight;
      const art=hero.cloneNode(true);art.removeAttribute('data-poster-art');art.classList.add('bpp-room-art');art.dataset.posterRoomArt='';
      const painting=art.querySelector('img');painting.removeAttribute('srcset');painting.removeAttribute('sizes');painting.loading='lazy';painting.fetchPriority='low';painting.alt=heroImage.alt;
      oldArt.replaceWith(art);
      section.querySelectorAll('img').forEach(img=>{img.loading='lazy';img.decoding='async';});
      const dialog=document.createElement('dialog');dialog.className='bpp-room-dialog';dialog.setAttribute('aria-labelledby','PosterRoomTitle');
      const zoomMarkup=zoom.innerHTML,zoomLabel=zoom.getAttribute('aria-label');
      zoom.setAttribute('aria-haspopup','dialog');zoom.setAttribute('aria-expanded','false');
      zoom.addEventListener('click',()=>{
        if(dialog.open){dialog.close();return;}
        dialog.append(section);dialog.showModal();zoom.textContent=copy.close;zoom.setAttribute('aria-label',copy.close);zoom.setAttribute('aria-expanded','true');requestAnimationFrame(renderRoom);
      });
      dialog.addEventListener('close',()=>{roomHost.insertBefore(section,dialog);zoom.innerHTML=zoomMarkup;if(zoomLabel)zoom.setAttribute('aria-label',zoomLabel);zoom.setAttribute('aria-expanded','false');requestAnimationFrame(()=>{renderRoom();if(active)zoom.focus({preventScroll:true});});});
      dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
      room={section,stage,art,reference,label,dialog,painting};
      roomHost.append(section,dialog);resize.observe(stage);
    }
    function renderRoom(){
      if(!room||!selected||!active)return;
      const f=roomGeometry(data.products[selected[0]],artworkRatio(heroImage),room.stage.clientWidth,room.stage.clientHeight);
      if(!f)return;
      applyArtGeometry(room.art,f,surface);
      room.art.style.left=f.x+'px';room.art.style.top=f.y+'px';
      room.reference.style.height=f.reference+'px';
      room.label.style.left=f.x+'px';room.label.style.top=(f.y+f.h/2+10)+'px';
      const format=data.products[selected[0]];
      room.label.textContent=dimensions(format.w,format.h);
      room.label.hidden=false;
      if(heroImage.complete&&heroImage.currentSrc&&room.painting.src!==heroImage.currentSrc)room.painting.src=heroImage.currentSrc;
    }
    function renderArt(){
      if(!active)return;
      if(hero&&selected){
        const f=data.products[selected[0]],ratio=artworkRatio(heroImage);
        setArt(hero,f,ratio);
        root.querySelectorAll('[data-poster-swatch-art]').forEach(art=>setArt(art,f,ratio,art.dataset.posterSwatchArt));
      }
      renderRoom();
      for(const [card,entry]of entries){
        if(!card.isConnected){resize.unobserve(entry.stage);entry.source.removeEventListener('load',entry.load);entries.delete(card);continue;}
        const ratio=artworkRatio(entry.source);
        const quote=Number.isFinite(ratio)&&best(ratio);
        entry.stage.hidden=!quote;
        card.classList.toggle('bpp-card-ready',Boolean(quote));
        if(quote)setArt(entry.art,data.products[quote[0]],ratio);
        const minimum=quote?Math.min(...options(ratio).map(q=>q[1])):null;
        if(entry.minimum!==minimum){entry.minimum=minimum;entry.price.replaceChildren();if(minimum!==null)entry.price.append(document.createTextNode(copy.from+' '),money(minimum),document.createElement('br'),document.createTextNode(copy.shipping_included));else entry.price.textContent=copy.no_size;}
      }
    }
    function render(){
      active=document.body.dataset.artworkBrowse==='print'&&document.body.dataset.artworkFinish==='poster';
      root.hidden=!active||!product;
      document.body.classList.toggle('bpp-active',active);
      if(heroImage)heroImage.fetchPriority=active?'high':'auto';
      if(!active){delete root.dataset.posterSelection;window.dispatchEvent(new Event('alpha:poster-selection'));if(room?.dialog.open)room.dialog.close();root.classList.remove('bpp-zoomed');const zoom=root.querySelector('[data-poster-zoom]');if(zoom)zoom.textContent=copy.zoom;return;}
      if(heroImage)heroImage.loading='eager';
      if(root.dataset.wall&&!root.dataset.wall.includes('Liquid error'))document.body.style.setProperty('--ap-photo-wall','url("'+root.dataset.wall+'")');
      if(!product){requestAnimationFrame(decorate);return;}
      ensureRoom();
      text('[data-poster-country]',regionName(country));
      const validCountry=Boolean(data.countries[country]?.length);
      const ratio=artworkRatio(heroImage);
      let choices=product&&Number.isFinite(ratio)?options(ratio):[];
      choices.sort((a,b)=>data.products[a[0]].w*data.products[a[0]].h-data.products[b[0]].w*data.products[b[0]].h);
      if(product){
        const old=selected&&data.products[selected[0]];
        selected=choices.find(q=>data.products[q[0]].w===old?.w&&data.products[q[0]].h===old?.h)||best(ratio)||null;
        const sizes=root.querySelector('[data-poster-sizes]');sizes.replaceChildren();
        for(const q of choices){const f=data.products[q[0]],button=document.createElement('button'),label=document.createElement('strong');button.type='button';button.dataset.posterSize=String(q[0]);button.setAttribute('aria-pressed',String(q===selected));label.textContent=dimensions(f.w,f.h);button.append(label,money(q[1]));sizes.append(button);}
      }
      root.querySelector('[data-poster-price-card]').hidden=!product||!selected;
      root.querySelector('[data-poster-details]').hidden=!product||!selected;
      if(hero)hero.parentElement.hidden=!selected;
      if(roomHost)roomHost.hidden=!selected;
      if(selected&&product){
        const f=data.products[selected[0]];
        hero.parentElement.dataset.orientation=f.w/f.h>1.05?'landscape':f.w/f.h<.95?'portrait':'square';
        text('[data-poster-selected-size]',dimensions(f.w,f.h));text('[data-poster-print-size]',dimensions(f.w,f.h));text('[data-poster-image-size]',dimensions(f.w,f.h));text('[data-poster-origin]',regionName(selected[3]));
        text('[data-poster-transit]',selected[4]===null||selected[5]===null?copy.transit_unknown:(selected[4]===selected[5]?selected[4]:selected[4]+'–'+selected[5])+' '+copy.days);
        root.querySelector('[data-poster-price]').replaceChildren(money(selected[1]));
        root.querySelector('[data-poster-shipping]').replaceChildren(document.createTextNode(copy.included+' ('),money(selected[2]),document.createTextNode(')'));
      }else text('[data-poster-origin]','—');
      root.querySelectorAll('[data-poster-surface]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.posterSurface===surface));b.disabled=!options(ratio,b.dataset.posterSurface).length;});
      root.querySelectorAll('[data-poster-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.posterUnit===unit)));
      text('[data-poster-status]',!validCountry?copy.unavailable:product&&!selected?copy.no_size:copy.ready);
      root.dataset.posterState=validCountry&&(!product||selected)?'ready':'unavailable';
      root.dataset.posterSelection=selected?JSON.stringify({sku:data.products[selected[0]].sku,widthMm:data.products[selected[0]].w,heightMm:data.products[selected[0]].h,surface,country,priceCents:selected[1],label:dimensions(data.products[selected[0]].w,data.products[selected[0]].h),fit:'cover',cropPosition:'center'}):'';
      window.dispatchEvent(new Event('alpha:poster-selection'));
      requestAnimationFrame(decorate);
    }
    function decorate(){
      if(!active)return;
      document.querySelectorAll('[data-alpha-product-card]').forEach(card=>{
        if(entries.has(card))return;
        const source=card.querySelector('.alpha-product-card__artwork-frame img'),media=card.querySelector('.alpha-product-card__media');
        if(!source||!media)return;
        const stage=document.createElement('div');stage.className='bpp-stage bpp-card-stage';
        const art=document.createElement('div');art.className='bpp-art';
        art.innerHTML='<div class="bpp-paper"><div class="bpp-image-area"></div></div>';
        const img=source.cloneNode();img.removeAttribute('id');img.className='bpp-image';img.alt='';img.decoding='async';img.fetchPriority='auto';
        const syncImage=()=>{if(source.complete&&source.naturalWidth&&source.currentSrc){img.removeAttribute('srcset');img.removeAttribute('sizes');if(img.src!==source.currentSrc)img.src=source.currentSrc;}};
        syncImage();art.querySelector('.bpp-image-area').append(img);stage.append(art);media.append(stage);
        const price=document.createElement('p');price.className='bpp-card-price';card.append(price);
        const load=()=>{syncImage();renderArt();};source.addEventListener('load',load);entries.set(card,{source,stage,art,load,price,minimum:undefined});resize.observe(stage);
      });renderArt();
    }
    root.addEventListener('click',e=>{
      if(root.dataset.posterPaying==='true')return;
      const size=e.target.closest('[data-poster-size]'),shade=e.target.closest('[data-poster-surface]'),units=e.target.closest('[data-poster-unit]');
      if(size){selected=options(artworkRatio(heroImage)).find(q=>q[0]===Number(size.dataset.posterSize));render();root.querySelector('[data-poster-size="'+size.dataset.posterSize+'"]')?.focus({preventScroll:true});}
      if(shade){surface=shade.dataset.posterSurface;render();}
      if(units){unit=units.dataset.posterUnit;render();}
      if(e.target.closest('[data-poster-zoom]')){root.classList.toggle('bpp-zoomed');e.target.textContent=root.classList.contains('bpp-zoomed')?copy.close:copy.zoom;requestAnimationFrame(renderArt);}
    });
    document.addEventListener('keydown',e=>{if(e.key==='Escape'){root.classList.remove('bpp-zoomed');if(root.querySelector('[data-poster-zoom]'))root.querySelector('[data-poster-zoom]').textContent=copy.zoom;}});
    window.addEventListener('alpha:artwork-browse',render);
    window.addEventListener('alpha-art-print:country-change',e=>{if(/^[A-Z]{2}$/.test(e.detail?.country)){country=e.detail.country;render();}});
    window.addEventListener('storage',e=>{if(e.key==='alpha-art-print-country'&&e.newValue){country=e.newValue;render();}});
    const grid=document.querySelector('#ResultsList');if(grid)new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-alpha-product-card], li')||n.querySelector('[data-alpha-product-card]')))))decorate();}).observe(grid,{childList:true,subtree:true});
    decorate();render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  window.addEventListener('alpha:artwork-browse',()=>{
    if(document.body.dataset.artworkFinish==='poster')return;
    document.body.classList.remove('bpp-active');
    const root=document.querySelector('[data-poster-preview]');if(root)root.hidden=true;
  });
  window.addEventListener('alpha:artwork-browse',init);
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-product-dialogs"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const template = document.getElementById('AlphaProductDialogTemplate');
    if (!template) return;
    let banner = document.querySelector('.apbanner');
    const setups = [
      {selector:'[data-alpha-browse-type]', title:'.abt__title', parts:['.abt__intro','.abt__controls','.abt__footer'], key:'support'},
      {selector:'[data-alpha-quality-tabs]', title:'.aqt__eyebrow', parts:['.aqt__shell'], key:'finishes'}
    ];
    setups.forEach(setup => {
      const root = document.querySelector(setup.selector);
      if (!root || root.dataset.productDialogReady) return;
      const title = root.querySelector(setup.title);
      const parts = setup.parts.map(s => root.querySelector(s)).filter(Boolean);
      if (!title || !parts.length) return;
      if (!banner) {
        banner = document.getElementById('AlphaProductBannerTemplate').content.firstElementChild.cloneNode(true);
        root.before(banner);
      }
      const dialog = template.content.firstElementChild.cloneNode(true);
      dialog.id = 'AlphaProductDialog-' + setup.key;
      const label = title.textContent.trim();
      dialog.setAttribute('aria-label', label);
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'apdialog__trigger';
      trigger.textContent = label;
      trigger.setAttribute('aria-haspopup','dialog');
      trigger.setAttribute('aria-controls',dialog.id);
      trigger.setAttribute('aria-expanded','false');
      parts.forEach(node => dialog.querySelector('.apdialog__content').append(node));
      banner.querySelector('.apbanner__actions').append(trigger);
      root.append(dialog);
      root.dataset.productDialogReady = 'true';
      const close = () => dialog.close();
      trigger.addEventListener('click', () => {
        if (setup.key === 'support') root.dataset.productsOpen = 'true';
        dialog.showModal();
        trigger.setAttribute('aria-expanded','true');
        window.dispatchEvent(new Event('resize'));
      });
      dialog.querySelector('[data-apdialog-close]').addEventListener('click',close);
      dialog.addEventListener('close', () => {
        trigger.setAttribute('aria-expanded','false');
        trigger.focus({preventScroll:true});
      });
      dialog.addEventListener('click',event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-product-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const root = document.querySelector('[data-alpha-browse-type]');
    const dialog = document.querySelector('[data-product-popup]');
    if (!root || !dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    root.append(dialog);
    const content = dialog.querySelector('[data-product-popup-content]');
    for (const selector of ['.abt__intro','.abt__controls','.abt__footer']) {
      const node = root.querySelector(selector); if (node) content.append(node);
    }
    root.dataset.productPopup = 'true';
    root.dataset.productsOpen = 'true';
    let opener;
    document.querySelectorAll('[data-product-popup-open]').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => {
        opener = button;
        if (!dialog.open) dialog.showModal();
        dialog.scrollTop = 0;
        dialog.querySelector('[data-product-popup-close]').focus();
      });
    });
    dialog.querySelectorAll('[data-product-popup-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus({preventScroll:true}); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-sidebar-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const sync = () => {
    const type = document.body.dataset.artworkBrowse;
    document.querySelectorAll('[data-sidebar-type]').forEach(button => {
      const radio = document.querySelector('[data-browse-type="' + button.dataset.sidebarType + '"]');
      button.disabled = !radio || radio.disabled || !!radio.closest('fieldset[disabled]');
      const selected = button.dataset.sidebarType === type;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    document.querySelectorAll('.acside__more').forEach(details => {
      const selected = details.querySelector('[data-sidebar-type][aria-pressed="true"]');
      details.querySelector('[data-sidebar-selected]').textContent = selected ? '· ' + selected.textContent.trim() : '';
    });
    const group = document.querySelector('[data-browse-for="' + type + '"]');
    document.querySelectorAll('[data-sidebar-presentations]').forEach(panel => {
      const options = [...(group?.querySelectorAll('input[data-browse-presentation]') || [])];
      panel.hidden = options.length < 2;
      const list = panel.querySelector('[data-sidebar-finishes]');
      options.forEach((radio, index) => {
        let button = list.children[index];
        if (!button) { button = document.createElement('button'); button.type = 'button'; button.className = 'acfilt__option'; list.append(button); }
        button.dataset.sidebarFinish = radio.value;
        button.dataset.sidebarMount = radio.dataset.browseMount || '';
        button.textContent = radio.closest('label')?.querySelector('.abt__finish-copy > strong')?.textContent.trim() || radio.value;
        button.disabled = radio.disabled || !!radio.closest('fieldset[disabled]');
        button.classList.toggle('is-selected', radio.checked);
        button.setAttribute('aria-pressed', String(radio.checked));
      });
      while (list.children.length > options.length) list.lastElementChild.remove();
    });
    document.querySelectorAll('.acside__tree a[aria-current="page"]').forEach(link => {
      for (let parent = link.parentElement; parent && !parent.classList.contains('acside'); parent = parent.parentElement) {
        if (parent.tagName === 'DETAILS') parent.open = true;
      }
    });
  };
  document.addEventListener('click', event => {
    const finish = event.target.closest('[data-sidebar-finish]');
    if (finish && !finish.disabled) {
      const group = document.querySelector('[data-browse-for="' + document.body.dataset.artworkBrowse + '"]');
      [...(group?.querySelectorAll('input[data-browse-presentation]') || [])].find(radio => radio.value === finish.dataset.sidebarFinish && (radio.dataset.browseMount || '') === finish.dataset.sidebarMount)?.click();
      sync(); return;
    }
    const button = event.target.closest('[data-sidebar-type]');
    if (!button || button.disabled) return;
    document.querySelector('[data-browse-type="' + button.dataset.sidebarType + '"]')?.click();
    sync();
  });
  window.addEventListener('alpha:artwork-browse', () => requestAnimationFrame(sync));
  window.addEventListener('pageshow', sync);
  document.addEventListener('shopify:section:load', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once:true}); else sync();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-simplified-details"] && !Shopify.designMode) return;
  try {
    (() => {
  const installed = new WeakSet();
  const shippingObservers = new Map();
  const wrapShippingAmount = shipping => {
    if (shipping.querySelector('span.money')) return;
    const walker = document.createTreeWalker(shipping, NodeFilter.SHOW_TEXT);
    const matches = [];
    let node;
    while ((node = walker.nextNode())) {
      const amounts = Array.from(node.textContent.matchAll(/\d[\d\s\u00a0\u202f]*[,.]\d{2}\s*€/g));
      amounts.forEach(match => matches.push({ node, match }));
    }
    if (matches.length !== 1) return;
    const { node: textNode, match } = matches[0];
    const value = textNode.textContent;
    const amount = document.createElement('span');
    amount.className = 'money';
    amount.textContent = match[0];
    textNode.replaceWith(document.createTextNode(value.slice(0, match.index)), amount, document.createTextNode(value.slice(match.index + match[0].length)));
  };
  const initialiseSummaryCurrency = () => {
    shippingObservers.forEach((observer, shipping) => {
      if (!shipping.isConnected) {
        observer.disconnect();
        shippingObservers.delete(shipping);
      }
    });
    document.querySelectorAll('[data-aap-root]').forEach(root => {
      root.querySelectorAll('[data-aap-artwork-price]').forEach(total => total.classList.add('money'));
      root.querySelectorAll('[data-aap-included-shipping]').forEach(shipping => {
        wrapShippingAmount(shipping);
        if (shippingObservers.has(shipping)) return;
        const observer = new MutationObserver(() => wrapShippingAmount(shipping));
        observer.observe(shipping, { childList: true, subtree: true, characterData: true });
        shippingObservers.set(shipping, observer);
      });
    });
  };
  const initialise = () => {
    const copy = document.querySelector('[data-alpha-simplified-details]');
    if (!copy) return;
    initialiseSummaryCurrency();
    document.querySelectorAll('[data-alpha-quality-tabs]').forEach(root => {
      ['fine-box', 'canvas-rolled'].forEach(key => {
        root.querySelectorAll('[data-aqt-option-tab="' + key + '"], [data-aqt-option-panel="' + key + '"], [data-aqt-detail="' + key + '"]').forEach(node => node.remove());
      });
      [['fine-art', 'print'], ['canvas', 'canvas']].forEach(([key, name]) => {
        const title = copy.dataset[name + 'Title'];
        const description = copy.dataset[name + 'Description'];
        const tab = root.querySelector('[data-aqt-tab="' + key + '"]');
        if (tab?.querySelector('strong') && title) tab.querySelector('strong').textContent = title;
        if (tab?.querySelector('small') && description) tab.querySelector('small').textContent = description;
        const panel = root.querySelector('[data-aqt-panel="' + key + '"]');
        panel?.querySelectorAll('[data-aqt-option-tabs]').forEach(group => {
          if (title) group.setAttribute('aria-label', title);
          const options = Array.from(group.querySelectorAll('[data-aqt-option-tab]'));
          const active = options.find(option => option.getAttribute('aria-selected') === 'true') || options[0];
          if (!active) return;
          const activeKey = active.dataset.aqtOptionTab;
          options.forEach(option => {
            const selected = option === active;
            option.setAttribute('aria-selected', String(selected));
            option.tabIndex = selected ? 0 : -1;
          });
          panel.querySelectorAll('[data-aqt-option-panel]').forEach(visual => { visual.hidden = visual.dataset.aqtOptionPanel !== activeKey; });
          panel.querySelectorAll('[data-aqt-detail]').forEach(detail => { detail.hidden = detail.dataset.aqtDetail !== activeKey; });
        });
      });
      if (installed.has(root)) return;
      installed.add(root);
      root.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-aqt-option-tab]');
        const group = tab?.closest('[data-aqt-option-tabs]');
        if (!group || !root.contains(group)) return;
        const options = Array.from(group.querySelectorAll('[data-aqt-option-tab]')).filter(option => !option.hidden && !option.disabled);
        const current = options.indexOf(tab);
        if (current < 0 || !options.length) return;
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % options.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + options.length) % options.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = options.length - 1;
        else return;
        event.preventDefault();
        event.stopImmediatePropagation();
        options[next].click();
        options[next].focus();
      }, true);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('shopify:section:unload', event => {
    const marker = document.querySelector('[data-alpha-simplified-details]');
    shippingObservers.forEach((observer, shipping) => {
      if (!shipping.isConnected || event.target.contains(shipping) || marker && event.target.contains(marker)) {
        observer.disconnect();
        shippingObservers.delete(shipping);
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-starting-prices"] && !Shopify.designMode) return;
  try {
    (() => {
  const supportKeys=['unframed','classic','stretched','floating','canvas_rolled'];
  const supportIds=['fine-art-german-etching','classic-framed-print','stretched-canvas','framed-canvas','rolled-canvas'];
  const typeFinishes={canvas:['canvas_rolled','stretched','floating'],print:['poster','budgetframe','unframed','classic','hanger','dibond','acrylic'],oil:['rolled'],digital:['files']};
  const priceFinish=(type,finish)=>type==='canvas'&&finish==='rolled'?'canvas_rolled':finish;
  const minimum=values=>{const valid=values.filter(v=>Number.isFinite(v)&&v>0);return valid.length?Math.min(...valid):null;};
  const orientation=r=>Math.abs(r-1)<.02?0:Math.sign(r-1);
  function formatMinimum(data,finish,country,ratio){
    const catalog=data?.[finish],index=catalog?.countries?.[country];
    if(index===undefined)return null;
    return minimum(catalog.pool[index].filter(([w,h])=>{
      if(ratio===null)return true;
      if(!Number.isFinite(ratio)||ratio<=0)return false;
      const target=finish==='hanger'?(w-10)/(h-30):w/h;
      return w>10&&h>(finish==='hanger'?30:10)&&orientation(w/h)===orientation(ratio)&&Math.min(ratio/target,target/ratio)>=(finish==='hanger'?.65:.85);
    }).map(row=>row[2]));
  }
  function oilMinimum(data,country,ratio){
    if(data?.countries?.[country]===undefined)return null;
    if(ratio!==null&&(!Number.isFinite(ratio)||ratio<=0))return null;
    return minimum(data.oil.sizes.filter(([long])=>ratio===null||Math.round(long*Math.min(ratio,1/ratio))>=data.oil.minimumShortSideCm).map(row=>row[1]));
  }
  function publicMinimums(payload){
    if(payload.currency&&payload.currency!=='EUR')throw Error('Unexpected price currency');
    if(!Array.isArray(payload.options))throw Error('Missing options');
    const values={};
    supportKeys.forEach((key,index)=>{values[key]=minimum(payload.options.filter(o=>o.supportId===supportIds[index]).map(o=>Number(o.totalPriceEur)*100).map(Math.round));});
    values.rolled=minimum(payload.options.filter(o=>o.supportId==='hand-painted-oil').map(o=>Number(o.totalPriceEur)*100).map(Math.round));
    return values;
  }
  function sourceKey(source){
    const gcd=(a,b)=>b?gcd(b,a%b):a;
    const w=Number(source?.width),h=Number(source?.height);
    if(!Number.isInteger(w)||!Number.isInteger(h)||w<=0||h<=0||!/^\d+$/.test(String(source?.variant)))return null;
    const divisor=gcd(w,h);return (w/divisor)+':'+(h/divisor);
  }
  if(typeof document==='undefined'){if(typeof module!=='undefined')module.exports={minimum,formatMinimum,oilMinimum,publicMinimums,sourceKey,priceFinish};return;}
  let dispose=()=>{},catalogPromise;
  const requests=new Map(),cache=new Map(),queue=[];
  let running=0;
  const ttl=10*60*1000,cachePrefix='alpha-starting-price-v2:';
  function readCached(key){
    let value=cache.get(key);
    if(!value)try{value=JSON.parse(sessionStorage.getItem(cachePrefix+key));}catch(_){/* Storage optional. */}
    if(!value||Date.now()-value.time>ttl)return null;
    if(!value.values||Object.values(value.values).some(v=>v!==null&&(!Number.isInteger(v)||v<=0)))return null;
    cache.set(key,value);return value.values;
  }
  function pump(){
    while(running<2&&queue.length){
      const job=queue.shift();running++;
      job().finally(()=>{running--;pump();});
    }
  }
  function livePrices(source,country){
    const ratioKey=sourceKey(source);if(!ratioKey)return Promise.reject(Error('Missing source'));
    const key=country+':'+ratioKey,cached=readCached(key);
    if(cached)return Promise.resolve(cached);
    if(requests.has(key))return requests.get(key);
    const promise=new Promise((resolve,reject)=>{
      queue.push(async()=>{
        const abort=new AbortController(),timer=setTimeout(()=>abort.abort(),20000);
        try{
          const url=new URL('/apps/alpha-art-print',location.origin);
          url.searchParams.set('variant',String(source.variant));url.searchParams.set('country',country);
          const response=await fetch(url,{signal:abort.signal,credentials:'same-origin'});
          if(!response.ok)throw Error('Prices unavailable');
          const payload=await response.json();
          if(payload.countryCode!==country||sourceKey({variant:source.variant,width:payload.source?.widthPx,height:payload.source?.heightPx})!==ratioKey)throw Error('Source or destination mismatch');
          // Strip the full response immediately: cache only numeric display minima.
          const values=publicMinimums(payload),saved={time:Date.now(),values};
          cache.set(key,saved);try{sessionStorage.setItem(cachePrefix+key,JSON.stringify(saved));}catch(_){/* Storage optional. */}
          resolve(values);
        }catch(error){reject(error);}finally{clearTimeout(timer);}
      });pump();
    });
    requests.set(key,promise);
    // Keep failures briefly to avoid repeat calls for every card sharing a ratio.
    promise.catch(()=>{setTimeout(()=>requests.delete(key),30000);});
    promise.then(()=>requests.delete(key),()=>{});
    return promise;
  }
  function init(){
    dispose();
    const root=document.querySelector('[data-starting-prices]'),selector=document.querySelector('[data-alpha-browse-type]');
    if(!root||!selector)return;
    const settings=JSON.parse(root.querySelector('[data-starting-price-settings]').textContent);
    settings.posterShipping=root.dataset.posterShipping;
    const listeners=new AbortController(),cards=new Map();
    let stopped=false,country=root.dataset.defaultCountry,data=null,catalogState='loading',scheduled=false,headerValues=null,headerState='loading',headerCountry='';
    try{country=localStorage.getItem('alpha-art-print-country')||country;}catch(_){/* Use the market country. */}
    country=String(country).toUpperCase();
    const parseSource=host=>{try{return JSON.parse(host.querySelector('[data-starting-price-source]')?.textContent||'null');}catch(_){return null;}};
    const productSource=parseSource(root),isProduct=root.dataset.page==='product';
    const writePrice=(node,value,finish,state='ready')=>{
      const digital=finish==='files';
      if(digital){value=296;state='ready';}
      const label=state==='loading'?settings.loading:state==='error'?settings.details:value===null?settings.unavailable:settings.from;
      const key=[country,finish,value,state].join(':');if(node.dataset.priceKey===key)return;
      node.dataset.priceKey=key;node.hidden=false;node.replaceChildren();
      const line=document.createElement('span');line.className='asp-price__line';line.textContent=label;
      if(state==='ready'&&value!==null){
        const money=document.createElement('strong');money.className='money';money.textContent=(value/100).toFixed(2)+' €';
        line.append(document.createTextNode(' '),money);
        if(digital)line.append(document.createTextNode(' '+settings.perImage));
      }
      node.append(line);
      if(digital||state==='ready'&&value!==null){
        const note=document.createElement('small');note.className='asp-price__note';note.textContent=digital?settings.credit+' · '+settings.digital:finish==='poster'?settings.posterShipping:finish==='rolled'?settings.oilShipping:settings.shipping;node.append(note);
      }
    };
    function schedule(){if(scheduled||stopped)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;if(!stopped)render();});}
    const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{const card=cards.get(entry.target);if(card&&entry.isIntersecting){card.visible=true;observer.unobserve(entry.target);}});schedule();},{rootMargin:'500px'});
    function attachCards(){
      document.querySelectorAll('[data-alpha-product-card]').forEach(card=>{
        if(cards.has(card)||!card.querySelector('[data-credit-add]'))return;
        const price=document.createElement('div');price.className='asp-price asp-card-price';price.hidden=true;card.append(price);
        const entry={price,source:parseSource(card),visible:false,values:null,state:'loading',country:''};cards.set(card,entry);card.dataset.startingPriceCard='';observer.observe(card);
      });
      for(const [card]of cards)if(!card.isConnected){observer.unobserve(card);cards.delete(card);}
    }
    function query(entry){
      if(entry.country===country)return;
      entry.country=country;entry.values=null;entry.state='loading';const requestedCountry=country;
      livePrices(entry.source,country).then(values=>{if(entry.country!==requestedCountry||stopped)return;entry.values=values;entry.state='ready';schedule();},()=>{if(entry.country!==requestedCountry||stopped)return;entry.state='error';schedule();});
    }
    function headerPrices(){
      const ratio=isProduct?Number(productSource?.width)/Number(productSource?.height):null;
      const values={};
      supportKeys.forEach((key,index)=>{values[key]=isProduct?headerValues?.[key]??null:data?.pool[data.countries[country]]?.[index]??null;});
      values.hanger=formatMinimum(data,'hanger',country,ratio);values.dibond=formatMinimum(data,'dibond',country,ratio);values.rolled=oilMinimum(data,country,ratio);
      values.acrylic=formatMinimum(data,'acrylic',country,ratio);
      values.poster=formatMinimum(data,'poster',country,ratio);
      values.budgetframe=formatMinimum(data,'budgetframe',country,ratio);
      return values;
    }
    function render(){
      attachCards();
      if(isProduct&&headerCountry!==country){
        headerCountry=country;headerValues=null;headerState='loading';const requestedCountry=country;
        livePrices(productSource,country).then(values=>{if(country!==requestedCountry||stopped)return;headerValues=values;headerState='ready';schedule();},()=>{if(country!==requestedCountry||stopped)return;headerState='error';schedule();});
      }
      const values=headerPrices();
      selector.querySelectorAll('[data-starting-finish]').forEach(node=>{
        const finish=node.dataset.startingFinish,state=supportKeys.includes(finish)&&isProduct?headerState:catalogState;writePrice(node,values[finish]??null,finish,state);
      });
      selector.querySelectorAll('[data-starting-type]').forEach(node=>{
        const type=node.dataset.startingType,finishes=typeFinishes[type];
        const state=isProduct&&['canvas','print'].includes(type)?headerState:catalogState;
        writePrice(node,minimum(finishes.map(f=>values[f])),finishes[0],state);
      });
      const type=document.body.dataset.artworkBrowse,finish=priceFinish(type,document.body.dataset.artworkFinish);
      for(const [card,entry]of cards){
        if(type==='phone'||type==='mug'||type==='board'){entry.price.hidden=true;continue;}
        if(!entry.visible&&!card.hasAttribute('data-price-filter-requested'))continue;
        entry.price.hidden=false;
        if(type==='digital'){writePrice(entry.price,null,'files');continue;}
        if(finish==='hanger'||finish==='dibond'||finish==='acrylic'||finish==='poster'||finish==='budgetframe'){
          const ratio=Number(card.dataset.alphaGalleryRatio)||Number(entry.source?.width)/Number(entry.source?.height);
          writePrice(entry.price,formatMinimum(data,finish,country,ratio),finish,catalogState);
        }else{
          query(entry);writePrice(entry.price,entry.values?.[finish]??null,finish,entry.state);
        }
      }
    }
    const grid=document.getElementById('ResultsList'),gridObserver=new MutationObserver(records=>{
      if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1&&(node.matches('[data-alpha-product-card],li')||node.querySelector('[data-alpha-product-card]')))))schedule();
    });
    if(grid)gridObserver.observe(grid,{childList:true,subtree:true});
    window.addEventListener('alpha:artwork-browse',schedule,{signal:listeners.signal});
    window.addEventListener('alpha:price-filter-evaluate',schedule,{signal:listeners.signal});
    const changeCountry=value=>{const next=String(value||root.dataset.defaultCountry).toUpperCase();if(!/^[A-Z]{2}$/.test(next)||next===country)return;country=next;schedule();};
    window.addEventListener('alpha-art-print:country-change',event=>changeCountry(event.detail?.country),{signal:listeners.signal});
    window.addEventListener('storage',event=>{if(event.key==='alpha-art-print-country')changeCountry(event.newValue);},{signal:listeners.signal});
    window.addEventListener('pageshow',()=>{try{changeCountry(localStorage.getItem('alpha-art-print-country'));}catch(_){}schedule();},{signal:listeners.signal});
    if(!catalogPromise)catalogPromise=fetch(settings.catalog).then(response=>{if(!response.ok)throw Error('Catalog unavailable');return response.json();}).catch(error=>{catalogPromise=null;throw error;});
    catalogPromise.then(value=>{if(stopped)return;data=value;catalogState='ready';schedule();},()=>{if(stopped)return;catalogState='error';schedule();});
    dispose=()=>{stopped=true;listeners.abort();observer.disconnect();gridObserver.disconnect();cards.forEach((entry,card)=>{entry.price.remove();delete card.dataset.startingPriceCard;});};
    schedule();
  }
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',()=>{if(!document.querySelector('[data-starting-prices]'))dispose();});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alpha-stretched-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const presentationState = (type, finish, mount = 'none') => {
    const floating = type === 'canvas' && finish === 'floating';
    const paper = type === 'print' && finish === 'unframed';
    const oil = type === 'oil' && finish === 'rolled';
    const rolled = type === 'canvas' && finish === 'rolled';
    const mounted = type === 'print' && finish === 'classic' && mount === 'white';
    const classic = type === 'print' && finish === 'classic' && (mount === 'none' || mounted);
    return { floating, paper, oil, rolled, mounted, classic, active: rolled || oil || classic || paper || type === 'canvas' && (finish === 'stretched' || floating) };
  };
  const fit = (ratio, width, height, floating = false) => {
    if (![ratio, width, height].every(value => Number.isFinite(value) && value > 0)) return null;
    const depth = floating ? Math.max(6, Math.min(52, width * .08)) : Math.max(5, Math.min(44, width * .065));
    const rim = floating ? Math.max(3, Math.min(18, width * .016)) : 0;
    const gap = rim * 5 / 12;
    const inset = 2 * (rim + gap);
    const imageWidth = Math.min(width * .96 - depth * .4 - inset, (height * .90 - inset) * ratio);
    if (imageWidth <= 0) return null;
    return { width: imageWidth + inset, height: imageWidth / ratio + inset, imageWidth, imageHeight: imageWidth / ratio, rim, gap, depth, perspective: Math.max(1600, width * 3) };
  };
  const fitPaper = (ratio, width, height) => {
    if (![ratio, width, height].every(value => Number.isFinite(value) && value > 0)) return null;
    const paperMargin = Math.max(2, Math.min(18, Math.min(width, height) * .024));
    const imageWidth = Math.min(width * .93 - 2 * paperMargin, (height * .88 - 2 * paperMargin) * ratio);
    if (imageWidth <= 0) return null;
    return { width: imageWidth + 2 * paperMargin, height: imageWidth / ratio + 2 * paperMargin, imageWidth, imageHeight: imageWidth / ratio, paperMargin, rim: 0, gap: 0, depth: 0, perspective: Math.max(1600, width * 3) };
  };
  const fitOil = (ratio, width, height) => {
    if (![ratio, width, height].every(value => Number.isFinite(value) && value > 0)) return null;
    const clothMargin = Math.max(1.5, Math.min(22, Math.min(width, height) * .022));
    const imageWidth = Math.min((width * .85 - 2 * clothMargin * 1.19) * ratio / (ratio + .19), (height * .78 - 2 * clothMargin) * ratio);
    if (imageWidth <= 0) return null;
    const roll = (imageWidth / ratio + 2 * clothMargin) * .19;
    return { width: imageWidth + 2 * clothMargin, height: imageWidth / ratio + 2 * clothMargin, imageWidth, imageHeight: imageWidth / ratio, clothMargin, roll, rim: 0, gap: 0, depth: 0, perspective: Math.max(1600, width * 3) };
  };
  const fitRolled = (ratio, width, height) => {
    if (![ratio, width, height].every(value => Number.isFinite(value) && value > 0)) return null;
    const imageWidth = Math.min(width * .85 * ratio / (ratio + .19), height * .78 * ratio);
    if (imageWidth <= 0) return null;
    return { width: imageWidth, height: imageWidth / ratio, imageWidth, imageHeight: imageWidth / ratio, clothMargin: 0, roll: imageWidth / ratio * .19, rim: 0, gap: 0, depth: 0, perspective: Math.max(1600, width * 3) };
  };
  const fitClassic = (ratio, width, height, mounted = false) => {
    if (![ratio, width, height].every(value => Number.isFinite(value) && value > 0)) return null;
    const rim = Math.max(2.5, Math.min(18, width * .016));
    const depth = Math.max(3, Math.min(20, width * .03));
    const mat = mounted ? Math.max(3, Math.min(72, Math.min(width, height) * .065)) : 0;
    const inset = 2 * (rim + mat);
    const imageWidth = Math.min(width * .94 - depth * .4 - inset, (height * .90 - inset) * ratio);
    if (imageWidth <= 0) return null;
    return { width: imageWidth + inset, height: imageWidth / ratio + inset, imageWidth, imageHeight: imageWidth / ratio, rim, mat, gap: 0, depth, perspective: Math.max(1600, width * 3) };
  };
  const fitMounted = (ratio, glazingRatio, width, height) => {
    if (![ratio, glazingRatio, width, height].every(value => Number.isFinite(value) && value > 0)) return null;
    const rim = Math.max(2.5, Math.min(18, width * .016));
    const depth = Math.max(3, Math.min(20, width * .03));
    const glazingWidth = Math.min(width * .94 - depth * .4 - 2 * rim, (height * .90 - 2 * rim) * glazingRatio);
    const glazingHeight = glazingWidth / glazingRatio;
    const mat = Math.max(3, Math.min(72, Math.min(width, height) * .065, Math.min(glazingWidth, glazingHeight) * .18));
    const imageWidth = Math.min(glazingWidth - 2 * mat, (glazingHeight - 2 * mat) * ratio);
    if (imageWidth <= 0) return null;
    const imageHeight = imageWidth / ratio;
    return { width: glazingWidth + 2 * rim, height: glazingHeight + 2 * rim, imageWidth, imageHeight, rim, mat, matX: (glazingWidth - imageWidth) / 2, matY: (glazingHeight - imageHeight) / 2, gap: 0, depth, perspective: Math.max(1600, width * 3) };
  };
  if (typeof document === 'undefined') {
    if (typeof module !== 'undefined') module.exports = { fit, fitPaper, fitOil, fitRolled, fitClassic, fitMounted, presentationState };
    return;
  }
  const target = '.alpha-product-card__artwork-frame, [data-aap-product-preview], [data-support-example-object]';
  const entries = new Map();
  let active = false;
  let floating = false;
  let paper = false;
  let oil = false;
  let rolled = false;
  let classic = false;
  let mounted = false;
  let scheduled = false;
  const resize = new ResizeObserver(() => schedule());
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      entries.forEach(update);
    });
  }
  function update(entry) {
    const { object, stage, image, sourceObserver, onLoad } = entry;
    if (!object.isConnected) {
      resize.unobserve(stage);
      sourceObserver.disconnect();
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onLoad);
      entries.delete(object);
      return;
    }
    const mode = entry.fixed || { active, floating, paper, oil, rolled, classic, mounted };
    render(entry, mode);
  }
  function render(entry, { active, floating, paper, oil, rolled, classic, mounted }) {
    const { object, stage, image } = entry;
    const ready = active && image.complete && image.naturalWidth > 0 && image.naturalHeight > 0;
    stage.classList.toggle('asc-stage', ready);
    stage.classList.toggle('asc-oil-stage', ready && oil);
    stage.classList.toggle('asc-rolled-stage', ready && rolled);
    object.classList.toggle('asc-canvas', ready);
    object.classList.toggle('asc-floating', ready && floating);
    object.classList.toggle('asc-paper', ready && paper);
    object.classList.toggle('asc-oil', ready && (oil || rolled));
    object.classList.toggle('asc-rolled', ready && rolled);
    object.classList.toggle('asc-classic', ready && classic);
    object.classList.toggle('asc-mounted', ready && mounted);
    object.classList.toggle('asc-framed', ready && (floating || classic));
    if (!ready) return;
    const nativeRoot = object.closest('[data-aap-root]');
    const dimensions = (nativeRoot?.querySelector('[data-aap-preview]')?.style.getPropertyValue('--aap-art-ratio') || '').split('/').map(Number);
    const selectedRatio = dimensions.length === 2 ? dimensions[0] / dimensions[1] : 0;
    const ratio = rolled && Number.isFinite(selectedRatio) && selectedRatio > 0 ? selectedRatio : image.naturalWidth / image.naturalHeight;
    const oilStageRatio = String(Math.max(1, Math.min(1.4, ratio * .82)));
    if (stage.style.getPropertyValue('--asc-oil-stage-ratio') !== oilStageRatio) stage.style.setProperty('--asc-oil-stage-ratio', oilStageRatio);
    const mountedOffer = mounted ? nativeRoot?.querySelector('[data-alpha-mounted-offer]') : null;
    const glazingRatio = mountedOffer?.dataset.mountedState === 'ready' ? Number(mountedOffer.dataset.mountedGlazingWidth) / Number(mountedOffer.dataset.mountedGlazingHeight) : 0;
    const size = rolled ? fitRolled(ratio, stage.clientWidth, stage.clientHeight) : oil ? fitOil(ratio, stage.clientWidth, stage.clientHeight) : mounted && Number.isFinite(glazingRatio) && glazingRatio > 0 ? fitMounted(ratio, glazingRatio, stage.clientWidth, stage.clientHeight) : classic ? fitClassic(ratio, stage.clientWidth, stage.clientHeight, mounted) : paper ? fitPaper(ratio, stage.clientWidth, stage.clientHeight) : fit(ratio, stage.clientWidth, stage.clientHeight, floating);
    if (!size) return;
    const values = { '--asc-width': size.width + 'px', '--asc-height': size.height + 'px', '--asc-rim': size.rim + 'px', '--asc-gap': size.gap + 'px', '--asc-depth': size.depth + 'px', '--asc-perspective': size.perspective + 'px', '--asc-image': 'url(' + JSON.stringify(image.currentSrc || image.src) + ')' };
    Object.entries(values).forEach(([name, value]) => {
      if (object.style.getPropertyValue(name) !== value) object.style.setProperty(name, value);
    });
    const margin = (size.paperMargin || 0) + 'px';
    if (object.style.getPropertyValue('--asc-paper-margin') !== margin) object.style.setProperty('--asc-paper-margin', margin);
    for (const [name, value] of [['--asc-cloth-margin', size.clothMargin || 0], ['--asc-roll', size.roll || 0]]) {
      if (object.style.getPropertyValue(name) !== value + 'px') object.style.setProperty(name, value + 'px');
    }
    const mat = (size.mat || 0) + 'px';
    if (object.style.getPropertyValue('--asc-mat') !== mat) object.style.setProperty('--asc-mat', mat);
    for (const [name, value] of [['--asc-mat-x', size.matX ?? size.mat ?? 0], ['--asc-mat-y', size.matY ?? size.mat ?? 0]]) {
      if (object.style.getPropertyValue(name) !== value + 'px') object.style.setProperty(name, value + 'px');
    }
    const edge = nativeRoot?.querySelector('[data-aap-finishes] [data-value][aria-pressed="true"]')?.dataset.value || 'mirror';
    object.dataset.ascEdge = /black/i.test(edge) ? 'black' : /white/i.test(edge) ? 'white' : 'image';
    const defaultFrame = nativeRoot || classic ? 'black' : 'natural';
    const frame = mounted ? (nativeRoot?.querySelector('[data-alpha-mounted-offer]')?.dataset.mountedFrameColor || 'black') : nativeRoot?.querySelector('[data-aap-preview]')?.dataset.frameColor || nativeRoot?.querySelector('[data-aap-frames] [data-value][aria-pressed="true"]')?.dataset.value || defaultFrame;
    object.dataset.ascFrameColor = ['dark-grey', 'light-grey', 'natural', 'white', 'brown', 'gold', 'silver', 'black'].find(color => String(frame).toLowerCase().includes(color)) || defaultFrame;
  }
  function add(object) {
    if (entries.has(object)) return;
    const image = object.querySelector('img');
    const stage = object.closest('.alpha-product-card__media, [data-aap-product-stage], [data-support-example-stage]');
    if (!image || !stage) return;
    const side = document.createElement('span');
    side.className = 'asc-side';
    side.setAttribute('aria-hidden', 'true');
    const bottom = document.createElement('span');
    bottom.className = 'asc-bottom';
    bottom.setAttribute('aria-hidden', 'true');
    const roll = document.createElement('span');
    roll.className = 'asc-roll';
    roll.setAttribute('aria-hidden', 'true');
    object.append(side, bottom, roll);
    const onLoad = () => schedule();
    const sourceObserver = new MutationObserver(onLoad);
    sourceObserver.observe(image, { attributes: true, attributeFilter: ['src', 'srcset'] });
    const nativePreview = object.closest('[data-aap-root]')?.querySelector('[data-aap-preview]');
    if (nativePreview) sourceObserver.observe(nativePreview, { attributes: true, attributeFilter: ['data-frame-color', 'style'] });
    const mountedOffer = document.querySelector('[data-alpha-mounted-offer]');
    if (object.closest('[data-aap-root]') && mountedOffer) sourceObserver.observe(mountedOffer, { attributes: true, attributeFilter: ['data-mounted-frame-color', 'data-mounted-glazing-width', 'data-mounted-glazing-height', 'data-mounted-state'] });
    image.addEventListener('load', onLoad);
    image.addEventListener('error', onLoad);
    const fixed = object.hasAttribute('data-support-example-object') ? presentationState(object.dataset.supportType, object.dataset.supportFinish) : null;
    entries.set(object, { object, stage, image, sourceObserver, onLoad, fixed });
    resize.observe(stage);
  }
  function scan(root) {
    if (root.matches?.(target)) add(root);
    root.querySelectorAll?.(target).forEach(add);
    schedule();
  }
  function init() {
    floating = document.body.dataset.artworkBrowse === 'canvas' && document.body.dataset.artworkFinish === 'floating';
    paper = document.body.dataset.artworkBrowse === 'print' && document.body.dataset.artworkFinish === 'unframed';
    oil = document.body.dataset.artworkBrowse === 'oil' && document.body.dataset.artworkFinish === 'rolled';
    rolled = document.body.dataset.artworkBrowse === 'canvas' && document.body.dataset.artworkFinish === 'rolled';
    mounted = document.body.dataset.artworkBrowse === 'print' && document.body.dataset.artworkFinish === 'classic' && document.body.dataset.artworkMount === 'white';
    classic = document.body.dataset.artworkBrowse === 'print' && document.body.dataset.artworkFinish === 'classic' && (document.body.dataset.artworkMount === 'none' || mounted);
    active = rolled || oil || classic || paper || document.body.dataset.artworkBrowse === 'canvas' && (document.body.dataset.artworkFinish === 'stretched' || floating);
    scan(document);
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1 && (node.matches(target) || node.querySelector(target))) scan(node);
      }));
      if (records.some(record => record.removedNodes.length)) schedule();
    }).observe(main, { childList: true, subtree: true });
  }
  window.addEventListener('alpha:artwork-browse', event => {
    floating = event.detail?.type === 'canvas' && event.detail?.finish === 'floating';
    paper = event.detail?.type === 'print' && event.detail?.finish === 'unframed';
    oil = event.detail?.type === 'oil' && event.detail?.finish === 'rolled';
    rolled = event.detail?.type === 'canvas' && event.detail?.finish === 'rolled';
    mounted = event.detail?.type === 'print' && event.detail?.finish === 'classic' && event.detail?.mount === 'white';
    classic = event.detail?.type === 'print' && event.detail?.finish === 'classic' && (event.detail?.mount === 'none' || mounted);
    active = rolled || oil || classic || paper || event.detail?.type === 'canvas' && (event.detail?.finish === 'stretched' || floating);
    schedule();
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-aap-finishes] [data-value], [data-aap-frames] [data-value], [data-am-frame-color]')) schedule();
  });
  window.addEventListener('alpha:mounted-state', schedule);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  window.addEventListener('pageshow', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["artwork-credit-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('artwork-credit-cart')) customElements.define('artwork-credit-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true; this.items = []; this.configured = []; this.nativeItems = []; this.wallet = null; this.busy = false; this.storageOK = true; this.pending = false; this.requestKey = null; this.pendingState = null; this.checkoutUrl = null; this.requestItems = null; this.lastMessage = null;
      this.dialog = this.querySelector('dialog'); this.abort = new AbortController();
      this.key = `artwork-wallet-v2:${this.dataset.shop}:${this.dataset.owner}`;
      this.endpoint = new URL(this.dataset.endpoint, location.origin);
      if (this.endpoint.origin !== location.origin || this.endpoint.pathname !== '/apps/alpha-art-print') return;
      this.load(); this.mergeGuest(); this.render();
      this.querySelectorAll('[data-pack-price]').forEach(node => { node.textContent = this.money(Number(node.dataset.packPrice)); });
      const options = { signal: this.abort.signal };
      this.querySelector('[data-open]').addEventListener('click', () => this.open(), options);
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), options);
      const outsideDialog = event => {
        const bounds = this.dialog.getBoundingClientRect();
        return event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
      };
      this.dialog.addEventListener('pointerdown', event => { this.backdropPress = outsideDialog(event); }, options);
      this.dialog.addEventListener('pointercancel', () => { this.backdropPress = false; }, options);
      this.dialog.addEventListener('click', event => {
        const dismiss = this.backdropPress && outsideDialog(event);
        this.backdropPress = false;
        if (dismiss) this.dialog.close();
      }, options);
      this.querySelector('[data-checkout]').addEventListener('click', () => this.checkout(), options);
      this.querySelector('[data-retry]').addEventListener('click', () => this.refresh(true), options);
      this.querySelector('[data-address]').addEventListener('submit', event => { event.preventDefault(); this.checkout(); }, options);
      this.querySelectorAll('[data-pack]').forEach(button => button.addEventListener('click', () => this.buyPack(button.dataset.pack), options));
      document.addEventListener('click', event => {
        const packEntry = event.target.closest('[data-credit-pack-select]');
        if (packEntry) { event.preventDefault(); this.open(); this.buyPack(packEntry.dataset.creditPackSelect); return; }
        const entry = event.target.closest('[data-credit-open]');
        if (entry && !entry.matches('[data-hvhd-cart],[data-hvhd-drawer-cart]')) {
          event.preventDefault(); event.stopPropagation(); this.open();
          if (entry.dataset.creditOpen === 'packs') {
            const heading = this.querySelector('.artwork-wallet-packs h3');
            heading.focus({preventScroll: true});
            heading.scrollIntoView({block: 'center', behavior: 'instant'});
          } else if (entry.dataset.creditOpen === 'checkout') this.dialog.scrollTop = 0;
          return;
        }
        const button = event.target.closest('[data-credit-add]'); if (!button) return;
        event.preventDefault(); event.stopPropagation();
        if (this.busy || this.pending) { this.open(); return; }
        const item = this.clean({id: button.dataset.productId, title: button.dataset.title, url: button.dataset.url, image: button.dataset.image, useCredit: true});
        if (!item || this.items.length >= 100) return;
        if (!this.items.some(row => row.id === item.id)) { this.items.push(item); this.requestKey = null; this.pendingState = null; this.save(); }
        this.open();
      }, {...options, capture: true});
      window.addEventListener('storage', event => { if (event.key === this.key && !this.busy) { this.load(); this.render(); if (this.dialog.open) this.refresh(true); } }, options);
      document.addEventListener('visibilitychange', () => { if (!document.hidden && this.pending) this.refresh(true); }, options);
      window.addEventListener('pageshow', () => { this.load(); this.render(); if (this.pending) this.refresh(true); }, options);
      document.addEventListener('cart:update', () => { if (this.dialog.open && !this.pending) this.refresh(); }, options);
      document.addEventListener('shopify:section:load', () => this.syncEntries(), options);
      this.mountPhysicalActions();
      this.pageObserver = new MutationObserver(() => this.mountPhysicalActions());
      this.pageObserver.observe(document.getElementById('MainContent') || document.body,{childList:true,subtree:true});
      if (this.dataset.owner !== 'guest') this.refresh(this.pending);
    }
    disconnectedCallback() { this.abort?.abort(); this.pageObserver?.disconnect(); this.ready = false; }
    copy(key) { return this.querySelector('[data-copy]').content.querySelector(`[data-key="${key}"]`)?.textContent || ''; }
    message(key) { const status = this.querySelector('[data-status]'); status.textContent = this.copy(key); status.hidden = key === 'login' && this.dataset.owner === 'guest'; }
    syncEntries() {
      const count = String(this.items.length + this.configured.length);
      document.querySelectorAll('[data-credit-entry-count]').forEach(node => { if (node.textContent !== count) node.textContent = count; });
      document.querySelectorAll('[data-credit-entry-label]').forEach(node => node.setAttribute('aria-label',`${node.dataset.creditEntryLabel} · ${count}`));
    }
    open() { if (!this.dialog.open) this.dialog.showModal(); this.render(); this.refresh(this.pending); }
    clean(value) {
      if (!value || !/^gid:\/\/shopify\/Product\/[1-9]\d*$/.test(value.id) || typeof value.title !== 'string') return null;
      try {
        const url = new URL(value.url, location.origin);
        if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return null;
        let image = '';
        if (value.image) { const src = new URL(value.image, location.origin); if (src.protocol === 'https:' && !src.username && !src.password && (src.hostname === location.hostname || src.hostname === 'cdn.shopify.com')) { src.searchParams.set('width','180'); image = src.href; } }
        return {id:value.id,title:value.title.slice(0,300),url:url.pathname,image,useCredit:value.useCredit !== false};
      } catch { return null; }
    }
    cleanConfigured(value) {
      const artwork = this.clean(value);
      if (!artwork || !/^gid:\/\/shopify\/ProductVariant\/[1-9]\d*$/.test(value.variantId || '') || !/^[A-Z]{2}$/.test(value.country || '') || typeof value.optionId !== 'string' || value.optionId.length > 1000 || typeof value.quoteToken !== 'string' || value.quoteToken.length > 8192 || !Number.isSafeInteger(value.priceCents) || value.priceCents < 0) return null;
      return {...artwork,variantId:value.variantId,country:value.country,optionId:value.optionId,quoteToken:value.quoteToken,priceCents:value.priceCents,label:String(value.label || '').slice(0,500),hangerCheckoutSent:value.hangerCheckoutSent===true};
    }
    load() {
      try {
        const raw = localStorage.getItem(this.key); if (raw?.length > 1000000) throw Error('STORAGE');
        const data = JSON.parse(raw || '{}');
        this.items = (Array.isArray(data.items) ? data.items : []).slice(0,100).map(item => this.clean(item)).filter(Boolean);
        this.items = this.items.filter((row,index,rows) => rows.findIndex(other => other.id === row.id) === index);
        this.configured = (Array.isArray(data.configured) ? data.configured : []).slice(0,10).map(item => this.cleanConfigured(item)).filter(Boolean);
        this.requestKey = /^[A-Za-z0-9_-]{16,128}$/.test(data.requestKey || '') ? data.requestKey : null;
        this.pending = data.pending === true && Boolean(this.requestKey);
        this.pendingState = this.pending ? 'UNKNOWN' : null; this.checkoutUrl = null;
        this.requestItems = this.pending && data.digitalOnly === true ? this.items.map(item => ({productId:item.id,kind:'digital',quantity:1,useCredit:item.useCredit})) : null;
      } catch { this.storageOK = false; }
    }
    save() {
      try { localStorage.setItem(this.key,JSON.stringify({items:this.items,configured:this.configured,requestKey:this.requestKey,pending:this.pending,digitalOnly:Boolean(this.requestItems?.length && this.requestItems.every(item => item.kind === 'digital'))})); }
      catch { this.storageOK = false; this.message('storage'); }
    }
    mergeGuest() {
      if (this.dataset.owner === 'guest' || this.pending) return;
      try {
        const guestKey = `artwork-wallet-v2:${this.dataset.shop}:guest`, raw = localStorage.getItem(guestKey);
        if (!raw) return; if (raw.length > 200000) throw Error('STORAGE');
        const guest = JSON.parse(raw);
        for (const candidate of (Array.isArray(guest.items) ? guest.items : []).slice(0,100)) { const item = this.clean(candidate); if (item && this.items.length < 100 && !this.items.some(other => other.id === item.id)) this.items.push(item); }
        for (const candidate of (Array.isArray(guest.configured) ? guest.configured : []).slice(0,10)) { const item = this.cleanConfigured(candidate); if (item && this.configured.length < 10 && !this.configured.some(other => other.id === item.id && other.optionId === item.optionId && other.country === item.country)) this.configured.push(item); }
        this.save(); if (this.storageOK) localStorage.removeItem(guestKey);
      } catch { this.storageOK = false; }
    }
    creditCount() { return this.items.filter(item => item.useCredit).length; }
    money(cents, currency = 'EUR') { try { return new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency}).format(cents/100); } catch { return `${(cents/100).toFixed(2)} ${currency}`; } }
    render() {
      const count = this.creditCount(), frozen = this.wallet?.frozen === true;
      this.querySelector('[data-count]').textContent = this.items.length + this.configured.length;
      this.syncEntries();
      this.querySelector('[data-wallet-summary]').textContent = this.wallet ? this.wallet.available : '—';
      this.querySelector('[data-empty]').hidden = this.items.length + this.configured.length > 0;
      this.querySelector('[data-login]').hidden = this.dataset.owner !== 'guest';
      this.querySelector('[data-balance-box]').hidden = !this.wallet;
      for (const [attribute,key] of [['available','available'],['reserved','reserved'],['used','spent']]) this.querySelector(`[data-${attribute}]`).textContent = this.wallet?.[key] ?? '—';
      this.querySelector('[data-selected-count]').textContent = count;
      this.querySelector('[data-remaining]').textContent = this.wallet ? Math.max(0,this.wallet.available - (this.pending ? 0 : count)) : '—';
      this.querySelector('[data-orders]').hidden = this.pendingState !== 'COMPLETE';
      const paid = this.items.length - count, paidNode = this.querySelector('[data-paid-digital]'); paidNode.hidden = paid === 0; paidNode.textContent = `${this.copy('paid_digital')} ${this.money(paid * 990)}`;
      const list = this.querySelector('[data-items]'); list.replaceChildren();
      for (const item of this.items) {
        const row = document.createElement('li'), image = document.createElement('img'), content = document.createElement('div'), link = document.createElement('a'), label = document.createElement('label'), toggle = document.createElement('input'), remove = document.createElement('button');
        image.alt = ''; image.width = 68; image.height = 76; image.loading = 'lazy'; if (item.image) image.src = item.image;
        link.href = item.url; link.textContent = item.title;
        toggle.type = 'checkbox'; toggle.checked = item.useCredit; toggle.disabled = this.busy || this.pending;
        const note = document.createElement('span'); note.textContent = item.useCredit ? this.copy('use_credit') : `${this.copy('pay_individually')} ${this.money(990)}`;
        toggle.addEventListener('change', () => { item.useCredit = toggle.checked; this.requestKey = null; this.pendingState = null; this.save(); this.render(); });
        label.append(toggle,note); content.append(link,label);
        remove.type = 'button'; remove.textContent = this.copy('remove'); remove.disabled = this.busy || this.pending;
        remove.addEventListener('click', () => { this.items = this.items.filter(other => other.id !== item.id); this.requestKey = null; this.pendingState = null; this.save(); this.render(); });
        row.append(image,content,remove); list.append(row);
      }
      this.renderNative();
      const digital = this.items.length > 0;
      this.querySelector('[data-digital-rule]').hidden = !digital;
      this.querySelector('.artwork-wallet-header p').hidden = !digital;
      this.querySelector('[data-balance-box]').hidden = !digital || !this.wallet;
      this.querySelector('[data-login]').hidden = !digital || this.dataset.owner !== 'guest';
      this.querySelector('.artwork-wallet-total').hidden = !digital;
      this.querySelector('.artwork-wallet-manual').hidden = !digital;
      this.querySelector('[data-checkout]').hidden = !digital && !this.pending;
      this.querySelector('[data-physical-rule]').hidden = !this.configured.length;
      const physicalList = this.querySelector('[data-configured-items]'); physicalList.replaceChildren();
      const physicalPayments = this.querySelector('[data-physical-payments]'); physicalPayments.replaceChildren(); physicalPayments.hidden = !this.configured.length;
      for (const item of this.configured) {
        const row = document.createElement('li'), image = document.createElement('img'), content = document.createElement('div'), link = document.createElement('a'), remove = document.createElement('button');
        image.width = 68; image.height = 76; image.alt = ''; image.loading = 'lazy'; if (item.image) image.src = item.image;
        link.href = item.url; link.textContent = item.title;
        const note = document.createElement('p'); note.textContent = `${item.label} · `;
        const itemPrice = document.createElement('span'); itemPrice.className = 'money'; itemPrice.textContent = this.money(item.priceCents); note.append(itemPrice, ` · ${item.country}`);
        const pay = document.createElement('button'); pay.type = 'button'; pay.className = 'artwork-wallet-secondary'; pay.textContent = this.copy('pay_physical'); pay.disabled = this.busy || item.hangerCheckoutSent; pay.addEventListener('click', () => this.checkoutPhysical(item));
        const paymentLabel = document.createElement('p'); paymentLabel.textContent = `${item.title} · ${item.label}`;
        const paymentPrice = document.createElement('span'); paymentPrice.className = 'money'; paymentPrice.textContent = this.money(item.priceCents); pay.append(' — ',paymentPrice);
        physicalPayments.append(paymentLabel,pay);
        content.append(link,note); remove.type = 'button'; remove.textContent = this.copy('remove'); remove.disabled = this.pending || this.busy;
        remove.addEventListener('click', () => { this.configured = this.configured.filter(other => other !== item); this.requestKey = null; this.pendingState = null; this.save(); this.render(); });
        row.append(image,content,remove); physicalList.append(row);
      }
      this.querySelector('[data-address]').hidden = !this.configured.length && !this.nativeItems.some(item => item.requires_shipping && item.properties?.['_Artwork quote token']);
      const action = this.querySelector('[data-checkout]'); action.textContent = this.copy(this.pendingState === 'OPEN' ? 'resume' : 'checkout');
      action.disabled = this.busy || !this.storageOK || this.dataset.owner === 'guest' || frozen || (this.pending ? !['OPEN','RETRY_SAFE'].includes(this.pendingState) : !count || !this.wallet || this.wallet.available < count);
      this.querySelector('[data-retry]').hidden = !this.pending;
      this.querySelector('[data-retry]').disabled = this.busy;
      this.querySelectorAll('[data-pack]').forEach(button => { button.disabled = this.busy || this.pending; });
      if (!this.storageOK) this.message('storage');
      else if (this.pending) this.message(this.pendingState === 'OPEN' ? 'resume' : 'pending');
      else if (this.pendingState === 'COMPLETE') this.message('complete');
      else if (this.pendingState === 'RELEASED') this.message('released');
      else if (frozen) this.message('frozen');
      else if (this.dataset.owner === 'guest') this.message('login');
      else if (this.wallet && this.wallet.available < count) this.message('short');
      else if (this.wallet) this.querySelector('[data-status]').textContent = `${this.copy('available')} ${this.wallet.available}`;
      this.querySelectorAll('[data-address] input,[data-address] select').forEach(input => { input.disabled = this.pending || this.busy; });
    }
    renderNative() {
      const list = this.querySelector('[data-native-items]'); list.replaceChildren();
      this.nativeInvalid = false;
      for (const item of this.nativeItems) {
        if (!item.requires_shipping || !item.properties?.['_Artwork quote token']) continue;
        const row = document.createElement('li'), image = document.createElement('img'), content = document.createElement('div'), link = document.createElement('a');
        image.width = 68; image.height = 76; image.alt = ''; image.loading = 'lazy';
        try { const url = new URL(item.image,location.origin); if (url.protocol === 'https:' && [location.hostname,'cdn.shopify.com'].includes(url.hostname)) { url.searchParams.set('width','180'); image.src = url.href; } } catch {}
        try { const url = new URL(item.url,location.origin); if (url.origin === location.origin) link.href = url.pathname; } catch {}
        link.textContent = `${item.product_title} × ${item.quantity}`;
        const price = document.createElement('span'); price.textContent = this.money(item.final_line_price,this.nativeCurrency); content.append(link,price);
        row.append(image,content); list.append(row);
      }
      this.querySelector('[data-native-box]').hidden = !list.children.length;
      this.querySelector('[data-pack-resume]').hidden = !this.hasNativePack() && !this.packNeedsReview;
      this.querySelector('[data-address]').hidden = !this.configured.length && !this.nativeItems.some(item => item.requires_shipping && item.properties?.['_Artwork quote token']);
    }
    hasNativePack() { return this.nativeItems.some(item => ['47171438280876','47171438543020','47171438641324'].includes(String(item.variant_id || item.id))); }
    async api(action, body) {
      const url = new URL(this.endpoint); url.searchParams.set('mode','credits'); url.searchParams.set('action',action);
      const response = await fetch(url,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:body?{'Content-Type':'application/json','X-Artwork-CSRF':this.csrf}:{},body:body?JSON.stringify(body):undefined,signal:AbortSignal.timeout(30000)});
      let data; try { data = await response.json(); } catch { throw Error('UNAVAILABLE'); }
      if (!response.ok) throw Error(data.error || 'UNAVAILABLE'); return data;
    }
    async readNativeCart() {
      const url = new URL(this.dataset.nativeCart,location.origin); if (url.origin !== location.origin) throw Error('CART_UNAVAILABLE');
      const response = await fetch(url,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(15000)}); if (!response.ok) throw Error('CART_UNAVAILABLE');
      const cart = await response.json(); if (!Array.isArray(cart.items) || cart.items.length > 100) throw Error('CART_UNAVAILABLE');
      this.nativeItems = cart.items; this.nativeCurrency = cart.currency || 'EUR'; return cart.items;
    }
    async refresh(recover = false) {
      if (this.dataset.owner === 'guest' || this.refreshing || this.busy) return;
      this.refreshing = true;
      try {
        if (!this.pending) await this.readNativeCart();
        const result = await this.api('balance');
        if (!Number.isSafeInteger(result.balance?.available) || result.balance.available < 0 || typeof result.csrf !== 'string') throw Error('UNAVAILABLE');
        this.wallet = result.balance; this.csrf = result.csrf;
        if (recover && this.pending) await this.recover();
        this.render();
      } catch (error) { this.render(); this.message(error.message === 'LOGIN_REQUIRED' ? 'login' : this.pending ? 'pending' : 'error'); }
      finally { this.refreshing = false; }
    }
    safeCheckout(value) {
      const url = new URL(value), allowed = [this.dataset.shop,location.hostname,'checkout.shopify.com','alphachristianart.com'];
      if (url.protocol !== 'https:' || url.username || url.password || url.port || !allowed.includes(url.hostname)) throw Error('UNAVAILABLE'); return url.href;
    }
    async recover() {
      try { this.applyState(await this.api('status',{requestKey:this.requestKey})); }
      catch (error) {
        if (error.message !== 'CHECKOUT_NOT_FOUND') throw error;
        this.pendingState = this.requestItems ? 'RETRY_SAFE' : 'UNKNOWN';
      }
    }
    applyState(result) {
      if (!['RESERVED','CREATE_PENDING','UNKNOWN','OPEN','COMPLETE','RELEASED'].includes(result.state)) throw Error('UNAVAILABLE');
      this.pendingState = result.state;
      if (result.state === 'OPEN') { this.checkoutUrl = this.safeCheckout(result.checkoutUrl); this.pending = true; }
      else if (result.state === 'COMPLETE') { this.items = []; this.pending = false; this.requestKey = null; this.checkoutUrl = null; this.message('complete'); }
      else if (result.state === 'RELEASED') { this.pending = false; this.requestKey = null; this.checkoutUrl = null; this.message('released'); }
      else { this.pending = true; this.checkoutUrl = null; }
      this.save();
    }
    async checkout() {
      if (this.busy || !this.storageOK || this.dataset.owner === 'guest') return;
      if (this.pending) {
        await this.refresh(true);
        if (this.pendingState === 'OPEN' && this.checkoutUrl && this.wallet?.frozen !== true) location.assign(this.safeCheckout(this.checkoutUrl));
        else if (this.pendingState === 'RETRY_SAFE' && this.requestItems && this.wallet?.frozen !== true) {
          this.busy = true; this.render();
          try { this.applyState(await this.api('checkout',{requestKey:this.requestKey,items:this.requestItems})); if (this.pendingState === 'OPEN') location.assign(this.safeCheckout(this.checkoutUrl)); }
          catch { this.message('pending'); }
          finally { this.busy = false; this.render(); }
        }
        return;
      }
      if (!this.creditCount() || !this.wallet || this.wallet.available < this.creditCount() || this.wallet.frozen) return;
      this.busy = true; this.checkoutNotice = null; this.message('loading'); this.render();
      try {
        const current = await this.api('balance');
        if (!Number.isSafeInteger(current.balance?.available) || current.balance.available < 0 || typeof current.csrf !== 'string') throw Error('UNAVAILABLE');
        this.wallet = current.balance; this.csrf = current.csrf;
        if (this.wallet.frozen || this.wallet.available < this.creditCount()) { this.checkoutNotice = this.wallet.frozen ? 'frozen' : 'short'; return; }
        await this.readNativeCart(); this.renderNative();
        const items = this.items.map(item => ({productId:item.id,kind:'digital',quantity:1,useCredit:item.useCredit}));
        if (new TextEncoder().encode(JSON.stringify(items)).byteLength > 60000 || items.length > 100) throw Error('UNAVAILABLE');
        this.requestItems = items; this.requestKey ||= crypto.randomUUID(); this.pending = true; this.pendingState = 'CREATE_PENDING'; this.save(); if (!this.storageOK) throw Error('STORAGE');
        const result = await this.api('checkout',{requestKey:this.requestKey,items}); this.applyState(result);
        if (this.pendingState === 'OPEN') location.assign(this.safeCheckout(this.checkoutUrl));
      } catch (error) {
        if (error.message === 'INSUFFICIENT_CREDITS' || error.message === 'WALLET_FROZEN') this.checkoutNotice = error.message === 'WALLET_FROZEN' ? 'frozen' : 'short';
        else this.checkoutNotice = this.pending ? 'pending' : 'error';
      } finally { this.busy = false; this.render(); if (this.checkoutNotice) this.message(this.checkoutNotice); }
    }
    async checkoutPhysical(item) {
      if (this.busy) return;
      if (item.hangerCheckoutSent) { this.message('physical_uncertain'); return; }
      const form = this.querySelector('[data-address]');
      form.querySelectorAll('input,select').forEach(input => { input.disabled = false; });
      if (!form.reportValidity()) return;
      const shippingAddress = Object.fromEntries(new FormData(form));
      const destination = shippingAddress.countryCode;
      const status = this.querySelector('[data-physical-status]'); status.hidden = false; status.textContent = this.copy('loading');
      this.busy = true; this.render(); this.message('loading');
      try {
        const option = await this.freshOption(item.variantId,destination,item.optionId);
        if (destination !== item.country || Math.round(option.totalPriceEur * 100) !== item.priceCents) { item.country = destination; item.optionId = option.id; item.priceCents = Math.round(option.totalPriceEur * 100); item.quoteToken = option.quoteToken; this.save(); throw Error('PRICE_CHANGED'); }
        if (/^(?:hanger-v[12]|(?:poster|budgetframe|phone|mug|board|acrylic|dibond)-v1)::/.test(item.optionId)) { item.hangerCheckoutSent=true; this.save(); if(!this.storageOK){item.hangerCheckoutSent=false;throw Error('STORAGE');} }
        const response = await fetch(this.endpoint,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({quoteToken:option.quoteToken,shippingAddress}),signal:AbortSignal.timeout(30000)});
        const result = await response.json(); if (!response.ok) throw Error('CHECKOUT_UNAVAILABLE');
        location.assign(this.safeCheckout(result.checkoutUrl));
      } catch (error) { this.busy = false; this.render(); const key = item.hangerCheckoutSent ? 'physical_uncertain' : error.message === 'PRICE_CHANGED' ? 'physical_price_changed' : 'physical_error'; this.message(key); status.textContent = this.copy(key); status.scrollIntoView({block:'nearest'}); }
    }
    mountPhysicalActions() {
      document.querySelectorAll('[data-aap-root]').forEach(root => {
        root.querySelectorAll('[data-aap-sizes] button > span:not([data-credit-size-money])').forEach(label => {
          const match = label.textContent.match(/\d[\d\s\u00a0\u202f]*[,.]\d{2}\s*€/);
          if (!match) return;
          const text = label.textContent;
          const amount = document.createElement('span'); amount.className = 'money'; amount.textContent = match[0];
          label.dataset.creditSizeMoney = '';
          label.replaceChildren(document.createTextNode(text.slice(0,match.index)), amount, document.createTextNode(text.slice(match.index + match[0].length)));
        });
        const pay = root.querySelector('[data-aap-checkout]'), price = root.querySelector('[data-aap-price]');
        if (pay && price && !pay.disabled && !root.classList.contains('is-digital-selection')) {
          let amount = pay.querySelector('[data-credit-cta-total]');
          if (!amount) { amount = document.createElement('b'); amount.dataset.creditCtaTotal = ''; amount.style.display = 'block'; amount.style.fontSize = '.9em'; pay.append(amount); }
          const total = price.textContent.trim(); if (amount.textContent !== total) amount.textContent = total;
        }
        const checkout = root.querySelector('[data-aap-checkout]'); if (!checkout || root.querySelector('[data-credit-physical]')) return;
        const button = document.createElement('button'); button.type = 'button'; button.className = 'artwork-credit-add'; button.dataset.creditPhysical = ''; button.textContent = this.copy('add_physical'); button.style.marginTop = '10px';
        button.addEventListener('click', () => this.addConfigured(root,button),{signal:this.abort.signal}); checkout.insertAdjacentElement('afterend',button);
      });
    }
    physicalSelection(root) {
      const active = name => root.querySelector(`[data-aap-${name}] button[aria-pressed="true"]`);
      if (root.getAttribute('aria-busy') === 'true' || root.classList.contains('is-digital-selection')) throw Error('UNAVAILABLE');
      const selection = {variantId:`gid://shopify/ProductVariant/${root.dataset.aapVariant}`,country:root.querySelector('[data-aap-country]')?.value,support:active('supports')?.dataset.support,size:active('sizes')?.dataset.value,finish:active('finishes')?.dataset.value,frame:active('frames')?.dataset.value || 'none'};
      if (!selection.support || !selection.size || !selection.finish || !/^[A-Z]{2}$/.test(selection.country || '')) throw Error('UNAVAILABLE'); return selection;
    }
    async freshOption(variantId,country,optionId,selection) {
      const url = new URL(this.endpoint); url.searchParams.set('variant',variantId.replace('gid://shopify/ProductVariant/','')); url.searchParams.set('country',country);
      if (typeof optionId === 'string' && /^(board|acrylic|dibond)-v1::/.test(optionId)) { const parts=optionId.split('::');if(parts.length!==4)throw Error('UNAVAILABLE');url.searchParams.set('catalog_profile',parts[0]);if(parts[0]==='board-v1'){const crop=parts[3].split('-');if(crop.length!==3||!crop.every(v=>/^\d{1,3}$/.test(v)))throw Error('UNAVAILABLE');url.searchParams.set('board_size',parts[2]);['x','y','zoom'].forEach((k,i)=>url.searchParams.set('board_'+k,crop[i]));}else{url.searchParams.set('panel_sku',parts[2]);url.searchParams.set('panel_surface',parts[3]);}parts[1]=country;optionId=parts.join('::');}
      if (typeof optionId === 'string' && optionId.startsWith('mug-v1::')) { const parts=optionId.split('::');if(parts.length!==3||!['two','panorama'].includes(parts[2]))throw Error('UNAVAILABLE');url.searchParams.set('catalog_profile','mug-v1');url.searchParams.set('mug_layout',parts[2]);parts[1]=country;optionId=parts.join('::'); }
      if (typeof optionId === 'string' && /^hanger-v[12]::/.test(optionId)) { url.searchParams.set('catalog_profile',optionId.split('::')[0]); const parts=optionId.split('::'); if(parts.length!==4)throw Error('UNAVAILABLE'); parts[1]=country; optionId=parts.join('::'); }
      if (typeof optionId === 'string' && optionId.startsWith('poster-v1::')) { url.searchParams.set('catalog_profile','poster-v1'); const parts=optionId.split('::'); if(parts.length!==4)throw Error('UNAVAILABLE'); parts[1]=country; optionId=parts.join('::'); }
      if (typeof optionId === 'string' && optionId.startsWith('budgetframe-v1::')) { url.searchParams.set('catalog_profile','budgetframe-v1'); const parts=optionId.split('::'); if(parts.length!==4)throw Error('UNAVAILABLE'); parts[1]=country; optionId=parts.join('::'); }
      if (typeof optionId === 'string' && optionId.startsWith('phone-v1::')) { const parts=optionId.split('::'),crop=parts[5]?.split('-');if(parts.length!==6||!crop||crop.length!==3||!crop.every(v=>/^\d{1,3}$/.test(v)))throw Error('UNAVAILABLE');url.searchParams.set('catalog_profile','phone-v1');url.searchParams.set('phone_model',parts[2]);['x','y','zoom'].forEach((k,i)=>url.searchParams.set('phone_'+k,crop[i]));parts[1]=country;optionId=parts.join('::'); }
      const response = await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(30000)}); if (!response.ok) throw Error('UNAVAILABLE');
      const data = await response.json(); if (!Array.isArray(data.options) || data.countryCode !== country) throw Error('UNAVAILABLE');
      const options = data.options.map(option => ({...option,id:option.id || [option.supportId,option.widthMm,option.heightMm,option.finishId,option.frameId || 'none'].join('::')}));
      const matches = options.filter(option => selection ? option.supportId === selection.support && [option.supportId,option.widthMm,option.heightMm].join('::') === selection.size && option.finishId === selection.finish && (option.frameId || 'none') === selection.frame : option.id === optionId).sort((a,b) => a.totalPriceEur - b.totalPriceEur);
      const option = matches[0]; if (!option || typeof option.quoteToken !== 'string' || !Number.isFinite(option.totalPriceEur) || option.totalPriceEur < 0) throw Error('UNAVAILABLE'); return option;
    }
    async addHangerConfiguration(source,selection,isCurrent) {
      if (this.busy || this.pending || this.configured.length >= 10) { this.open(); return; }
      const option = await this.freshOption(selection.variantId,selection.country,selection.optionId);
      if (this.busy || this.pending || this.configured.length >= 10 || !isCurrent?.() || option.supportId !== 'art-print-with-hanger' || option.offerProfile !== 'hanger-v2' || Math.round(option.totalPriceEur*100) !== selection.priceCents) throw Error('UNAVAILABLE');
      const item = this.cleanConfigured({...source,variantId:selection.variantId,country:selection.country,optionId:option.id,quoteToken:option.quoteToken,priceCents:selection.priceCents,label:selection.label});
      if (!item) throw Error('UNAVAILABLE');
      if (!this.configured.some(other => other.id === item.id && other.optionId === item.optionId && other.country === item.country)) this.configured.push(item);
      this.requestKey = null; this.pendingState = null; this.save(); this.open(); this.message('physical_added');
    }
    async addPosterConfiguration(source,selection,isCurrent) {
      if (this.busy || this.pending || this.configured.length >= 10) { this.open(); return; }
      const option = await this.freshOption(selection.variantId,selection.country,selection.optionId);
      if (this.busy || this.pending || this.configured.length >= 10 || !isCurrent?.() || option.supportId !== 'budget-poster' || option.offerProfile !== 'poster-v1' || Math.round(option.totalPriceEur*100) !== selection.priceCents) throw Error('UNAVAILABLE');
      const item = this.cleanConfigured({...source,variantId:selection.variantId,country:selection.country,optionId:option.id,quoteToken:option.quoteToken,priceCents:selection.priceCents,label:selection.label});
      if (!item) throw Error('UNAVAILABLE');
      if (!this.configured.some(other => other.id === item.id && other.optionId === item.optionId && other.country === item.country)) this.configured.push(item);
      this.requestKey = null; this.pendingState = null; this.save(); this.open(); this.message('physical_added');
    }
    async addBudgetframeConfiguration(source,selection,isCurrent) {
      if (this.busy || this.pending || this.configured.length >= 10) { this.open(); return; }
      const option = await this.freshOption(selection.variantId,selection.country,selection.optionId);
      if (this.busy || this.pending || this.configured.length >= 10 || !isCurrent?.() || option.supportId !== 'budget-framed-poster' || option.offerProfile !== 'budgetframe-v1' || Math.round(option.totalPriceEur*100) !== selection.priceCents) throw Error('UNAVAILABLE');
      const item = this.cleanConfigured({...source,variantId:selection.variantId,country:selection.country,optionId:option.id,quoteToken:option.quoteToken,priceCents:selection.priceCents,label:selection.label});
      if (!item) throw Error('UNAVAILABLE');
      if (!this.configured.some(other => other.id === item.id && other.optionId === item.optionId && other.country === item.country)) this.configured.push(item);
      this.requestKey = null; this.pendingState = null; this.save(); this.open(); this.message('physical_added');
    }
    async addPhoneConfiguration(source,selection,isCurrent) {
      if (this.busy || this.pending || this.configured.length >= 10) { this.open(); return; }
      const option = await this.freshOption(selection.variantId,selection.country,selection.optionId);
      if (this.busy || this.pending || this.configured.length >= 10 || !isCurrent?.() || option.supportId !== 'phone-case' || option.offerProfile !== 'phone-v1' || Math.round(option.totalPriceEur*100) !== selection.priceCents) throw Error('UNAVAILABLE');
      const item = this.cleanConfigured({...source,variantId:selection.variantId,country:selection.country,optionId:option.id,quoteToken:option.quoteToken,priceCents:selection.priceCents,label:selection.label});
      if (!item) throw Error('UNAVAILABLE');
      if (!this.configured.some(other => other.id === item.id && other.optionId === item.optionId && other.country === item.country)) this.configured.push(item);
      this.requestKey = null; this.pendingState = null; this.save(); this.open(); this.message('physical_added');
    }
    async addMugConfiguration(source,selection,isCurrent) {
      if (this.busy || this.pending || this.configured.length >= 10) { this.open(); return; }
      const option = await this.freshOption(selection.variantId,selection.country,selection.optionId);
      if (this.busy || this.pending || this.configured.length >= 10 || !isCurrent?.() || option.supportId !== 'ceramic-mug' || option.offerProfile !== 'mug-v1' || Math.round(option.totalPriceEur*100) !== selection.priceCents) throw Error('UNAVAILABLE');
      const item = this.cleanConfigured({...source,variantId:selection.variantId,country:selection.country,optionId:option.id,quoteToken:option.quoteToken,priceCents:selection.priceCents,label:selection.label});
      if (!item) throw Error('UNAVAILABLE');
      if (!this.configured.some(other => other.id === item.id && other.optionId === item.optionId && other.country === item.country)) this.configured.push(item);
      this.requestKey = null; this.pendingState = null; this.save(); this.open(); this.message('physical_added');
    }
    async addRigidConfiguration(source,selection,isCurrent) {
      if (this.busy || this.pending || this.configured.length >= 10) { this.open(); return; }
      const option = await this.freshOption(selection.variantId,selection.country,selection.optionId);
      const profile=selection.optionId.split('::')[0],support={'board-v1':'gallery-board-stand','acrylic-v1':'acrylic-panel','dibond-v1':'aluminium-panel'}[profile];
      if (this.busy || this.pending || this.configured.length >= 10 || !isCurrent?.() || !support || option.supportId !== support || option.offerProfile !== profile || !option.rigid || Math.round(option.totalPriceEur*100) !== selection.priceCents) throw Error('UNAVAILABLE');
      const item = this.cleanConfigured({...source,variantId:selection.variantId,country:selection.country,optionId:option.id,quoteToken:option.quoteToken,priceCents:selection.priceCents,label:selection.label});
      if (!item) throw Error('UNAVAILABLE');
      if (!this.configured.some(other => other.id === item.id && other.optionId === item.optionId && other.country === item.country)) this.configured.push(item);
      this.requestKey = null; this.pendingState = null; this.save(); this.open(); this.message('physical_added');
    }
    async addConfigured(root,button) {
      if (this.busy || this.pending || this.configured.length >= 10) { this.open(); return; }
      button.disabled = true;
      try {
        const selection = this.physicalSelection(root), option = await this.freshOption(selection.variantId,selection.country,null,selection);
        if (JSON.stringify(selection) !== JSON.stringify(this.physicalSelection(root))) throw Error('UNAVAILABLE');
        const source = root.closest('[data-aam-pod-product]')?.querySelector('[data-credit-add]'); if (!source) throw Error('UNAVAILABLE');
        const item = this.cleanConfigured({id:source.dataset.productId,title:source.dataset.title,url:source.dataset.url,image:source.dataset.image,variantId:selection.variantId,country:selection.country,optionId:option.id,quoteToken:option.quoteToken,priceCents:Math.round(option.totalPriceEur * 100),label:root.querySelector('[data-aap-selection]')?.textContent || `${option.widthMm/10} × ${option.heightMm/10} cm`});
        if (!item) throw Error('UNAVAILABLE');
        if (!this.configured.some(other => other.id === item.id && other.optionId === item.optionId && other.country === item.country)) this.configured.push(item);
        this.requestKey = null; this.pendingState = null; this.save(); this.open(); this.message('physical_added');
      } catch { this.open(); this.message('physical_missing'); }
      finally { button.disabled = false; }
    }
    async buyPack(variant) {
      if (this.busy || this.pending) return;
      if (this.dataset.owner === 'guest') { location.assign(this.querySelector('[data-login]').href); return; }
      if (!['47171438280876','47171438543020','47171438641324'].includes(variant)) return;
      this.busy = true; this.save(); this.render(); this.message('loading'); let failed = false;
      try {
        await this.readNativeCart();
        const packIds = ['47171438280876','47171438543020','47171438641324'];
        const selected = () => this.nativeItems.some(item => String(item.variant_id || item.id) === variant);
        if (!selected()) {
          const url = new URL(this.dataset.nativeAdd,location.origin); if (url.origin !== location.origin) throw Error('PACK');
          const response = await fetch(url,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variant,quantity:1}]}),signal:AbortSignal.timeout(20000)});
          if (!response.ok) throw Error('PACK');
          await this.readNativeCart();
          if (!selected()) throw Error('PACK');
        }
        const obsolete = this.nativeItems.filter(item => packIds.includes(String(item.variant_id || item.id)) && String(item.variant_id || item.id) !== variant);
        if (obsolete.length) {
          const updateUrl = new URL(this.dataset.cartUrl.replace(/\/$/,'') + '/update.js',location.origin);
          if (updateUrl.origin !== location.origin || obsolete.some(item => !item.key)) throw Error('PACK');
          const response = await fetch(updateUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:Object.fromEntries(obsolete.map(item => [item.key,0]))}),signal:AbortSignal.timeout(20000)});
          if (!response.ok) throw Error('PACK');
        }
        await this.readNativeCart();
        if (!selected() || this.nativeItems.some(item => packIds.includes(String(item.variant_id || item.id)) && String(item.variant_id || item.id) !== variant)) throw Error('PACK');
        location.assign(this.dataset.cartUrl);
      } catch { failed = true; }
      finally { this.busy = false; this.packNeedsReview = failed; this.render(); if (failed) this.message('pack_error'); }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["artwork-digital-credit-actions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('artwork-digital-credit-actions')) customElements.define('artwork-digital-credit-actions', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.root = this.closest('[data-aam-pod-product]');
      this.template = this.querySelector('template');
      if (!this.root || !this.template) return;
      this.observer = new MutationObserver(() => this.mount());
      this.observer.observe(this.root, {childList: true, subtree: true});
      this.mount();
    }
    mount() {
      const host = this.root.querySelector('[data-aap-digital-info]');
      if (!host) {
        this.summary?.remove();
        this.summary = null;
        this.panel?.remove();
        this.panel = null;
        this.root.removeAttribute('data-digital-credit-mounted');
        return;
      }
      if (this.panel?.parentElement === host && this.summary?.parentElement === host) return;
      this.summary?.remove();
      this.panel?.remove();
      this.summary = this.template.content.querySelector('[data-digital-summary]').cloneNode(true);
      host.insertBefore(this.summary, host.querySelector('.aap-digital-info__order'));
      this.panel = this.template.content.querySelector('[data-digital-credit-panel]').cloneNode(true);
      host.append(this.panel);
      this.root.setAttribute('data-digital-credit-mounted', '');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.summary?.remove();
      this.summary = null;
      this.panel?.remove();
      this.panel = null;
      this.root?.removeAttribute('data-digital-credit-mounted');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
